/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AccountId` scalar represents the MongoDB ObjectId of a Buffer Account */
  AccountId: { input: string; output: string; }
  /** The `ChannelGroupId` scalar represents the MongoDB ObjectId of a Channel Group. */
  ChannelGroupId: { input: any; output: any; }
  /** The `ChannelId` scalar represents the MongoDB ObjectId of a Buffer Channel */
  ChannelId: { input: string; output: string; }
  /**
   * The `CommentId` scalar represents the MongoDB ObjectId of a Comment.
   * A Comment is a reply to a post
   */
  CommentId: { input: string; output: string; }
  /** The `Date` scalar represents a date */
  Date: { input: string; output: string; }
  /** The `DateTime` scalar represents a date and time following the ISO 8601 standard. */
  DateTime: { input: string; output: string; }
  /** The `DraftId` scalar represents the MongoDB ObjectId of a Buffer Draft */
  DraftId: { input: any; output: any; }
  /** The `ErrorMessageId` scalar represents the MongoDB ObjectId of an Error Message in our CMS */
  ErrorMessageId: { input: any; output: any; }
  /**
   * The `FeedCollectionId` scalar represents the MongoDB ObjectId of a Feed Group
   * A Feed Group is a collection of Feeds for a particular organization
   */
  FeedCollectionId: { input: string; output: string; }
  /**
   * The `FeedId` scalar represents the MongoDB ObjectId of a Content Feed (eg RSS)
   * A Feed is a source of content- for example, a specific RSS feed
   */
  FeedId: { input: string; output: string; }
  /**
   * The `FeedItemId` scalar represents the MongoDB ObjectId of a Feed Item
   * A Feed Item is a single item in a Feed- for example, an article from an RSS feed
   */
  FeedItemId: { input: string; output: string; }
  /** The `HexColorCode` scalar represents a valid hex color code. */
  HexColorCode: { input: any; output: any; }
  /** The `IdeaId` scalar represents the MongoDB ObjectId of a Buffer Idea */
  IdeaId: { input: string; output: string; }
  /** The `MimeType` scalar represents a valid MIME type, e.g. `image/png` */
  MimeType: { input: any; output: any; }
  /** The `NoteId` scalar represents the MongoDB ObjectId of a Buffer Note */
  NoteId: { input: string; output: string; }
  /** The `OrganizationId` scalar represents the MongoDB ObjectId of a Buffer Organization */
  OrganizationId: { input: string; output: string; }
  /** The `PostId` scalar represents the MongoDB ObjectId of a Buffer Post */
  PostId: { input: string; output: string; }
  /** The `SavedReplyId` scalar represents the MongoDB ObjectId of a Saved Reply. */
  SavedReplyId: { input: string; output: string; }
  /** The `ShopGridLinkId` scalar represents the MongoDB ObjectId of a Buffer ShopGridLink */
  ShopGridLinkId: { input: any; output: any; }
  /** The `SubProfileId` scalar represents the MongoDB ObjectId of a Buffer SubProfile */
  SubProfileId: { input: string; output: string; }
  /** The `TagId` scalar represents the MongoDB ObjectId of a Buffer Tag */
  TagId: { input: string; output: string; }
  /** The `TimeZone` scalar represents a valid timezone, e.g. `America/New_York` */
  TimeZone: { input: any; output: any; }
  /** The `URL` scalar represents a valid URL */
  URL: { input: any; output: any; }
};

/** AI Specific settings */
export type AiSettings = {
  __typename?: 'AISettings';
  /** Flag that indicates if AI onboarding has been completed */
  onboarded?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSettingsInput = {
  /** Flag that indicates if AI onboarding has been completed */
  onboarded: Scalars['Boolean']['input'];
};

/** Response for successful getAccessTokenForChannel query */
export type AccessTokens = {
  __typename?: 'AccessTokens';
  /** access token for channel */
  accessToken: Scalars['String']['output'];
  /** shared access token for channel */
  sharedAccessToken?: Maybe<Scalars['String']['output']>;
  /**
   * JWT token to that can be used instead of TFA code. This token expires in 30 minutes and allows advocates a short window
   * of time to perform sensitive actions without needing to enter a TFA code again.
   */
  tfaToken?: Maybe<Scalars['String']['output']>;
};

/** Account is a representation of a Buffer user. */
export type Account = {
  __typename?: 'Account';
  /** The internal admin comment associated with this account */
  adminComment?: Maybe<Scalars['String']['output']>;
  avatar: Scalars['String']['output'];
  backupEmail?: Maybe<Scalars['String']['output']>;
  backupEmailVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Fetch all channels for the account taking in account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using AccountOrganization.channels, Organization.channels or Query.channels instead
   * @deprecated Use root 'channels' query instead
   */
  channels: Array<Channel>;
  /** The connected apps for the account */
  connectedApps?: Maybe<Array<ConnectedApp>>;
  /** Date the account was created in the Core DB. For older customers, it's possible a Publish account existed in the Publish DB for this customer before this date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentOrganization?: Maybe<AccountOrganization>;
  /** Array of user's dismissed banners */
  dismissedBanners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email: Scalars['String']['output'];
  emailVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  featureFlips: Array<Scalars['String']['output']>;
  hasVerifiedBackupEmail?: Maybe<Scalars['Boolean']['output']>;
  hasVerifiedEmail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Used during the login verification flow to indicate if the user has successfully completed the login verification flow.
   * This field will only be set for users who require login verification.
   */
  hasVerifiedLogin?: Maybe<Scalars['Boolean']['output']>;
  hellonextSsoToken?: Maybe<Scalars['String']['output']>;
  helpScoutBeaconSignature?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isImpersonation: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  /** The date of the last login for the account */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date that the login verification flow was initiated.
   * This field will only be set for users who require login verification.
   */
  loginVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The account name, different from the organization name */
  name?: Maybe<Scalars['String']['output']>;
  organizations: Array<AccountOrganization>;
  /** The accounts preferences */
  preferences?: Maybe<Preferences>;
  products?: Maybe<Array<ProductLink>>;
  role: AccountRole;
  /** Account specific settings */
  settings?: Maybe<Settings>;
  /** Flag for new users to indicate if banner should be shown for email verification */
  shouldShowEmailVerificationCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** Flag for existing users to indicate if banner should be shown to request email verification */
  shouldShowEmailVerificationLinkRequest?: Maybe<Scalars['Boolean']['output']>;
  /** The account-level TFA information */
  tfa?: Maybe<Tfa>;
  /** The account-level timezone - this is used as a default input for streaks, posting plans, and new channel channel connections. */
  timezone?: Maybe<Scalars['String']['output']>;
};


/** Account is a representation of a Buffer user. */
export type AccountChannelsArgs = {
  input?: InputMaybe<AccountChannelsInput>;
  product?: InputMaybe<Product>;
};


/** Account is a representation of a Buffer user. */
export type AccountOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
};

/** Input for the channels field on Account */
export type AccountChannelsInput = {
  /** Query's filter. */
  filter?: InputMaybe<ChannelsFiltersInput>;
};

export type AccountCompleteEmailVerification = AccountCompleteEmailVerificationErrorJwtExpired | AccountCompleteEmailVerificationResponse | Error;

export type AccountCompleteEmailVerificationErrorJwtExpired = {
  __typename?: 'AccountCompleteEmailVerificationErrorJWTExpired';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  errorMessageCode: Scalars['String']['output'];
};

export type AccountCompleteEmailVerificationResponse = {
  __typename?: 'AccountCompleteEmailVerificationResponse';
  channelId?: Maybe<Scalars['ID']['output']>;
  redirectTo?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  sucessMessageCode: Scalars['String']['output'];
};

/** Reason to delete an account */
export type AccountDeletedReason = {
  /** Additional information about the account deletion */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the account to be deleted */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccountInitiateEmailVerificationError = {
  __typename?: 'AccountInitiateEmailVerificationError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountInitiateEmailVerificationPayload = AccountInitiateEmailVerificationError | AccountInitiateEmailVerificationResponse;

export type AccountInitiateEmailVerificationResponse = {
  __typename?: 'AccountInitiateEmailVerificationResponse';
  success: Scalars['Boolean']['output'];
};

/** AccountOrganization is a representation of a Buffer Organization resolved through a Buffer Account. */
export type AccountOrganization = {
  __typename?: 'AccountOrganization';
  billing: Billing;
  /** @deprecated deprecated in favor of billing field */
  billingDetails?: Maybe<BillingDetails>;
  billingNotifications: BillingNotificationSet;
  canAddPaymentDetails: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of privileges field */
  canEdit: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of privileges field */
  canManageBilling?: Maybe<Scalars['Boolean']['output']>;
  canMigrateToBufferViaHub?: Maybe<CanMigrateToOneBuffer>;
  canMigrateToOneBuffer: CanMigrateToOneBuffer;
  /** @deprecated deprecated in favor of field 'limits' */
  channelLimit: Scalars['Int']['output'];
  channelRecommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Fetch all channels for the account taking in account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using AccountOrganization.channels, Organization.channels or Query.channels instead
   */
  channels: Array<Channel>;
  commonTrackingProperties?: Maybe<CommonTrackingProperties>;
  contactAccountId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedObjects?: Maybe<Array<Maybe<DismissedObject>>>;
  entitlements: Array<Maybe<Entitlement>>;
  /**
   * Feature flips belonging to the organization admin account
   * in the future, we might want to start creating feature flips in the
   * organization object itself
   */
  featureFlips: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is the organization enrolled in the alpha program? */
  isAlphaEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the organization enrolled in the beta program? */
  isBetaEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCurrentOrganization: Scalars['Boolean']['output'];
  isOneBufferOrganization: Scalars['Boolean']['output'];
  lifetimeConnectedChannelsCount?: Maybe<Array<Maybe<LifetimeConnectedChannelCount>>>;
  limits: OrganizationLimits;
  members: MemberConnection;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  privileges: AccountPrivileges;
  role: Role;
  /**
   * We display the invite CTA when the organization account is an admin and when there are no more
   * members in the organization than the admin.
   */
  shouldDisplayInviteCTA: Scalars['Boolean']['output'];
  shouldShowTeamMemberOrganizationDowngradedBanner: Scalars['Boolean']['output'];
  /** Fetch all accounts that can be new owners for this organization */
  validNewOwners: Array<Account>;
};


/** AccountOrganization is a representation of a Buffer Organization resolved through a Buffer Account. */
export type AccountOrganizationChannelsArgs = {
  input?: InputMaybe<OrganizationChannelsInput>;
  product?: InputMaybe<Product>;
};

export type AccountPrivileges = {
  __typename?: 'AccountPrivileges';
  canEdit: Scalars['Boolean']['output'];
  canManageAllNotes: Scalars['Boolean']['output'];
  canManageBilling: Scalars['Boolean']['output'];
  canManageChannels: Scalars['Boolean']['output'];
  canManageTeamMembers: Scalars['Boolean']['output'];
  canPublishStartPages: Scalars['Boolean']['output'];
  canReceiveOrganizationOwnership: Scalars['Boolean']['output'];
  canTransferOwnership: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
};

export type AccountRemoveError = {
  __typename?: 'AccountRemoveError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountRemovePayload = AccountRemoveError | AccountRemoveResponse;

export type AccountRemoveResponse = {
  __typename?: 'AccountRemoveResponse';
  /** The id of the account that was removed. */
  id: Scalars['String']['output'];
};

export type AccountRole =
  | 'admin'
  | 'customer';

export type AccountSetSettingsError = {
  __typename?: 'AccountSetSettingsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountSetSettingsResponse = {
  __typename?: 'AccountSetSettingsResponse';
  settings: Settings;
  success: Scalars['Boolean']['output'];
};

export type AccountSuspendResponse = Error | Response;

export type AccountUnsuspendResponse = Error | Response;

/** input for the accountUpdateRole mutation */
export type AccountUpdateRoleInput = {
  accountId: Scalars['String']['input'];
  role: AccountRole;
};

/** The response of the accountUpdateRole mutation */
export type AccountUpdateRoleResponse = Error | Response;

/** An actor represents who/what the currently authorized entity is */
export type Actor =
  /** Represents a caller querying the core-api from api-gateway */
  | 'Account'
  /** Represents a caller making a request to the authentication service from the api-gateway */
  | 'ApiGateway'
  /** Represents a caller, who is a Buffer Admin, querying the core-api from api-gateway */
  | 'BufferAdmin'
  /** Represents a caller querying the core-api from an internal service */
  | 'InternalService'
  /** Represents a caller who are authenticated using a Publish access token */
  | 'LegacyClient'
  /** NullActor to be used in test to represent a request that is not authenticated */
  | 'NullActor'
  /** For request coming from the legacy RPC API */
  | 'RpcClient'
  /** Represents a script using some of the use cases */
  | 'Script';

export type AddEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteType: NoteType;
  text: Scalars['String']['input'];
};

export type AddEntityNotePayload = AddEntityNoteResponse | CoreWebAppCommonError;

export type AddEntityNoteResponse = {
  __typename?: 'AddEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Input to pass when creating a Note */
export type AddNoteToPostInput = {
  /** The id of post */
  postId: Scalars['PostId']['input'];
  /** The content of note to create */
  text: Scalars['String']['input'];
};

/** Create note request response payload. */
export type AddNoteToPostPayload = AddNoteToPostSuccess | InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response returns the full up-to-date post from after the note was created */
export type AddNoteToPostSuccess = {
  __typename?: 'AddNoteToPostSuccess';
  /** Post on which the note was successfully created */
  post: Post;
};

export type AddOrUpdateDismissedObjectError = {
  __typename?: 'AddOrUpdateDismissedObjectError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AddOrUpdateDismissedObjectPayload = AddOrUpdateDismissedObjectError | AddOrUpdateDismissedObjectResponse;

export type AddOrUpdateDismissedObjectResponse = {
  __typename?: 'AddOrUpdateDismissedObjectResponse';
  success: Scalars['Boolean']['output'];
};

/** addPostToQueue mutation schedule to the next available post by id. */
export type AddPostToQueueInput = {
  /** Post id to schedule to the next available slot. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by addPostToQueue mutation. */
export type AddPostToQueuePayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the mutation to add a shop grid custom link */
export type AddShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Link text to be saved */
  text: Scalars['String']['input'];
  /** URL to be saved */
  url: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AllowedCommentsStatuses =
  | 'AUTODISMISSED'
  | 'DISMISSED'
  | 'ENGAGED'
  | 'NONE';

export type AlphaFeature = {
  __typename?: 'AlphaFeature';
  description: Scalars['String']['output'];
  feedbackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platforms: Array<FeaturePlatform>;
};

export type AnalyticsAnswer = {
  __typename?: 'AnalyticsAnswer';
  best?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Array<Maybe<AnalyticsAnswersMetric>>>;
};

export type AnalyticsAnswers = {
  __typename?: 'AnalyticsAnswers';
  day: AnalyticsAnswer;
  frequency: AnalyticsAnswer;
  type: AnalyticsAnswer;
};

export type AnalyticsAnswersMetric = {
  __typename?: 'AnalyticsAnswersMetric';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AnalyticsContent = {
  __typename?: 'AnalyticsContent';
  description?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDaily = {
  __typename?: 'AnalyticsDaily';
  day: Scalars['Date']['output'];
  organic: AnalyticsDailyStatisticsOrganic;
  paid?: Maybe<AnalyticsDailyStatisticsPaid>;
  previousDay?: Maybe<Scalars['Date']['output']>;
  previousOrganic?: Maybe<AnalyticsDailyStatisticsOrganic>;
  previousPaid?: Maybe<AnalyticsDailyStatisticsPaid>;
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
};

export type AnalyticsDailyStatisticsOrganic = {
  __typename?: 'AnalyticsDailyStatisticsOrganic';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  followersGainOrganic?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  pageViews?: Maybe<Scalars['Int']['output']>;
  postsCount?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDailyStatisticsPaid = {
  __typename?: 'AnalyticsDailyStatisticsPaid';
  followersGainPaid?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsHashtag = {
  __typename?: 'AnalyticsHashtag';
  avgClicks?: Maybe<Scalars['Float']['output']>;
  avgComments?: Maybe<Scalars['Float']['output']>;
  avgEngagement?: Maybe<Scalars['Float']['output']>;
  avgEngagementRate?: Maybe<Scalars['Float']['output']>;
  avgImpressions?: Maybe<Scalars['Float']['output']>;
  avgLikes?: Maybe<Scalars['Float']['output']>;
  avgMentions?: Maybe<Scalars['Float']['output']>;
  avgShares?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  postsCount: Scalars['Int']['output'];
};

export type AnalyticsLastUpdatedAtInput = {
  channelId: Scalars['String']['input'];
  ingestionType: ChannelIngestionType;
  organizationId: Scalars['String']['input'];
};

export type AnalyticsOrderByField = {
  field: AnalyticsSortFields;
  order: AnalyticsSortOrder;
};

export type AnalyticsPeriodPostStatistics = {
  __typename?: 'AnalyticsPeriodPostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  postsCount: Scalars['Int']['output'];
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsPost = {
  __typename?: 'AnalyticsPost';
  content?: Maybe<AnalyticsContent>;
  id: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
  statistics?: Maybe<AnalyticsPostStatistics>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsPostStatistics = {
  __typename?: 'AnalyticsPostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsPostsTotals = {
  __typename?: 'AnalyticsPostsTotals';
  organic: AnalyticsPeriodPostStatistics;
  paid?: Maybe<AnalyticsPeriodPostStatistics>;
  previousOrganic?: Maybe<AnalyticsPeriodPostStatistics>;
};

export type AnalyticsSortFields =
  | 'CLICKS'
  | 'COMMENTS'
  | 'ENGAGEMENTS'
  | 'ENGAGEMENT_RATE'
  | 'IMPRESSIONS'
  | 'LIKES'
  | 'MENTIONS'
  | 'SENT_AT'
  | 'SHARES';

export type AnalyticsSortOrder =
  /** Sort records in ascending order. */
  | 'ASC'
  /** Sort records in descending order. */
  | 'DESC';

export type AnalyticsTotals = {
  __typename?: 'AnalyticsTotals';
  organic: AnalyticsDailyStatisticsOrganic;
  paid?: Maybe<AnalyticsDailyStatisticsPaid>;
  previousOrganic?: Maybe<AnalyticsDailyStatisticsOrganic>;
  previousPaid?: Maybe<AnalyticsDailyStatisticsPaid>;
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
};

/** Annotation representing all the entities in the text */
export type Annotation = {
  __typename?: 'Annotation';
  /**
   * The content of the annotation. Annotations can sometimes be different from the actual text content.
   * E.g., Mastodon mentions have 'text: @buffer', but includes the server name in the content, 'content: @buffer@threads.net'
   */
  content: Scalars['String']['output'];
  /** The indices of the annotation in the text */
  indices: Array<Scalars['Int']['output']>;
  /** The text representation of the annotation, eg '@buffer' */
  text: Scalars['String']['output'];
  /** The type of the annotation */
  type: AnnotationType;
  /** The URL the annotation points to */
  url: Scalars['String']['output'];
};

/** Annotation representing all the entities in the text */
export type AnnotationInputFacebook = {
  /** The content of the annotation, e.g. '107509875938399' */
  content: Scalars['String']['input'];
  /** The indices of the annotation in the text, e.g. [6, 9] (from 6 to 9 characters in the text) */
  indices: Array<Scalars['Int']['input']>;
  /** The text representation of the annotation, eg 'Buffer' */
  text: Scalars['String']['input'];
  /** The URL the annotation points to, e.g. https://www.facebook.com/107509875938399 */
  url: Scalars['String']['input'];
};

/** Annotation representing all the entities in the text */
export type AnnotationInputLinkedIn = {
  /** The entity of the annotation, e.g. urn:li:organization:1521226 */
  entity: Scalars['String']['input'];
  /** The id of the annotation, e.g. 1521226 */
  id: Scalars['String']['input'];
  /** The length of the annotation, e.g. 6 */
  length: Scalars['Int']['input'];
  /** The link of the annotation, e.g. https://www.linkedin.com/company/bufferapp */
  link: Scalars['String']['input'];
  /** The localized name of the annotation, e.g. Buffer */
  localizedName: Scalars['String']['input'];
  /** The start of the annotation, e.g. 5 */
  start: Scalars['Int']['input'];
  /** The vanity name of the annotation, e.g. bufferapp */
  vanityName: Scalars['String']['input'];
};

/** List of possible types for an annotation */
export type AnnotationType =
  | 'annotation'
  | 'cashtag'
  | 'hashtag'
  | 'mention'
  | 'url';

/** Approve Post request. */
export type ApprovePostInput = {
  /** Post id to approve. */
  id: Scalars['PostId']['input'];
};

/** Reject approval request response payload. */
export type ApprovePostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Asset interface with common fields */
export type Asset = {
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Asset types */
export type AssetType =
  | 'document'
  | 'image'
  | 'video';

/** Asset interface with common fields */
export type AssetsInput = {
  /** Documents to be attached to the post */
  documents?: InputMaybe<Array<DocumentAssetInput>>;
  /** Images to be attached to the post */
  images?: InputMaybe<Array<ImageAssetInput>>;
  /** Link to be attached to the post */
  link?: InputMaybe<LinkAssetInput>;
  /** Videos to be attached to the post */
  videos?: InputMaybe<Array<VideoAssetInput>>;
};

export type Attachment = {
  __typename?: 'Attachment';
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttributionInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  upgradePathName?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type AuthConnectionFlowType =
  | 'multi'
  | 'single';

/** Represent the author of a post or note. */
export type Author = {
  __typename?: 'Author';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The email address of the author. */
  email: Scalars['String']['output'];
  /** The unique identifier of the author. */
  id: Scalars['AccountId']['output'];
  /** Indicates whether the author is a deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** The name of the author. Null if the user has not yet set a name. */
  name?: Maybe<Scalars['String']['output']>;
};

export type AuthorizeChannelsError = {
  __typename?: 'AuthorizeChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** An enum representing the type of error that occurred. */
  errorType: ChannelAuthorizationErrorType;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AuthorizeChannelsPayload = AuthorizeChannelsError | AuthorizeChannelsResponse;

export type AuthorizeChannelsResponse = {
  __typename?: 'AuthorizeChannelsResponse';
  channels: Array<Channel>;
};

export type BackfillChannelPostsAndAnalyticsPayload = BasicError | MutationBasicResponse;

export type BackfillChannelUpdatesResponse = Error | Response;

/** Input for backfilling the updates for grid preview */
export type BackfillUpdatesForGridInput = {
  /** The channel id to backfill updates for */
  channelId: Scalars['ChannelId']['input'];
};

/**
 * The payload of the response from backfillUpdatesForGrid.
 * Since it requires internal client, UnauthorizedError is thrown
 * for unofficial clients. If the rate limit is hit, the response
 * is still successful to not throw too many errors at the client.
 */
export type BackfillUpdatesForGridPayload = BackfillUpdatesForGridResponse | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** success response for updateLastActivityAtForChannel mutation */
export type BackfillUpdatesForGridResponse = MutationSuccess & {
  __typename?: 'BackfillUpdatesForGridResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Represents the main information for a comment in the system. */
export type BaseComment = {
  /** Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** Information about the author of the comment. */
  author: CommentAuthor;
  /** Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Last Reply to this comment. */
  lastReply?: Maybe<LastReply>;
  /** Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp when this comment was created on the third-party service. It could be undefined
   *   if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type BaseResponse = Error | Response;

export type BasicChannelInfo = {
  __typename?: 'BasicChannelInfo';
  /** The avatar URL of the channel */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The display name of the channel */
  displayName: Scalars['String']['output'];
  /** The service ID of the channel */
  serviceId: Scalars['String']['output'];
};

export type BasicError = MutationBasicError & {
  __typename?: 'BasicError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type BetaFeature = {
  __typename?: 'BetaFeature';
  description: Scalars['String']['output'];
  feedbackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platforms: Array<FeaturePlatform>;
};

/** Represents the billing details for both One Buffer and Multi-Products organizations. */
export type Billing = {
  address?: Maybe<Address>;
  balance: Scalars['Float']['output'];
  canAccessAnalytics: Scalars['Boolean']['output'];
  canAccessEngagement: Scalars['Boolean']['output'];
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  taxDetails?: Maybe<TaxDetails>;
  taxExempt?: Maybe<Scalars['String']['output']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type BillingCreateCheckoutSessionPayload = BillingCreateCheckoutSessionResponse | BillingError;

export type BillingCreateCheckoutSessionResponse = {
  __typename?: 'BillingCreateCheckoutSessionResponse';
  /** The url returned by Stripe as a redirect for success, failed, or cancelled session */
  redirectUrl: Scalars['String']['output'];
};

/** Deprecated in favor of the CreateCustomerPortalSessionPayload type. */
export type BillingCreateCustomerPortalSessionPayload = BillingCreateCustomerPortalSessionResponse | BillingError;

/** Deprecated in favor of the CreateCustomerPortalSessionResponse type. */
export type BillingCreateCustomerPortalSessionResponse = {
  __typename?: 'BillingCreateCustomerPortalSessionResponse';
  /** The customer session url returned by Stripe */
  customerPortalSessionUrl: Scalars['String']['output'];
};

export type BillingCreateSetupIntentResponse = {
  __typename?: 'BillingCreateSetupIntentResponse';
  /** The setup intent client secret returned by Stripe to use in the Stripe payment mehtod form */
  clientSecret: Scalars['String']['output'];
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

export type BillingCreatedSetupIntentPayload = BillingCreateSetupIntentResponse | BillingError;

/**
 * Represents the billing details structured to mock our legacy RPC endpoint. This was to help transitioning from RPC to GraphQL without having to change how the core settings frontend works.
 * Deprecated in favor of Billing type.
 */
export type BillingDetails = {
  __typename?: 'BillingDetails';
  allStripeAccounts: Array<Maybe<Customer>>;
};

export type BillingError = {
  __typename?: 'BillingError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type BillingGateway =
  | 'android'
  | 'apple'
  | 'bank'
  | 'check'
  | 'gift'
  | 'none'
  | 'paypal'
  | 'revenuecat'
  | 'stripe';

export type BillingGatewayPlatform =
  | 'android'
  | 'apple'
  | 'web';

export type BillingIncreaseSubscriptionQuantityByChannelIdsPayload = BillingError | BillingResponse;

export type BillingInterval =
  | 'month'
  | 'year';

export type BillingMigrateToOneBufferPayload = BillingError | BillingMigrateToOneBufferResponse;

export type BillingMigrateToOneBufferResponse = {
  __typename?: 'BillingMigrateToOneBufferResponse';
  billing: Billing;
};

export type BillingNotificationSet = {
  __typename?: 'BillingNotificationSet';
  shouldDowngradeMobileSubscription?: Maybe<Scalars['Boolean']['output']>;
  shouldUpgradeMobileSubscription?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingResponse = {
  __typename?: 'BillingResponse';
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

export type BillingStartTrialPayload = BillingError | BillingResponse;

export type BillingState =
  | 'free'
  | 'paid'
  | 'trial';

export type BillingUpdateCustomerPaymentMethodPayload = BillingError | BillingResponse;

/** The payload response of the billing mutations */
export type BillingUpdateSubscriptionPlanPayload = BillingError | BillingUpdateSubscriptionPlanResponse;

export type BillingUpdateSubscriptionPlanResponse = {
  __typename?: 'BillingUpdateSubscriptionPlanResponse';
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdate>;
  success: Scalars['Boolean']['output'];
};

export type BillingUpdateSubscriptionQuantityPayload = BillingError | BillingUpdateSubscriptionPlanResponse;

/** Input Types */
export type BlockConfigInput = {
  data?: InputMaybe<BlockDataInput>;
  type?: InputMaybe<StartPageBlockTypes>;
};

export type BlockDataInput = {
  backgroundMedia?: InputMaybe<MediaInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  htmlJson?: InputMaybe<Scalars['String']['input']>;
  htmlText?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
  logoMedia?: InputMaybe<MediaInput>;
  media?: InputMaybe<MediaInput>;
  overlay?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlockMutationResponse = BlockMutationSuccess | CommonError;

/** Query / Mutation responses */
export type BlockMutationSuccess = MutationResponse & {
  __typename?: 'BlockMutationSuccess';
  block?: Maybe<StartPageBlock>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BlocksMutationResponse = BlocksMutationSuccess | CommonError;

export type BlocksMutationSuccess = MutationResponse & {
  __typename?: 'BlocksMutationSuccess';
  blocks?: Maybe<Array<Maybe<StartPageBlock>>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Bluesky metadata */
export type BlueskyMetadata = {
  __typename?: 'BlueskyMetadata';
  /** The instance of bluesky of the channel */
  serverUrl: Scalars['String']['output'];
};

/** Bluesky post metadata */
export type BlueskyPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'BlueskyPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Bluesky post metadata */
export type BlueskyPostMetadataInput = {
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

export type Calendar = {
  __typename?: 'Calendar';
  campaigns?: Maybe<Array<PublishingCampaign>>;
  days?: Maybe<Array<CalendarDay>>;
  posts: Array<PublishingPost>;
};

export type CalendarDay = Day & {
  __typename?: 'CalendarDay';
  /** A list of campaigns present on the requested day */
  campaigns?: Maybe<Array<PublishingCampaign>>;
  /** The number of posts for the given day */
  counts?: Maybe<Array<PostServiceCount>>;
  /** The day of the week, e.g., 'Monday' */
  dayName: DayName;
  /** The numerical day of the month, e.g., 31 */
  dayOfMonth: Scalars['Int']['output'];
  /** A collection of time spans for the given day which may contain posts */
  intervals?: Maybe<Array<CalendarInterval>>;
  /** The name of the month, e.g., 'January' */
  monthName: MonthName;
  /** A list of posts for the given day */
  posts?: Maybe<Array<PublishingPost>>;
  /** The start timestamp of the day in seconds */
  startTimestamp: Scalars['Int']['output'];
};

export type CalendarInput = {
  /** MOCK MODE ONLY: Seed value for random generator */
  _seed?: InputMaybe<Scalars['Int']['input']>;
  /** The campaign(s) to fetch posts for */
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel(s) to fetch posts for */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate: Scalars['Int']['input'];
  /** Whether or not to include posts with status set to 'draft' */
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The span of time for each group of posts */
  intervalSize?: InputMaybe<IntervalSize>;
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate: Scalars['Int']['input'];
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String']['input'];
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a span of time in the calendar which may or may not contain post items.
 * The length of the interval is configured by the intervalLength passed to the query.
 */
export type CalendarInterval = {
  __typename?: 'CalendarInterval';
  /** A human readable label for the start of the interval, e.g., '2 PM' or '14:00' */
  label: Scalars['String']['output'];
  /** A list of posts within this interval */
  posts?: Maybe<Array<PublishingPost>>;
  /** A unix timestamp representing the beginning of the interval */
  startTimestamp: Scalars['Int']['output'];
};

/** Input to fetch a single post by id */
export type CalendarPostInput = {
  /** The id of the post to fetch */
  id: Scalars['ID']['input'];
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String']['input'];
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime: Scalars['Boolean']['input'];
};

export type CalendarsPayload = Calendar | PublishingError;

export type CanMigrateToOneBuffer = {
  __typename?: 'CanMigrateToOneBuffer';
  /** Whether the organization is eligible to be migrated to One Buffer */
  canMigrate: Scalars['Boolean']['output'];
  /** Reasons why canMigrate resolved to false. It will be an empty array otherwise. */
  reasons: Array<Maybe<Scalars['String']['output']>>;
  /** Subscription discount information used in the migration process */
  subscriptionDiscount?: Maybe<Discount>;
};

/** input for cancelTrial mutation */
export type CancelTrialInput = {
  /** Id of organization on the trial. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** cancelTrial response payload. */
export type CancelTrialPayload = CancelTrialResponse | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response for successful cancelTrial mutation */
export type CancelTrialResponse = MutationSuccess & {
  __typename?: 'CancelTrialResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Channel entity */
export type Channel = {
  __typename?: 'Channel';
  /**
   * The level of permissions a user has for a channel.
   * Only use for communication purposes.
   * To make decision about specific action a user can take, please use Post.allowedActions or Note.allowedActions.
   * If the entity you work with doesn't have allowedActions, please implement that pattern.
   * Source: field resolver
   * Defined in: new proposal
   */
  accessLevel: ChannelAccessLevel;
  /**
   * The allowed actions for the current user
   * Source: field resolver
   * Defined in: new proposal
   */
  allowedActions: Array<ChannelAction>;
  /**
   * A collection of timestamps with related to analytics ingestion for the channel or for the channel updates
   * Source: mapper from channel collection - channel.analytics
   * Defined in: current implementation
   */
  analytics?: Maybe<ChannelAnalyticsMetadata>;
  /**
   * The version of the third-party API used by the channel - null if we don't track the version on the backend
   * Source: mapper from channel collection - channel.credentials.apiVersion
   * Defined in: current implementation
   */
  apiVersion?: Maybe<Scalars['String']['output']>;
  /**
   * The avatar URL of the channel
   * Source: mapper from channel collection - channel.avatar
   * Defined in: both proposals
   */
  avatar: Scalars['String']['output'];
  /**
   * Indicates if banners should be shown - often tied to using an old version of the API
   * Source: mapper from channel collection data
   * Defined in: new proposal
   */
  banners: Array<ChannelBanner>;
  /**
   * Indicates if the user can publish the start page
   * Source: field resolver - legacy query.resolver
   * Defined in: current implementation
   * @deprecated Use allowedActions instead
   */
  canPublishStartPage: Scalars['Boolean']['output'];
  /**
   * The creation date of the channel
   * Source: mapper from channel collection - channel.createdAt
   * Defined in: both proposals
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Formatted name of the channel service and type: e.g. 'Twitter Profile' or 'Facebook Page'
   * Source: mapper from channel collection - channel.service and channel.type
   * Defined in: current implementation
   */
  descriptor: Scalars['String']['output'];
  /**
   * The display name of the channel - nullable (reason?)
   * Source: mapper from channel collection - channel.displayName
   * Defined in: current implementation
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The channel's URL on the social network (e.g. instagram.com/username or facebook.com/page)
   * Source: field resolver
   * Returns null if the channel is not supported
   */
  externalLink?: Maybe<Scalars['String']['output']>;
  /**
   * Whether at least one member of the orginization who have access to this channel
   * also has a user device registered for push notifications
   */
  hasActiveMemberDevice: Scalars['Boolean']['output'];
  /**
   * The ID of the channel
   * Source: mapper from channel collection - channel._id
   * Defined in: both proposals
   */
  id: Scalars['ChannelId']['output'];
  /**
   * Indicates if the channel is properly connected to Buffer
   * Source: mapper from channel collection - channel.credentials.invalid
   * Defined in: both proposals
   */
  isDisconnected: Scalars['Boolean']['output'];
  /**
   * Indicates if the channel is locked - Locked channels can't be used for posting.
   * A channel can be locked when the organization downgrades and reduces the channel quantity of their plan.
   * Source: mapper from channel collection - channel.isLocked
   * Defined in: both proposals
   */
  isLocked: Scalars['Boolean']['output'];
  /**
   * Indicates if the channel was recently created (in less than 10 seconds). This is used to determine the redirect modal after channel authorization
   * Source: mapper from channel collection - channel.createdAt comparison with current time
   * Defined in: current implementation
   */
  isNew: Scalars['Boolean']['output'];
  /**
   * Indicates is the queue is paused for the channel. A paused queue means schedules posts won't be published.
   * Source: Field resolver - From profiles collection - profile.paused
   * Defined in: new proposal
   */
  isQueuePaused: Scalars['Boolean']['output'];
  /** Link Shortening settings for the channel */
  linkShortening: ChannelLinkShortening;
  /**
   * Metadata about the location of the business associated with the channel. Only available for Facebook and GPB
   * Source: mapper from channel collection - channel.locationData
   * Defined in: current implementation
   * @deprecated Use metadata instead
   */
  locationData?: Maybe<LocationData>;
  /**
   * Metadata or settings depending on the service type - such as the server URL for Mastodon or Location data for Facebook/GPB
   * Source: Field resolver - From channel collection: channel.locationData + channel.serverURL | profile collection: profile.default_to_reminder
   * Defined in: new proposal
   */
  metadata?: Maybe<ChannelMetadata>;
  /**
   * The name of the channel - the handle name, username, etc.
   * Source: mapper from channel collection - channel.name
   * Defined in: both proposals
   */
  name: Scalars['String']['output'];
  /**
   * Data Loader is not applied here so we risk having a n+1 query if we fetch this field for a set of channels
   * Source: field resolvers in legacy query.resolver
   * Defined in: current implementation
   * @deprecated only used internally - we don't want to promote for public API
   */
  organization?: Maybe<ChannelOrganization>;
  /**
   * The organization ID of the channel
   * Source: mapper from channel collection - channel.organizationId
   * Defined in: both proposals
   */
  organizationId: Scalars['OrganizationId']['output'];
  /** The posting goal for the channel */
  postingGoal?: Maybe<PostingGoal>;
  /**
   * Provides the posting slots for each day of the week
   * Source: field resolver based on profiles collection - getPostingSchedule
   */
  postingSchedule: Array<ScheduleV2>;
  /** Products that support a given channel */
  products?: Maybe<Array<Product>>;
  /**
   * Scopes requested for a given channel - empty array if we don't have them tracked
   * Source: mapper from channel collection - channel.credentials.scopes
   * Defined in: current implementation
   */
  scopes: Array<Maybe<Scalars['String']['output']>>;
  /**
   * The instance of mastodon of the channel
   * Source: mapper from channel collection - channel.serverUrl
   * Defined in: current implementation
   * @deprecated Use metadata instead
   */
  serverUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Represents the social network
   * Source: mapper from channel collection - channel.serviceType
   * Defined in: both proposals
   */
  service: Service;
  /**
   * Similar to metadata - Deprecated
   * Source: mapper from channel collection - channel.serviceData
   * Defined in: current implementation
   * @deprecated use metadata (TwitterMetadata) instead
   */
  serviceData?: Maybe<ServiceData>;
  /**
   * Represents the external ID of the channel on social network API
   * Source: mapper from channel collection - channel.serviceId
   * Defined in: both proposals
   */
  serviceId: Scalars['String']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowLinkedInUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowPinterestUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowTiktokUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * The timezone of the channel - Default if not set is Europe/London
   * Source: field resolver based on profiles collection - timezone
   * Defined in: both proposals
   */
  timezone: Scalars['String']['output'];
  /**
   * The type of the channel - Page, Profile, Business, Group, Account, etc.
   * Source: mapper from channel collection - channel.type
   * Defined in: both proposals
   */
  type: ChannelType;
  /**
   * The last time the channel was updated
   * Source: mapper from channel collection - channel.updatedAt
   * Defined in: both proposals
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Weekly posting limit for the channel
   * @deprecated This field is not used anymore
   */
  weeklyPostingLimit?: Maybe<WeeklyPostingLimit>;
};

/**
 * The level of permissions a user has for a channel.
 * Only use for communication purposes.
 * To make decision about specific action a user can take, please use Post.allowedActions or Note.allowedActions.
 * If the entity you work with doesn't have allowedActions, please implement that pattern.
 */
export type ChannelAccessLevel =
  | 'fullPosting'
  | 'none'
  | 'requiresApproval';

/** List of possible actions that can be performed on a Channel */
export type ChannelAction =
  | 'publishStartPage';

export type ChannelAnalyticsLastUpdateAtPayload = Error | Response;

/** List of analytics timestamp used to track the last time the channel was checked for updates/posts */
export type ChannelAnalyticsMetadata = {
  __typename?: 'ChannelAnalyticsMetadata';
  /** Timestamp of the last time the channel succesfully collected channel analytics */
  channelLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel succesfully collected post analytics */
  postsLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was checked for update/post analytics */
  updatesLastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was checked for collecting new updates/posts */
  updatesLastCollectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChannelAuthorizationError = {
  __typename?: 'ChannelAuthorizationError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelAuthorizationErrorType =
  | 'noChannelsError'
  | 'notEnoughPermissions'
  | 'stealingNotAllowed'
  | 'undefinedError';

/** Input for getting the authorization info for a network. */
export type ChannelAuthorizationInfoInput = {
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelAuthorizationInfoMetadata>;
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to authorize. */
  service: Service;
};

/** Metadata for Channel Authorization for different services */
export type ChannelAuthorizationInfoMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
};

/** The response with authorization info for a network. */
export type ChannelAuthorizationInfoResponse = {
  __typename?: 'ChannelAuthorizationInfoResponse';
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['output'];
  /** The state token used for the authorization URL */
  state: Scalars['String']['output'];
  /** The URL to use to authorize the channel. */
  url: Scalars['String']['output'];
};

export type ChannelAuthorizationInput = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  service: Service;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Instagram API to be used for authorization */
export type ChannelAuthorizationInstagramApi =
  /** Facebook Login API - used for business and creator accounts, with all features */
  | 'facebookLogin'
  /** Instagram Login API - used for business and creator accounts, with limited features */
  | 'instagramLogin';

/** Instagram metadata for Channel Authorization */
export type ChannelAuthorizationInstagramMetadata = {
  /** Method of authorization used for IG Auth */
  apiVersion: ChannelAuthorizationInstagramApi;
};

/** Mastodon metadata for Channel Authorization */
export type ChannelAuthorizationMastodonMetadata = {
  /** Follow Buffer in the mastodon.social instance */
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Mastodon server to be used for connection */
  server: Scalars['String']['input'];
};

export type ChannelAuthorizationPayload = ChannelAuthorizationError | ChannelAuthorizationResponse;

export type ChannelAuthorizationResponse = {
  __typename?: 'ChannelAuthorizationResponse';
  channel: Channel;
  /** @deprecated deprecated in favor of returning a channel */
  success: Scalars['Boolean']['output'];
};

/** Twitter metadata for Channel Authorization */
export type ChannelAuthorizationTwitterMetadata = {
  /** The Twitter oauth_verifier token to be used for getting the credentials */
  codeVerifier: Scalars['String']['input'];
};

export type ChannelAuthorizationUrlError = {
  __typename?: 'ChannelAuthorizationUrlError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelAuthorizationUrlInput = {
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
  service: Service;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelAuthorizationUrlPayload = ChannelAuthorizationUrlError | ChannelAuthorizationUrlResponse;

export type ChannelAuthorizationUrlResponse = {
  __typename?: 'ChannelAuthorizationUrlResponse';
  url: Scalars['String']['output'];
};

/** Allows the backfilling of posts and analytics for a given channel */
export type ChannelBackfillInput = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The list of channel banners that we currently support */
export type ChannelBanner =
  | 'linkedinUpgrade'
  | 'pinterestUpgrade'
  | 'tiktokUpgrade';

/** Options that define how the service should be grouped */
export type ChannelCategory =
  | 'creator'
  | 'ecommerce'
  | 'small_business';

export type ChannelConnectionAvailability = {
  __typename?: 'ChannelConnectionAvailability';
  connectionAvailability: ConnectionAvailability;
  service: Service;
  serviceId: Scalars['String']['output'];
};

/** Channel Authorization error when a channel cannot be stolen */
export type ChannelConnectionCannotStealChannelError = MutationError & {
  __typename?: 'ChannelConnectionCannotStealChannelError';
  /** The error message */
  message: Scalars['String']['output'];
};

export type ChannelConnectionInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: ChannelCredentialsInput;
  service: Service;
  serviceId: Scalars['String']['input'];
};

/** Input for listing the channels of a service. */
export type ChannelConnectionListInput = {
  /** The code to be used to exchange the access_token. */
  code: Scalars['String']['input'];
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelConnectionListMetadata>;
  /** The organization ID to list the channels. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to list the channels from. */
  service: Service;
};

/** Input for metadata for Channel Connection List */
export type ChannelConnectionListMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
  /** Twitter metadata for Channel Authorization */
  twitterMetadata?: InputMaybe<ChannelAuthorizationTwitterMetadata>;
};

/** The payload of the response from ChannelConnectionList */
export type ChannelConnectionListPayload = ChannelConnectionListResponse | ChannelConnectionNoChannelsError | UnauthorizedError | UnexpectedError;

/** The response with the list of channels fetch from the service. */
export type ChannelConnectionListResponse = {
  __typename?: 'ChannelConnectionListResponse';
  /** The list of channels */
  channels: Array<ConnectableChannel>;
};

/** Channel Authorization error when there are no channels found */
export type ChannelConnectionNoChannelsError = MutationError & {
  __typename?: 'ChannelConnectionNoChannelsError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** Input for reconnecting the channels of a service. */
export type ChannelConnectionRefreshInput = {
  /** The code to be used to exchange the access_token. */
  code: Scalars['String']['input'];
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelConnectionRefreshMetadata>;
  /** The organization ID to reconnect the service. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to reconnect. */
  service: Service;
};

/** Input for metadata for Channel Authorization Reconnect */
export type ChannelConnectionRefreshMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
  /** Twitter metadata for Channel Authorization */
  twitterMetadata?: InputMaybe<ChannelAuthorizationTwitterMetadata>;
};

/** The payload of the response from ChannelConnectionRefresh */
export type ChannelConnectionRefreshPayload = ChannelConnectionCannotStealChannelError | ChannelConnectionNoChannelsError | ChannelConnectionRefreshResponse | ChannelConnectionRefreshWrongAccountError | UnauthorizedError | UnexpectedError;

/** The response with the list of channels that were reconnected. */
export type ChannelConnectionRefreshResponse = {
  __typename?: 'ChannelConnectionRefreshResponse';
  /** The list of channels that were reconnected. */
  channels: Array<Channel>;
};

export type ChannelConnectionRefreshWrongAccountError = MutationError & {
  __typename?: 'ChannelConnectionRefreshWrongAccountError';
  /** Channel that exist on network but are not connected to Buffer */
  channel: BasicChannelInfo;
  /** The error message */
  message: Scalars['String']['output'];
};

/** The current connection status of the service */
export type ChannelConnectionStatus = {
  __typename?: 'ChannelConnectionStatus';
  /** An optional message to be displayed when the ConnectionStatus is of the `disabled` type */
  message?: Maybe<Scalars['String']['output']>;
  /** The connection status of a service */
  status: ConnectionStatus;
};

export type ChannelCredentials = {
  __typename?: 'ChannelCredentials';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  accessTokenSecret?: Maybe<Scalars['String']['output']>;
  invalid?: Maybe<Scalars['Boolean']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharedAccessToken?: Maybe<Scalars['String']['output']>;
  sharedAccessTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharedOwner?: Maybe<Scalars['String']['output']>;
};

export type ChannelCredentialsInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  accessTokenSecret?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedAccessToken?: InputMaybe<Scalars['String']['input']>;
  sharedAccessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedOwner?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelData = {
  __typename?: 'ChannelData';
  googlebusiness?: Maybe<GoogleBusinessData>;
  instagram?: Maybe<InstagramData>;
  linkedin?: Maybe<LinkedinData>;
  pinterest?: Maybe<PinterestData>;
  startPage?: Maybe<StartPageData>;
  threads?: Maybe<ThreadsData>;
  youtube?: Maybe<YoutubeData>;
};

/** A group of channels that can be managed together. */
export type ChannelGroup = {
  __typename?: 'ChannelGroup';
  /** ID of the account that owns this channel group */
  accountId: Scalars['AccountId']['output'];
  /** The number of channels in the channel group, regardless of the limit set on the channel group */
  channelCount: Scalars['Int']['output'];
  /** The channels that are part of the Channel Group. Sorted */
  channels?: Maybe<Array<Channel>>;
  /** The date and time the channel group was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the channel group */
  id: Scalars['ChannelGroupId']['output'];
  /** Display name of the channel group */
  name: Scalars['String']['output'];
  /** ID of the organization this channel group belongs to */
  organizationId: Scalars['OrganizationId']['output'];
  /** The date and time the channel group was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for fetching a single channel group */
export type ChannelGroupInput = {
  /** The channel group ID */
  id: Scalars['ChannelGroupId']['input'];
};

/** Channel Group Query Payload: Success and errors */
export type ChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Response for channel group query */
export type ChannelGroupResponse = {
  __typename?: 'ChannelGroupResponse';
  /** The channel group */
  channelGroup: ChannelGroup;
};

/** Input for fetching all channel groups for an account in the organization */
export type ChannelGroupsInput = {
  /** The account for which the user fetches the channel groups */
  accountId: Scalars['AccountId']['input'];
  /** The limit of the channel groups to fetch */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The organization for which the user fetches the channel groups */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Channel Groups Query Payload: Success and errors */
export type ChannelGroupsPayload = ChannelGroupsResponse | UnauthorizedError | UnexpectedError;

/** Response for channel groups query */
export type ChannelGroupsResponse = {
  __typename?: 'ChannelGroupsResponse';
  /** The channel groups */
  channelGroups: Array<ChannelGroup>;
};

export type ChannelIngestionType =
  | 'channel'
  | 'posts';

/** Input for the channel query */
export type ChannelInput = {
  /** The ID of the channel to be retrieved */
  id: Scalars['ChannelId']['input'];
};

export type ChannelLimitError = {
  __typename?: 'ChannelLimitError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
};

/** Settings for link shortening */
export type ChannelLinkShortening = {
  __typename?: 'ChannelLinkShortening';
  /** Configuration of link shortening integration. Null if disabled. */
  config?: Maybe<LinkShorteningConfig>;
  /** If link shortening is enabled for the channel */
  isEnabled: Scalars['Boolean']['output'];
};

/** The payload of the response from updateChannelLinkShortening */
export type ChannelLinkShorteningPayload = ChannelLinkShortening | NotFoundError | UnauthorizedError | UnexpectedError;

export type ChannelLocationData = {
  __typename?: 'ChannelLocationData';
  location?: Maybe<Scalars['String']['output']>;
  mapsLink?: Maybe<Scalars['String']['output']>;
};

/** Metadata or settings about the channel depending on the service type */
export type ChannelMetadata = BlueskyMetadata | FacebookMetadata | GoogleBusinessMetadata | InstagramMetadata | LinkedInMetadata | MastodonMetadata | PinterestMetadata | TwitterMetadata;

export type ChannelMutationResponse = ChannelResponse | Error;

export type ChannelNativeService =
  | 'startPage';

/** Subset of the Organization type - only used internally to reduce the number of GraphQL queries - should not be used in public API */
export type ChannelOrganization = {
  __typename?: 'ChannelOrganization';
  /** Account ID of the "main" admin */
  contactAccountId: Scalars['String']['output'];
  /** List of entitlements for the organization */
  entitlements: Array<Maybe<Entitlement>>;
  /** The ID of the organization */
  id: Scalars['OrganizationId']['output'];
};

/** Error returned when the channel needs a refresh */
export type ChannelRefreshRequired = MutationError & {
  __typename?: 'ChannelRefreshRequired';
  /** ChannelIds that need refreshing */
  channelIds: Array<Scalars['ChannelId']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

export type ChannelResponse = {
  __typename?: 'ChannelResponse';
  channel: Channel;
  success: Scalars['Boolean']['output'];
};

export type ChannelServiceDataInput = {
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelSlotDetails = {
  __typename?: 'ChannelSlotDetails';
  /** The number of channels purchased that the customer will pay a per unit amount. For non Agency plans that will be equal to currentQuantity */
  chargableQuantity: Scalars['Int']['output'];
  /** The number of channels purchased for this subscription. */
  currentQuantity: Scalars['Int']['output'];
  /** Fixed amount for the plan. It will contain a non 0 value only for the Agency plan */
  flatFee: Scalars['Float']['output'];
  /** The lowest value that the quantity can have for the specific subscription. It will be 1 for all plans except for Agency, where it will be 10. */
  minimumQuantity: Scalars['Int']['output'];
  /** The price that a customer will pay for every chargableQuantity */
  pricePerQuantity: Scalars['Float']['output'];
};

export type ChannelStoreTemporaryCredentialsResponse = Error | Response;

export type ChannelThirdPartyService =
  | 'bluesky'
  | 'facebook'
  | 'googlebusiness'
  | 'instagram'
  | 'linkedin'
  | 'mastodon'
  | 'pinterest'
  | 'threads'
  | 'tiktok'
  | 'twitter'
  | 'youtube';

/** Channel is a representation of a social media account or page that can be connected to Buffer. */
export type ChannelType =
  | 'account'
  | 'business'
  | 'channel'
  | 'group'
  | 'page'
  | 'profile';

export type ChannelUpdateCredentialsInput = {
  credentials: ChannelCredentialsInput;
  service: Service;
  serviceIds: Array<Scalars['String']['input']>;
};

export type ChannelUpdateLockedStatusInput = {
  channelId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
};

export type ChannelUpdateLockedStatusResponse = ChannelLimitError | Error | Response;

export type ChannelWithCredentialsInput = {
  avatar: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials?: InputMaybe<ChannelCredentialsInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  locationData?: InputMaybe<LocationDataInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  /** Channels are now linked to a single Buffer product by default. This field will be removed on the 29th September */
  products?: InputMaybe<Array<Product>>;
  serverUrl?: InputMaybe<Scalars['String']['input']>;
  service: ChannelThirdPartyService;
  serviceData?: InputMaybe<ChannelServiceDataInput>;
  serviceId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: ChannelType;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChannelsConnectError = {
  __typename?: 'ChannelsConnectError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelsConnectPayload = ChannelsConnectError | ChannelsConnectResponse;

export type ChannelsConnectResponse = {
  __typename?: 'ChannelsConnectResponse';
  channels: Array<Channel>;
};

/** Filter to pass when fetching channels. */
export type ChannelsFiltersInput = {
  /**
   * If not defined, it returns all channels
   * Else,
   *   if true, it only returns locked channels
   *   if false, it only returns not locked channels
   */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If not passed, it return all channels
   * Else, it filters the channels based on what the product supports.
   */
  product?: InputMaybe<Product>;
};

/** Input to pass when fetching channels. */
export type ChannelsInput = {
  /** A list of option filters - passing null means we don't want to filter */
  filter?: InputMaybe<ChannelsFiltersInput>;
  /** The Organization id to fetch channels for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type ChannelsSetRecommendationsError = {
  __typename?: 'ChannelsSetRecommendationsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelsSetRecommendationsPayload = ChannelsSetRecommendationsError | ChannelsSetRecommendationsResponse;

export type ChannelsSetRecommendationsResponse = {
  __typename?: 'ChannelsSetRecommendationsResponse';
  success: Scalars['Boolean']['output'];
};

export type ChannelsUpdateCredentialsResponse = Error | Response;

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Float']['output'];
  amountAvailableForRefund: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  amountRefunded: Scalars['Float']['output'];
  canBeRefunded: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  /** 'isRefunded' will only be true if the charge was fully refunded. It will remain false for partial refunds */
  isRefunded: Scalars['Boolean']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: ChargeStatus;
};

export type ChargeStatus =
  | 'failed'
  | 'pending'
  | 'succeeded';

/** Query responses */
export type Checklist = {
  __typename?: 'Checklist';
  id: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
  title: Scalars['String']['output'];
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
};

export type ChecklistsPayload = ChecklistsResponse | CoreWebAppCommonError;

export type ChecklistsResponse = {
  __typename?: 'ChecklistsResponse';
  checklists?: Maybe<Array<Maybe<Checklist>>>;
};

export type ChildBlockConfigInput = {
  data?: InputMaybe<BlockDataInput>;
  parentBlockId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StartPageBlockTypes>;
};

/** Client response returned by the client query, containing configuration details for the client making the request */
export type Client = {
  __typename?: 'Client';
  supportStatus: ClientSupportStatus;
};

/** Error response returned when there is a problem retrieving the information for a client */
export type ClientError = {
  __typename?: 'ClientError';
  cause: Scalars['String']['output'];
};

export type ClientInput = {
  platform: ClientPlatform;
  version: Scalars['String']['input'];
};

/** Payload response returned by the client query */
export type ClientPayload = Client | ClientError;

/** The platform that the client is being used on */
export type ClientPlatform =
  | 'android'
  | 'ios'
  | 'web';

/** Specifies the support status of a client, along with an (optional) reason as to why that client might not be supported */
export type ClientSupportStatus = {
  __typename?: 'ClientSupportStatus';
  reason?: Maybe<Scalars['String']['output']>;
  status: SupportStatus;
};

export type Comment = {
  __typename?: 'Comment';
  attachment?: Maybe<Attachment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Error>;
  from?: Maybe<From>;
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  needsAttention?: Maybe<Scalars['Boolean']['output']>;
  replies?: Maybe<Array<Maybe<Reply>>>;
  repliesNeedsAttention?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AllowedCommentsStatuses>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Represents the author of a comment. */
export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The default avatar settings of the author. */
  defaultAvatarSettings?: Maybe<DefaultAvatarSettings>;
  /** The name of the author. */
  name?: Maybe<Scalars['String']['output']>;
  /** The username of the author. */
  username: Scalars['String']['output'];
};

/** Input for the comment context query */
export type CommentContextInput = {
  /** The comment id to fetch context for */
  commentId: Scalars['CommentId']['input'];
};

/** Response for the comment context query */
export type CommentContextResponse = {
  __typename?: 'CommentContextResponse';
  /** Original comment */
  comment: CommentData;
  /**
   * Array of comments parents of the input comment.
   * Empty array if the input comment is a root comment.
   */
  context?: Maybe<Array<CommentData>>;
};

/** A Comment can be a Comment received from a Third Party or a Comment sent by Buffer */
export type CommentData = CommentFromBuffer | CommentFromThirdParty;

/** The different status for a comment sent by Buffer */
export type CommentEngagementStatusTypes =
  /** Comment created but not sent yet to the third party */
  | 'draft'
  /** The publishing process failed */
  | 'error'
  /** The publishing process is in progress */
  | 'processing'
  /** The publishing process succeded */
  | 'published';

/**
 * Describes a comment sent by Buffer where we need to track the publishing
 * process status.
 * publishedAt and publicUrl are optional as the publishing process could fail.
 */
export type CommentFromBuffer = BaseComment & {
  __typename?: 'CommentFromBuffer';
  /** BaseComment: Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** BaseComment: Information about the author of the comment. */
  author: CommentAuthor;
  /** BaseComment:  Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** BaseComment:  The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** BaseComment: ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** BaseComment: Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * BaseComment: Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** BaseComment: Last Reply to this comment. */
  lastReply?: Maybe<LastReply>;
  /** BaseComment: Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * BaseComment: Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** BaseComment: The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * BaseComment: The timestamp when this comment was created on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Describes the status of a comment sent by Buffer to third party
   * and potential errors.
   */
  publishingStatus: PublishingStatus;
  /**
   * BaseComment: The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** BaseComment: The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** BaseComment: The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * BaseComment: The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** BaseComment: The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Describes a comment received from a third-party. We'll add labels, sentimentAnalysis
 * and suggestions during the ingestion process.
 */
export type CommentFromThirdParty = BaseComment & {
  __typename?: 'CommentFromThirdParty';
  /** BaseComment: Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** BaseComment: Information about the author of the comment. */
  author: CommentAuthor;
  /** BaseComment:  Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** BaseComment:  The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** BaseComment: ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** BaseComment: Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * BaseComment: Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Labels assigned to the comment. e.g. question, negativity */
  labels: Array<CommentLabel>;
  /** BaseComment: Last Reply to this comment. */
  lastReply?: Maybe<LastReply>;
  /** BaseComment: Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * BaseComment: Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** BaseComment: The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * BaseComment: The timestamp when this comment was created on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * BaseComment: The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /**
   * Sentiment analysis results for the comment. It could contain detailed
   * information related to the label assigned to the comment.
   * It is optional because it won't calculated in all the cases.
   */
  sentimentAnalysis?: Maybe<Array<SentimentAnalysis>>;
  /** BaseComment: The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** BaseComment: The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /** Suggested actions or responses for the comment. */
  suggestions: Array<Suggestion>;
  /**
   * BaseComment: The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** BaseComment: The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Labels that can be assigned to a comment. */
export type CommentLabel =
  /** The comment contains negative sentiment. */
  | 'negative'
  /** The comment doesn't contain negative or positive sentiment. */
  | 'neutral'
  /** The comment contains positive sentiment. */
  | 'positive'
  /** The comment is a question. */
  | 'question'
  /** The author of the comment is a super fan */
  | 'superfan';

/** We support only the "rich" type for now. */
export type CommentOEmbed = OEmbedRich;

/** The comments score broken down to its individual score metrics, responseRate, responseSpeed, consistency */
export type CommentScoreDetailed = {
  __typename?: 'CommentScoreDetailed';
  /**
   * The consistency of comments
   * maximum value is 20
   */
  consistency: CommentsScoreMetric;
  /**
   * The response rate of comments
   * maximum value is 50
   */
  responseRate: CommentsScoreMetric;
  /**
   * The response speed of comments
   * maximum value is 30
   */
  responseSpeed: CommentsScoreMetric;
  /** The total value of the comments score. Maximum value is 100. */
  totalValue: Scalars['Int']['output'];
};

/** Fields that can be used to sort comments. */
export type CommentSortableKey =
  /** Sort comments based on their published timestamp. */
  | 'publishedAt';

/** Possible statuses of a comment. */
export type CommentStatus =
  /** The comment has been dismissed. */
  | 'dismissed'
  /**
   * new is not a real status but it's considered as a status here for simplicity
   * a new comment is an unreplied one received in the last 48 hours and not seen by the user
   */
  | 'new'
  /** The comment has received a reply. */
  | 'replied'
  /** The comment is being replied to. */
  | 'replying'
  /** The comment has not been replied to. */
  | 'unreplied';

/**
 * Suggestions source: currently, they could be generated by AI or from a kind
 * of template
 */
export type CommentSuggestionSource =
  /** Suggestions generated by AI */
  | 'ai'
  /** Suggestions selected from a file with fixed suggestions */
  | 'template';

/** Input for the commentSuggestions query */
export type CommentSuggestionsInput = {
  /** The comment id to fetch suggestions for */
  commentId: Scalars['CommentId']['input'];
  /** Whether to regenerate the suggestions, false by default */
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for the quick replies generated by the AI */
export type CommentSuggestionsResponse = {
  __typename?: 'CommentSuggestionsResponse';
  /** List of suggestions for the comment */
  suggestions: Array<Suggestion>;
};

/** Input for the comment thread query */
export type CommentThreadInput = {
  /** The comment id to fetch thread for */
  commentId: Scalars['CommentId']['input'];
};

/** Response for the comment thread query */
export type CommentThreadResponse = {
  __typename?: 'CommentThreadResponse';
  /** The thread of the comment */
  thread: Array<CommentData>;
};

/** Comments Count for a channel */
export type CommentsCount = {
  __typename?: 'CommentsCount';
  /** The id of the channel if a channelId list was provided as input */
  channelId: Scalars['ChannelId']['output'];
  /** The count of comments that satisfies the filters */
  count: Scalars['Int']['output'];
  /**
   * This field is used by the BE to limit the results in the DB query
   * when the query fails due to a time out.
   * BE will return the used limit to the FE and the FE will have to handle it
   * to get the remaining data.
   */
  limit: Scalars['Int']['output'];
};

/** Filters for the comments count query */
export type CommentsCountsFiltersInput = {
  /**
   * When set, it will filter comments by channel.
   * If not provided, query will return count for the organization
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The sentiment of comments to return: Labels are question, negativity, etc. */
  label?: InputMaybe<CommentLabel>;
  /** The postId to fetch comments for */
  postId?: InputMaybe<Array<Scalars['PostId']['input']>>;
  /**
   * When set, it will filter comments by the date they were published.
   * DateTimeComprator is a range filter with a start and end date.
   */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /**
   * When set, it will filter comments by status: new, replied, unreplied, dismissed
   * new is not a real status but it's considered as a status here for simplicity
   */
  status?: InputMaybe<Array<CommentStatus>>;
};

/** Input for the comments count query */
export type CommentsCountsInput = {
  /** The filters to apply to the comments query */
  filters?: InputMaybe<CommentsCountsFiltersInput>;
  /** The Organization id to fetch comments counts for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Query Response */
export type CommentsCountsResponse = {
  __typename?: 'CommentsCountsResponse';
  /** list of counts */
  counts: Array<CommentsCount>;
};

/** Represents a single comment and its pagination cursor. */
export type CommentsEdge = {
  __typename?: 'CommentsEdge';
  /** A unique identifier (cursor) for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual comment data. */
  node: CommentData;
};

/** Fields that can be used to filter comments. */
export type CommentsFiltersInput = {
  /** The channel(s) ids to fetch comments for */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The sentiment of comments to return */
  label?: InputMaybe<CommentLabel>;
  /** The postId to fetch comments for */
  postId?: InputMaybe<Array<Scalars['PostId']['input']>>;
  /** When set, it will filter comments by the date they were published */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /** When set, it will filter comments by status: new, replied, unreplied, dismissed */
  status?: InputMaybe<Array<CommentStatus>>;
};

/** Input for the comments query */
export type CommentsInput = {
  /** The filters to apply to the comments query */
  filters?: InputMaybe<CommentsFiltersInput>;
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * The preferred option to sort the comments query results.
   *    default: newestFirst if no provided
   */
  sort?: InputMaybe<Array<CommentsSortInput>>;
};

/** Input for the comments insights query */
export type CommentsInsightsInput = {
  /** The channel id to fetch comments for */
  channelId: Scalars['ChannelId']['input'];
  /** The prompt to fetch comments for */
  prompt: Scalars['String']['input'];
};

/** Response for the comments insights query */
export type CommentsInsightsResponse = {
  __typename?: 'CommentsInsightsResponse';
  /** The insights for the given channel and prompt */
  insights: Scalars['String']['output'];
};

/** Input based on the oEmbed specification plus a required channelId for internal use. */
export type CommentsOEmbedInput = {
  /** ID of the channel making the request. */
  channelId: Scalars['ChannelId']['input'];
  /** The maximum height of the embedded resource (in pixels). */
  maxheight?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum width of the embedded resource (in pixels). */
  maxwidth?: InputMaybe<Scalars['Int']['input']>;
  /** The URL to retrieve the oEmbed representation for. */
  url: Scalars['String']['input'];
};

/** The oEmbed response */
export type CommentsOEmbedResponse = {
  __typename?: 'CommentsOEmbedResponse';
  /** The oEmbed response object as specified by https://oembed.com/. */
  oEmbed: CommentOEmbed;
};

/** Represents a paginated list of comments. */
export type CommentsResults = {
  __typename?: 'CommentsResults';
  /** List of comment edges (each containing a comment and its cursor). */
  edges: Array<CommentsEdge>;
  /** Information about pagination, such as whether more results are available. */
  pageInfo: PaginationPageInfo;
};

/** Input for the comments score query */
export type CommentsScoreInput = {
  /** The channel id to fetch comments for */
  channelId: Scalars['ChannelId']['input'];
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** The score metric for comments */
export type CommentsScoreMetric = {
  __typename?: 'CommentsScoreMetric';
  /** The percentage of the value for the given metric */
  percentage: Scalars['Int']['output'];
  /** The score value of the metric */
  value: Scalars['Int']['output'];
};

/**
 * The response for the comments score query containing the detailed score for the current week,
 * the previous week and the achievement level label for the current week.
 */
export type CommentsScoreResponse = {
  __typename?: 'CommentsScoreResponse';
  /**
   * An achievement level based on the current week score.
   * The potential values are: 'bronze', 'Newcomer', 'Responder', 'Conversationalist', 'EngagementPro', 'CommunityLeader'
   */
  currentAchievementLevel: Scalars['String']['output'];
  /** The score of comments for the current week */
  currentWeekScore: CommentScoreDetailed;
  /** The score of comments for the previous week */
  previousWeekScore: CommentScoreDetailed;
};

/** Fields and direction that can be used to sort comments. */
export type CommentsSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: CommentSortableKey;
};

export type CommonError = {
  __typename?: 'CommonError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CommonMutationError = MutationResponse & {
  __typename?: 'CommonMutationError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CommonMutationResponse = MutationResponse & {
  __typename?: 'CommonMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Common properties for all post metadata types */
export type CommonPostMetadata = {
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

export type CommonTrackingProperties = {
  __typename?: 'CommonTrackingProperties';
  atEventBillingCycle: BillingInterval;
  atEventBillingGateway: BillingGateway;
  atEventBillingPlan: Scalars['String']['output'];
  atEventBillingState: BillingState;
  atEventChannelQty: Scalars['Int']['output'];
  atEventIsNewBuffer: Scalars['Boolean']['output'];
};

/** Input for the completeEmailVerification mutation */
export type CompleteEmailVerificationInput = {
  /** JWT for new email to be verified, as a string */
  emailVerificationJWT: Scalars['String']['input'];
};

/** completeEmailVerification response payload */
export type CompleteEmailVerificationPayload = CompleteEmailVerificationSuccess | UnexpectedError;

/** success response for completeEmailVerification mutation */
export type CompleteEmailVerificationSuccess = {
  __typename?: 'CompleteEmailVerificationSuccess';
  /** Action which was triggered to start complete email verification */
  action: Scalars['String']['output'];
};

/** Input for the completeLoginVerification mutation */
export type CompleteLoginVerificationInput = {
  /** JWT to be verified, as a string */
  loginVerificationJWT: Scalars['String']['input'];
};

/**
 * Channel information returned from the service with connection availability.
 * TODO: create a base interface to avoid duplication with type Channel for common fields
 */
export type ConnectableChannel = {
  __typename?: 'ConnectableChannel';
  /** The avatar URL of the channel */
  avatar: Scalars['String']['output'];
  /** The connection availability of the channel */
  connectionAvailability: ConnectionAvailability;
  /** The display name of the channel - nullable (reason?) */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if the channel is locked - Locked channels can't be used for posting.
   * A channel can be locked when the organization downgrades and reduces the channel quantity of their plan.
   */
  isLocked: Scalars['Boolean']['output'];
  /**
   * Metadata about the location of the business associated with the channel. Only available for Facebook and GPB
   * @deprecated Use metadata instead
   */
  locationData?: Maybe<LocationData>;
  /** The name of the channel - the handle name, username, etc. */
  name: Scalars['String']['output'];
  /** The instance of mastodon of the channel */
  serverUrl?: Maybe<Scalars['String']['output']>;
  /** Represents the external ID of the channel on social network API */
  serviceId: Scalars['String']['output'];
  /** The type of the channel - Page, Profile, Business, Group, Account, etc. */
  type: ChannelType;
};

/** A service that can be connected to an Organization */
export type ConnectableService = {
  __typename?: 'ConnectableService';
  /** The target audience whose content that this service is intended for */
  audience?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of status */
  canConnect: Scalars['Boolean']['output'];
  /** Categories that define how the service should be grouped, this is used for filtering between grouped services */
  categories: Array<ChannelCategory>;
  /** The types of content that can be shared to this service */
  contentTypes: Array<ContentType>;
  /** Descriptive points about the service and its offerings (e.g what the service is used for) */
  description: Array<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of serviceStatus */
  isNew: Scalars['Boolean']['output'];
  /** Support links related to connecting this service */
  links?: Maybe<Array<HelpCenterLink>>;
  /** @deprecated all services belong to a single product */
  products: Array<Product>;
  /** The corresponding service that is being connected */
  service: Service;
  /** A remote URL representing the service logo */
  serviceIconUrl: Scalars['String']['output'];
  /** Global status for the service, defining it's availability within the Buffer product */
  serviceStatus: ServiceStatus;
  /** Other services that are similar to this one (such as similar content types being shared) */
  similarNetworks?: Maybe<Array<Service>>;
  /** Social proof (such as statistic) that demonstrate the success of this service */
  socialProof?: Maybe<Scalars['String']['output']>;
  /** Organization-level status for the service, defining it's availability for the current Organization */
  status: ChannelConnectionStatus;
  /** The subtitle, which will generally consist of the channel types or service offerings */
  subtitle: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  /** The title represents the name of the service being connected */
  title: Scalars['String']['output'];
  /** The type of channels that can be connected via this service */
  types: Array<ChannelType>;
};

/** The error response for connectable services */
export type ConnectableServicesError = {
  __typename?: 'ConnectableServicesError';
  cause: Scalars['String']['output'];
  userFriendlyMessage: Scalars['String']['output'];
};

/**
 * The input provided when requesting connectable services.
 * Note: This will be made non-optional soon, please migrate to provide it
 */
export type ConnectableServicesInput = {
  /**
   * The client the services are being connected from
   * Note: This will be made non-optional soon, please migrate to provide it
   */
  client?: InputMaybe<ClientPlatform>;
  /**
   * The organization ID that is to be connecting the services
   * Note: This will be made non-optional soon, please migrate to provide it
   */
  organization?: InputMaybe<Scalars['ID']['input']>;
};

/** The payload returned when requesting connectable services */
export type ConnectableServicesPayload = ConnectableServicesError | ConnectableServicesResponse;

/** The success response for connectable services */
export type ConnectableServicesResponse = {
  __typename?: 'ConnectableServicesResponse';
  /**
   * A list of services for connection.
   * Not all of these will be available for connection - use the ConnectableService to determine which services
   * can be connected by the Organization.
   */
  services: Array<ConnectableService>;
};

/** Connected App */
export type ConnectedApp = {
  __typename?: 'ConnectedApp';
  /** The id of the connectedApp. */
  clientId: Scalars['ID']['output'];
  /** The date and time when the connected app was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the connected app. */
  description: Scalars['String']['output'];
  /** The name of the connected app. */
  name: Scalars['String']['output'];
  /** The id of the user that has granted access to the app. */
  userId: Scalars['ID']['output'];
  /** The website URL of the connected app. */
  website: Scalars['String']['output'];
};

/**
 * Represents whether a channel can be connected or not.
 * - Available: can be connected (or stolen from the organization that owns it now).
 * - Unavailable: can not be connected because it's owned by an organization that we can't steal it from.
 * - Already connected: the current organization owns this channel already.
 */
export type ConnectionAvailability =
  | 'alreadyConnected'
  | 'available'
  | 'unavailable';

/** The connection status of a service */
export type ConnectionStatus =
  /** The service is available for connection and should be shown in the UI */
  | 'available'
  /** The service cannot be connected. It should still be shown in the UI, using the message from ChannelConnectionStatus to communicate why it is unavailable when the service is clicked. */
  | 'disabled'
  /**
   * The service is not available for connection and should not be shown to the user.
   * This would be due to the user not being on the split, or not having the entitlement to that service.
   */
  | 'unavailable';

/** The type of content feed */
export type ContentFeedType =
  /** News search */
  | 'NewsSearch'
  /** RSS or Atom feed */
  | 'RSSAtom';

/** Input Types */
export type ContentGenerationInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  previousGeneration?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
  variations?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentType =
  | 'analytics'
  | 'audience_insights'
  | 'engagement'
  | 'image'
  | 'link_tracking'
  | 'page_analytics'
  | 'pdf'
  | 'post_analytics'
  | 'reels'
  | 'shorts'
  | 'stories'
  | 'text'
  | 'threads'
  | 'video';

/** Input for converting custom channels, like Bluesky or FB Group */
export type ConvertCustomChannelInput = {
  /** Avatar of this channel */
  avatar: Scalars['String']['input'];
  /** ChannelId for the channel being converted */
  channelId: Scalars['ID']['input'];
  /** Display name for this channel */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Name for this channel */
  name: Scalars['String']['input'];
  /** Organization this channel will be connected to */
  organizationId: Scalars['ID']['input'];
  /** Service to convert to */
  service: ChannelThirdPartyService;
  /** ServiceId for the channelConnection that we convert to */
  serviceId: Scalars['String']['input'];
  /** Timezone used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Channel type to convert to */
  type: ChannelType;
};

/** Payload for convertCustomChannel mutation */
export type ConvertCustomChannelPayload = ConvertCustomChannelResponse | CustomChannelError;

/** The response for custom channel conversion */
export type ConvertCustomChannelResponse = {
  __typename?: 'ConvertCustomChannelResponse';
  /** Converted channel */
  channel: Channel;
};

/** Common error type to be used whenever no custom Error type needs to be created */
export type CoreWebAppCommonError = CoreWebAppError & {
  __typename?: 'CoreWebAppCommonError';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/** Base error interface used to implement custom error types */
export type CoreWebAppError = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/** Base mutation response interface used to implement custom mutation response types */
export type CoreWebAppMutationResponse = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type Counters = {
  __typename?: 'Counters';
  labelsCount?: Maybe<Array<Maybe<LabelCount>>>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalPendingComments?: Maybe<Scalars['Int']['output']>;
};

/** Bluesky-specific metadata for custom channel creation */
export type CreateBlueskyMetadata = {
  /** Bluesky account App Password */
  appPassword: Scalars['String']['input'];
  /** Should follow Buffer official profile on Bluesky */
  followBuffer: Scalars['Boolean']['input'];
  /** Bluesky account Handle (username) */
  handle: Scalars['String']['input'];
  /**
   * The server to be used for connection
   * @deprecated extracted from passed handle
   */
  server?: InputMaybe<Scalars['String']['input']>;
};

/** Input for createChannelGroup mutation */
export type CreateChannelGroupInput = {
  /** The account for which the user creates the Channel Group */
  accountId: Scalars['AccountId']['input'];
  /** The channels to be added to the group */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The name of the channel group */
  name: Scalars['String']['input'];
  /** The organization for which the user creates the Channel Group */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors */
export type CreateChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Input parameters required to create a new Checkout session */
export type CreateCheckoutSessionInput = {
  /** The attribution for the subscription */
  attribution?: InputMaybe<AttributionInput>;
  /** The interval of the plan to create the checkout session for */
  interval: BillingInterval;
  /** The ID of the organization for which to create the checkout session */
  organizationId: Scalars['OrganizationId']['input'];
  /** The plan to create the checkout session for */
  plan: ObPlanId;
  /** The quantity of the plan to create the checkout session for */
  quantity: Scalars['Int']['input'];
  /** The redirect URL for the checkout session */
  redirectUrl: Scalars['String']['input'];
};

/** Union type representing either a successful response with a checkout session URL or a billing error */
export type CreateCheckoutSessionPayload = BillingError | CreateCheckoutSessionResponse;

/** Response type for creating a Stripe Checkout session */
export type CreateCheckoutSessionResponse = {
  __typename?: 'CreateCheckoutSessionResponse';
  /** The url returned by Stripe as a redirect for success, failed, or cancelled session */
  redirectUrl: Scalars['String']['output'];
};

/** Channel-specific metadata for custom channel creation */
export type CreateCustomChannelMetadata = {
  /** Bluesky-specific metadata */
  blueskyMetadata?: InputMaybe<CreateBlueskyMetadata>;
  /** FB Group-specific metadata */
  facebookGroupMetadata?: InputMaybe<CreateFacebookGroupMetadata>;
  /** Instagram Personal Profiles-specific metada */
  instagramPersonalProfileMetadata?: InputMaybe<CreateInstagramPersonalProfileMetadata>;
};

/** Input for creating a custom channel */
export type CreateCustomChannelSingleInput = {
  /** Channel-specific metadata to use during creation */
  customChannelMetadata: CreateCustomChannelMetadata;
  /** Organization ID for channel connection */
  organizationId: Scalars['OrganizationId']['input'];
  /** Service for custom channel connection */
  service: ChannelThirdPartyService;
  /** Timezone to be used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Channel type for custom channel connection */
  type: ChannelType;
};

/** Input for creating custom channels, like Bluesky or FB Group */
export type CreateCustomChannelsInput = {
  /** List of channels to create */
  channels: Array<CreateCustomChannelSingleInput>;
};

/** Payload for createCustomChannels mutation */
export type CreateCustomChannelsPayload = CreateCustomChannelsResponse | CustomChannelError;

/** The response for custom channel connection */
export type CreateCustomChannelsResponse = {
  __typename?: 'CreateCustomChannelsResponse';
  /** Created channels */
  channels: Array<Channel>;
};

/** Input parameters required to create a new Customer Portal session */
export type CreateCustomerPortalSessionInput = {
  /** The ID of the organization for which to create the portal session */
  organizationId: Scalars['OrganizationId']['input'];
  /** The URL where the customer will be redirected after they complete their session in the portal */
  returnURL: Scalars['String']['input'];
};

/** Union type representing either a successful response with a portal URL or a billing error */
export type CreateCustomerPortalSessionPayload = BillingError | CreateCustomerPortalSessionResponse;

/** Response type for creating a Stripe Customer Portal session */
export type CreateCustomerPortalSessionResponse = {
  __typename?: 'CreateCustomerPortalSessionResponse';
  /**
   * The customer session url returned by Stripe.
   * This URL provides direct access to the Stripe Customer Portal where users can manage their billing settings.
   */
  customerPortalSessionUrl: Scalars['String']['output'];
};

/** Facebook Group-specific metadata for custom channel creation */
export type CreateFacebookGroupMetadata = {
  /** Avatar URL of this FB Group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this FB Group */
  name: Scalars['String']['input'];
  /** URL to FB Group's page */
  url: Scalars['String']['input'];
};

/** Input for creating a new failed post error. */
export type CreateFailedPostErrorInput = {
  /** Localized link to further information, if any. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Localized link text to display. */
  linkText?: InputMaybe<LocalizedTextInput>;
  /** The patterns that should be matched for this error. */
  patterns: Array<Scalars['String']['input']>;
  /** The position of the error message in the list of error messages. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The service that this error is associated with. */
  service?: InputMaybe<Service>;
  /** Localized text for the error message. */
  text: LocalizedTextInput;
};

/** Union type representing either a successful creation of a failed post error or an error */
export type CreateFailedPostErrorPayload = CreateFailedPostErrorSuccess | InvalidInputError | UnauthorizedError | UnexpectedError;

/** Payload for successfully creating a failed post error. */
export type CreateFailedPostErrorSuccess = {
  __typename?: 'CreateFailedPostErrorSuccess';
  /** The failed post error that was created. */
  failedPostError: FailedPostError;
};

/** Input for createFeedCollection mutation */
export type CreateFeedCollectionInput = {
  /**
   * Feeds to subscribe to in this feed
   * @deprecated Use moveFeed mutation to manage feed associations
   */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
  /** The name of the feed collection. */
  name: Scalars['String']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * Input for createFeed mutation
 * Contains feed creation details to connect
 */
export type CreateFeedInput = {
  /** The collection the feed should be stored in. If null, the feed will be a top level feed. */
  collectionId?: InputMaybe<Scalars['FeedCollectionId']['input']>;
  /** Input for creating a news search feed */
  newsSearch?: InputMaybe<NewsSearchFeedCreation>;
  /** The organization that the feed will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Insert the feed after the feed with the given id. If null, the feed will be inserted at the start of the collection. */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
  /** Input for creating an RSS/Atom feed */
  rssAtom?: InputMaybe<RssAtomFeedCreationInput>;
};

/** Input type for creating an idea group. */
export type CreateIdeaGroupInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Union type representing possible payloads for creating an idea group. */
export type CreateIdeaGroupPayload = IdeaGroup | InvalidInputError | UnauthorizedError | UnexpectedError;

/** createIdea input type */
export type CreateIdeaInput = {
  /** Content and metadata for the new idea */
  content: IdeaContentInput;
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Group placement (null for unassigned group) */
  group?: InputMaybe<IdeaGroupInput>;
  /** Organization ID that will own the idea */
  organizationId: Scalars['ID']['input'];
  /** Template ID used to create the idea */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** createIdea response (including errors) */
export type CreateIdeaPayload = Idea | IdeaResponse | InvalidInputError | LimitReachedError | UnauthorizedError | UnexpectedError;

/** Instagram Personal Profile-specific metadata for custom channel creation */
export type CreateInstagramPersonalProfileMetadata = {
  /** Avatar URL for this channel */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this IG Profile */
  name: Scalars['String']['input'];
};

/** All possible response types that can be returned by updateFeedCollection or createFeedCollection mutation. */
export type CreateOrUpdateFeedCollectionPayload = FeedCollectionActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** All possible response types that can be returned by updateFeedCollection or createFeedCollection mutation. */
export type CreateOrUpdateFeedPayload = FeedActionSuccess | FeedConnectionError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Create post's request input. */
export type CreatePostInput = {
  /** If this post was created with the help of AI */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** assets */
  assets?: InputMaybe<AssetsInput>;
  /** Channel's Id for which we want to create the post */
  channelId: Scalars['ChannelId']['input'];
  /** Is set when the Post is generated from a Draft */
  draftId?: InputMaybe<Scalars['DraftId']['input']>;
  /** Date when the post is scheduled to be published */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Is set when the Post is generated from an Idea */
  ideaId?: InputMaybe<Scalars['IdeaId']['input']>;
  /** Metadata of the post which differs based on the social network/service */
  metadata?: InputMaybe<PostInputMetaData>;
  /** How the post is being scheduled. */
  mode: ShareMode;
  /** Scheduling type to indicate notification publishing or automatic publishing */
  schedulingType: SchedulingType;
  /** source where the composer was initiated from, used for tracking. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** List of tag IDs */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /** Text content of the Post */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for adding a new saved reply. */
export type CreateSavedReplyInput = {
  /** The organization that owns this saved reply. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The saved reply to create. */
  savedReply: SavedReplyToCreateInput;
};

/**
 * Response type for the createSavedReply mutation.
 * It can return either success or an error.
 */
export type CreateSavedReplyPayload = DuplicateError | InvalidInputError | LimitReachedError | NotFoundError | SavedReplyActionSuccess | UnauthorizedError | UnexpectedError;

/** Input to pass when creating a Tag. */
export type CreateTagInput = {
  /** The Organization id to add tags on */
  organizationId: Scalars['OrganizationId']['input'];
  /** The tag to create */
  tag: TagToCreateInput;
};

/** Create tag request response payload. */
export type CreateTagPayload = DuplicateError | InvalidInputError | LimitReachedError | NotFoundError | RestProxyError | TagActionSuccess | UnauthorizedError | UnexpectedError;

export type CredentialsForChannelsError = {
  __typename?: 'CredentialsForChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** An enum representing the type of error that occurred. */
  errorType: ChannelAuthorizationErrorType;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type CredentialsForChannelsInput = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  redirectUri: Scalars['String']['input'];
  service: Service;
};

export type CredentialsForChannelsPayload = CredentialsForChannelsError | CredentialsForChannelsResponse;

export type CredentialsForChannelsResponse = {
  __typename?: 'CredentialsForChannelsResponse';
  connectableChannels: Array<Maybe<ConnectableChannel>>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type CustomChannelCreateInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  service: ChannelThirdPartyService;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: ChannelType;
  url: Scalars['String']['input'];
};

/** Error thrown for custom channel mutations */
export type CustomChannelError = MutationError & {
  __typename?: 'CustomChannelError';
  /** An error message of the issue */
  message: Scalars['String']['output'];
};

export type CustomChannelUpdateInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChannelUpdatePayload = CustomChannelUpdateResponse | CustomChannelsError;

export type CustomChannelUpdateResponse = {
  __typename?: 'CustomChannelUpdateResponse';
  channel: Channel;
};

export type CustomChannelsCreatePayload = CustomChannelsCreateResponse | CustomChannelsError;

export type CustomChannelsCreateResponse = {
  __typename?: 'CustomChannelsCreateResponse';
  channels: Array<Channel>;
};

/** Error thrown for custom channel mutations */
export type CustomChannelsError = {
  __typename?: 'CustomChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

/**
 * Custom Link
 *
 * This type represents a custom link in the shop grid.
 */
export type CustomLink = {
  __typename?: 'CustomLink';
  /** Date of the creation of the link */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the link */
  id: Scalars['ShopGridLinkId']['output'];
  /** Text of the link */
  text: Scalars['String']['output'];
  /** Date of the last update of the link */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the link */
  url: Scalars['URL']['output'];
};

/** Deprecated in favor of Billing type. */
export type Customer = {
  __typename?: 'Customer';
  billing?: Maybe<CustomerBilling>;
  created: Scalars['Int']['output'];
  customerIsPausedWithCoupon: Scalars['Boolean']['output'];
  delinquent: Scalars['Boolean']['output'];
  hasMoreInvoices: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invoices?: Maybe<Array<Maybe<LegacyInvoice>>>;
  name: Scalars['String']['output'];
  products: Subscriptionv2;
};

/** Deprecated in favor of Billing type. */
export type CustomerBilling = {
  __typename?: 'CustomerBilling';
  card?: Maybe<CreditCard>;
};

/** Comparator for filtering by date */
export type DateTimeComparator = {
  /**
   * Include results with dates equal to or before
   * the specified date
   */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Include results with dates equal to or after
   * the specified date
   */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Day = {
  campaigns?: Maybe<Array<PublishingCampaign>>;
  dayName: DayName;
  dayOfMonth: Scalars['Int']['output'];
  monthName: MonthName;
  startTimestamp: Scalars['Int']['output'];
};

export type DayName =
  | 'Friday'
  | 'Monday'
  | 'Saturday'
  | 'Sunday'
  | 'Thursday'
  | 'Tuesday'
  | 'Wednesday';

export type DayOfWeek =
  | 'fri'
  | 'mon'
  | 'sat'
  | 'sun'
  | 'thu'
  | 'tue'
  | 'wed';

/** Represents the default avatar settings of an author. */
export type DefaultAvatarSettings = {
  __typename?: 'DefaultAvatarSettings';
  /** The consistent text color for the specific author the default avatar (HEX code). */
  backgroundColor: Scalars['String']['output'];
  /** The letter of the author. */
  letter: Scalars['String']['output'];
  /** The consistent text color for the specific author of the default avatar (HEX code). */
  textColor: Scalars['String']['output'];
};

/** input for deleteAccount mutation */
export type DeleteAccountInput = {
  /** Account id of account to delete. */
  accountId: Scalars['AccountId']['input'];
};

/** deleteAccount response payload. */
export type DeleteAccountPayload = DeleteAccountSuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** success response for deleteAccount mutation */
export type DeleteAccountSuccess = MutationSuccess & {
  __typename?: 'DeleteAccountSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for deleteAdminComment mutation */
export type DeleteAdminCommentInput = {
  /** ID of the account that will have the comment delete */
  accountId: Scalars['AccountId']['input'];
};

/** deleteAdminComment response payload */
export type DeleteAdminCommentPayload = EmptySuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for deleteChannelGroup mutation */
export type DeleteChannelGroupInput = {
  /** The id of the channel group */
  id: Scalars['ChannelGroupId']['input'];
};

/** Mutation Response: Success and errors */
export type DeleteChannelGroupPayload = DeleteChannelGroupSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response for deleteChannelGroup mutation */
export type DeleteChannelGroupSuccess = {
  __typename?: 'DeleteChannelGroupSuccess';
  /** The id of the deleted channel group */
  id: Scalars['ChannelGroupId']['output'];
};

export type DeleteEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['input'];
};

export type DeleteEntityNotePayload = CoreWebAppCommonError | DeleteEntityNoteResponse;

export type DeleteEntityNoteResponse = {
  __typename?: 'DeleteEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Input for deleting a failed post error. */
export type DeleteFailedPostErrorInput = {
  /** The ID of the failed post error to delete. */
  id: Scalars['ErrorMessageId']['input'];
};

/** Union type representing either a successful deletion of a failed post error or an error */
export type DeleteFailedPostErrorPayload = DeleteFailedPostErrorSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Payload for successfully deleting a failed post error. */
export type DeleteFailedPostErrorSuccess = {
  __typename?: 'DeleteFailedPostErrorSuccess';
  /** The ID of the failed post error that was deleted. */
  deletedId: Scalars['ErrorMessageId']['output'];
};

/** Input for deleting a feed collection */
export type DeleteFeedCollectionInput = {
  /** The ids of the feeds to delete. */
  feedCollectionId: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** All possible response types that can be returned by deleteFeedCollection mutation. */
export type DeleteFeedCollectionPayload = FeedCollectionDeleteSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for deleting a feed */
export type DeleteFeedInput = {
  /** The feed to delete */
  id: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for feed deletion */
export type DeleteFeedPayload = DeleteFeedResponse | UnexpectedError;

/** Response for deleting a feed */
export type DeleteFeedResponse = {
  __typename?: 'DeleteFeedResponse';
  /** The ID of the deleted feed */
  id: Scalars['FeedId']['output'];
};

/** Input type for deleting an idea group. */
export type DeleteIdeaGroupInput = {
  id: Scalars['ID']['input'];
};

/** Union type representing possible payloads for deleting an idea group. */
export type DeleteIdeaGroupPayload = DeleteIdeaGroupResponse | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response type for deleting an idea group. */
export type DeleteIdeaGroupResponse = {
  __typename?: 'DeleteIdeaGroupResponse';
  updatedIdeas: Array<Idea>;
};

/** Input to pass when deleting a note from a post */
export type DeleteNoteFromPostInput = {
  /** The id of note to delete */
  noteId: Scalars['NoteId']['input'];
  /** The id of post */
  postId: Scalars['PostId']['input'];
};

/** Delete note request response payload. */
export type DeleteNoteFromPostPayload = DeleteNoteFromPostSuccess | InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response */
export type DeleteNoteFromPostSuccess = {
  __typename?: 'DeleteNoteFromPostSuccess';
  /** the full up-to-date post from after the note was deleted */
  post: Post;
};

export type DeletePostInput = {
  postId: Scalars['String']['input'];
};

/** deletePostV2 mutation deletes a post by id. */
export type DeletePostInputV2 = {
  /** Post id to delete. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by deletePostV2 mutation. */
export type DeletePostResult = DeletePostSuccess | NotFoundError | RestProxyError | UnauthorizedError | UnexpectedError;

/** deletePostV2 success response returns the post id that was deleted. */
export type DeletePostSuccess = {
  __typename?: 'DeletePostSuccess';
  /** Post id that was delete. */
  id: Scalars['PostId']['output'];
};

/** Input type for deleting a saved reply. */
export type DeleteSavedReplyInput = {
  /** Id of the saved reply to delete. */
  id: Scalars['SavedReplyId']['input'];
};

/**
 * Response type for the deleteSavedReply mutation.
 * It can return either success or an error.
 */
export type DeleteSavedReplyPayload = DeleteSavedReplySuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful response for deleting a saved reply. */
export type DeleteSavedReplySuccess = {
  __typename?: 'DeleteSavedReplySuccess';
  /** Id of the deleted saved reply. */
  id: Scalars['SavedReplyId']['output'];
};

/** Input for the mutation to delete a shop grid custom link */
export type DeleteShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The ID of the custom link to be deleted */
  id: Scalars['ShopGridLinkId']['input'];
};

/** Success response returns the full up-to-date tag from after deleting a tab. */
export type DeleteTagActionSuccess = {
  __typename?: 'DeleteTagActionSuccess';
  /** Id of the deleted tag. */
  id: Scalars['TagId']['output'];
};

/** Input to pass when deleting a Tag. */
export type DeleteTagInput = {
  /** The id of tag to delete */
  id: Scalars['TagId']['input'];
};

/** Delete tag request response payload. */
export type DeleteTagPayload = DeleteTagActionSuccess | InvalidInputError | NotFoundError | RestProxyError | UnauthorizedError | UnexpectedError;

export type Discount = {
  __typename?: 'Discount';
  duration: DiscountDuration;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: DiscountType;
  value: Scalars['Float']['output'];
};

export type DiscountDuration =
  | 'forever'
  | 'once'
  | 'repeating';

export type DiscountType =
  | 'amount'
  | 'percent';

/** Input type for dismissing all comments for a channel. */
export type DismissAllCommentsByChannelIdInput = {
  /** Id of the channel whose comments should be dismissed. */
  channelId: Scalars['ChannelId']['input'];
};

/** Input type for dismissing all comments for a  organization. */
export type DismissAllCommentsByOrganizationIdInput = {
  /** Id of the organization whose comments should be dismissed. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Input type for dismissing all comments for a post. */
export type DismissAllCommentsByPostIdInput = {
  /** Id of the post whose comments should be dismissed. */
  postId: Scalars['PostId']['input'];
};

/** Input type for dismissing all comments for a list of channel. */
export type DismissAllCommentsForChannelsInput = {
  /** List of channel ids whose comments should be dismissed. */
  channelIds: Array<Scalars['ChannelId']['input']>;
};

/** Mutation Response for Dismissing all comments for a list of channels */
export type DismissAllCommentsForChannelsPayload = DismissAllCommentsForChannelsSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response for a list of channels. */
export type DismissAllCommentsForChannelsSuccess = {
  __typename?: 'DismissAllCommentsForChannelsSuccess';
  /** The list of channels with their comments dismissed or failed to be dismissed. */
  channels?: Maybe<Array<DismissedChannelCommentsPayload>>;
};

/** Mutation Response: Success and errors */
export type DismissAllCommentsPayload = DismissAllCommentsSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response. */
export type DismissAllCommentsSuccess = {
  __typename?: 'DismissAllCommentsSuccess';
  /** The number of comments that were dismissed or enqueued */
  affectedCommentCount: Scalars['Int']['output'];
  /** The operation status: processed or enqueued. */
  status: DismissAllStatus;
};

/** Successful dismiss response. We're using an enum to make room to different statuses in the future. */
export type DismissAllStatus =
  /** The operation was enqueeued and will be processed asynchronously. */
  | 'enqueued'
  /** The operation was completed successfully and the comments were dismissed. */
  | 'processed';

export type DismissBannerError = {
  __typename?: 'DismissBannerError';
  cause: Scalars['String']['output'];
};

export type DismissBannerPayload = DismissBannerError | DismissBannerResponse;

export type DismissBannerResponse = {
  __typename?: 'DismissBannerResponse';
  success: Scalars['Boolean']['output'];
};

/**
 * Input type for the `dismissComment` mutation.
 * Defines the comment being dismissed.
 */
export type DismissCommentInput = {
  /** ID of the comment being dismissed. */
  commentId: Scalars['CommentId']['input'];
};

/** Mutation Response: Success and errors */
export type DismissCommentPayload = DismissCommentSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response. */
export type DismissCommentSuccess = {
  __typename?: 'DismissCommentSuccess';
  /** The comment that was successfully dismissed. */
  comment: CommentData;
};

/** Payload for a dismissed channel comments. */
export type DismissedChannelCommentsPayload = {
  __typename?: 'DismissedChannelCommentsPayload';
  /** The id of the channel. */
  id: Scalars['ChannelId']['output'];
  /** The status of the operation. */
  status: DismissedChannelCommentsPayloadStatus;
};

/** Enum for the status of the operation for a channel related to the dismissal of comments. */
export type DismissedChannelCommentsPayloadStatus =
  /** The operation has failed for the channel. */
  | 'error'
  /** The operation was completed successfully and the comments were dismissed for the channel. */
  | 'success';

export type DismissedObject = {
  __typename?: 'DismissedObject';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
};

export type DismissedObjectInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
};

/** Document asset */
export type DocumentAsset = Asset & {
  __typename?: 'DocumentAsset';
  /** Document specific metadata */
  document: DocumentMetadata;
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Document asset */
export type DocumentAssetInput = {
  /** Document thumbnail URL */
  thumbnailUrl: Scalars['String']['input'];
  /** Document title */
  title: Scalars['String']['input'];
  /** Document URL */
  url: Scalars['String']['input'];
};

/** Document metadata */
export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  /** Document fileSize in bytes */
  filesize?: Maybe<Scalars['Int']['output']>;
  /** Number of pages in the document */
  numPages: Scalars['Int']['output'];
  /** URLs to the static thumbnails of the document pages */
  thumbnails: Array<Scalars['String']['output']>;
};

/** Drop post's request input. */
export type DropPostInput = {
  /** New dueAt date */
  dueAt: Scalars['DateTime']['input'];
  /** ID of post to update */
  id: Scalars['PostId']['input'];
  /** By default true so it would pin to slot. */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Drop post's request response payload. */
export type DropPostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Error returned when a unique constraint is violated */
export type DuplicateError = MutationError & {
  __typename?: 'DuplicateError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type EditEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type EditEntityNotePayload = CoreWebAppCommonError | EditEntityNoteResponse;

export type EditEntityNoteResponse = {
  __typename?: 'EditEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Edit post's request input. */
export type EditPostInput = {
  /** If this post was edited with the help of AI */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** assets */
  assets?: InputMaybe<AssetsInput>;
  /** Is set when the Post is generated from a Draft */
  draftId?: InputMaybe<Scalars['DraftId']['input']>;
  /** Date when the post is scheduled to be published */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of the post to edit */
  id: Scalars['PostId']['input'];
  /** Is set when the Post is generated from an Idea */
  ideaId?: InputMaybe<Scalars['IdeaId']['input']>;
  /** Metadata of the post which differs based on the social network/service */
  metadata?: InputMaybe<PostInputMetaData>;
  /** How the post is being scheduled. */
  mode: ShareMode;
  /** Scheduling type to indicate notification publishing or automatic publishing */
  schedulingType: SchedulingType;
  /** source where the composer was initiated from, used for tracking. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** tags */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /** Text content of the Post */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EmailNotificationPreference = {
  __typename?: 'EmailNotificationPreference';
  cioTopicId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subscribed: Scalars['Boolean']['output'];
};

export type EmailNotificationPreferenceError = {
  __typename?: 'EmailNotificationPreferenceError';
  message: Scalars['String']['output'];
};

export type EmailNotificationPreferenceInput = {
  id: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};

export type EmailNotificationPreferencePayload = EmailNotificationPreferenceError | EmailNotificationPreferencesResponse;

export type EmailNotificationPreferencesResponse = {
  __typename?: 'EmailNotificationPreferencesResponse';
  preferences: Array<EmailNotificationPreference>;
};

/**
 * Empty mutation success response used when client doesn't need any data back
 * or simply needs to respond to a success or error.
 */
export type EmptySuccess = MutationSuccess & {
  __typename?: 'EmptySuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type EngageChannel = {
  __typename?: 'EngageChannel';
  backfillingComplete?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelsCount?: Maybe<Array<Maybe<LabelCount>>>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalPendingComments?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EngageOrganization = {
  __typename?: 'EngageOrganization';
  channels?: Maybe<Array<Maybe<EngageChannel>>>;
  emojis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type EngagePost = {
  __typename?: 'EngagePost';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  backfilling?: Maybe<Scalars['Boolean']['output']>;
  channelService?: Maybe<Scalars['String']['output']>;
  channelServiceId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  commentsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  dismissingAll?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isGiveaway?: Maybe<Scalars['Boolean']['output']>;
  labelsCount?: Maybe<Array<Maybe<LabelCount>>>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalLikes?: Maybe<Scalars['Int']['output']>;
  totalPendingComments?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EngagementMutationResponse = MutationResponse & {
  __typename?: 'EngagementMutationResponse';
  channel?: Maybe<EngageChannel>;
  channelCounters?: Maybe<Counters>;
  code: Scalars['String']['output'];
  comment?: Maybe<Comment>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  engagedWithId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  post?: Maybe<EngagePost>;
  postCounters?: Maybe<Counters>;
  reply?: Maybe<Reply>;
  replySent?: Maybe<Reply>;
  success: Scalars['Boolean']['output'];
};

/** Representation of a feature that a user has access to. */
export type Entitlement =
  | 'analytics'
  | 'analyticsOnPosts'
  | 'approvalFlow'
  | 'bluesky'
  | 'calendar'
  | 'campaigns'
  | 'channelGroupsInComposer'
  | 'channelSearchBar'
  | 'content'
  | 'customBitly'
  | 'customVideoThumbnailInstagram'
  | 'customizeUTMParam'
  | 'drafts'
  | 'engagement'
  | 'finishLater'
  | 'firstComment'
  | 'firstCommentLinkedin'
  | 'hashtagManager'
  | 'instagramPersonalProfile'
  | 'mastodon'
  | 'mobileOverview'
  | 'notes'
  | 'offlinePosts'
  | 'pinterest'
  | 'publishing'
  | 'sentPosts30Days'
  | 'shareNext'
  | 'shopGrid'
  | 'startPage'
  | 'stories'
  | 'tagUsersInImages'
  | 'tags'
  | 'teamsPanel'
  | 'threads'
  | 'tiktok'
  | 'twitterImpressions'
  | 'twitterLongContent'
  | 'unlimitedUploads'
  | 'youtube';

export type EntityWithNotes =
  | 'idea'
  | 'post';

/** Basic mutation error */
export type Error = {
  __typename?: 'Error';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExternalServiceDomain =
  | 'analytics'
  | 'broadcasting'
  | 'engagement'
  | 'publish';

export type FacebookEntity = {
  __typename?: 'FacebookEntity';
  content: Scalars['String']['output'];
  indices: Array<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Facebook metadata */
export type FacebookMetadata = {
  __typename?: 'FacebookMetadata';
  /** Metadata about the location of the business associated with the channel. Only available for Facebook and GPB */
  locationData?: Maybe<LocationData>;
};

/** Facebook post metadata */
export type FacebookPostMetadata = CommonPostMetadata & {
  __typename?: 'FacebookPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Facebook post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** Title of Facebook reel */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Facebook post metadata */
export type FacebookPostMetadataInput = {
  /** Annotations representing entities in the text */
  annotations?: InputMaybe<Array<AnnotationInputFacebook>>;
  /** Facebook post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** The channel-specific type of the post, eg, post, story, reel for Facebook */
  type: PostTypeFacebook;
};

/** Failed post error entity. */
export type FailedPostError = {
  __typename?: 'FailedPostError';
  /** ID of the failed post error. */
  id: Scalars['ErrorMessageId']['output'];
  /** A link to further information, if any. */
  link?: Maybe<Scalars['String']['output']>;
  /** The localized link text. */
  linkText?: Maybe<LocalizedText>;
  /** The patterns used to match this error. */
  patterns: Array<Scalars['String']['output']>;
  /** The position of the error in the post. */
  position: Scalars['Int']['output'];
  /** The service that this error is associated with. */
  service?: Maybe<Service>;
  /** The localized error message text. */
  text: LocalizedText;
  /** When the failed post error was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FeatureAction =
  | 'expandText'
  | 'generateIdeas'
  | 'generateSuggestions'
  | 'generateText'
  | 'rephraseText'
  | 'summarizeText';

export type FeatureFlip = {
  __typename?: 'FeatureFlip';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FeaturePlatform =
  | 'android'
  | 'ios'
  | 'mobile'
  | 'web';

/**
 * A feed is a collection of feed items owned by a single organization.
 * An example of a feed is a RSS feed.
 */
export type Feed = {
  __typename?: 'Feed';
  /**
   * The collection this feed belongs to. If null, this is a top level feed
   * and does not belong to any collections
   */
  collection?: Maybe<FeedCollection>;
  /** Metadata used to connect to the feed. */
  connectionMetadata: FeedConnectionMetadata;
  /**
   * The browsable view of the feed (when applicable), eg the youtube channel,
   * News category page, Blog, etc
   */
  homepage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the feed. */
  id: Scalars['FeedId']['output'];
  /** The last time we refreshed the feed. */
  lastRefreshed: Scalars['DateTime']['output'];
  /** The name of the feed, typically defined by the feed itself. */
  name: Scalars['String']['output'];
  /** The organization that owns this feed. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Float value for ordering among sibling feeds. */
  sortPosition: Scalars['Float']['output'];
  /** The type of content feed */
  type: ContentFeedType;
};

/** Successful response following an update to an RSS feed */
export type FeedActionSuccess = {
  __typename?: 'FeedActionSuccess';
  /** Feed on which the action was successfully performed. */
  feed: Feed;
};

/** A feed collection is a collection of feeds created by a single organization. */
export type FeedCollection = {
  __typename?: 'FeedCollection';
  /**
   * The feeds in the feed collection.
   * @deprecated Use Feed.collection instead to query feed associations
   */
  feeds: Array<Feed>;
  /** The unique identifier for the feed collection. */
  id: Scalars['FeedCollectionId']['output'];
  /** The name of the feed collection. */
  name: Scalars['String']['output'];
  /** The organization that owns the feed collection. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Float value for ordering among feed collections at the same level. */
  sortPosition: Scalars['Float']['output'];
};

/** Successful response following an update to an RSS feed collection */
export type FeedCollectionActionSuccess = {
  __typename?: 'FeedCollectionActionSuccess';
  /** Feed Group on which the action was successfully performed. */
  feedCollection: FeedCollection;
};

/** Results for the feed collections query. */
export type FeedCollectionConnection = {
  __typename?: 'FeedCollectionConnection';
  /** The list of feed collections that match the query. */
  edges: Array<FeedCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** Successful response following a deletion of feed collections */
export type FeedCollectionDeleteSuccess = {
  __typename?: 'FeedCollectionDeleteSuccess';
  /** Feed Group ID which was deleted */
  feedCollectionId: Scalars['FeedCollectionId']['output'];
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type FeedCollectionEdge = {
  __typename?: 'FeedCollectionEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current feed collection in the list. */
  node: FeedCollection;
};

/** Query input to load a single feed collection */
export type FeedCollectionInput = {
  /** The feed collection ID */
  id: Scalars['FeedCollectionId']['input'];
  /** The organization ID to fetch the feed collection for */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Query input to load a list of feed collections */
export type FeedCollectionsInput = {
  /** The organization ID to fetch feed collections for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Error connecting to source feed - this is most often due to typos in RSS feeds */
export type FeedConnectionError = {
  __typename?: 'FeedConnectionError';
  /** The type of error that occured */
  error: FeedConnectionErrorType;
  /** Human readable error message */
  message: Scalars['String']['output'];
  /** Feed suggestions that the user is likely looking for */
  suggestions: Array<FeedConnectionSuggestion>;
};

/** Error type from connection attempt */
export type FeedConnectionErrorType =
  /** Response from server was not valid atom/RSS */
  | 'MalformedResponse'
  /** Server sent a 4** response, indicating the user is not allowed to access */
  | 'NotAllowed'
  /** The server took too long to respond */
  | 'Timeout'
  /** An uncategorized error occured */
  | 'Unknown';

/** Abstact union type representing RSS Feeds */
export type FeedConnectionMetadata = NewsSearchConnectionMetadata | RssFeedConnectionMetadata;

/** Feed data provided as a suggestion */
export type FeedConnectionSuggestion = {
  __typename?: 'FeedConnectionSuggestion';
  /** Metadata used to connect to the feed. */
  connectionMetadata: FeedConnectionMetadata;
  /**
   * The browsable view of the feed (when applicable), eg the youtube channel,
   * News category page, Blog, etc
   */
  homepage?: Maybe<Scalars['String']['output']>;
  /** The name of the feed, typically defined by the feed itself. */
  name: Scalars['String']['output'];
  /** The type of content feed */
  type: ContentFeedType;
};

/** Query input to load a single feed */
export type FeedInput = {
  /** The feed ID */
  id: Scalars['FeedId']['input'];
  /** The organization ID to fetch the feed for */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * An individual feed item. Feed items are shared amongst all users.
 * An example of a feed item is a news article from an RSS feed.
 */
export type FeedItem = {
  __typename?: 'FeedItem';
  /** The URL for the feed item. */
  articleUrl: Scalars['String']['output'];
  /** The date the feed item was published. */
  contentTextPreview: Scalars['String']['output'];
  /** The date the feed item was created/published. */
  createdAt: Scalars['DateTime']['output'];
  /** The feed that the item belongs to. */
  feed: Feed;
  /** The unique identifier for the feed item. */
  id: Scalars['FeedItemId']['output'];
  /** The title of the feed item. */
  title: Scalars['String']['output'];
};

/** Results for the feed contents query. */
export type FeedItemConnection = {
  __typename?: 'FeedItemConnection';
  /** The list of feed items that match the query. */
  edges: Array<FeedItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** An edge in a connection. */
export type FeedItemEdge = {
  __typename?: 'FeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeedItem;
};

/** Query input to load feed items */
export type FeedItemsFiltersInput = {
  /** The feed collection ID. When set, it will return feed items for the given feed collection */
  feedCollectionIds?: InputMaybe<Array<Scalars['FeedCollectionId']['input']>>;
  /** The feed IDs. When set, it will return feed items for the given feeds. */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
};

/** Input to fetch feed items */
export type FeedItemsInput = {
  /** The filters to apply to the feed items query */
  filter?: InputMaybe<FeedItemsFiltersInput>;
  /** The Organization id to fetch feed items for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for feed move operations */
export type FeedMoveUpdatesPayload = FeedMoveUpdatesResponse | UnexpectedError;

/** Response containing updated feeds and collections after a move operation */
export type FeedMoveUpdatesResponse = {
  __typename?: 'FeedMoveUpdatesResponse';
  /** Feed collections that have updated due to move */
  updatedFeedCollections: Array<FeedCollection>;
  /** Feeds that have updated due to move */
  updatedFeeds: Array<Feed>;
};

/** Query input to load a list of feeds */
export type FeedsInput = {
  /** The organization ID to fetch feeds for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type FilterBy = {
  by: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Input parameters for generating hashtags based on a post's content */
export type FreeToolHashtagGeneratorTemplateInput = {
  /** Content of a post to generate hashtags for */
  content: Scalars['String']['input'];
  /** The service to generate hashtags for. Defaults to instagram */
  service: Service;
};

export type From = {
  __typename?: 'From';
  isChannel?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type GatewayDetails = {
  __typename?: 'GatewayDetails';
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** This is available only on the paid plans and will have the values android, apple and web when the plan is purchased via the play_store, app_store or web (stripe) respectively. */
  gatewayPlatform?: Maybe<BillingGatewayPlatform>;
  gatewayType: BillingGateway;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Main input for generating templated completions */
export type GenerateTemplatedCompletionInput = {
  /**
   * Token, required for free tools, to validate usage of API via
   * Free tools
   */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional call-to-action text to include in the completion */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Parameters for the selected template */
  freeToolHashtagGenerator?: InputMaybe<FreeToolHashtagGeneratorTemplateInput>;
  /** Marketing id to be used when using completions via free tools */
  marketingId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization requesting the completion */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Selected template for completion generation */
  template: GenerateTemplatedCompletionTemplate;
  /** Number of different variations to generate */
  variations?: InputMaybe<Scalars['Int']['input']>;
};

/** Union type for possible completion mutation responses */
export type GenerateTemplatedCompletionPayload = GenerateTemplatedCompletionSuccess | LimitReachedError | UnexpectedError;

/** Successful completion generation response */
export type GenerateTemplatedCompletionSuccess = {
  __typename?: 'GenerateTemplatedCompletionSuccess';
  /** Array of generated completion suggestions */
  suggestions: Array<GenerateTemplatedCompletionSuggestion>;
};

/** Individual completion suggestion container */
export type GenerateTemplatedCompletionSuggestion = {
  __typename?: 'GenerateTemplatedCompletionSuggestion';
  /** Generated completion text content */
  content: Scalars['String']['output'];
};

/** Available templates for AI text completion generation */
export type GenerateTemplatedCompletionTemplate =
  /** Generates a list of hashtags based on a post's content */
  | 'freeToolHashtagGenerator';

export type GenericSubscription = {
  interval: BillingInterval;
  trial?: Maybe<Trial>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Input for getAccessTokenForChannel query */
export type GetAccessTokensForChannelInput = {
  /** ID of channel */
  channelId: Scalars['ChannelId']['input'];
  /** TFA code to verify. */
  tfaCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * JWT token to verify instead of TFA code. This token is used to allow advocates a short window of time
   * to perform sensitive actions without needing to enter a TFA code again.
   */
  tfaToken?: InputMaybe<Scalars['String']['input']>;
};

/** getAccessTokenForChannel response payload. */
export type GetAccessTokensForChannelPayload = AccessTokens | NotFoundError | UnauthorizedError | UnexpectedError | UnsupportedChannelError;

export type GoogleBusinessData = {
  __typename?: 'GoogleBusinessData';
  code?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String']['output'];
  start_date?: Maybe<Scalars['Int']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Metadata for a GBP post that is an event */
export type GoogleBusinessEventMetaData = {
  __typename?: 'GoogleBusinessEventMetaData';
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** End date of the event */
  endDate: Scalars['DateTime']['output'];
  /**
   * End time of the event
   * @deprecated get time from the endDate
   */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Indicate whether the event has a start or end time. */
  isFullDayEvent: Scalars['Boolean']['output'];
  /** Link to the action */
  link?: Maybe<Scalars['String']['output']>;
  /** Start date of the event */
  startDate: Scalars['DateTime']['output'];
  /**
   * Start time of the event
   * @deprecated get time from the startDate
   */
  startTime?: Maybe<Scalars['String']['output']>;
  /** Title of the event */
  title: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an event */
export type GoogleBusinessEventMetaDataInput = {
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** End date of the event */
  endDate: Scalars['DateTime']['input'];
  /** Indicate whether the event has a start or end time. */
  isFullDayEvent: Scalars['Boolean']['input'];
  /** Link to the action */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the event */
  startDate: Scalars['DateTime']['input'];
  /** Title of the event */
  title: Scalars['String']['input'];
};

/** Google Business metadata */
export type GoogleBusinessMetadata = {
  __typename?: 'GoogleBusinessMetadata';
  /** Metadata about the location of the business associated with the channel. Only available for Facebook and GPB */
  locationData?: Maybe<LocationData>;
};

/** Metadata for a GBP post that is an offer */
export type GoogleBusinessOfferMetaData = {
  __typename?: 'GoogleBusinessOfferMetaData';
  /** Coupon code for the offer */
  code?: Maybe<Scalars['String']['output']>;
  /** End date of the offer */
  endDate: Scalars['DateTime']['output'];
  /** Link to the offer */
  link?: Maybe<Scalars['String']['output']>;
  /** Start date of the offer */
  startDate: Scalars['DateTime']['output'];
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Title of the offer */
  title: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an offer */
export type GoogleBusinessOfferMetaDataInput = {
  /** Coupon code for the offer */
  code?: InputMaybe<Scalars['String']['input']>;
  /** End date of the offer */
  endDate: Scalars['DateTime']['input'];
  /** Link to the offer */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the offer */
  startDate: Scalars['DateTime']['input'];
  /** Terms and Conditions */
  terms?: InputMaybe<Scalars['String']['input']>;
  /** Title of the offer */
  title: Scalars['String']['input'];
};

/** List of possible types for GBP cta */
export type GoogleBusinessPostActionType =
  | 'book'
  | 'call'
  | 'learn_more'
  | 'none'
  | 'order'
  | 'shop'
  | 'signup';

/** GoogleBusiness Metadata details */
export type GoogleBusinessPostDetails = GoogleBusinessEventMetaData | GoogleBusinessOfferMetaData | GoogleBusinessWhatsNewMetaData;

/**
 * Google Business Profile post metadata
 * @deprecated: pending proposal for specific GBP post types: update, offer and event metadata types
 */
export type GoogleBusinessPostMetadata = CommonPostMetadata & {
  __typename?: 'GoogleBusinessPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Details of the metadata */
  details?: Maybe<GoogleBusinessPostDetails>;
  /** Title if available in the given GBP post type: event and offer */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/**
 * Google Business Profile post metadata
 * @deprecated: pending proposal for specific GBP post types: update, offer and event metadata types
 */
export type GoogleBusinessPostMetadataInput = {
  /** Details of the Event metadata */
  detailsEvent?: InputMaybe<GoogleBusinessEventMetaDataInput>;
  /** Details of the Offer metadata */
  detailsOffer?: InputMaybe<GoogleBusinessOfferMetaDataInput>;
  /** Details of the Whats new metadata */
  detailsWhatsNew?: InputMaybe<GoogleBusinessWhatsNewMetaDataInput>;
  /** Title if available in the given GBP post type: event and offer */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The channel-specific type of the post, eg, post, offer, event for Google Business Profile */
  type: PostTypeGoogleBusiness;
};

/** Metadata for a GBP post of type Whats new */
export type GoogleBusinessWhatsNewMetaData = {
  __typename?: 'GoogleBusinessWhatsNewMetaData';
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** Link to the action */
  link?: Maybe<Scalars['String']['output']>;
};

/** Metadata for a GBP post of type Whats new */
export type GoogleBusinessWhatsNewMetaDataInput = {
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** Link to the action */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type HealthStatus = {
  __typename?: 'HealthStatus';
  ok: Scalars['Boolean']['output'];
};

export type HellonextSsoMutationResponse = Error | HellonextSsoResponse | UnverifiedEmailAddressError;

export type HellonextSsoResponse = {
  __typename?: 'HellonextSsoResponse';
  ssoToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type HelpCenterLink = {
  __typename?: 'HelpCenterLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HexColor = {
  __typename?: 'HexColor';
  value?: Maybe<Scalars['String']['output']>;
};

/** Ideas are the main entity in the create space */
export type Idea = {
  __typename?: 'Idea';
  /** The actual content and metadata of the idea */
  content: IdeaContent;
  /** Unix timestamp of when the idea was created */
  createdAt: Scalars['Int']['output'];
  /** ID of the group this idea belongs to (if any) */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the idea */
  id: Scalars['ID']['output'];
  /** ID of the organization that owns this idea */
  organizationId: Scalars['ID']['output'];
  /** Numerical position for ordering within a group */
  position?: Maybe<Scalars['Float']['output']>;
  /** Unix timestamp of when the idea was last modified */
  updatedAt: Scalars['Int']['output'];
};

/** Content of an idea */
export type IdeaContent = {
  __typename?: 'IdeaContent';
  /** Indicates whether AI tools were used in creating this idea */
  aiAssisted: Scalars['Boolean']['output'];
  /** DateTime set by user associated with the idea - this often reflects a target publish date. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** List of media items attached to the idea */
  media?: Maybe<Array<IdeaMedia>>;
  /** Services tagged by the user - this is typically used to annotate ideas with their target services */
  services: Array<Service>;
  /** Tags used to categorize and organize the idea */
  tags: Array<PublishingTag>;
  /** Main body text or description of the idea */
  text?: Maybe<Scalars['String']['output']>;
  /** Title or headline of the idea */
  title?: Maybe<Scalars['String']['output']>;
};

/** content input for creating/updating an idea */
export type IdeaContentInput = {
  /** Whether AI tools were used in creation */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target date for the idea, often used for planning publish schedules */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of media items to attach */
  media?: InputMaybe<Array<IdeaMediaInput>>;
  /** Services associated with the idea for targeting specific platforms */
  services?: InputMaybe<Array<Service>>;
  /** Tags to categorize the idea */
  tags?: InputMaybe<Array<TagInput>>;
  /** Main body text or description */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Title or headline of the idea */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IdeaCreationInput = {
  content: IdeaContentInput;
  cta?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['String']['input'];
  /** @deprecated Use input.cta instead */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination type for Ideas */
export type IdeaEdge = {
  __typename?: 'IdeaEdge';
  /** Opaque cursor for pagination, used to fetch subsequent pages */
  cursor: Scalars['String']['output'];
  /** The idea object */
  node: Idea;
};

/** Idea groups are used to organize ideas in the board */
export type IdeaGroup = {
  __typename?: 'IdeaGroup';
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** idea group input for create/update */
export type IdeaGroupInput = {
  /** Target group ID (null for unassigned group) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of idea to place after (null for top position) */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for retrieving idea groups by organization ID. */
export type IdeaGroupsInput = {
  organizationId: Scalars['ID']['input'];
};

export type IdeaIdInput = {
  id: Scalars['String']['input'];
};

/** Media attached to an idea */
export type IdeaMedia = {
  __typename?: 'IdeaMedia';
  /** Alternative text description for accessibility */
  alt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the media in Buffer's upload system */
  id: Scalars['ID']['output'];
  /** File size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Source platform information for the media */
  source?: Maybe<IdeaMediaSource>;
  /** URL to a smaller version of the media for preview purposes */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Type of media (e.g., image, video, gif) */
  type: MediaType;
  /** Direct URL to access the media file */
  url: Scalars['String']['output'];
};

export type IdeaMediaInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The upload id */
  id: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<IdeaMediaSourceInput>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  type: MediaType;
  url: Scalars['String']['input'];
};

/** Media source for the idea, e.g. Unsplash, Gifphy, etc. */
export type IdeaMediaSource = {
  __typename?: 'IdeaMediaSource';
  /** Name of the content creator/author */
  author?: Maybe<Scalars['String']['output']>;
  /** URL to the author's profile on the source platform */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier from the source platform */
  id?: Maybe<Scalars['String']['output']>;
  /** Name of the media source platform (e.g., 'Unsplash', 'Giphy') */
  name: Scalars['String']['output'];
};

export type IdeaMediaSourceInput = {
  /** for unsplash only */
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type IdeaMutationPayload = CoreWebAppCommonError | IdeaMutationSuccess;

export type IdeaMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeaMutationSuccess';
  code: Scalars['String']['output'];
  /** The created ideas */
  idea: Idea;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IdeaPayload = CoreWebAppCommonError | Idea;

/** createIdea response type */
export type IdeaResponse = {
  __typename?: 'IdeaResponse';
  /** The affected idea */
  idea?: Maybe<Idea>;
  /** If true, the client should refresh the ideas list because other ideas might have been moved */
  refreshIdeas: Scalars['Boolean']['output'];
};

export type IdeaUpdateInput = {
  content: IdeaContentInput;
  cta?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
};

export type IdeasCount = {
  __typename?: 'IdeasCount';
  count: Scalars['Int']['output'];
};

export type IdeasCountByTag = {
  __typename?: 'IdeasCountByTag';
  count: Scalars['Int']['output'];
  tagId: Scalars['String']['output'];
};

export type IdeasCountByTagInput = {
  organizationId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type IdeasCountByTags = {
  __typename?: 'IdeasCountByTags';
  counts: Array<IdeasCountByTag>;
};

export type IdeasCountByTagsPayload = CoreWebAppCommonError | IdeasCountByTags;

export type IdeasCountPayload = CoreWebAppCommonError | IdeasCount;

export type IdeasDeletionInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type IdeasDeletionPayload = CoreWebAppCommonError | IdeasDeletionSuccess;

export type IdeasDeletionSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeasDeletionSuccess';
  code: Scalars['String']['output'];
  /** The deleted ideas */
  ideas: Array<Idea>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** @deprecated: Use IdeasListInputV2 */
export type IdeasListInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterBy>;
  first: Scalars['Int']['input'];
  order?: InputMaybe<OrderBy>;
  organizationId: Scalars['String']['input'];
};

/** Input to filter ideas */
export type IdeasListInputV2 = {
  /**
   * Legacy filter argument - deprecated in favor of tags
   * @deprecated Use the tags filter input
   */
  filter?: InputMaybe<FilterBy>;
  /** Filter by idea groups: null means no filtering, null ID in array includes unassigned ideas */
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The organization ID to fetch ideas from */
  organizationId: Scalars['ID']['input'];
  /** Filter by tags: null means no filtering, null ID in array includes untagged ideas */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Image = {
  __typename?: 'Image';
  author?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  regularUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** Image asset */
export type ImageAsset = Asset & {
  __typename?: 'ImageAsset';
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** Image specific metadata */
  image: ImageMetadata;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Image asset */
export type ImageAssetInput = {
  /** Image specific metadata */
  metadata?: InputMaybe<ImageMetadataInput>;
  /** URL to the static thumbnail of the asset */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the file source */
  url: Scalars['String']['input'];
};

/** Image dimensions */
export type ImageDimensionsInput = {
  /** Image height in pixels */
  height: Scalars['Int']['input'];
  /** Image width in pixels */
  width: Scalars['Int']['input'];
};

/** Image metadata */
export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  /** Alternative text for accessibility */
  altText: Scalars['String']['output'];
  /** Animated thumbnail URL */
  animatedThumbnail?: Maybe<Scalars['String']['output']>;
  /** Image height in pixels */
  height: Scalars['Int']['output'];
  /** Is the image animated? */
  isAnimated: Scalars['Boolean']['output'];
  /** User tags in the image */
  userTags?: Maybe<Array<UserTag>>;
  /** Image width in pixels */
  width: Scalars['Int']['output'];
};

/** Image metadata */
export type ImageMetadataInput = {
  /** Alternative text for accessibility */
  altText: Scalars['String']['input'];
  /** Animated thumbnail URL */
  animatedThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** Image dimensions */
  dimensions?: InputMaybe<ImageDimensionsInput>;
  /** User tags in the image */
  userTags?: InputMaybe<Array<UserTagInput>>;
};

export type ImageResultInfo = {
  __typename?: 'ImageResultInfo';
  count: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  query?: Maybe<Scalars['String']['output']>;
};

export type ImageSearchError = MutationBasicError & {
  __typename?: 'ImageSearchError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ImageSearchPayload = ImageSearchError | ImageSearchResponse;

export type ImageSearchResponse = {
  __typename?: 'ImageSearchResponse';
  images: Array<Maybe<Image>>;
  info: ImageResultInfo;
};

export type ImpersonationResponse = Error | Response;

/** input for initiateEmailUpdateRequest mutation */
export type InitiateEmailUpdateRequestInput = {
  /** Account id to change email address. */
  accountId: Scalars['AccountId']['input'];
  /** New email address to set. */
  newEmail: Scalars['String']['input'];
};

/** initiateEmailUpdateRequest response payload. */
export type InitiateEmailUpdateRequestPayload = InitiateEmailUpdateRequestSuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** success response for setPasswordForAccount mutation */
export type InitiateEmailUpdateRequestSuccess = MutationSuccess & {
  __typename?: 'InitiateEmailUpdateRequestSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updateEmail mutation */
export type InitiateUpdateEmailInput = {
  /** Account id of account to update email of. */
  accountId: Scalars['AccountId']['input'];
  /** Indicate whether it is a backup email */
  isBackupEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** New email to update Account with */
  newEmail: Scalars['String']['input'];
  /** Password for Account to verify if we allow updating the email */
  password: Scalars['String']['input'];
};

/** updateEmail response payload */
export type InitiateUpdateEmailPayload = EmptySuccess | InvalidInputError | NotFoundError | UnexpectedError;

export type InstagramData = {
  __typename?: 'InstagramData';
  comment_text?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String']['output'];
  service_geolocation_id?: Maybe<Scalars['String']['output']>;
  service_geolocation_name?: Maybe<Scalars['String']['output']>;
};

/** Instagram Geolocation */
export type InstagramGeolocation = {
  __typename?: 'InstagramGeolocation';
  /** The id of this location */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of this location */
  text?: Maybe<Scalars['String']['output']>;
};

/** Instagram Geolocation */
export type InstagramGeolocationInput = {
  /** The id of this location */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of this location */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Instagram metadata */
export type InstagramMetadata = {
  __typename?: 'InstagramMetadata';
  /**
   * Indicates if we should default to reminder for Instagram
   * Source: field resolver: profile.default_to_reminders
   */
  defaultToReminders: Scalars['Boolean']['output'];
};

/** Instagram post metadata */
export type InstagramPostMetadata = CommonPostMetadata & {
  __typename?: 'InstagramPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Instagram post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Geolocation of the post */
  geolocation?: Maybe<InstagramGeolocation>;
  /** Shop Grid link for the post */
  link?: Maybe<Scalars['String']['output']>;
  /** Indicates whether post should be shared to feed */
  shouldShareToFeed: Scalars['Boolean']['output'];
  /** Sticker fields for reminder-based publishing */
  stickerFields?: Maybe<InstagramStickerFields>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Instagram post metadata */
export type InstagramPostMetadataInput = {
  /** Instagram post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Geolocation of the post */
  geolocation?: InputMaybe<InstagramGeolocationInput>;
  /** Shop Grid link for the post */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether post should be shared to feed */
  shouldShareToFeed: Scalars['Boolean']['input'];
  /** Sticker fields for reminder-based publishing */
  stickerFields?: InputMaybe<InstagramStickerFieldsInput>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/**
 * Instagram fields for reminder-based publishing. Upon the reminder for publishing, the user
 * is prompted to copy and paste these fields into the Instagram app to complete the post.
 */
export type InstagramStickerFields = {
  __typename?: 'InstagramStickerFields';
  /** Placeholder text for the post's music */
  music?: Maybe<Scalars['String']['output']>;
  /** Additional field for any other post content */
  other?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the post's linked products */
  products?: Maybe<Scalars['String']['output']>;
  /** Text for the Story or Reel */
  text?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the post's topics (Reels only) */
  topics?: Maybe<Scalars['String']['output']>;
};

/**
 * Instagram fields for reminder-based publishing. Upon the reminder for publishing, the user
 * is prompted to copy and paste these fields into the Instagram app to complete the post.
 */
export type InstagramStickerFieldsInput = {
  /** Placeholder text for the post's music */
  music?: InputMaybe<Scalars['String']['input']>;
  /** Additional field for any other post content */
  other?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the post's linked products */
  products?: InputMaybe<Scalars['String']['input']>;
  /** Text for the Story or Reel */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the post's topics (Reels only) */
  topics?: InputMaybe<Scalars['String']['input']>;
};

export type IntervalSize =
  | 'oneHour'
  | 'thirtyMinutes'
  | 'twoHours';

/** Error returned when the input is invalid */
export type InvalidInputError = MutationError & {
  __typename?: 'InvalidInputError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  chargeId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: InvoiceStatus;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<Maybe<InvoiceNode>>;
  pageInfo: PageInfo;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  amountTax?: Maybe<Scalars['Float']['output']>;
  amountWithoutTax?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type InvoiceNode = {
  __typename?: 'InvoiceNode';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export type InvoiceStatus =
  | 'open'
  | 'paid';

export type LabelCount = {
  __typename?: 'LabelCount';
  count?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** The last reply to the comment */
export type LastReply = {
  __typename?: 'LastReply';
  /** Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** Information about the author of the comment. */
  author: CommentAuthor;
  /** Refers to the core.channels._id. */
  channelId: Scalars['ChannelId']['output'];
  /** The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** ObjectId of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Refers to the core.organizations._id. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Refers to the engage.postComments (this collection) _id, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp when this comment was created on the third-party service. It could be undefined
   *   if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Deprecated in favor of Billing type. */
export type LegacyDiscount = {
  __typename?: 'LegacyDiscount';
  discount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Deprecated in favor of Billing type. */
export type LegacyInvoice = {
  __typename?: 'LegacyInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Int']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LifetimeConnectedChannelCount = {
  __typename?: 'LifetimeConnectedChannelCount';
  service?: Maybe<Service>;
  serviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Error returned when the limit is reached */
export type LimitReachedError = MutationError & {
  __typename?: 'LimitReachedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Link attached to the post */
export type LinkAssetInput = {
  /** Description of the link */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Thumbnail URL of the link */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the link */
  title?: InputMaybe<Scalars['String']['input']>;
  /** URL to the link */
  url: Scalars['String']['input'];
};

/** Link attachment */
export type LinkAttachment = ScrapedLink & {
  __typename?: 'LinkAttachment';
  /** Full URL that the link asset has been built from */
  expandedUrl?: Maybe<Scalars['String']['output']>;
  /** Description for the scraped link */
  text: Scalars['String']['output'];
  /** Selected thumbnail for this link preview */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Thumbnails of media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** Title for the link attachment */
  title: Scalars['String']['output'];
  /** URL that the link asset has been built from */
  url: Scalars['String']['output'];
};

/** Link attachment */
export type LinkAttachmentInput = {
  /** URL that the link asset has been built from */
  url: Scalars['String']['input'];
};

export type LinkInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input to configure link shortening domain */
export type LinkShortenerConfigInput = {
  /**
   * The domain of the link shortening service. Either buff.ly, dub.co,
   * or a user defined shortener based on an integration
   */
  domain: Scalars['String']['input'];
  /** The human readable name of the shortener */
  name: Scalars['String']['input'];
};

/** Link Shortening Configuration */
export type LinkShorteningConfig = {
  __typename?: 'LinkShorteningConfig';
  /**
   * Domain of the link shortener - eg buff.ly, dub.co,
   * or the user's custom domain.
   */
  domain: Scalars['String']['output'];
  /**
   * Human readable string to describe the link shortening
   * service.
   */
  name: Scalars['String']['output'];
};

/** Input to configure link shortening */
export type LinkShorteningSettingsInput = {
  /** Channel to update settings for */
  channelId: Scalars['ChannelId']['input'];
  /**
   * Configuration for the link shortener service. Leave blank
   * if shortening is not enabled
   */
  config?: InputMaybe<LinkShortenerConfigInput>;
  /** Setting to control if user links should be shortened or not */
  isEnabled: Scalars['Boolean']['input'];
  /** Organization to update settings for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type LinkedInAnnotation = {
  __typename?: 'LinkedInAnnotation';
  entity: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  length: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  localizedName: Scalars['String']['output'];
  start: Scalars['Int']['output'];
  vanityName: Scalars['String']['output'];
};

/** LinkedIn metadata */
export type LinkedInMetadata = {
  __typename?: 'LinkedInMetadata';
  /** Property parsed from scopes indicating whether the client should show the LinkedIn analytics refresh banner */
  shouldShowLinkedinAnalyticsRefreshBanner: Scalars['Boolean']['output'];
};

/** LinkedIn post metadata */
export type LinkedInPostMetadata = CommonPostMetadata & {
  __typename?: 'LinkedInPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** LinkedIn post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** LinkedIn post metadata */
export type LinkedInPostMetadataInput = {
  /** Annotations representing entities in the text */
  annotations?: InputMaybe<Array<AnnotationInputLinkedIn>>;
  /** LinkedIn post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
};

export type LinkedinData = {
  __typename?: 'LinkedinData';
  comment_text?: Maybe<Scalars['String']['output']>;
};

/** Union type representing either a successful listing of failed post errors or an error */
export type ListFailedPostErrorsPayload = ListFailedPostErrorsSuccess | UnauthorizedError | UnexpectedError;

/** Success response for listing all failed post errors. */
export type ListFailedPostErrorsSuccess = {
  __typename?: 'ListFailedPostErrorsSuccess';
  /** List of all failed post errors. */
  failedPostErrors: Array<Maybe<FailedPostError>>;
};

/** Localized text for multiple languages. */
export type LocalizedText = {
  __typename?: 'LocalizedText';
  /** Localized text in English (required). */
  en: Scalars['String']['output'];
  /** Localized text in Spanish (optional). Will default to English if not provided. */
  es?: Maybe<Scalars['String']['output']>;
};

/** Localized text input for multiple languages. */
export type LocalizedTextInput = {
  /** Localized text for English (required). */
  en: Scalars['String']['input'];
  /** Localized text for Spanish (optional). Will default to English if not provided. */
  es?: InputMaybe<Scalars['String']['input']>;
};

/** Location data about the channel */
export type LocationData = {
  __typename?: 'LocationData';
  /** Google Account Id of the business */
  googleAccountId?: Maybe<Scalars['String']['output']>;
  /** Location of the business associated with the channel */
  location?: Maybe<Scalars['String']['output']>;
  /** Link to the map */
  mapsLink?: Maybe<Scalars['String']['output']>;
};

export type LocationDataInput = {
  googleAccountId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapsLink?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPayload = {
  __typename?: 'LocationPayload';
  country?: Maybe<Scalars['String']['output']>;
};

/** completeLoginVerification response payload */
export type LoginVerificationResponsePayload = EmptySuccess | UnexpectedError;

export type MpBilling = Billing & {
  __typename?: 'MPBilling';
  /** Describes the billing address of the customer */
  address?: Maybe<Address>;
  /** Any credit (negative balance) or debit (positive balance) a customer might have */
  balance: Scalars['Float']['output'];
  /** This URL is used to redirect the user to the appropriate billing page, when the OB plan selector is triggered. */
  billingRedirectUrl: Scalars['String']['output'];
  canAccessAnalytics: Scalars['Boolean']['output'];
  canAccessEngagement: Scalars['Boolean']['output'];
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  /** Describes any discount coupon a customer might have */
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  /** Describes whether the customer is eligible for automatic tax collection in Stripe */
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Describes whether the customer's subscription is eligible for automatic tax collection in Stripe */
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  subscriptions: Array<MpSubscription>;
  /** Describes tax details for the Stripe customer */
  taxDetails?: Maybe<TaxDetails>;
  /** Describes customer's tax exemption status */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** Describes tax ids customer might have */
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type MpSubscription = GenericSubscription & {
  __typename?: 'MPSubscription';
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /** The UTC DateTime of the subscription period end */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: Scalars['String']['output'];
  product: Product;
  trial?: Maybe<Trial>;
};

export type MarkNoteAuthorAsDeletedForOrganizationError = {
  __typename?: 'MarkNoteAuthorAsDeletedForOrganizationError';
  cause: Scalars['String']['output'];
};

export type MarkNoteAuthorAsDeletedForOrganizationResponse = MarkNoteAuthorAsDeletedForOrganizationError | MarkNoteAuthorAsDeletedForOrganizationSuccessResponse;

export type MarkNoteAuthorAsDeletedForOrganizationSuccessResponse = {
  __typename?: 'MarkNoteAuthorAsDeletedForOrganizationSuccessResponse';
  success: Scalars['Boolean']['output'];
};

/** Mastodon metadata */
export type MastodonMetadata = {
  __typename?: 'MastodonMetadata';
  /** The instance of mastodon of the channel */
  serverUrl: Scalars['String']['output'];
};

/** Mastodon post metadata */
export type MastodonPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'MastodonPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Spoiler text hiding the root text of this post */
  spoilerText?: Maybe<Scalars['String']['output']>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Mastodon post metadata */
export type MastodonPostMetadataInput = {
  /** Spoiler text hiding the root text of this post */
  spoilerText?: InputMaybe<Scalars['String']['input']>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

export type MediaInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MediaType =
  | 'document'
  | 'gif'
  | 'image'
  | 'link'
  | 'unsupported'
  | 'video';

/** Represents the members connection edge. Later, we can add the list of members with the page info to follow our connection edge pattern. */
export type MemberConnection = {
  __typename?: 'MemberConnection';
  /** The total count of team members counting the org owner and team members from the Publish DB. */
  totalCount: Scalars['Int']['output'];
};

export type MigrationMarketingFeature =
  | 'advancedInstagramFeatures'
  | 'bestTimeToPost'
  | 'campaignAnalytics'
  | 'comprehensiveAnalytics'
  | 'customisableReports'
  | 'engagementTools'
  | 'hashtagManager'
  | 'organicAndBoostedPosts'
  | 'perChannelPricing'
  | 'publishingTools';

export type MigrationMarketingFeaturesCopy = {
  __typename?: 'MigrationMarketingFeaturesCopy';
  id: MigrationMarketingFeature;
  tagline: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MigrationPlan = {
  __typename?: 'MigrationPlan';
  interval: BillingInterval;
  name: Scalars['String']['output'];
  /** The UTC DateTime of the MP subscription period end. Suggested plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  supportedFeatures: Array<Maybe<MigrationMarketingFeature>>;
};

export type MigrationSummary = {
  __typename?: 'MigrationSummary';
  baseMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  basePlanPrice?: Maybe<Scalars['Float']['output']>;
  channelCount?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  migrationPreview?: Maybe<PlanMigrationPreview>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type MonthName =
  | 'April'
  | 'August'
  | 'December'
  | 'February'
  | 'January'
  | 'July'
  | 'June'
  | 'March'
  | 'May'
  | 'November'
  | 'October'
  | 'September';

/** Input for moving a feed collection */
export type MoveFeedCollectionInput = {
  /** Feed Collection that is being moved */
  id: Scalars['FeedCollectionId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Feed or FeedCollection the feed should come after. If null, it will be placed at the start */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for moving a feed */
export type MoveFeedInput = {
  /** FeedCollection the Feed should be stored in */
  collectionId?: InputMaybe<Scalars['FeedCollectionId']['input']>;
  /** Feed that is being moved */
  id: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Feed or FeedCollection the feed should come after. If null, it will be placed at the start */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for moving an idea group. */
export type MoveIdeaGroupInput = {
  id: Scalars['ID']['input'];
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** Union type representing possible payloads for moving an idea group. */
export type MoveIdeaGroupPayload = InvalidInputError | MoveIdeaGroupResponse | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response type for moving an idea group. */
export type MoveIdeaGroupResponse = {
  __typename?: 'MoveIdeaGroupResponse';
  ideaGroups: Array<IdeaGroup>;
};

/** moveIdea input type */
export type MoveIdeaInput = {
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Target group ID (null moves to unassigned) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the idea to move */
  ideaId: Scalars['ID']['input'];
  /** ID of the idea to place this idea after (null places at top) */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** moveIdea response (including errors) */
export type MoveIdeaPayload = MoveIdeaResponse | UnexpectedError;

/** moveIdea response type */
export type MoveIdeaResponse = {
  __typename?: 'MoveIdeaResponse';
  /** List of ideas that were affected by the move operation */
  updatedIdeas: Array<Idea>;
};

/** All possible response types that can be returned by movePostToDraftsV2 mutation. */
export type MovePostToDraftsResult = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** movePostToDraftsV2 mutation moves a post to drafts by id. */
export type MovePostToDraftsV2Input = {
  /** Post id to move to drafts. */
  id: Scalars['PostId']['input'];
};

/** List of post Mutation operations */
export type Mutation = {
  __typename?: 'Mutation';
  accountCompleteEmailVerification: AccountCompleteEmailVerification;
  accountInitiateEmailVerification: AccountInitiateEmailVerificationPayload;
  accountRemove: AccountRemovePayload;
  accountSetAvatar: Scalars['Boolean']['output'];
  accountSetCurrentOrganization: Scalars['Boolean']['output'];
  accountSetSettings: AccountSetSettingsPayload;
  accountSuspend: AccountSuspendResponse;
  accountUnsuspend: AccountUnsuspendResponse;
  /**
   * Changes account role for a given account. Can be either "customer" or "admin",
   * with "admin" only being set for Buffer employees.
   */
  accountUpdateRole: AccountUpdateRoleResponse;
  addBlock?: Maybe<BlockMutationResponse>;
  addBlocks?: Maybe<BlockMutationResponse>;
  addChildBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use the new addNoteToPost mutation */
  addEntityNote: AddEntityNotePayload;
  /** Add a note on a post */
  addNoteToPost: AddNoteToPostPayload;
  addOrUpdateDismissedObject: AddOrUpdateDismissedObjectPayload;
  addOrganizationToBetaProgram: MutationBasicPayload;
  /** Schedule the post to the next available slot. */
  addPostToQueue: AddPostToQueuePayload;
  /** Add Shop Grid Custom link */
  addShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Approve post request. */
  approvePost: ApprovePostPayload;
  /** @deprecated deprecated in favor of channelsConnectionRefresh */
  authorizeChannels: AuthorizeChannelsPayload;
  /**
   * Backfills channel analytics, posts and post analytics, were applicable.
   * It takes care of triggering both the new ingestion pipeline (buffer-mono) and
   * the legacy one (buffer-analytics).
   */
  backfillChannelPostsAndAnalytics: BackfillChannelPostsAndAnalyticsPayload;
  /** @deprecated Use `backfillChannelPostsAndAnalytics` instead. */
  backfillChannelUpdates: BackfillChannelUpdatesResponse;
  /**
   * Backfill natively posted updates for the grid preview.
   * Accessible only for internal clients, and rate-limited mutation.
   */
  backfillUpdatesForGrid: BackfillUpdatesForGridPayload;
  banStartPagesForOrg?: Maybe<StartPageMutationResponse>;
  /** @deprecated Use the createCheckoutSession mutation instead */
  billingCreateCheckoutSession: BillingCreateCheckoutSessionPayload;
  /** @deprecated Use the createCustomerPortalSession mutation instead */
  billingCreateCustomerPortalSession: BillingCreateCustomerPortalSessionPayload;
  /** @deprecated This endpoint has been deprecated */
  billingCreateSetupIntent: BillingCreatedSetupIntentPayload;
  billingIncreaseSubscriptionQuantityByChannelIds: BillingIncreaseSubscriptionQuantityByChannelIdsPayload;
  billingMigrateToBufferViaHub: BillingMigrateToOneBufferPayload;
  billingMigrateToOneBuffer: BillingMigrateToOneBufferPayload;
  billingStartTrial: BillingStartTrialPayload;
  /** @deprecated This endpoint has been deprecated */
  billingUpdateCustomerPaymentMethod: BillingUpdateCustomerPaymentMethodPayload;
  billingUpdateSubscriptionPlan: BillingUpdateSubscriptionPlanPayload;
  billingUpdateSubscriptionQuantity: BillingUpdateSubscriptionQuantityPayload;
  /** Cancel a trial for an organization. */
  cancelTrial: CancelTrialPayload;
  /** List the channels from a service */
  channelConnectionList: ChannelConnectionListPayload;
  /** Reconnect the channels of a service */
  channelConnectionRefresh: ChannelConnectionRefreshPayload;
  channelCreateOrUpdateNativeChannel: ChannelMutationResponse;
  channelStoreTemporaryCredentials: ChannelStoreTemporaryCredentialsResponse;
  channelUpdateLockedStatus: ChannelUpdateLockedStatusResponse;
  /** @deprecated deprecated in favor of authorizeChannels > channelsConnectionRefresh */
  channelsAuthorization: ChannelAuthorizationPayload;
  /** @deprecated deprecated in favor of channelsConnectWithResponse */
  channelsConnect?: Maybe<Scalars['Boolean']['output']>;
  channelsConnectWithResponse: ChannelsConnectPayload;
  /** @deprecated deprecated in favor of channelConnectionList */
  channelsForConnection: CredentialsForChannelsPayload;
  channelsLock?: Maybe<Scalars['Boolean']['output']>;
  channelsLockAllForOrganization?: Maybe<Array<Channel>>;
  /** Recalculate channel lock states for an organization */
  channelsLockForOrganization?: Maybe<Array<Channel>>;
  channelsRemove?: Maybe<Scalars['Boolean']['output']>;
  channelsSetRecommendations: ChannelsSetRecommendationsPayload;
  channelsUpdateCredentials: ChannelsUpdateCredentialsResponse;
  /** Verify an email update by verifying the JWT */
  completeEmailVerification: CompleteEmailVerificationPayload;
  /** Verify a suspicious login attempt by verifying the JWT */
  completeLoginVerification: LoginVerificationResponsePayload;
  /** Convert custom channel to API-enabled channel (e.g. IG Personal Profile to IG Business) */
  convertCustomChannel: ConvertCustomChannelPayload;
  /** Create a new channel group */
  createChannelGroup: CreateChannelGroupPayload;
  /**
   * Creates a new Stripe Checkout session for creating a subscription.
   * Returns either a success response with a checkout session URL or a billing error.
   */
  createCheckoutSession: CreateCheckoutSessionPayload;
  /** Connect a custom channel (e.g. FB Group or Bluesky) */
  createCustomChannels: CreateCustomChannelsPayload;
  /**
   * Creates a new Stripe Customer Portal session for managing billing settings.
   * Returns either a success response with a portal URL or a billing error.
   */
  createCustomerPortalSession: CreateCustomerPortalSessionPayload;
  /** Mutation to create a new failed post error. */
  createFailedPostError: CreateFailedPostErrorPayload;
  /** Create a new feed */
  createFeed: CreateOrUpdateFeedPayload;
  /** Add a create a feed collection */
  createFeedCollection: CreateOrUpdateFeedCollectionPayload;
  /** Create a new idea with the given content and metadata */
  createIdea: CreateIdeaPayload;
  /** Creates a new idea group with the provided input parameters. */
  createIdeaGroup: CreateIdeaGroupPayload;
  /** Create post for channel */
  createPost: PostActionPayload;
  /** Mutation for adding a saved reply */
  createSavedReply: CreateSavedReplyPayload;
  createStartPage?: Maybe<StartPageMutationResponse>;
  /** Create a new tag for the organization. */
  createTag: CreateTagPayload;
  /** @deprecated deprecated in favor of updateCustomChannel */
  customChannelUpdate: CustomChannelUpdatePayload;
  /** @deprecated deprecated in favor of createCustomChannels */
  customChannelsCreate: CustomChannelsCreatePayload;
  /** Delete an account (by a Buffer Admin) */
  deleteAccount: DeleteAccountPayload;
  /** Delete an internal comment from an account */
  deleteAdminComment: DeleteAdminCommentPayload;
  deleteBlock?: Maybe<BlocksMutationResponse>;
  /** Delete a channel group */
  deleteChannelGroup: DeleteChannelGroupPayload;
  /** @deprecated Use the new deleteNoteFromPost mutation */
  deleteEntityNote: DeleteEntityNotePayload;
  /** Mutation to delete a failed post error. */
  deleteFailedPostError: DeleteFailedPostErrorPayload;
  /** Delete a feed */
  deleteFeed: DeleteFeedPayload;
  /** Delete a feed collection */
  deleteFeedCollection: DeleteFeedCollectionPayload;
  /** Deletes an existing idea group based on the provided input parameters. */
  deleteIdeaGroup: DeleteIdeaGroupPayload;
  /** Delete a note from a post */
  deleteNoteFromPost: DeleteNoteFromPostPayload;
  /** @deprecated Use the new deletePostV2 mutation */
  deletePost: PostDeletionPayload;
  /** Delete a post by id. */
  deletePostV2: DeletePostResult;
  /** Deletes an existing saved reply. */
  deleteSavedReply: DeleteSavedReplyPayload;
  /** Delete Shop Grid Custom link */
  deleteShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Delete a tag for the organization. */
  deleteTag: DeleteTagPayload;
  /** Mutation for dismissing all comments for a given channel */
  dismissAllCommentsByChannelId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given organization */
  dismissAllCommentsByOrganizationId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given post */
  dismissAllCommentsByPostId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given channel */
  dismissAllCommentsForChannels: DismissAllCommentsForChannelsPayload;
  dismissBanner: DismissBannerPayload;
  /** Dismisses a comment, marking it as read or no longer relevant. */
  dismissComment: DismissCommentPayload;
  /** Update post dueAt date. We named it drop because it is called when a user drop a post on an empty slot during drag-and-drop. */
  dropPost: DropPostPayload;
  editBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use the new updateNoteOnPost mutation */
  editEntityNote: EditEntityNotePayload;
  /** Edit post for channel */
  editPost: PostActionPayload;
  emailNotificationPreferences: EmailNotificationPreferencePayload;
  engageDismiss?: Maybe<EngagementMutationResponse>;
  engageDismissAll?: Maybe<CommonMutationResponse>;
  engageHideMarkAsReadModal?: Maybe<CommonMutationResponse>;
  engageReply?: Maybe<EngagementMutationResponse>;
  engageUnDismiss?: Maybe<EngagementMutationResponse>;
  /**
   * Exchange a Publish access token for a JWT. Used by legacy clients wishing to communicate with the API gateway.
   * [See this document for more information](https://www.notion.so/buffer/Exchanging-an-Access-Token-for-a-JWT-28d4f5dd3ec9401194f1490bc336ce17).
   */
  exchangeAccessTokenForJwt: Scalars['String']['output'];
  exchangeGoogleTokenForBufferAdminJwt: Scalars['String']['output'];
  expandPost?: Maybe<TextGenerationResponse>;
  expandText?: Maybe<TextGenerationResponse>;
  generateHellonextSsoTokenForAccount: HellonextSsoMutationResponse;
  generateIdeas?: Maybe<TextGenerationResponse>;
  generatePost?: Maybe<TextGenerationResponse>;
  /**
   * Generates AI text completions based on pre-defined templates.
   * Returns either successful completion suggestions or an error.
   */
  generateTemplatedCompletion: GenerateTemplatedCompletionPayload;
  generateText?: Maybe<TextGenerationResponse>;
  getAuthorizationJwt: Scalars['String']['output'];
  hideOrShowBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use createIdea */
  ideaCreate: IdeaMutationPayload;
  /** @deprecated Use updateIdea */
  ideaUpdate: IdeaMutationPayload;
  ideasRemove: IdeasDeletionPayload;
  /** Initiate request flow for updating an account's email address */
  initiateEmailUpdateRequest: InitiateEmailUpdateRequestPayload;
  /** Update Account email */
  initiateUpdateEmail: InitiateUpdateEmailPayload;
  markNoteAuthorAsDeletedForOrganization: MarkNoteAuthorAsDeletedForOrganizationResponse;
  /** Move a feed to a new position and/or collection */
  moveFeed: FeedMoveUpdatesPayload;
  /** Move a feed collection to a new position */
  moveFeedCollection: FeedMoveUpdatesPayload;
  /** Move an idea to a new position within or between groups */
  moveIdea: MoveIdeaPayload;
  /** Moves an existing idea group within the organization based on the provided input parameters. */
  moveIdeaGroup: MoveIdeaGroupPayload;
  /** @deprecated Use the new movePostToDraftsV2 mutation */
  movePostToDrafts: PostUpdatedPayload;
  /** Move a post to drafts by id. */
  movePostToDraftsV2: MovePostToDraftsResult;
  /**
   * Optimizes a channel's posting schedule using Buffer's best time to post recommendations
   * This mutation applies Buffer's intelligent scheduling recommendations, with options
   * to either add to or override the existing schedule.
   */
  optimizePostingSchedule: OptimizePostingSchedulePayload;
  /** Reorders a channel for an account by placing it after another channel */
  orderChannelForAccount: OrderChannelForAccountPayload;
  organizationSetName?: Maybe<Scalars['Boolean']['output']>;
  /** Publish a post now without adding it to the queue. */
  publishPostNow: PublishPostNowPayload;
  publishStartPage?: Maybe<StartPageMutationResponse>;
  reOrderBlock?: Maybe<BlocksMutationResponse>;
  /** Refresh a feed */
  refreshFeed: RefreshFeedPayload;
  /** Refresh a feed collection */
  refreshFeedCollection: RefreshFeedCollectionPayload;
  refundCharge: Refund;
  /** Reject approval request. */
  rejectPost: RejectPostPayload;
  /** Delete an account by a user from the account */
  removeAccount: RemoveAccountPayload;
  /** Removes feature flip from account in DB */
  removeLegacyGlobalFeatureFlip: RemoveLegacyGlobalFeatureFlipPayload;
  removeOrganizationFromBetaProgram: MutationBasicPayload;
  /** Remove the scheduled time from a post. */
  removePostScheduledTime: RemovePostScheduledTimePayload;
  removeSubscriptionSchedule: RemoveSubscriptionSchedulePayload;
  removeTagFromIdea: IdeaMutationPayload;
  removeTagFromIdeas: TagActionInIdeasPayload;
  /** Reorder the post, moving it from it's current position to another. */
  reorderPosts: ReorderPostsPayload;
  rephrasePost?: Maybe<TextGenerationResponse>;
  rephraseText?: Maybe<TextGenerationResponse>;
  /** Replies to a comment with a text */
  replyToComment: ReplyToCommentPayload;
  /** Request post approval. */
  requestPostApproval: RequestPostApprovalPayload;
  /** Revert approval request. */
  revertPostApprovalRequest: RevertPostApprovalRequestPayload;
  /** Revoke access to a connectedApp */
  revokeAccessConnectedApp: RevokeAccessConnectedAppPayload;
  saveStartPageName?: Maybe<StartPageMutationResponse>;
  saveTheme?: Maybe<StartPageMutationResponse>;
  /** Schedule a post to a specific time. */
  schedulePost: SchedulePostPayload;
  /** Send test notification */
  sendTestNotification: SendTestNotificationPayload;
  /** Set password for account by id */
  setPasswordForAccount: SetPasswordForAccountPayload;
  /** Set posting schedule for Channel by id */
  setPostingScheduleForChannel: SetPostingScheduleForChannelPayload;
  startImpersonation: ImpersonationResponse;
  stopImpersonation: ImpersonationResponse;
  summarizePost?: Maybe<TextGenerationResponse>;
  summarizeText?: Maybe<TextGenerationResponse>;
  /** Swap posts in queue - It is called when a user drags a post and drops it on a slot containing another post. */
  swapPostsInQueue: SwapPostsInQueuePayload;
  /** Swap Shop Grid Custom links */
  swapShopGridCustomLinks: ShopGridCustomLinksMutationPayload;
  trackExternalServiceUsageForChannel: TrackExternalServiceUsageResponse;
  trackExternalServiceUsageForOrganization: TrackExternalServiceUsageResponse;
  /** Track Onboarding Survey being completed and the last answers for questions in db */
  trackOnboardingSurveyCompleted: TrackActionOnboardingSurveyPayload;
  /** Track Onboarding Survey being skipped in db */
  trackOnboardingSurveySkipped: TrackActionOnboardingSurveyPayload;
  /** Track Onboarding Survey being viewed in db */
  trackOnboardingSurveyViewed: TrackActionOnboardingSurveyPayload;
  /** Transfer the ownership of an organization to a new account. */
  transferOrganizationOwnership: TransferOrganizationOwnershipPayload;
  /** Confirm Two Factor Authentication */
  twoFactorConfirm: TwoFactorConfirmPayload;
  /** Disable Two Factor Authentication */
  twoFactorDisable: TwoFactorDisablePayload;
  /**
   * Disable Two Factor Authentication for an account
   * This is used for Buffer Admin to disable Two Factor Authentication for an account
   */
  twoFactorDisableByAccountId: TwoFactorDisablePayload;
  /** Requests a One-Time Password for Two Factor Authentication */
  twoFactorRequestOneTimePassword: TwoFactorRequestOneTimePasswordPayload;
  /** Set up Two Factor Authentication */
  twoFactorSetup: TwoFactorSetupPayload;
  unPublishStartPage?: Maybe<StartPageMutationResponse>;
  /** Undismisses a comment, marking it as unreplied, meaning it needs attention. */
  undismissComment: UndismissCommentPayload;
  /** update the avatar url for an account */
  updateAccountAvatar: UpdateAccountAvatarPayload;
  /** update the name of an account with the name provided */
  updateAccountName: UpdateAccountNamePayload;
  /** Update account preferences */
  updateAccountPreferences: UpdateAccountPreferencesPayload;
  /** Update account timezone */
  updateAccountTimezone: UpdateAccountTimezonePayload;
  /** Create or edit an internal comment that will be displayed in User Hub */
  updateAdminComment: UpdateAdminCommentPayload;
  /**
   * Temporary mutation to update the last updated at timestamps for analytics
   * This will be called by the Analyze workers. This will be removed once
   * the Analyze workers are migrated to monorepo or deprecated.
   */
  updateAnalyticsLastUpdatedAtByIngestionType: ChannelAnalyticsLastUpdateAtPayload;
  /** Update a channel group */
  updateChannelGroup: UpdateChannelGroupPayload;
  /** Update posting goal for Channel by id */
  updateChannelPostingGoal: UpdateChannelPostingGoalPayload;
  /** Update custom channel data */
  updateCustomChannel: UpdateCustomChannelPayload;
  /** Update custom links colors for a channel */
  updateCustomLinksColors: UpdateCustomLinksColorsPayload;
  /** Mutation to update an existing failed post error. */
  updateFailedPostError: UpdateFailedPostErrorPayload;
  updateFeatureTokenUsageForOrganization: OrganizationFeatureUsageUpdateResponse;
  /** Update a feed collection */
  updateFeedCollection: CreateOrUpdateFeedCollectionPayload;
  /** Update an existing idea with new content and metadata */
  updateIdea: UpdateIdeaPayload;
  /** Updates an existing idea group with the provided input parameters. */
  updateIdeaGroup: UpdateIdeaGroupPayload;
  /** Update lastActivityAt for a channel by id */
  updateLastActivityAtForChannel: UpdateLastActivityAtForChannelPayload;
  /** Update settings for a channel */
  updateLinkShorteningSettings: ChannelLinkShorteningPayload;
  /** Updates a note on a post and returns the result */
  updateNoteOnPost: UpdateNoteOnPostPayload;
  /** Update Account password */
  updatePassword: UpdatePasswordPayload;
  /** @todo: change response to use the generic PostUpdatedPayload */
  updatePostDueAt: UpdatePostDueAtMutationResponse;
  /** Assign tags to a post. Can also be used to remove all tags by passing an empty array. */
  updatePostTags: UpdatePostTagsPayload;
  /** Modifies an existing saved reply. */
  updateSavedReply: UpdateSavedReplyPayload;
  /** Update Shop Grid Custom link */
  updateShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Update Shop Grid Post link */
  updateShopGridPostLink: UpdateShopGridPostLinkPayload;
  /** Update account start of week preference */
  updateStartOfWeekPreference: UpdateStartOfWeekPreferencePayload;
  /** Update a tag for the organization. */
  updateTag: UpdateTagPayload;
  updateTagInIdeas: TagActionInIdeasPayload;
  /** Update account time format preference */
  updateTimeFormatPreference: UpdateTimeFormatPreferencePayload;
  /** Update timezone for Channel by id */
  updateTimezoneForChannel: UpdateTimezoneForChannelPayload;
  /**
   * Create a feed if it does not yet exist
   * @deprecated Use createFeed mutation instead
   */
  upsertFeed: CreateOrUpdateFeedPayload;
  /** Verify account by checking the password in DB */
  verifyPassword: VerifyPasswordPayload;
  /** Verify TFA code for account */
  verifyTfaCode: VerifyTfaCodePayload;
  voteForFeatureOnFeatureOS: VoteForFeatureMutationResponse;
};


/** List of post Mutation operations */
export type MutationAccountCompleteEmailVerificationArgs = {
  emailVerificationJWT: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAccountInitiateEmailVerificationArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountSetAvatarArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountSetCurrentOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountSetSettingsArgs = {
  settings: SettingsInput;
};


/** List of post Mutation operations */
export type MutationAccountSuspendArgs = {
  accountId: Scalars['String']['input'];
  shouldForceOperation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountUnsuspendArgs = {
  accountId: Scalars['String']['input'];
  shouldForceOperation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Mutation operations */
export type MutationAccountUpdateRoleArgs = {
  accountRole: AccountUpdateRoleInput;
};


/** List of post Mutation operations */
export type MutationAddBlockArgs = {
  config?: InputMaybe<BlockConfigInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddBlocksArgs = {
  config?: InputMaybe<Array<InputMaybe<BlockConfigInput>>>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddChildBlockArgs = {
  accountId: Scalars['String']['input'];
  config?: InputMaybe<ChildBlockConfigInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddEntityNoteArgs = {
  input: AddEntityNoteInput;
};


/** List of post Mutation operations */
export type MutationAddNoteToPostArgs = {
  input: AddNoteToPostInput;
};


/** List of post Mutation operations */
export type MutationAddOrUpdateDismissedObjectArgs = {
  dismissedObject: DismissedObjectInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddOrganizationToBetaProgramArgs = {
  bufferAdminAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationAddPostToQueueArgs = {
  input: AddPostToQueueInput;
};


/** List of post Mutation operations */
export type MutationAddShopGridCustomLinkArgs = {
  input: AddShopGridCustomLinkInput;
};


/** List of post Mutation operations */
export type MutationApprovePostArgs = {
  input: ApprovePostInput;
};


/** List of post Mutation operations */
export type MutationAuthorizeChannelsArgs = {
  channelAuthorization: ChannelAuthorizationInput;
};


/** List of post Mutation operations */
export type MutationBackfillChannelPostsAndAnalyticsArgs = {
  input: ChannelBackfillInput;
};


/** List of post Mutation operations */
export type MutationBackfillChannelUpdatesArgs = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBackfillUpdatesForGridArgs = {
  input: BackfillUpdatesForGridInput;
};


/** List of post Mutation operations */
export type MutationBanStartPagesForOrgArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBillingCreateCheckoutSessionArgs = {
  attribution?: InputMaybe<AttributionInput>;
  currentURL?: InputMaybe<Scalars['String']['input']>;
  interval: BillingInterval;
  organizationId: Scalars['String']['input'];
  plan: ObPlanId;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shouldCollectAutomaticTax?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingCreateCustomerPortalSessionArgs = {
  organizationId: Scalars['String']['input'];
  returnURL?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingCreateSetupIntentArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingIncreaseSubscriptionQuantityByChannelIdsArgs = {
  attribution?: InputMaybe<AttributionInput>;
  channelIds: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBillingMigrateToBufferViaHubArgs = {
  interval: BillingInterval;
  organizationId: Scalars['String']['input'];
  plan: ObPlanId;
  quantity: Scalars['Int']['input'];
};


/** List of post Mutation operations */
export type MutationBillingMigrateToOneBufferArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationBillingStartTrialArgs = {
  attribution?: InputMaybe<AttributionInput>;
  interval?: InputMaybe<BillingInterval>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
};


/** List of post Mutation operations */
export type MutationBillingUpdateCustomerPaymentMethodArgs = {
  attribution?: InputMaybe<AttributionInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingUpdateSubscriptionPlanArgs = {
  attribution?: InputMaybe<AttributionInput>;
  interval?: InputMaybe<BillingInterval>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Mutation operations */
export type MutationBillingUpdateSubscriptionQuantityArgs = {
  attribution?: InputMaybe<AttributionInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Mutation operations */
export type MutationCancelTrialArgs = {
  input: CancelTrialInput;
};


/** List of post Mutation operations */
export type MutationChannelConnectionListArgs = {
  input: ChannelConnectionListInput;
};


/** List of post Mutation operations */
export type MutationChannelConnectionRefreshArgs = {
  input: ChannelConnectionRefreshInput;
};


/** List of post Mutation operations */
export type MutationChannelCreateOrUpdateNativeChannelArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  channel: NativeChannelInput;
};


/** List of post Mutation operations */
export type MutationChannelStoreTemporaryCredentialsArgs = {
  channelConnections?: InputMaybe<Array<ChannelConnectionInput>>;
};


/** List of post Mutation operations */
export type MutationChannelUpdateLockedStatusArgs = {
  input: ChannelUpdateLockedStatusInput;
};


/** List of post Mutation operations */
export type MutationChannelsAuthorizationArgs = {
  channelAuthorization: ChannelAuthorizationInput;
};


/** List of post Mutation operations */
export type MutationChannelsConnectArgs = {
  channels?: InputMaybe<Array<ChannelWithCredentialsInput>>;
};


/** List of post Mutation operations */
export type MutationChannelsConnectWithResponseArgs = {
  channels?: InputMaybe<Array<ChannelWithCredentialsInput>>;
};


/** List of post Mutation operations */
export type MutationChannelsForConnectionArgs = {
  credentialsForChannels: CredentialsForChannelsInput;
};


/** List of post Mutation operations */
export type MutationChannelsLockArgs = {
  channelIdsToLock?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIdsToUnlock?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationChannelsLockAllForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationChannelsLockForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationChannelsRemoveArgs = {
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** List of post Mutation operations */
export type MutationChannelsSetRecommendationsArgs = {
  channels: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationChannelsUpdateCredentialsArgs = {
  channelsUpdatedCredentials: ChannelUpdateCredentialsInput;
};


/** List of post Mutation operations */
export type MutationCompleteEmailVerificationArgs = {
  input: CompleteEmailVerificationInput;
};


/** List of post Mutation operations */
export type MutationCompleteLoginVerificationArgs = {
  input: CompleteLoginVerificationInput;
};


/** List of post Mutation operations */
export type MutationConvertCustomChannelArgs = {
  input: ConvertCustomChannelInput;
};


/** List of post Mutation operations */
export type MutationCreateChannelGroupArgs = {
  input: CreateChannelGroupInput;
};


/** List of post Mutation operations */
export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


/** List of post Mutation operations */
export type MutationCreateCustomChannelsArgs = {
  input: CreateCustomChannelsInput;
};


/** List of post Mutation operations */
export type MutationCreateCustomerPortalSessionArgs = {
  input: CreateCustomerPortalSessionInput;
};


/** List of post Mutation operations */
export type MutationCreateFailedPostErrorArgs = {
  input: CreateFailedPostErrorInput;
};


/** List of post Mutation operations */
export type MutationCreateFeedArgs = {
  input: CreateFeedInput;
};


/** List of post Mutation operations */
export type MutationCreateFeedCollectionArgs = {
  input: CreateFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationCreateIdeaArgs = {
  input: CreateIdeaInput;
};


/** List of post Mutation operations */
export type MutationCreateIdeaGroupArgs = {
  input: CreateIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


/** List of post Mutation operations */
export type MutationCreateSavedReplyArgs = {
  input: CreateSavedReplyInput;
};


/** List of post Mutation operations */
export type MutationCreateStartPageArgs = {
  config?: InputMaybe<StartPageConfigInput>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/** List of post Mutation operations */
export type MutationCustomChannelUpdateArgs = {
  channel: CustomChannelUpdateInput;
};


/** List of post Mutation operations */
export type MutationCustomChannelsCreateArgs = {
  channels?: InputMaybe<Array<CustomChannelCreateInput>>;
};


/** List of post Mutation operations */
export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


/** List of post Mutation operations */
export type MutationDeleteAdminCommentArgs = {
  input: DeleteAdminCommentInput;
};


/** List of post Mutation operations */
export type MutationDeleteBlockArgs = {
  blockId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationDeleteChannelGroupArgs = {
  input: DeleteChannelGroupInput;
};


/** List of post Mutation operations */
export type MutationDeleteEntityNoteArgs = {
  input: DeleteEntityNoteInput;
};


/** List of post Mutation operations */
export type MutationDeleteFailedPostErrorArgs = {
  input: DeleteFailedPostErrorInput;
};


/** List of post Mutation operations */
export type MutationDeleteFeedArgs = {
  input: DeleteFeedInput;
};


/** List of post Mutation operations */
export type MutationDeleteFeedCollectionArgs = {
  input: DeleteFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationDeleteIdeaGroupArgs = {
  input: DeleteIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationDeleteNoteFromPostArgs = {
  input: DeleteNoteFromPostInput;
};


/** List of post Mutation operations */
export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


/** List of post Mutation operations */
export type MutationDeletePostV2Args = {
  input: DeletePostInputV2;
};


/** List of post Mutation operations */
export type MutationDeleteSavedReplyArgs = {
  input: DeleteSavedReplyInput;
};


/** List of post Mutation operations */
export type MutationDeleteShopGridCustomLinkArgs = {
  input: DeleteShopGridCustomLinkInput;
};


/** List of post Mutation operations */
export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsByChannelIdArgs = {
  input: DismissAllCommentsByChannelIdInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsByOrganizationIdArgs = {
  input: DismissAllCommentsByOrganizationIdInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsByPostIdArgs = {
  input: DismissAllCommentsByPostIdInput;
};


/** List of post Mutation operations */
export type MutationDismissAllCommentsForChannelsArgs = {
  input: DismissAllCommentsForChannelsInput;
};


/** List of post Mutation operations */
export type MutationDismissBannerArgs = {
  banner: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationDismissCommentArgs = {
  input: DismissCommentInput;
};


/** List of post Mutation operations */
export type MutationDropPostArgs = {
  input: DropPostInput;
};


/** List of post Mutation operations */
export type MutationEditBlockArgs = {
  blockId: Scalars['String']['input'];
  data?: InputMaybe<BlockDataInput>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEditEntityNoteArgs = {
  input: EditEntityNoteInput;
};


/** List of post Mutation operations */
export type MutationEditPostArgs = {
  input: EditPostInput;
};


/** List of post Mutation operations */
export type MutationEmailNotificationPreferencesArgs = {
  input: Array<EmailNotificationPreferenceInput>;
};


/** List of post Mutation operations */
export type MutationEngageDismissArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEngageDismissAllArgs = {
  targetId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEngageReplyArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationEngageUnDismissArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationExchangeGoogleTokenForBufferAdminJwtArgs = {
  googleToken?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationExpandPostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationExpandTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGenerateHellonextSsoTokenForAccountArgs = {
  accountId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGenerateIdeasArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGeneratePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGenerateTemplatedCompletionArgs = {
  input: GenerateTemplatedCompletionInput;
};


/** List of post Mutation operations */
export type MutationGenerateTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationGetAuthorizationJwtArgs = {
  product?: InputMaybe<Product>;
};


/** List of post Mutation operations */
export type MutationHideOrShowBlockArgs = {
  blockId: Scalars['String']['input'];
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationIdeaCreateArgs = {
  input: IdeaCreationInput;
};


/** List of post Mutation operations */
export type MutationIdeaUpdateArgs = {
  input: IdeaUpdateInput;
};


/** List of post Mutation operations */
export type MutationIdeasRemoveArgs = {
  input: IdeasDeletionInput;
};


/** List of post Mutation operations */
export type MutationInitiateEmailUpdateRequestArgs = {
  input: InitiateEmailUpdateRequestInput;
};


/** List of post Mutation operations */
export type MutationInitiateUpdateEmailArgs = {
  input: InitiateUpdateEmailInput;
};


/** List of post Mutation operations */
export type MutationMarkNoteAuthorAsDeletedForOrganizationArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationMoveFeedArgs = {
  input: MoveFeedInput;
};


/** List of post Mutation operations */
export type MutationMoveFeedCollectionArgs = {
  input: MoveFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationMoveIdeaArgs = {
  input: MoveIdeaInput;
};


/** List of post Mutation operations */
export type MutationMoveIdeaGroupArgs = {
  input: MoveIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationMovePostToDraftsArgs = {
  input: PostIdInput;
};


/** List of post Mutation operations */
export type MutationMovePostToDraftsV2Args = {
  input: MovePostToDraftsV2Input;
};


/** List of post Mutation operations */
export type MutationOptimizePostingScheduleArgs = {
  input: OptimizePostingScheduleInput;
};


/** List of post Mutation operations */
export type MutationOrderChannelForAccountArgs = {
  input: OrderChannelForAccountInput;
};


/** List of post Mutation operations */
export type MutationOrganizationSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationPublishPostNowArgs = {
  input: PublishPostNowInput;
};


/** List of post Mutation operations */
export type MutationPublishStartPageArgs = {
  data?: InputMaybe<PublishStartPageInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationReOrderBlockArgs = {
  blockId: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationRefreshFeedArgs = {
  input: RefreshFeedInput;
};


/** List of post Mutation operations */
export type MutationRefreshFeedCollectionArgs = {
  input: RefreshFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationRefundChargeArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Mutation operations */
export type MutationRejectPostArgs = {
  input: RejectPostInput;
};


/** List of post Mutation operations */
export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};


/** List of post Mutation operations */
export type MutationRemoveLegacyGlobalFeatureFlipArgs = {
  input: RemoveLegacyGlobalFeatureFlipInput;
};


/** List of post Mutation operations */
export type MutationRemoveOrganizationFromBetaProgramArgs = {
  bufferAdminAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationRemovePostScheduledTimeArgs = {
  input: RemovePostScheduledTimeInput;
};


/** List of post Mutation operations */
export type MutationRemoveSubscriptionScheduleArgs = {
  organizationId: Scalars['OrganizationId']['input'];
};


/** List of post Mutation operations */
export type MutationRemoveTagFromIdeaArgs = {
  input: TagRemovalFromIdeaInput;
};


/** List of post Mutation operations */
export type MutationRemoveTagFromIdeasArgs = {
  input: TagRemovalFromIdeasInput;
};


/** List of post Mutation operations */
export type MutationReorderPostsArgs = {
  input: ReorderPostsInput;
};


/** List of post Mutation operations */
export type MutationRephrasePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationRephraseTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationReplyToCommentArgs = {
  input: ReplyToCommentInput;
};


/** List of post Mutation operations */
export type MutationRequestPostApprovalArgs = {
  input: RequestPostApprovalInput;
};


/** List of post Mutation operations */
export type MutationRevertPostApprovalRequestArgs = {
  input: RevertPostApprovalRequestInput;
};


/** List of post Mutation operations */
export type MutationRevokeAccessConnectedAppArgs = {
  input: RevokeAccessConnectedAppInput;
};


/** List of post Mutation operations */
export type MutationSaveStartPageNameArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationSaveThemeArgs = {
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  theme?: InputMaybe<StartPageThemeInput>;
};


/** List of post Mutation operations */
export type MutationSchedulePostArgs = {
  input: SchedulePostInput;
};


/** List of post Mutation operations */
export type MutationSetPasswordForAccountArgs = {
  input: SetPasswordForAccountInput;
};


/** List of post Mutation operations */
export type MutationSetPostingScheduleForChannelArgs = {
  input: SetPostingScheduleForChannelInput;
};


/** List of post Mutation operations */
export type MutationStartImpersonationArgs = {
  input: StartImpersonationInput;
};


/** List of post Mutation operations */
export type MutationStopImpersonationArgs = {
  input: StopImpersonationInput;
};


/** List of post Mutation operations */
export type MutationSummarizePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationSummarizeTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationSwapPostsInQueueArgs = {
  input: SwapPostsInQueueInput;
};


/** List of post Mutation operations */
export type MutationSwapShopGridCustomLinksArgs = {
  input: SwapShopGridCustomLinksInput;
};


/** List of post Mutation operations */
export type MutationTrackExternalServiceUsageForChannelArgs = {
  action: Scalars['String']['input'];
  channelServiceId: Scalars['String']['input'];
  domain: ExternalServiceDomain;
  endpoint: Scalars['String']['input'];
  service: ChannelThirdPartyService;
  source: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationTrackExternalServiceUsageForOrganizationArgs = {
  action: Scalars['String']['input'];
  domain: ExternalServiceDomain;
  endpoint: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  service: ChannelThirdPartyService;
  source: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationTrackOnboardingSurveyCompletedArgs = {
  input: OnboardingSurveyCompletedInput;
};


/** List of post Mutation operations */
export type MutationTrackOnboardingSurveySkippedArgs = {
  input: OnboardingSurveyActionInput;
};


/** List of post Mutation operations */
export type MutationTrackOnboardingSurveyViewedArgs = {
  input: OnboardingSurveyActionInput;
};


/** List of post Mutation operations */
export type MutationTransferOrganizationOwnershipArgs = {
  input: TransferOrganizationOwnershipInput;
};


/** List of post Mutation operations */
export type MutationTwoFactorConfirmArgs = {
  input: TwoFactorConfirmInput;
};


/** List of post Mutation operations */
export type MutationTwoFactorDisableByAccountIdArgs = {
  input: TwoFactorDisableByAccountIdInput;
};


/** List of post Mutation operations */
export type MutationTwoFactorSetupArgs = {
  input: TwoFactorSetupInput;
};


/** List of post Mutation operations */
export type MutationUnPublishStartPageArgs = {
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** List of post Mutation operations */
export type MutationUndismissCommentArgs = {
  input: UndismissCommentInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountAvatarArgs = {
  input: UpdateAccountAvatarInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountNameArgs = {
  input: UpdateAccountNameInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountPreferencesArgs = {
  input: UpdateAccountPreferencesInput;
};


/** List of post Mutation operations */
export type MutationUpdateAccountTimezoneArgs = {
  input: UpdateAccountTimezoneInput;
};


/** List of post Mutation operations */
export type MutationUpdateAdminCommentArgs = {
  input: UpdateAdminCommentInput;
};


/** List of post Mutation operations */
export type MutationUpdateAnalyticsLastUpdatedAtByIngestionTypeArgs = {
  input: AnalyticsLastUpdatedAtInput;
};


/** List of post Mutation operations */
export type MutationUpdateChannelGroupArgs = {
  input: UpdateChannelGroupInput;
};


/** List of post Mutation operations */
export type MutationUpdateChannelPostingGoalArgs = {
  input: UpdateChannelPostingGoalInput;
};


/** List of post Mutation operations */
export type MutationUpdateCustomChannelArgs = {
  input: UpdateCustomChannelInput;
};


/** List of post Mutation operations */
export type MutationUpdateCustomLinksColorsArgs = {
  input: UpdateCustomLinksColorsInput;
};


/** List of post Mutation operations */
export type MutationUpdateFailedPostErrorArgs = {
  input: UpdateFailedPostErrorInput;
};


/** List of post Mutation operations */
export type MutationUpdateFeatureTokenUsageForOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  tokenUsageInput?: InputMaybe<TokenUsageInput>;
};


/** List of post Mutation operations */
export type MutationUpdateFeedCollectionArgs = {
  input: UpdateFeedCollectionInput;
};


/** List of post Mutation operations */
export type MutationUpdateIdeaArgs = {
  input: UpdateIdeaInput;
};


/** List of post Mutation operations */
export type MutationUpdateIdeaGroupArgs = {
  input: UpdateIdeaGroupInput;
};


/** List of post Mutation operations */
export type MutationUpdateLastActivityAtForChannelArgs = {
  input: UpdateLastActivityAtForChannelInput;
};


/** List of post Mutation operations */
export type MutationUpdateLinkShorteningSettingsArgs = {
  input: LinkShorteningSettingsInput;
};


/** List of post Mutation operations */
export type MutationUpdateNoteOnPostArgs = {
  input: UpdateNoteOnPostInput;
};


/** List of post Mutation operations */
export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


/** List of post Mutation operations */
export type MutationUpdatePostDueAtArgs = {
  input: UpdatePostDueAtInput;
};


/** List of post Mutation operations */
export type MutationUpdatePostTagsArgs = {
  input: UpdatePostTagsInput;
};


/** List of post Mutation operations */
export type MutationUpdateSavedReplyArgs = {
  input: UpdateSavedReplyInput;
};


/** List of post Mutation operations */
export type MutationUpdateShopGridCustomLinkArgs = {
  input: UpdateShopGridCustomLinkInput;
};


/** List of post Mutation operations */
export type MutationUpdateShopGridPostLinkArgs = {
  input: UpdateShopGridPostLinkInput;
};


/** List of post Mutation operations */
export type MutationUpdateStartOfWeekPreferenceArgs = {
  input: UpdateStartOfWeekPreferenceInput;
};


/** List of post Mutation operations */
export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** List of post Mutation operations */
export type MutationUpdateTagInIdeasArgs = {
  input: UpdateTagInIdeasInput;
};


/** List of post Mutation operations */
export type MutationUpdateTimeFormatPreferenceArgs = {
  input: UpdateTimeFormatPreferenceInput;
};


/** List of post Mutation operations */
export type MutationUpdateTimezoneForChannelArgs = {
  input: UpdateTimezoneForChannelInput;
};


/** List of post Mutation operations */
export type MutationUpsertFeedArgs = {
  input: CreateFeedInput;
};


/** List of post Mutation operations */
export type MutationVerifyPasswordArgs = {
  input: VerifyPasswordInput;
};


/** List of post Mutation operations */
export type MutationVerifyTfaCodeArgs = {
  input: VerifyTfaCodeInput;
};


/** List of post Mutation operations */
export type MutationVoteForFeatureOnFeatureOsArgs = {
  accountId: Scalars['String']['input'];
  featureId: Scalars['Int']['input'];
};

export type MutationBasicError = {
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type MutationBasicPayload = BasicError | MutationBasicResponse;

export type MutationBasicResponse = {
  __typename?: 'MutationBasicResponse';
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

/** Base Mutation Error type */
export type MutationError = {
  /** Error message */
  message: Scalars['String']['output'];
};

export type MutationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Base Mutation Success type
 * Used when we have a success response with no data, we return this type with empty string
 */
export type MutationSuccess = {
  /**
   * The value is alwaus an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type NativeChannelInput = {
  avatar: Scalars['String']['input'];
  /** channelId is only necessary for update operation: omitting the channeId will result in channel creation */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  service: ChannelNativeService;
  type: ChannelType;
};

/** Connection metadata for RSS feeds */
export type NewsSearchConnectionMetadata = {
  __typename?: 'NewsSearchConnectionMetadata';
  /** Search query */
  query?: Maybe<Scalars['String']['output']>;
};

/** Create a live news search feed by query string */
export type NewsSearchFeedCreation = {
  /** The query string to use for news search */
  query: Scalars['String']['input'];
};

/** Error returned when the resource is not found */
export type NotFoundError = MutationError & {
  __typename?: 'NotFoundError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Note entity */
export type Note = {
  __typename?: 'Note';
  /** The allowed actions a user can perform on the note. */
  allowedActions: Array<NoteAction>;
  /** The author of the note - null if the user is deleted or left the organization. */
  author: Author;
  /** The date and time when the note was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the note. */
  id: Scalars['NoteId']['output'];
  /** The content of the note. */
  text: Scalars['String']['output'];
  /** The type of the note. */
  type: NoteType;
  /** The date and time when the note was last edited. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** List of possible actions that can be performed on a note */
export type NoteAction =
  /** The user can delete the note. */
  | 'deleteNote'
  /** The user can update the note. */
  | 'updateNote';

export type NoteAuthor = {
  __typename?: 'NoteAuthor';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** The type of a note. */
export type NoteType =
  /** A note that was generated by our AI system. */
  | 'aiGenerated'
  /** A note that was generated by our internal system. Can be used for approval flows notifications or other automated processes. */
  | 'bufferGenerated'
  /** A note that was manually written by a user. */
  | 'userGenerated';

/** List of possible statuses for a notification */
export type NotificationStatus =
  | 'markedAsPublished'
  | 'notified';

export type ObBilling = Billing & {
  __typename?: 'OBBilling';
  /** Describes the billing address of the customer */
  address?: Maybe<Address>;
  /** Any credit (negative balance) or debit (positive balance) a customer might have */
  balance: Scalars['Float']['output'];
  canAccessAnalytics: Scalars['Boolean']['output'];
  canAccessEngagement: Scalars['Boolean']['output'];
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  canStartTrial: Scalars['Boolean']['output'];
  changePlanOptions: Array<Maybe<ObPlanOption>>;
  channelSlotDetails: ChannelSlotDetails;
  /** Describes any discount coupon a customer might have */
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  generateContentTokensLeft: Scalars['Int']['output'];
  hasNeverBeenPayingCustomer: Scalars['Boolean']['output'];
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  /** Describes whether the customer is eligible for automatic tax collection in Stripe */
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Describes whether the customer's subscription is eligible for automatic tax collection in Stripe */
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  /** A set of price details that support tiers, used to calculate the total cost on the client. Non-tiered plans will only contain one PricingTier */
  pricingTiers: Array<PricingTier>;
  /** The amount of channels that can be refunded */
  refundableChannels: Scalars['Int']['output'];
  subscription: ObSubscription;
  /** Describes tax details for the Stripe customer */
  taxDetails?: Maybe<TaxDetails>;
  /** Describes customer's tax exemption status */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** Describes tax ids customer might have */
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type ObPlan = {
  __typename?: 'OBPlan';
  id: ObPlanId;
  interval: BillingInterval;
  limits: PlanLimits;
  name: Scalars['String']['output'];
  prices: PlanPrices;
};

export type ObPlanId =
  | 'agency'
  | 'essentials'
  | 'free'
  | 'team';

export type ObPlanOption = {
  __typename?: 'OBPlanOption';
  /** A message that displays the savings between, yearly and monthly. e.g. 'Save $24/year' when monthly plan selected or 'Saving $24/year' when yearly plan selected. For Free plans the value is empty string '' */
  absoluteSavings: Scalars['String']['output'];
  basePrice: Scalars['Float']['output'];
  /** A set of values per plan option to be used for calculating the 'Slot Based' price on the client side. */
  channelSlotDetails?: Maybe<ChannelSlotDetails>;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * A message that will be displayed when the subscription is to be canceled at the period end.
   * e.g. Your plan was recently changed to Free. You can continue using the Essentials plan features until the end of your billing cycle on April 24, 2021.
   */
  downgradedMessage: Scalars['String']['output'];
  highlights: Array<Maybe<Scalars['String']['output']>>;
  highlightsHeading: Scalars['String']['output'];
  isCurrentPlan: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  planId: ObPlanId;
  planInterval: BillingInterval;
  planName: Scalars['String']['output'];
  priceNote: Scalars['String']['output'];
  /** A set of price details that support tiers, used to calculate the total cost on the client. Non-tiered plans will only contain one PricingTierÏ */
  pricingTiers: Array<PricingTier>;
  summary: ObPlanOptionSummary;
  totalPrice: Scalars['Float']['output'];
};

export type ObPlanOptionSummary = {
  __typename?: 'OBPlanOptionSummary';
  details: Array<Maybe<Scalars['String']['output']>>;
};

export type ObSubscription = GenericSubscription & {
  __typename?: 'OBSubscription';
  /** The UTC DateTime of the cancelation */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of the its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /**
   * Indicates whether the customer's current subscription payment is past due. Used by the frontend to display a past due banner to the customer.
   * This field is not for the purpose of determining subscription status (see the Billing interface instead)
   */
  isPaymentPastDue?: Maybe<Scalars['Boolean']['output']>;
  /** The UTC DateTime of the subscription period end. Free plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: ObPlan;
  quantity: Scalars['Int']['output'];
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdate>;
  trial?: Maybe<Trial>;
};

/** The oEmbed response object as specified by https://oembed.com/. */
export type OEmbedRich = {
  __typename?: 'OEmbedRich';
  /** The name of the author/owner of the resource. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** A URL for the author/owner of the resource. */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Suggested cache lifetime for the resource (in seconds). */
  cacheAge?: Maybe<Scalars['Int']['output']>;
  /**
   * The height of the embedded resource in pixels.
   * Regarding the specification this field should be mandatory but Threads at least
   * is not sending us this field, so we'll keep optional by now.
   */
  height?: Maybe<Scalars['Int']['output']>;
  /** The HTML required to embed the resource. */
  html: Scalars['String']['output'];
  /** The name of the resource provider. */
  providerName?: Maybe<Scalars['String']['output']>;
  /** The URL of the resource provider. */
  providerUrl?: Maybe<Scalars['String']['output']>;
  /** The height of the thumbnail image in pixels. */
  thumbnailHeight?: Maybe<Scalars['Int']['output']>;
  /** A URL to a thumbnail image representing the resource. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The width of the thumbnail image in pixels. */
  thumbnailWidth?: Maybe<Scalars['Int']['output']>;
  /** A text title, describing the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of content. Always "rich". */
  type: Scalars['String']['output'];
  /** The oEmbed version number. Currently, only "1.0" is supported. */
  version: Scalars['String']['output'];
  /** The width of the embedded resource in pixels. */
  width: Scalars['Int']['output'];
};

/** Onboarding Survey Input Type for tracking an action */
export type OnboardingSurveyActionInput = {
  /** organizationId of the organization that the survey is being taken for */
  organizationId: Scalars['OrganizationId']['input'];
  /** surveyId of the survey that is being tracked */
  surveyId: Scalars['String']['input'];
};

/** Onboarding Survey Action Taken */
export type OnboardingSurveyActionTaken = {
  __typename?: 'OnboardingSurveyActionTaken';
  /** action that was taken */
  action: OnboardingSurveyActionTakenType;
  /** timestamp when the action was taken */
  date: Scalars['String']['output'];
};

/** Onboarding Survey: 3 different types of actions can be taken */
export type OnboardingSurveyActionTakenType =
  | 'completed'
  | 'skipped'
  | 'viewed';

export type OnboardingSurveyCompletedInput = {
  /** organizationId of the organization that the survey has been completed */
  organizationId: Scalars['OrganizationId']['input'];
  /** answers to the survey questions */
  questions: Array<OnboardingSurveyQuestionInput>;
  /** surveyId of the survey that is being taken */
  surveyId: Scalars['String']['input'];
};

/** OnboardingSurveyQuestion Input Type */
export type OnboardingSurveyQuestionInput = {
  /** answer options for the question */
  answers: Array<Scalars['String']['input']>;
  /** questionId of the question */
  questionId: Scalars['String']['input'];
};

/** Input parameters for optimizing a channel's posting schedule with Buffer's recommendations */
export type OptimizePostingScheduleInput = {
  /** The ID of the channel to optimize the schedule for */
  channelId: Scalars['ChannelId']['input'];
  /** The number of posts per week to target */
  postsPerWeek: Scalars['Int']['input'];
  /** How to apply recommendations to the existing schedule (override or add) */
  updateMode: OptimizeScheduleMode;
};

/** The result of optimizing a posting schedule */
export type OptimizePostingSchedulePayload = InvalidInputError | NotFoundError | OptimizePostingScheduleResponse | UnauthorizedError | UnexpectedError;

/** Response for successful schedule optimization */
export type OptimizePostingScheduleResponse = {
  __typename?: 'OptimizePostingScheduleResponse';
  /** The updated posting schedule */
  postingSchedule: Array<Maybe<ScheduleV2>>;
};

/** The mode for updating the posting schedule: override or add */
export type OptimizeScheduleMode =
  | 'add'
  | 'override';

/** Input Types */
export type OrderBy = {
  by: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Input for ordering a channel for an account */
export type OrderChannelForAccountInput = {
  /**
   * ID of the channel after which the target channel should be positioned.
   * If set to null, the channel to order will go to the first position of the list
   */
  afterChannelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** ID of the channel to be ordered */
  channelId: Scalars['ChannelId']['input'];
  /** ID of the organization to be ordered */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Possible responses when ordering a channel for an account */
export type OrderChannelForAccountPayload = EmptySuccess | NotFoundError | UnexpectedError;

/** Organization is a representation of a Buffer Organization. */
export type Organization = {
  __typename?: 'Organization';
  billing: Billing;
  billingNotifications: BillingNotificationSet;
  canMigrateToBufferViaHub?: Maybe<CanMigrateToOneBuffer>;
  canMigrateToOneBuffer: CanMigrateToOneBuffer;
  channelCount: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of field 'limits' */
  channelLimit: Scalars['Int']['output'];
  /**
   * Fetch all channels for the account taking in account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using AccountOrganization.channels, Organization.channels or Query.channels instead
   */
  channels: Array<Channel>;
  commonTrackingProperties?: Maybe<CommonTrackingProperties>;
  contactAccountId: Scalars['String']['output'];
  dismissedObjects?: Maybe<Array<Maybe<DismissedObject>>>;
  entitlements: Array<Maybe<Entitlement>>;
  id: Scalars['ID']['output'];
  /** Is the organization enrolled in the alpha program? */
  isAlphaEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the organization enrolled in the beta program? */
  isBetaEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOneBufferOrganization: Scalars['Boolean']['output'];
  lifetimeConnectedChannelsCount?: Maybe<Array<Maybe<LifetimeConnectedChannelCount>>>;
  limits: OrganizationLimits;
  members: MemberConnection;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  shouldShowTeamMemberOrganizationDowngradedBanner: Scalars['Boolean']['output'];
  /** Fetch all accounts that can be new owners for this organization */
  validNewOwners: Array<Account>;
};


/** Organization is a representation of a Buffer Organization. */
export type OrganizationChannelsArgs = {
  input?: InputMaybe<OrganizationChannelsInput>;
  product?: InputMaybe<Product>;
};

/** Input for the channels field on Account */
export type OrganizationChannelsInput = {
  /** Query's filter. */
  filter?: InputMaybe<ChannelsFiltersInput>;
};

export type OrganizationFeatureUsageUpdateResponse = Error | Response;

/** Allow retrieving a specific AccountOrganization */
export type OrganizationFilterInput = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationIdInput = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationLimits = {
  __typename?: 'OrganizationLimits';
  channels: Scalars['Int']['output'];
  generateContent: Scalars['Int']['output'];
  ideaGroups: Scalars['Int']['output'];
  ideas: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  savedReplies: Scalars['Int']['output'];
  scheduledPosts: Scalars['Int']['output'];
  scheduledStoriesPerChannel: Scalars['Int']['output'];
  scheduledThreadsPerChannel: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
};

export type OrganizationReferralCodeResponse = {
  __typename?: 'OrganizationReferralCodeResponse';
  referralCode: Scalars['String']['output'];
};

export type OrganizationsInput = {
  ids: Array<Scalars['OrganizationId']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

/** @drepecated: Use PaginatedIdeasV2 */
export type PaginatedIdeasList = {
  __typename?: 'PaginatedIdeasList';
  edges: Array<Maybe<IdeaEdge>>;
  pageInfo: PaginationPageInfo;
};

/** @drepecated: Use PaginatedIdeasV2 */
export type PaginatedIdeasPayload = CoreWebAppCommonError | PaginatedIdeasList;

/** Pagination connection for Ideas */
export type PaginatedIdeasV2 = {
  __typename?: 'PaginatedIdeasV2';
  /** List of idea edges containing the ideas and their cursors */
  edges: Array<IdeaEdge>;
  /** Pagination metadata including hasNextPage and endCursor */
  pageInfo: PaginationPageInfo;
};

export type PaginatedPosts = {
  __typename?: 'PaginatedPosts';
  edges?: Maybe<Array<PublishingPostEdge>>;
  pageInfo: PostPageInfo;
};

export type PaginatedPostsResponse = {
  __typename?: 'PaginatedPostsResponse';
  edges?: Maybe<Array<Maybe<PostEdge>>>;
  pageInfo?: Maybe<PaginationPageInfo>;
};

/** Information to aid in pagination. */
export type PaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  /** The last cursor in the list. It can be used to fetch the next page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When set to true, it means there is a next page available. */
  hasNextPage: Scalars['Boolean']['output'];
  /** When set to true, it means there is a previous page available. Will always return false for now as we only support forward pagination. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The first cursor in the list. It can be used to fetch the previous page. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The payment details for the customer's current subscription on their current billing gateway */
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** The credit card information for the customer, if applicable */
  creditCard?: Maybe<CreditCard>;
  /** Whether the customer has payment details stored in the billing gateway */
  hasPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  /** The payment method used by the customer to pay for their current subscription */
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

/** A Pinterest board */
export type PinterestBoard = {
  __typename?: 'PinterestBoard';
  /** The board avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The board description */
  description?: Maybe<Scalars['String']['output']>;
  /** The board name */
  name: Scalars['String']['output'];
  /** The ID of the service */
  serviceId: Scalars['String']['output'];
  /** The board URL */
  url: Scalars['String']['output'];
};

export type PinterestData = {
  __typename?: 'PinterestData';
  is_repin?: Maybe<Scalars['Boolean']['output']>;
};

/** Pinterest metadata */
export type PinterestMetadata = {
  __typename?: 'PinterestMetadata';
  /** The list of boards the user has on Pinterest */
  boards: Array<PinterestBoard>;
};

/** Pinterest post metadata */
export type PinterestPostMetadata = CommonPostMetadata & {
  __typename?: 'PinterestPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The board the Pin is saved to */
  board?: Maybe<PinterestBoard>;
  /** The title of the Pin */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
  /** The Pin destination link */
  url?: Maybe<Scalars['String']['output']>;
};

/** Pinterest post metadata */
export type PinterestPostMetadataInput = {
  /**
   * The board ID of the Pin, can be obtained when fetching the channel details with the following query:
   * ```
   * query GetChannelWithSubprofiles {
   *   channel(input: { id: "[CHANNEL_ID_HERE]" }) {
   *     metadata {
   *       ... on PinterestMetadata {
   *         boards {
   *           serviceId
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   */
  boardServiceId: Scalars['String']['input'];
  /** The title of the Pin */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The Pin destination link */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceholderIdeasCreatedPayload = CoreWebAppCommonError | PlaceholderIdeasMutationSuccess;

/** Query / Mutation responses */
export type PlaceholderIdeasMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'PlaceholderIdeasMutationSuccess';
  code: Scalars['String']['output'];
  /** The created ideas */
  ideas: Array<Idea>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PlanLimits = {
  __typename?: 'PlanLimits';
  channels: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  scheduledPosts: Scalars['Int']['output'];
};

export type PlanMigrationPreview = {
  __typename?: 'PlanMigrationPreview';
  chargeAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  intervalAmount?: Maybe<Scalars['Float']['output']>;
};

export type PlanMigrationPreviewDetails = {
  __typename?: 'PlanMigrationPreviewDetails';
  currentPlan: MigrationPlan;
  migrationSummary?: Maybe<MigrationSummary>;
  planFeatures: Array<Maybe<MigrationMarketingFeaturesCopy>>;
  suggestedPlan: MigrationPlan;
};

export type PlanMigrationPreviewResponse = {
  __typename?: 'PlanMigrationPreviewResponse';
  preview?: Maybe<PlanMigrationPreviewDetails>;
  showPreview: Scalars['Boolean']['output'];
};

export type PlanPrices = {
  __typename?: 'PlanPrices';
  /**
   * Describes the monthly amount of a Plan, in dollars, without the quantity multipliers and any customer or subscription discounts.
   * This value differs from the "upcomingInvoiceAmount" that describes the exact amount that the customer is paying.
   */
  baseMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Describes Plan amount, in dollars, without the quantity multipliers and any customer or subscription discounts.
   * This value differs from the "upcomingInvoiceAmount" that describes the exact amount that the customer is paying.
   */
  basePlanPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The amount of channels up to that are covered by the flat Fee.
   * Used for tiered pricing plans only.
   */
  channelTierUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The monthly channel price a customer pays for every channel above the channelTierUnit.
   * Used for tiered pricing plans only.
   */
  monthlyChannelPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The monthly amount (calculated as monthly for yearly subscriptions as well) a customer pays, irrelevant to the amount of channels connected.
   * Used for tiered pricing plans only.
   */
  monthlyFlatFee?: Maybe<Scalars['Float']['output']>;
};

/** Post entity */
export type Post = {
  __typename?: 'Post';
  /** actions */
  allowedActions: Array<PostAction>;
  /** assets */
  assets: Array<Asset>;
  /** Represents the user who created the post */
  author?: Maybe<Author>;
  /** channel */
  channel: Channel;
  /** channel ID (faster than resolving the channnel.id) */
  channelId: Scalars['ChannelId']['output'];
  /** channel service (faster than resolving the channnel.service) */
  channelService: Service;
  /** Date when the post was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date when the post is scheduled to be published */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** error */
  error?: Maybe<PostPublishingError>;
  /** The external URL of the post at the destination service */
  externalLink?: Maybe<Scalars['String']['output']>;
  /** ObjectId of the post */
  id: Scalars['PostId']['output'];
  /** Is set when the Post is generated from an Idea */
  ideaId?: Maybe<Scalars['IdeaId']['output']>;
  /** Indicates whether time to publish was manually selected by the user */
  isCustomScheduled: Scalars['Boolean']['output'];
  /** flags */
  isPinned: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  /**
   * Metadata of the post which differs based on the social network/service
   * @see post.metadata.graphql
   */
  metadata?: Maybe<PostMetadata>;
  /** Metrics for the sent post. If post is not yet sent, this field will be null */
  metrics?: Maybe<Array<PostMetric>>;
  /** Metrics for the sent post. If post is not yet sent, this field will be null */
  metricsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** notes */
  notes: Array<Note>;
  /** notificationStatus: notified or markedAsPublished */
  notificationStatus?: Maybe<NotificationStatus>;
  /** Scheduling type can be null if the post was created natively on the social network without using notification publishing or automatic publishing */
  schedulingType?: Maybe<SchedulingType>;
  /** Date when the post is published */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the post was shared via publish now action */
  sharedNow: Scalars['Boolean']['output'];
  /** status */
  status: PostStatus;
  /** tags - sorted by name in ascending order */
  tags: Array<Tag>;
  /** Text content of the Post */
  text: Scalars['String']['output'];
  /** Date when the post was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Indicates if the post is created from Buffer or the API */
  via: PostVia;
};

/** List of possible actions that can be performed on a Post */
export type PostAction =
  | 'addPostNote'
  | 'addPostToQueue'
  | 'approvePost'
  | 'copyPostLink'
  | 'deletePost'
  | 'duplicatePost'
  | 'movePostToDraft'
  | 'publishPostNext'
  | 'publishPostNow'
  | 'rejectPost'
  | 'removePostScheduledTime'
  | 'requestPostApproval'
  | 'revertPostApprovalRequest'
  | 'sharePostLink'
  | 'updatePost'
  | 'updatePostSchedule'
  | 'updatePostTags'
  | 'updateShopGridLink'
  | 'viewPost';

/** Create post's request response payload. */
export type PostActionPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Success response returns the full up-to-date post from after the action was performed. */
export type PostActionSuccess = {
  __typename?: 'PostActionSuccess';
  /** Post on which the action was successfully performed. */
  post: Post;
};

/** Filters for the posts count query */
export type PostCountsFiltersInput = {
  /** When set, it will filter posts by channel */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** When set, it will filter posts by status */
  status?: InputMaybe<Array<PostStatus>>;
  /** When set, it will filter posts by tag */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
};

/** Input for the posts count query */
export type PostCountsInput = {
  /** The filters to apply to the posts query */
  filter?: InputMaybe<PostCountsFiltersInput>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the post counts query */
export type PostCountsResponse = {
  __typename?: 'PostCountsResponse';
  /** The list of counts for the given organization */
  counts: Array<PostsCount>;
};

export type PostDeletionPayload = PostDeletionResponse | PublishingError;

export type PostDeletionResponse = {
  __typename?: 'PostDeletionResponse';
  postId: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EngagePost>;
};

export type PostFiltersInput = {
  /** The channel(s) ids to fetch posts for */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate?: InputMaybe<Scalars['Int']['input']>;
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate?: InputMaybe<Scalars['Int']['input']>;
  /** The status of posts to return */
  status?: InputMaybe<Array<PublishingPostStatus>>;
  /** The tag(s) ids of posts to return */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PostIdInput = {
  postId: Scalars['String']['input'];
};

/** Input for the post query */
export type PostInput = {
  /** The ID of the post to be retrieved */
  id: Scalars['PostId']['input'];
};

/** Metadata of the post which differs based on the social network/service */
export type PostInputMetaData = {
  /** Metadata for Bluesky post */
  bluesky?: InputMaybe<BlueskyPostMetadataInput>;
  /** Metadata for Facebook post */
  facebook?: InputMaybe<FacebookPostMetadataInput>;
  /** Metadata for Google Business Profile post */
  google?: InputMaybe<GoogleBusinessPostMetadataInput>;
  /** Metadata for Instagram post */
  instagram?: InputMaybe<InstagramPostMetadataInput>;
  /** Metadata for LinkedIn post */
  linkedin?: InputMaybe<LinkedInPostMetadataInput>;
  /** Metadata for Mastodon post */
  mastodon?: InputMaybe<MastodonPostMetadataInput>;
  /** Metadata for Pinterest post */
  pinterest?: InputMaybe<PinterestPostMetadataInput>;
  /** Metadata for Start Page post */
  startPage?: InputMaybe<StartPagePostMetadataInput>;
  /** Metadata for Threads post */
  threads?: InputMaybe<ThreadsPostMetadataInput>;
  /** Metadata for Twitter post */
  twitter?: InputMaybe<TwitterPostMetadataInput>;
  /** Metadata for Youtube post */
  youtube?: InputMaybe<YoutubePostMetadataInput>;
};

/** Post metadata union type. Contains all possible types of post metadata. */
export type PostMetadata = BlueskyPostMetadata | FacebookPostMetadata | GoogleBusinessPostMetadata | InstagramPostMetadata | LinkedInPostMetadata | MastodonPostMetadata | PinterestPostMetadata | StartPagePostMetadata | ThreadsPostMetadata | TiktokPostMetadata | TwitterPostMetadata | YoutubePostMetadata;

/** Post metric */
export type PostMetric = {
  __typename?: 'PostMetric';
  /** The metric description */
  description: Scalars['String']['output'];
  /** The displayble metric name */
  displayName: Scalars['String']['output'];
  /** The metric name */
  name: Scalars['String']['output'];
  /** The metric value returning null if not in the DB */
  nullableValue?: Maybe<Scalars['Float']['output']>;
  /** The metric type */
  type: PostMetricType;
  /** The metric unit of the value */
  unit: PostMetricUnit;
  /** The metric value */
  value: Scalars['Float']['output'];
};

export type PostMetricLegacy = {
  __typename?: 'PostMetricLegacy';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type PostMetricObject = {
  __typename?: 'PostMetricObject';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values?: Maybe<Array<PostMetricLegacy>>;
};

/** List of possible metrics available for a Post. Some services may have different metrics (e.g., Instagram has likes, comments, shares but Twitter has retweets, likes) */
export type PostMetricType =
  | 'clicks'
  | 'comments'
  | 'engagementRate'
  | 'favorites'
  | 'impressions'
  | 'likes'
  | 'link_clicks'
  /** deprecated */
  | 'other'
  | 'quotes'
  | 'reach'
  | 'reactions'
  | 'reblogs'
  | 'repins'
  | 'replies'
  | 'reposts'
  | 'retweets'
  | 'saves'
  | 'shares'
  | 'totalTimeWatched'
  | 'viewers'
  | 'views';

/** The unit representing the value of a PostMetric */
export type PostMetricUnit =
  | 'count'
  | 'percentage';

export type PostNotFound = CoreWebAppMutationResponse & {
  __typename?: 'PostNotFound';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The ID of the post that could not be found */
  postId: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostNotUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostNotUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The ID of the post that could not be found */
  postId: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostPageInfo = {
  __typename?: 'PostPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Post publishing error */
export type PostPublishingError = {
  __typename?: 'PostPublishingError';
  /** Error message to display */
  message: Scalars['String']['output'];
  /** Link to a help center article to help resolve the error */
  supportUrl?: Maybe<Scalars['String']['output']>;
};

/** Represents the number of posts for a service during some span of time */
export type PostServiceCount = {
  __typename?: 'PostServiceCount';
  hasAutoApprovedDrafts: Scalars['Boolean']['output'];
  hasDraftsAwaitingApproval: Scalars['Boolean']['output'];
  service: Service;
  value: Scalars['Int']['output'];
};

/** Sort order of post results. List multiple to create tie-breaking order. */
export type PostSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: PostSortableKey;
};

/** Key of collection to use for sorting */
export type PostSortableKey =
  /**
   * Sort by the post's createdAt field.
   * Created at is the date when the post was created.
   */
  | 'createdAt'
  /**
   * Sort by the post's dueAt field.
   * Due at is the date when the post is scheduled to be published.
   */
  | 'dueAt';

export type PostStatistics = {
  __typename?: 'PostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  favorites?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  linkClicks?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  quotes?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  reach_twitter?: Maybe<Scalars['Int']['output']>;
  reactions?: Maybe<Scalars['Int']['output']>;
  repins?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Scalars['Int']['output']>;
  reposts?: Maybe<Scalars['Int']['output']>;
  reshares?: Maybe<Scalars['Int']['output']>;
  retweets?: Maybe<Scalars['Int']['output']>;
  saves?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostStatisticsV2 = PostMetricLegacy | PostMetricObject;

/** List of possible statuses for a Post */
export type PostStatus =
  | 'draft'
  | 'error'
  | 'needs_approval'
  | 'scheduled'
  | 'sending'
  | 'sent';

/** List of possible types for a Post. Some services may have different types (e.g., Instagram has story, reel, post but Twitter has only post) */
export type PostType =
  | 'carousel'
  | 'event'
  | 'offer'
  | 'post'
  | 'reel'
  | 'short'
  | 'story'
  | 'whats_new';

/** List of specific post types available for Facebook */
export type PostTypeFacebook =
  | 'post'
  | 'reel'
  | 'story';

/** List of specific post types available for Google Business profiles */
export type PostTypeGoogleBusiness =
  | 'event'
  | 'offer'
  | 'whats_new';

export type PostUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The updated post */
  post: PublishingPost;
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostUpdatedPayload = CoreWebAppCommonError | PostNotFound | PostNotUpdated | PostUpdated;

/** List of possible ways to create a Post */
export type PostVia =
  | 'api'
  | 'buffer'
  | 'network';

/** Represents a posting goal for a channel, including target, progress, and status information. */
export type PostingGoal = {
  __typename?: 'PostingGoal';
  /** The target number of posts for this goal. */
  goal: Scalars['Int']['output'];
  /** The end date of the period for this posting goal. */
  periodEnd: Scalars['DateTime']['output'];
  /** The start date of the period for this posting goal. */
  periodStart: Scalars['DateTime']['output'];
  /** The number of posts that are scheduled to be sent for this goal. */
  scheduledCount: Scalars['Int']['output'];
  /** The number of posts that have been sent (published or ingested) for this goal. */
  sentCount: Scalars['Int']['output'];
  /** The current status of the posting goal. */
  status: PostingGoalStatus;
};

/** PostingGoalStatus is used to track the status of a posting goal. */
export type PostingGoalStatus =
  | 'AtRisk'
  | 'Hit'
  | 'OnTrack';

export type PostingSchedule = {
  __typename?: 'PostingSchedule';
  schedules: Array<Schedule>;
};

/** Counts for a given channel */
export type PostsCount = {
  __typename?: 'PostsCount';
  /** The channel the counts are for */
  channelId: Scalars['ChannelId']['output'];
  /** The count of posts matching the filters and channel */
  count: Scalars['Int']['output'];
  /**
   * This field is used by the BE to limit the results in the DB query
   * when the query fails due to a time out.
   * BE will return the used limit to the FE and the FE will have to handle it
   * to get the remaining data.
   */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type PostsEdge = {
  __typename?: 'PostsEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current post in the list. */
  node: Post;
};

export type PostsFilter = {
  by?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filter to apply to the posts query */
export type PostsFiltersInput = {
  /** When set, it will filter posts by channel */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** When set, it will filter posts by the date they were created */
  createdAt?: InputMaybe<DateTimeComparator>;
  /** When set, it will filter posts by their scheduled posting date */
  dueAt?: InputMaybe<DateTimeComparator>;
  /**
   * When set, it will return posts with createdAt or dueAt date before endDate
   * @deprecated Use field specific filters instead (e.g. dueAt, createdAt, sentAt)
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * When set, it will return posts with createdAt or dueAt date after startDate
   * @deprecated Use field specific filters instead (e.g. dueAt, createdAt, sentAt)
   */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** When set, it will filter posts by status */
  status?: InputMaybe<Array<PostStatus>>;
  /** When set, it will filter posts by tag */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
};

/** Input for the posts query */
export type PostsInput = {
  /** The filters to apply to the posts query */
  filter?: InputMaybe<PostsFiltersInput>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['OrganizationId']['input'];
  /** The sort to apply to the posts results */
  sort?: InputMaybe<Array<PostSortInput>>;
};

export type PostsLegacyInput = {
  /** The cursor to start returning posts from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The filters to apply to the posts query */
  filters?: InputMaybe<PostFiltersInput>;
  /** The amount of posts to return */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['ID']['input'];
};

/** Results for the posts query. */
export type PostsResults = {
  __typename?: 'PostsResults';
  /** The list of posts that match the query. */
  edges?: Maybe<Array<PostsEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
  /**
   * The total number of posts that match the query.
   * @deprecated Use postsCount instead
   */
  totalCount: Scalars['Int']['output'];
};

/** Account preferences */
export type Preferences = {
  __typename?: 'Preferences';
  defaultScheduleOption: ScheduleOption;
  startOfWeek?: Maybe<Scalars['String']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
};

export type PricingTier = {
  __typename?: 'PricingTier';
  /** Fixed amount for the tier, if applicable. */
  flatFee: Scalars['Float']['output'];
  /** The price that a customer will pay for each unit (e.g. channel) within this tier */
  unitPrice: Scalars['Float']['output'];
  /** The upper bound for this tier. */
  upperBound: Scalars['Int']['output'];
};

/** Buffer products, buffer is used as all producs */
export type Product =
  | 'analyze'
  | 'buffer'
  | 'comments'
  | 'engage'
  | 'publish'
  | 'startPage';

export type ProductLink = {
  __typename?: 'ProductLink';
  name: Product;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** publishPostNow mutation publish now a post by id. */
export type PublishPostNowInput = {
  /** Post id to publish now. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by publishPostNow mutation. */
export type PublishPostNowPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError | VideoProcessingError;

export type PublishStartPageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type PublishingCampaign = {
  __typename?: 'PublishingCampaign';
  color: HexColor;
  endDate?: Maybe<Scalars['Int']['output']>;
  /** Human readable date of campaign. E.g., 'Oct 11-13' */
  formattedDateRange?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Int']['output']>;
};

export type PublishingChannel = {
  __typename?: 'PublishingChannel';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationData?: Maybe<ChannelLocationData>;
  serverUrl?: Maybe<Scalars['String']['output']>;
  service: Service;
  timezone?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type PublishingError = {
  __typename?: 'PublishingError';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A code to describe the status eg 200 for success, 404 for not found */
  code?: Maybe<Scalars['String']['output']>;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type PublishingNote = {
  __typename?: 'PublishingNote';
  author: NoteAuthor;
  createdAt: Scalars['Int']['output'];
  editedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: NoteType;
};

export type PublishingPost = {
  __typename?: 'PublishingPost';
  /** LinkedIn mentions, referred to as annotations */
  annotations?: Maybe<Array<LinkedInAnnotation>>;
  /** Attachments such as retweet, link, etc. for this post */
  attachments?: Maybe<Array<Maybe<PublishingPostAttachment>>>;
  /** The author of the post */
  author: Author;
  /** The campaign this post is associated with */
  campaign?: Maybe<PublishingCampaign>;
  /** The channel to which this post will be (or is) published */
  channel: PublishingChannel;
  /** Channel specific data */
  channelData?: Maybe<ChannelData>;
  /** Id of the user who created the post */
  createdBy: Scalars['ID']['output'];
  /** The unix timestamp of when the post was (or will be) sent */
  dueAt?: Maybe<Scalars['Int']['output']>;
  /** Facebook mentions, referred to as entities */
  entities?: Maybe<Array<FacebookEntity>>;
  /** Details of the post error, if present */
  error?: Maybe<PublishingPostError>;
  /** A human readable timestamp of when the post is (or will be) sent, e.g., '2:10 PM' or '14:10' */
  formattedTime?: Maybe<Scalars['String']['output']>;
  /** The location for the post */
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  /** Flag to check if the post was created via Blueprints */
  isBlueprint?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this post is (or was) scheduled for a specific date and time */
  isCustomScheduled: Scalars['Boolean']['output'];
  /** Whether this post is (or was) specifically scheduled into one of the channel's schedule time slots */
  isPinned: Scalars['Boolean']['output'];
  /** Is the profile queue paused */
  isQueuePaused: Scalars['Boolean']['output'];
  /** Whether this post is (or will be) sent as an Instagram reminder */
  isReminder: Scalars['Boolean']['output'];
  /** Whether this post is a retweet */
  isRetweet: Scalars['Boolean']['output'];
  /** Media items (images, videos) attached to this post */
  media?: Maybe<Array<PublishingPostMedia>>;
  /** Whether a post needs approval before being scheduled */
  needsApproval?: Maybe<Scalars['Boolean']['output']>;
  /** The list of notes added to the post */
  notes?: Maybe<Array<Maybe<PublishingNote>>>;
  /** The direct URL to the post */
  serviceLink?: Maybe<Scalars['String']['output']>;
  /** Pinterest source url */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Post analytics */
  statistics?: Maybe<PostStatistics>;
  /** Post analytics V2 - supports filtering of Premium analytics */
  statisticsV2: Array<PostStatisticsV2>;
  /** The current state of the post */
  status: PublishingPostStatus;
  /** The subprofile is currently only used for Pinterest Boards */
  subprofile?: Maybe<PublishingSubprofile>;
  /** Attachments such as retweet, link, etc. for this post */
  tags: Array<PublishingTag>;
  /** The text content of the post */
  text?: Maybe<Scalars['String']['output']>;
  /** Number of threaded updates, including the parent update */
  threadCount?: Maybe<Scalars['Int']['output']>;
  /** The post title, this is currently only used for Pinterest */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of post, always 'post' for now, but could be 'story' in a future version */
  type: PublishingPostType;
  /** Type of the update (e.g. Reel or Feed for IG) */
  updateType?: Maybe<Scalars['String']['output']>;
  /** Source of the post */
  via?: Maybe<Scalars['String']['output']>;
};

export type PublishingPostAttachment = PublishingPostDestinationUrl | PublishingPostFirstComment | PublishingPostLink | PublishingPostRetweet;

export type PublishingPostDestinationUrl = {
  __typename?: 'PublishingPostDestinationUrl';
  url: Scalars['String']['output'];
};

export type PublishingPostEdge = {
  __typename?: 'PublishingPostEdge';
  cursor: Scalars['String']['output'];
  node: PublishingPost;
};

export type PublishingPostError = {
  __typename?: 'PublishingPostError';
  actionType?: Maybe<PublishingPostErrorAction>;
  code?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rawError?: Maybe<Scalars['String']['output']>;
};

export type PublishingPostErrorAction =
  | 'refresh'
  | 'verify';

export type PublishingPostFirstComment = {
  __typename?: 'PublishingPostFirstComment';
  text: Scalars['String']['output'];
};

export type PublishingPostLink = {
  __typename?: 'PublishingPostLink';
  description?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PublishingPostMedia = {
  __typename?: 'PublishingPostMedia';
  original: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: MediaType;
};

export type PublishingPostRetweet = {
  __typename?: 'PublishingPostRetweet';
  accountName: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  /** The unix timestamp of when the tweet was sent to retweets */
  sentAt: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  /** The tweet url */
  url: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type PublishingPostStatus =
  | 'draft'
  | 'error'
  | 'pending'
  | 'pending_approval'
  | 'pending_tiktok'
  | 'scheduled'
  | 'sent';

export type PublishingPostType =
  | 'draft'
  | 'post'
  | 'story';

/** Represents the publishing status of a comment. */
export type PublishingStatus = {
  __typename?: 'PublishingStatus';
  /** Error message, if the reply failed and the status is Error */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The current status of the reply (e.g. error, published, processing). */
  status: CommentEngagementStatusTypes;
};

export type PublishingSubprofile = {
  __typename?: 'PublishingSubprofile';
  avatar?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['ID']['output'];
  createdAt: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShared: Scalars['Boolean']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  service: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type PublishingTag = {
  __typename?: 'PublishingTag';
  /** Hex color for tag e.g #F523F1 */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PusherAuth = {
  __typename?: 'PusherAuth';
  auth?: Maybe<Scalars['String']['output']>;
};

export type PusherAuthenticationInput = {
  organizationId: Scalars['String']['input'];
  pusherChannel: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};

/** List of post Query operations */
export type Query = {
  __typename?: 'Query';
  account: Account;
  /** Fetch a Buffer account by its associated email address */
  accountByEmail: Account;
  /** Fetch a Buffer account by its account Id */
  accountById: Account;
  /** Fetch a Buffer account by a product name and foreign key */
  accountByProductLink: Account;
  alphaFeatures: Array<AlphaFeature>;
  analyticsAnswers: AnalyticsAnswers;
  analyticsDailies: Array<Maybe<AnalyticsDaily>>;
  analyticsHashtags: Array<Maybe<AnalyticsHashtag>>;
  analyticsPosts: Array<Maybe<AnalyticsPost>>;
  analyticsPostsTotals: AnalyticsPostsTotals;
  analyticsTotals: AnalyticsTotals;
  betaFeatures: Array<BetaFeature>;
  /** Fetch a calendar for a given channel and time period */
  calendar?: Maybe<CalendarsPayload>;
  /** Fetch a single post by id */
  calendarPost?: Maybe<PublishingPost>;
  canConnectChannels?: Maybe<Array<ChannelConnectionAvailability>>;
  /** Fetches a single channel using the provided ID */
  channel: Channel;
  /** Get the authorization URL for a network. */
  channelAuthorizationInfo: ChannelAuthorizationInfoResponse;
  channelAuthorizationUrl: ChannelAuthorizationUrlPayload;
  /**
   * Fetch a channel by its channel Id
   * @deprecated Use the new channel query instead
   */
  channelById?: Maybe<Channel>;
  channelGetByServiceAndServiceId?: Maybe<Channel>;
  channelGetTemporaryCredentials: ChannelCredentials;
  /** Fetches a single channel group */
  channelGroup: ChannelGroupPayload;
  /** Fetches all channel groups for an account in the organization */
  channelGroups: ChannelGroupsPayload;
  /** Fetch all channels for the organization taking in account the current's user permissions */
  channels: Array<Channel>;
  chargeById?: Maybe<Charge>;
  checklists: ChecklistsPayload;
  /** Retrieve information for an API client based on the provided arguments (such as the client platform) */
  client: ClientPayload;
  /**
   * Returns the comments' context menaning the parent comments of the input comment, the parent of the parent and so on
   * until the root comment
   */
  commentContext: CommentContextResponse;
  /** Returns the suggestions for a given comment generated by the AI */
  commentSuggestions: CommentSuggestionsResponse;
  /**
   * Returns the comments' thread meaning the parent comments of the input comment, the parent of the parent and so on
   * until the root comment, the comment and the reply to the comment (if comment has been replied)
   */
  commentThread: CommentThreadResponse;
  /**
   * Fetches comments for the given organization and filters.
   * The results are sorted by the option in sort.
   * first and after can be set for forward pagination using Relay convention.
   * Index in DB: { organizationId: 1 , channelId: 1, status: 1, publishedAt: 1)
   */
  comments: CommentsResults;
  /** Query to fetch the counts for comments in the organization */
  commentsCounts: CommentsCountsResponse;
  /** Returns the insights for a given channelID and prompt extracted from the last comments and posts using AI */
  commentsInsights: CommentsInsightsResponse;
  /** Retrieve the oEmbed representation of a URL for a given channel. */
  commentsOEmbed?: Maybe<CommentsOEmbedResponse>;
  /** Returns the comments' score for a given channel for the current and previous week */
  commentsScore: CommentsScoreResponse;
  /** Provides a list of services, with properties based on the provided organization and client information */
  connectableServices: ConnectableServicesPayload;
  emailNotificationPreferences: EmailNotificationPreferencePayload;
  engageOrganization?: Maybe<EngageOrganization>;
  engagePost?: Maybe<EngagePost>;
  engagePosts?: Maybe<PaginatedPostsResponse>;
  engagePostsV2?: Maybe<PaginatedPostsResponse>;
  engagePusherAuthentication?: Maybe<PusherAuth>;
  engageUserSettings?: Maybe<UserSettings>;
  featureFlips?: Maybe<Array<FeatureFlip>>;
  /** Fetches a (single) feed by FeedID */
  feed?: Maybe<Feed>;
  /** Fetches a (single) feed collection by FeedCollectionID */
  feedCollection: FeedCollection;
  /** Fetches (lists) feed collections for the given organization */
  feedCollections: FeedCollectionConnection;
  /** Fetches (lists) feed items for the given feed collection */
  feedItems: FeedItemConnection;
  /** Fetches all feeds for the given organization */
  feeds: Array<Feed>;
  /** Fetches an  access token for a channel */
  getAccessTokensForChannel: GetAccessTokensForChannelPayload;
  healthStatus?: Maybe<HealthStatus>;
  idea?: Maybe<IdeaPayload>;
  /** Retrieves idea groups based on the provided input parameters. */
  ideaGroups: Array<IdeaGroup>;
  /** @deprecated Use ideasV2 */
  ideas: PaginatedIdeasPayload;
  ideasCount: IdeasCountPayload;
  ideasCountByTag: IdeasCountPayload;
  ideasCountByTags: IdeasCountByTagsPayload;
  /** Fetch a paginated list of ideas with optional filtering */
  ideasV2: PaginatedIdeasV2;
  imagesTrackDownload: MutationBasicPayload;
  invoicesByOrganization: InvoiceConnection;
  isNewRemindersEnabledForOrganization: SplitEnabledResponse;
  isSplitEnabledForOrganization: SplitEnabledResponse;
  /** Query to list all failed post errors. */
  listFailedPostErrors: ListFailedPostErrorsPayload;
  location: LocationPayload;
  organization?: Maybe<Organization>;
  /** Retrieve the Referral Code for a particular organization */
  organizationReferralCode: OrganizationReferralCodeResponse;
  organizations: Array<Maybe<Organization>>;
  /**
   * This is a new previewPlanMigration query which is focusing on the
   * Migration Hub summary only.
   */
  planMigrationSummaryViaHub: PlanMigrationPreview;
  /** Fetches a post by PostID for the given organization: first and last can be set for forward pagination using Relay convention */
  post: Post;
  /** Returns the counts by channel for the given organization */
  postCounts: PostCountsResponse;
  /** Fetches posts for the given organization: first and last can be set for forward pagination using Relay convention */
  posts: PostsResults;
  /** @deprecated Use the new posts query */
  postsLegacy: PaginatedPosts;
  previewCustomUpcomingInvoice: UpcomingInvoiceCostsPreview;
  /**
   * Querying the plan migration preview will result into a null preview
   * if the canMigrateToOneBuffer flag is false or if the account is on a Free plan
   */
  previewPlanMigration: PlanMigrationPreviewResponse;
  pusherAuthentication: PusherAuth;
  /** Get the recovery code for Two Factor Authentication */
  recoveryCode: TwoFactorRecoveryCodePayload;
  /**
   * Get an S3 pre-signed URL for the given filename and mime-type.
   * The S3 pre-signed URL can be used to directly upload the file to S3 from the client application.
   */
  s3PreSignedURL: S3PreSigneUrlResult;
  /** Get S3 signature for uploading files */
  s3Signature: S3Signature;
  s3SignedUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Get an S3 pre-signed URL for the given filename and mime-type.
   * The an S3 pre-signed URL can be used to directly upload the file to S3 from the client application.
   * @deprecated Use s3PreSignedURL instead
   */
  s3UploadPreSignedURL: S3UploadPreSigneUrlResult;
  /** Returns the saved replies for a given organization */
  savedReplies: SavedRepliesResponse;
  schedules: SchedulesPayload;
  searchImages: ImageSearchPayload;
  /**
   * Search for Threads locations that can be tagged in posts.
   * Requires at least 2 characters in the search query.
   */
  searchThreadsLocations: SearchThreadsLocationsPayload;
  /** Retrieves a list of service tags based on the provided input. */
  serviceMentions: Array<ServiceMention>;
  /** Get Shop Grid Custom Links */
  shopGridCustomLinks: ShopGridCustomLinksPayload;
  startPage?: Maybe<StartPageResponse>;
  startPageBlock?: Maybe<StartPageBlock>;
  startPageTemplates?: Maybe<StartPageTemplatesResponse>;
  startPageThemes?: Maybe<StartPageThemesResponse>;
  /** @deprecated Use `startPage`. */
  startPageV2?: Maybe<StartPageResponse>;
  startPages?: Maybe<StartPagesResponse>;
  /** Fetch all tags for the organization sorted by name in ascending order */
  tags: Array<Tag>;
  /**
   * Dummy query for testing the new BufferAdmin actor during Retool development.
   * Will be removed later.
   */
  testAdminRestrictedQuery: Scalars['String']['output'];
  upload?: Maybe<UploadPayload>;
  /**
   * Returns the weekly posting streak for the given organization.
   * Null means, the streak widget should not be shown.
   * It checks that the actor is an owner of the organization, otherwise it returns null.
   */
  weeklyPostingStreak?: Maybe<Streak>;
  /** Retrieve categories for youtube videos. Categories are hardcoded for now. */
  youtubeCategories: Array<YoutubeCategory>;
};


/** List of post Query operations */
export type QueryAccountByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryAccountByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryAccountByProductLinkArgs = {
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Product>;
};


/** List of post Query operations */
export type QueryAnalyticsAnswersArgs = {
  endDate: Scalars['Date']['input'];
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsDailiesArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsHashtagsArgs = {
  endDate: Scalars['Date']['input'];
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsPostsArgs = {
  endDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: AnalyticsOrderByField;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsPostsTotalsArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryAnalyticsTotalsArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** List of post Query operations */
export type QueryCalendarArgs = {
  input?: InputMaybe<CalendarInput>;
};


/** List of post Query operations */
export type QueryCalendarPostArgs = {
  input: CalendarPostInput;
};


/** List of post Query operations */
export type QueryCanConnectChannelsArgs = {
  channels?: InputMaybe<Array<CanConnectChannelsInput>>;
};


/** List of post Query operations */
export type QueryChannelArgs = {
  input: ChannelInput;
};


/** List of post Query operations */
export type QueryChannelAuthorizationInfoArgs = {
  input: ChannelAuthorizationInfoInput;
};


/** List of post Query operations */
export type QueryChannelAuthorizationUrlArgs = {
  channelAuthorizationUrl: ChannelAuthorizationUrlInput;
};


/** List of post Query operations */
export type QueryChannelByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryChannelGetByServiceAndServiceIdArgs = {
  service: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryChannelGetTemporaryCredentialsArgs = {
  service: Scalars['String']['input'];
  serviceId: Service;
};


/** List of post Query operations */
export type QueryChannelGroupArgs = {
  input: ChannelGroupInput;
};


/** List of post Query operations */
export type QueryChannelGroupsArgs = {
  input: ChannelGroupsInput;
};


/** List of post Query operations */
export type QueryChannelsArgs = {
  input: ChannelsInput;
};


/** List of post Query operations */
export type QueryChargeByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryChecklistsArgs = {
  input: OrganizationIdInput;
};


/** List of post Query operations */
export type QueryClientArgs = {
  input: ClientInput;
};


/** List of post Query operations */
export type QueryCommentContextArgs = {
  input: CommentContextInput;
};


/** List of post Query operations */
export type QueryCommentSuggestionsArgs = {
  input: CommentSuggestionsInput;
};


/** List of post Query operations */
export type QueryCommentThreadArgs = {
  input: CommentThreadInput;
};


/** List of post Query operations */
export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CommentsInput;
};


/** List of post Query operations */
export type QueryCommentsCountsArgs = {
  input: CommentsCountsInput;
};


/** List of post Query operations */
export type QueryCommentsInsightsArgs = {
  input: CommentsInsightsInput;
};


/** List of post Query operations */
export type QueryCommentsOEmbedArgs = {
  input: CommentsOEmbedInput;
};


/** List of post Query operations */
export type QueryCommentsScoreArgs = {
  input: CommentsScoreInput;
};


/** List of post Query operations */
export type QueryConnectableServicesArgs = {
  input?: InputMaybe<ConnectableServicesInput>;
};


/** List of post Query operations */
export type QueryEngageOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryEngagePostArgs = {
  id: Scalars['String']['input'];
  refreshMedia?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List of post Query operations */
export type QueryEngagePostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelService: Scalars['String']['input'];
  channelServiceId: Scalars['String']['input'];
  filter?: InputMaybe<PostsFilter>;
  first: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryEngagePostsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelServiceId: Scalars['String']['input'];
  filter?: InputMaybe<PostsFilter>;
  first: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryEngagePusherAuthenticationArgs = {
  organizationId: Scalars['String']['input'];
  pusherChannel: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryFeedArgs = {
  input: FeedInput;
};


/** List of post Query operations */
export type QueryFeedCollectionArgs = {
  input: FeedCollectionInput;
};


/** List of post Query operations */
export type QueryFeedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedCollectionsInput;
};


/** List of post Query operations */
export type QueryFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedItemsInput;
};


/** List of post Query operations */
export type QueryFeedsArgs = {
  input: FeedsInput;
};


/** List of post Query operations */
export type QueryGetAccessTokensForChannelArgs = {
  input: GetAccessTokensForChannelInput;
};


/** List of post Query operations */
export type QueryIdeaArgs = {
  input: IdeaIdInput;
};


/** List of post Query operations */
export type QueryIdeaGroupsArgs = {
  input: IdeaGroupsInput;
};


/** List of post Query operations */
export type QueryIdeasArgs = {
  input: IdeasListInput;
};


/** List of post Query operations */
export type QueryIdeasCountArgs = {
  input: OrganizationIdInput;
};


/** List of post Query operations */
export type QueryIdeasCountByTagArgs = {
  input: IdeasCountByTagInput;
};


/** List of post Query operations */
export type QueryIdeasCountByTagsArgs = {
  input: OrganizationIdInput;
};


/** List of post Query operations */
export type QueryIdeasV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: IdeasListInputV2;
};


/** List of post Query operations */
export type QueryImagesTrackDownloadArgs = {
  trackUrl?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryInvoicesByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryIsNewRemindersEnabledForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryIsSplitEnabledForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryOrganizationReferralCodeArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryOrganizationsArgs = {
  input: OrganizationsInput;
};


/** List of post Query operations */
export type QueryPlanMigrationSummaryViaHubArgs = {
  interval?: InputMaybe<BillingInterval>;
  organizationId: Scalars['String']['input'];
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Query operations */
export type QueryPostArgs = {
  input: PostInput;
};


/** List of post Query operations */
export type QueryPostCountsArgs = {
  input: PostCountsInput;
};


/** List of post Query operations */
export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PostsInput;
};


/** List of post Query operations */
export type QueryPostsLegacyArgs = {
  input: PostsLegacyInput;
};


/** List of post Query operations */
export type QueryPreviewCustomUpcomingInvoiceArgs = {
  interval?: InputMaybe<BillingInterval>;
  organizationId: Scalars['String']['input'];
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** List of post Query operations */
export type QueryPreviewPlanMigrationArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryPusherAuthenticationArgs = {
  input: PusherAuthenticationInput;
};


/** List of post Query operations */
export type QueryRecoveryCodeArgs = {
  input: TwoFactorRecoveryCodeInput;
};


/** List of post Query operations */
export type QueryS3PreSignedUrlArgs = {
  input: S3PreSignedUrlInput;
};


/** List of post Query operations */
export type QueryS3SignatureArgs = {
  input: S3SignatureInput;
};


/** List of post Query operations */
export type QueryS3SignedUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryS3UploadPreSignedUrlArgs = {
  input: S3UploadPreSignedUrlInput;
};


/** List of post Query operations */
export type QuerySavedRepliesArgs = {
  input: SavedRepliesInput;
};


/** List of post Query operations */
export type QuerySchedulesArgs = {
  input: SchedulesInput;
};


/** List of post Query operations */
export type QuerySearchImagesArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QuerySearchThreadsLocationsArgs = {
  input: SearchThreadsLocationsInput;
};


/** List of post Query operations */
export type QueryServiceMentionsArgs = {
  input: ServiceMentionsInput;
};


/** List of post Query operations */
export type QueryShopGridCustomLinksArgs = {
  input: ShopGridCustomLinksInput;
};


/** List of post Query operations */
export type QueryStartPageArgs = {
  organizationId: Scalars['String']['input'];
  pageId?: InputMaybe<Scalars['String']['input']>;
};


/** List of post Query operations */
export type QueryStartPageBlockArgs = {
  blockId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryStartPageV2Args = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryStartPagesArgs = {
  organizationId: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryTagsArgs = {
  input: TagsInput;
};


/** List of post Query operations */
export type QueryTestAdminRestrictedQueryArgs = {
  email: Scalars['String']['input'];
};


/** List of post Query operations */
export type QueryUploadArgs = {
  input: UploadIdInput;
};


/** List of post Query operations */
export type QueryWeeklyPostingStreakArgs = {
  input: WeeklyPostingStreakInput;
};

/** Create an RSS/Atom Feed by url */
export type RssAtomFeedCreationInput = {
  /** The url of the RSS/Atom feed */
  url: Scalars['String']['input'];
};

/** Connection metadata for RSS feeds */
export type RssFeedConnectionMetadata = {
  __typename?: 'RSSFeedConnectionMetadata';
  /** The last time we connected to the RSS feed */
  lastConnected: Scalars['DateTime']['output'];
  /** The URL of the RSS feed */
  url: Scalars['String']['output'];
};

/** Input for refreshing a single feed collection. */
export type RefreshFeedCollectionInput = {
  /** The ID of the feed collection to refresh. */
  feedCollectionId: Scalars['FeedCollectionId']['input'];
  /** The organization that the feed collection belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the refreshFeedCollection mutation. */
export type RefreshFeedCollectionPayload = FeedCollectionActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for refreshing a single feed. */
export type RefreshFeedInput = {
  /** The ID of the feed to refresh. */
  feedId: Scalars['FeedId']['input'];
  /** The organization that the feed belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the refreshFeed mutation. */
export type RefreshFeedPayload = FeedActionSuccess | FeedConnectionError | NotFoundError | UnauthorizedError | UnexpectedError;

export type Refund = {
  __typename?: 'Refund';
  id: Scalars['ID']['output'];
  status: RefundStatus;
};

export type RefundStatus =
  | 'canceled'
  | 'failed'
  | 'pending'
  | 'succeeded';

/** Reject approval request. */
export type RejectPostInput = {
  /** Post id to reject approval request. */
  id: Scalars['PostId']['input'];
};

/** Reject approval request response payload. */
export type RejectPostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the removeAccount mutation */
export type RemoveAccountInput = {
  /** The password to be used to authorize deleting account */
  password?: InputMaybe<Scalars['String']['input']>;
  /** reason for the account to be deleted */
  reason?: InputMaybe<AccountDeletedReason>;
};

/** removeAccount response payload */
export type RemoveAccountPayload = InvalidInputError | NotFoundError | RemoveAccountSuccess | UnauthorizedError | UnexpectedError;

/** success response for removeAccount mutation */
export type RemoveAccountSuccess = MutationSuccess & {
  __typename?: 'RemoveAccountSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for removeLegacyGlobalFeatureFlip mutation. */
export type RemoveLegacyGlobalFeatureFlipInput = {
  /** Account id to remove feature flip from. */
  accountId: Scalars['AccountId']['input'];
  /** Feature flip to remove. */
  featureFlip: Scalars['String']['input'];
};

/** removeLegacyGlobalFeatureFlip response payload. */
export type RemoveLegacyGlobalFeatureFlipPayload = InvalidInputError | NotFoundError | RemoveLegacyGlobalFeatureFlipSuccess | UnexpectedError;

/** removeLegacyGlobalFeatureFlip success response. */
export type RemoveLegacyGlobalFeatureFlipSuccess = MutationSuccess & {
  __typename?: 'RemoveLegacyGlobalFeatureFlipSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Remove post's scheduled time request input. */
export type RemovePostScheduledTimeInput = {
  /** ID of post to update */
  id: Scalars['PostId']['input'];
};

/** Remove post's scheduled time response payload. */
export type RemovePostScheduledTimePayload = PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

export type RemoveSubscriptionScheduleError = MutationError & {
  __typename?: 'RemoveSubscriptionScheduleError';
  message: Scalars['String']['output'];
};

export type RemoveSubscriptionSchedulePayload = RemoveSubscriptionScheduleError | RemoveSubscriptionScheduleResponse;

export type RemoveSubscriptionScheduleResponse = {
  __typename?: 'RemoveSubscriptionScheduleResponse';
  success: Scalars['Boolean']['output'];
};

/** The input for the ReorderPosts mutation. */
export type ReorderPostsInput = {
  /** Channel ID for the posts to reorder. */
  channelId: Scalars['ChannelId']['input'];
  /** Ordered collection of Post IDs. */
  ids: Array<Scalars['PostId']['input']>;
};

/** ReorderPosts response payload */
export type ReorderPostsPayload = NotFoundError | ReorderPostsSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** The ReorderPosts success response. */
export type ReorderPostsSuccess = {
  __typename?: 'ReorderPostsSuccess';
  /** Ordered collection of Post IDs. */
  ids: Array<Scalars['PostId']['output']>;
};

export type Reply = {
  __typename?: 'Reply';
  attachment?: Maybe<Attachment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Error>;
  from?: Maybe<From>;
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  needsAttention?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AllowedCommentsStatuses>;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * Input type for the `replyComment` mutation.
 * Defines the comment being replied to and the reply content.
 */
export type ReplyToCommentInput = {
  /** Id of the comment being replied to. */
  commentId: Scalars['CommentId']['input'];
  /** The content of the reply, currently only text is supported. */
  reply: ReplyToContent;
};

/** Mutation Reply To Comment Response: Success and errors */
export type ReplyToCommentPayload = InvalidInputError | NotFoundError | ReplyToCommentSuccess | UnauthorizedError | UnexpectedError;

/** Successful reply response to reply to comment */
export type ReplyToCommentSuccess = {
  __typename?: 'ReplyToCommentSuccess';
  /** The reply comment that was successfully sent to the service. */
  comment: CommentData;
};

/** The content of a reply. */
export type ReplyToContent = {
  /** The text content of the reply. */
  text: Scalars['String']['input'];
};

/** Request post approval mutation. */
export type RequestPostApprovalInput = {
  /** Post id to request approval. */
  id: Scalars['PostId']['input'];
};

/** Request post approval possible responses. */
export type RequestPostApprovalPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Basic mutation response */
export type Response = {
  __typename?: 'Response';
  success: Scalars['Boolean']['output'];
};

/** Error proxied from the REST API response */
export type RestProxyError = MutationError & {
  __typename?: 'RestProxyError';
  /** Error code from the REST API response - https://buffer.com/developers/api/errors */
  code?: Maybe<Scalars['Int']['output']>;
  /** Link to our Help center from the REST API response */
  link?: Maybe<Scalars['String']['output']>;
  /** An error message from the REST API response that we proxied here */
  message: Scalars['String']['output'];
};

/** Information about the initial Tweet that was retweeted */
export type RetweetMetadata = ScrapedLink & {
  __typename?: 'RetweetMetadata';
  /** Date when the original tweet was created */
  createdAt: Scalars['DateTime']['output'];
  /** Retweet ID */
  id: Scalars['String']['output'];
  /** Text of the original tweet */
  text: Scalars['String']['output'];
  /** Thumbnails to media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** Link to original tweet */
  url: Scalars['String']['output'];
  /** User who created the original tweet */
  user: RetweetUserMetadata;
};

/** Information about the initial Tweet that was retweeted */
export type RetweetMetadataInput = {
  /** Retweet ID */
  id: Scalars['String']['input'];
};

/** Information about the initial author of the Tweet that was retweeted */
export type RetweetUserMetadata = {
  __typename?: 'RetweetUserMetadata';
  /** Avatar of the user who created the original Tweet */
  avatar: Scalars['String']['output'];
  /** Name of the user who created the original Tweet */
  name: Scalars['String']['output'];
  /** Username of the user who created the original Tweet */
  username: Scalars['String']['output'];
};

/** Revert approval request mutation. */
export type RevertPostApprovalRequestInput = {
  /** Post id to revert approval request. */
  id: Scalars['PostId']['input'];
};

/** Revert approval request possible responses. */
export type RevertPostApprovalRequestPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the revokeAccessConnectedApp mutation */
export type RevokeAccessConnectedAppInput = {
  /** The id of the connectedApp to revoke access for. */
  clientId: Scalars['ID']['input'];
};

/** The payload for the revokeAccessConnectedApp mutation */
export type RevokeAccessConnectedAppPayload = EmptySuccess | UnexpectedError;

export type Role =
  | 'admin'
  | 'member';

/** The result of the s3PreSignedURL query */
export type S3PreSigneUrlResult = {
  __typename?: 'S3PreSigneURLResult';
  /** The URL of the asset to use after it's uploaded to S3 */
  assetUrl: Scalars['String']['output'];
  /** The bucked where the file was saved */
  bucket: Scalars['String']['output'];
  /** The name/path of the file within the bucket */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file to S3 */
  url: Scalars['String']['output'];
};

/** Input for the s3PreSignedURL query */
export type S3PreSignedUrlInput = {
  /** The full filename with the extension, e.g. puppy.png */
  fileName: Scalars['String']['input'];
  /** The mime type of the file, e.g. image/png */
  mimeType: Scalars['MimeType']['input'];
  /** The organization for which the pre-signed URL is being requested */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Whether the asset will be used in the composer or as an account/channel avatar.
   * In the backend, this will decide which S3 bucket to use.
   */
  uploadType: UploadType;
};

/** S3 signature response */
export type S3Signature = {
  __typename?: 'S3Signature';
  /** success_action_status - 201 when successful */
  actionStatus: Scalars['String']['output'];
  /** Signature algorithm */
  algorithm: Scalars['String']['output'];
  /** Base64 encoded policy */
  base64policy: Scalars['String']['output'];
  /** S3 bucket name - on prod environment it'll be the same as input, on dev it'll be suffixed with '-dev' */
  bucket: Scalars['String']['output'];
  /** AWS credentials */
  credentials: Scalars['String']['output'];
  /** Date of the signature */
  date: Scalars['String']['output'];
  /** Expiration date of the signature */
  expires: Scalars['String']['output'];
  /** AWS signature */
  signature: Scalars['String']['output'];
  /** AWS temporary security token */
  temporarySecurityToken: Scalars['String']['output'];
};

/** Input for the s3Signature query */
export type S3SignatureInput = {
  /** S3 bucket name */
  bucket: Scalars['String']['input'];
};

/** The result of the s3UploadPreSignedURL query */
export type S3UploadPreSigneUrlResult = {
  __typename?: 'S3UploadPreSigneURLResult';
  /** The URL of the asset to use after it's uploaded to S3 */
  assetUrl: Scalars['String']['output'];
  /** The bucked where the file was saved */
  bucket: Scalars['String']['output'];
  /** The name/path of the file within the bucket */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file to S3 */
  url: Scalars['String']['output'];
};

/** Input for the s3UploadPreSignedURL query */
export type S3UploadPreSignedUrlInput = {
  /** The full filename with the extension, e.g. puppy.png */
  fileName: Scalars['String']['input'];
  /** The mime type of the file, e.g. image/png */
  mimeType: Scalars['MimeType']['input'];
  /**
   * Whether the asset will be used in the composer or as an account/channel avatar.
   * In the backend, this will decide which S3 bucket to use.
   */
  uploadType: UploadType;
};

/** Input for the saved replies query */
export type SavedRepliesInput = {
  /** The organization id to fetch saved replies for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the saved replies query */
export type SavedRepliesResponse = {
  __typename?: 'SavedRepliesResponse';
  /** List of saved replies */
  savedReplies: Array<SavedReply>;
};

/**
 * Saved reply: it contains a text used to reply to a comment easily.
 * The keyboard hotkeys is used to access quickly to the saved reply.
 */
export type SavedReply = {
  __typename?: 'SavedReply';
  /** The content of the saved reply. */
  content: SavedReplyContent;
  /** The date and time when the saved reply was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional hotkeys to reply with the saved reply, i.e. Ctrl+a. */
  hotkeys?: Maybe<Array<Scalars['String']['output']>>;
  /** The id for the saved reply. */
  id: Scalars['SavedReplyId']['output'];
  /** The organization that owns this saved reply. */
  organizationId: Scalars['OrganizationId']['output'];
  /** The title of the saved reply. */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time when the saved reply was created or updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Successful response for adding a saved reply. */
export type SavedReplyActionSuccess = {
  __typename?: 'SavedReplyActionSuccess';
  /** The saved reply that was successfully created. */
  savedReply: SavedReply;
};

/**
 * The content of a saved reply.
 * Currently, only text is supported.
 * We could add other types of content in the future.
 */
export type SavedReplyContent = {
  __typename?: 'SavedReplyContent';
  /** The text content of the saved reply. */
  text: Scalars['String']['output'];
};

/**
 * The content of a saved reply to be created or updated.
 * Currently, only text is supported.
 * We could add other types of content in the future.
 */
export type SavedReplyContentInput = {
  /** The text content of the saved reply. */
  text: Scalars['String']['input'];
};

/** Input type for creating a saved reply. */
export type SavedReplyToCreateInput = {
  /** The content of the saved reply. */
  content: SavedReplyContentInput;
  /** Optional hotkeys to reply with the saved reply, i.e. Ctrl+a. */
  hotkeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the saved reply. It could be null or empty. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input type for updating a saved reply.
 * All fields are optional. The user could update only the title or the content or the hotkeys.
 */
export type SavedReplyToUpdateInput = {
  /**
   * The content we want to update. It could be optional if we want to keep the same content
   * and update the title or the hotkeys.
   */
  content?: InputMaybe<SavedReplyContentInput>;
  /**
   * Optional hotkeys to reply with the saved reply, i.e. Ctrl+a.
   *   - Omit this field to leave the existing hotkeys unchanged.
   *   - Provide an empty array `[]` to clear all hotkeys.
   *   - Provide an array of strings to replace with new hotkeys.
   */
  hotkeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the saved reply. Uses title: null to remove the title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Schedule = {
  __typename?: 'Schedule';
  day: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  times: Array<Scalars['String']['output']>;
};

export type ScheduleOption =
  | 'FixedTime'
  | 'Now'
  | 'Prioritize'
  | 'Queue';

/** Schedule post's request input. */
export type SchedulePostInput = {
  /** New dueAt date */
  dueAt: Scalars['DateTime']['input'];
  /** ID of post to update */
  id: Scalars['PostId']['input'];
};

/** Schedule post's request response payload. */
export type SchedulePostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** The mode for updating the posting schedule: override, add, or none */
export type ScheduleUpdateMode =
  | 'add'
  | 'none'
  | 'override';

/** The posting schedule (slots) for a day of the week */
export type ScheduleV2 = {
  __typename?: 'ScheduleV2';
  /** The day of the week: mon, tue, wed, thu, fri, sat, sun */
  day: DayOfWeek;
  /** Indicates if this days is paused in the posting schedule. */
  paused: Scalars['Boolean']['output'];
  /** The times the channel is scheduled to post on the day: HH:MM */
  times: Array<Scalars['String']['output']>;
};

/** Posting Schedule input */
export type ScheduleV2Input = {
  /** The day of the week: mon, tue, wed, thu, fri, sat, sun */
  day: DayOfWeek;
  /** Indicates if this days is paused in the posting schedule. */
  paused: Scalars['Boolean']['input'];
  /** The times the channel is scheduled to post on the day: HH:MM */
  times: Array<Scalars['String']['input']>;
};

export type ScheduledSubscriptionUpdate = {
  __typename?: 'ScheduledSubscriptionUpdate';
  effectiveDate: Scalars['DateTime']['output'];
  newInterval: BillingInterval;
  newPlan: Scalars['String']['output'];
  newQuantity: Scalars['Int']['output'];
};

export type SchedulesError = {
  __typename?: 'SchedulesError';
  cause: Scalars['String']['output'];
};

export type SchedulesInput = {
  channelId: Scalars['String']['input'];
};

export type SchedulesPayload = SchedulesError | SchedulesResponse;

export type SchedulesResponse = {
  __typename?: 'SchedulesResponse';
  schedule: PostingSchedule;
};

/** Indicates whether the post was scheduled for notification publishing or automatic publishing */
export type SchedulingType =
  /** The post was created natively on the social network using automatic publishing */
  | 'automatic'
  /** The post was created natively on the social network using notification publishing */
  | 'notification';

/** Link data for link preview */
export type ScrapedLink = {
  /** Description for the scraped link */
  text: Scalars['String']['output'];
  /** Thumbnails of media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** URL that the link asset has been built from */
  url: Scalars['String']['output'];
};

/** Input for searching Threads locations */
export type SearchThreadsLocationsInput = {
  /** Channel IDs for the Threads channels to search locations for */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** Search query for locations (minimum 2 characters required) */
  query: Scalars['String']['input'];
};

/** Payload returned when searching for Threads locations */
export type SearchThreadsLocationsPayload = ChannelRefreshRequired | SearchThreadsLocationsResponse | TooShortQueryStringError;

/** Success response for searching Threads locations */
export type SearchThreadsLocationsResponse = {
  __typename?: 'SearchThreadsLocationsResponse';
  /** List of locations matching the search query */
  locations: Array<ThreadsLocation>;
};

/** success response for sendTestNotification mutation */
export type SendTestNotificationError = {
  __typename?: 'SendTestNotificationError';
  /** Error code if the notification was not sent successfully. */
  code: Scalars['Int']['output'];
  /** Error message if the notification was not sent successfully. */
  message: Scalars['String']['output'];
};

/** SendTestNotification response payload. */
export type SendTestNotificationPayload = SendTestNotificationError | SendTestNotificationSuccess;

/** error response for sendTestNotification mutation */
export type SendTestNotificationSuccess = {
  __typename?: 'SendTestNotificationSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Represents sentiment analysis results for a comment. */
export type SentimentAnalysis = {
  __typename?: 'SentimentAnalysis';
  /** The sentiment score indicating intensity. */
  score: Scalars['Int']['output'];
  /** The type of sentiment detected (e.g., positive, negative, neutral). */
  type: CommentLabel;
};

/** The list of services that can be authorized. */
export type Service =
  | 'bluesky'
  | 'facebook'
  | 'googlebusiness'
  | 'instagram'
  | 'linkedin'
  | 'mastodon'
  | 'pinterest'
  | 'startPage'
  | 'threads'
  | 'tiktok'
  | 'twitter'
  | 'youtube';

/** Indicates the type of subscription the user has on Twitter - Deprecated in favor of TwitterMetadata */
export type ServiceData = {
  __typename?: 'ServiceData';
  /** The type of subscription the user has on Twitter */
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

/** Represents a tag associated with a specific service. */
export type ServiceMention = {
  __typename?: 'ServiceMention';
  /** The user-friendly name of the tag, to displayed in the UI. */
  displayName: Scalars['String']['output'];
  /** The entity that the tag represents within the given service. */
  entity: Scalars['String']['output'];
  /** The unique identifier of the service tag. */
  id: Scalars['String']['output'];
  /** Image representing the tag, used for display purposes. */
  image?: Maybe<Scalars['URL']['output']>;
  /** A link or URL associated with the tag. */
  link: Scalars['URL']['output'];
  /** A URL-friendly version of the tag's name. */
  vanityName: Scalars['String']['output'];
};

/** Input type for the `serviceTags` query. */
export type ServiceMentionsInput = {
  /** The unique identifier of the account querying for tags. */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The search query string used to query for tags. */
  query: Scalars['String']['input'];
};

/** The current status of the connectable service */
export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  /**
   * Details to be used when allowing users to upvote service functionality.
   * If `label: none`, details will be null
   */
  details?: Maybe<UpvoteDetails>;
  /** The label used to reflect the current status of a service */
  label: StatusLabel;
};

/** input for setPasswordForAccount mutation */
export type SetPasswordForAccountInput = {
  /** Account id to set password. */
  accountId: Scalars['AccountId']['input'];
  /** New password to set. */
  newPassword: Scalars['String']['input'];
};

/** setPasswordForAccount response payload. */
export type SetPasswordForAccountPayload = InvalidInputError | NotFoundError | SetPasswordSuccess | UnexpectedError;

/** success response for setPasswordForAccount mutation */
export type SetPasswordSuccess = MutationSuccess & {
  __typename?: 'SetPasswordSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for setting up posting schedules for a Channel */
export type SetPostingScheduleForChannelInput = {
  /** The channel id to update the posting schedule */
  channelId: Scalars['ChannelId']['input'];
  /** The posting schedule to update for a Channel */
  postingSchedule: Array<InputMaybe<ScheduleV2Input>>;
};

/** The payload of the response from setPostingScheduleForChannel */
export type SetPostingScheduleForChannelPayload = InvalidInputError | NotFoundError | SetPostingScheduleForChannelResponse | UnauthorizedError | UnexpectedError;

/** The response for setting up posting schedules for a Channel */
export type SetPostingScheduleForChannelResponse = {
  __typename?: 'SetPostingScheduleForChannelResponse';
  /** The posting schedules updated from the Channel */
  postingSchedule: Array<Maybe<ScheduleV2>>;
};

/** Settings */
export type Settings = {
  __typename?: 'Settings';
  aiSettings?: Maybe<AiSettings>;
};

export type SettingsInput = {
  aiSettings?: InputMaybe<AiSettingsInput>;
};

/** How the post is being scheduled. */
export type ShareMode =
  | 'addToQueue'
  | 'shareNext'
  | 'shareNow';

/**
 * ShopGrid Custom Links
 * This query retrieves the custom links for the shop grid.
 * The response includes the color, contrast color, and a list of custom links.
 * The input requires the channel ID to fetch the specific links for that channel.
 */
export type ShopGridCustomLinksInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
};

/** Mutation Payload for custom links: Success and errors */
export type ShopGridCustomLinksMutationPayload = NotFoundError | ShopGridCustomLinksPayload | UnauthorizedError | UnexpectedError;

/** Response payload for Shop Grid Custom Link */
export type ShopGridCustomLinksPayload = {
  __typename?: 'ShopGridCustomLinksPayload';
  /** Color for links */
  color?: Maybe<Scalars['HexColorCode']['output']>;
  /** Contrast color for links */
  contrastColor?: Maybe<Scalars['HexColorCode']['output']>;
  /** List of links */
  links?: Maybe<Array<CustomLink>>;
};

/** Direction to sort the results by. */
export type SortDirection =
  /** Sort records in ascending order. */
  | 'asc'
  /** Sort records in descending order. */
  | 'desc';

export type SplitEnabledResponse = {
  __typename?: 'SplitEnabledResponse';
  isEnabled: Scalars['Boolean']['output'];
};

export type StartImpersonationInput = {
  bufferTeammateAccountId: Scalars['String']['input'];
  impersonatedCustomerAccountId: Scalars['String']['input'];
};

/** The start of week preference for the account. */
export type StartOfWeek =
  /** The start of week is Monday. */
  | 'monday'
  /** The start of week is Sunday. */
  | 'sunday';

export type StartPage = {
  __typename?: 'StartPage';
  blocks?: Maybe<Array<Maybe<StartPageBlock>>>;
  domain?: Maybe<Scalars['String']['output']>;
  hasUnPublishedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  migrationAsAChannel?: Maybe<StartPageMigrationAsAChannel>;
  organizationId: Scalars['ID']['output'];
  statistics?: Maybe<StartPageStats>;
  theme?: Maybe<StartPageThemeSaved>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Output Types */
export type StartPageBlock = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockButtonLink = StartPageBlock & {
  __typename?: 'StartPageBlockButtonLink';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Button link specific data */
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockFeed = StartPageBlock & {
  __typename?: 'StartPageBlockFeed';
  /** Feed specific data */
  children?: Maybe<Array<Maybe<StartPageBlockFeedPost>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type StartPageBlockFeedChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageBlockFeedPost = StartPageBlock & {
  __typename?: 'StartPageBlockFeedPost';
  /**
   * Feed Post specific data
   * @deprecated deprecated, will be removed
   */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockHeader = StartPageBlock & {
  __typename?: 'StartPageBlockHeader';
  backgroundMedia?: Maybe<StartPageMedia>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  logoMedia?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  overlay?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** Header specific data */
  title?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockIconLinks = StartPageBlock & {
  __typename?: 'StartPageBlockIconLinks';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Icon links specific data */
  links?: Maybe<Array<Maybe<StartPageIconLink>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockImageLink = StartPageBlock & {
  __typename?: 'StartPageBlockImageLink';
  /** Image link specific data */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockImageLinksGrid = StartPageBlock & {
  __typename?: 'StartPageBlockImageLinksGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Links grid specific data */
  links?: Maybe<Array<Maybe<StartPageLinkGrid>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

/** deprecated(reason: "Use StartPageBlockImageLinksGrid.") */
export type StartPageBlockInstagramLinksGrid = StartPageBlock & {
  __typename?: 'StartPageBlockInstagramLinksGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Links grid specific data */
  links?: Maybe<Array<Maybe<StartPageLinkGrid>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockMailchimp = StartPageBlock & {
  __typename?: 'StartPageBlockMailchimp';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Mailchimp specific data */
  htmlText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockSpotify = StartPageBlock & {
  __typename?: 'StartPageBlockSpotify';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  /** Spotify specific data */
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockStyles = {
  __typename?: 'StartPageBlockStyles';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<StartPageBlockTypes>;
  border?: Maybe<Scalars['String']['output']>;
  corners?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
  secondaryFontFamily?: Maybe<Scalars['String']['output']>;
  secondaryTextColor?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<StartPageTextAlign>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockStylesInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  blockType?: InputMaybe<StartPageBlockTypes>;
  border?: InputMaybe<Scalars['String']['input']>;
  corners?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  secondaryFontFamily?: InputMaybe<Scalars['String']['input']>;
  secondaryTextColor?: InputMaybe<Scalars['String']['input']>;
  textAlign?: InputMaybe<StartPageTextAlign>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageBlockSubHeading = StartPageBlock & {
  __typename?: 'StartPageBlockSubHeading';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** SubHeading specific data */
  text?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockText = StartPageBlock & {
  __typename?: 'StartPageBlockText';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  htmlJson?: Maybe<Scalars['String']['output']>;
  htmlText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** Text specific data */
  text?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockTypes =
  | 'BUTTON_LINK'
  | 'FEED'
  | 'FEED_POST'
  | 'HEADER'
  | 'ICON_LINKS'
  | 'IMAGE_LINK'
  | 'IMAGE_LINKS_GRID'
  | 'INSTAGRAM_LINKS_GRID'
  | 'MAILCHIMP'
  | 'SPOTIFY'
  | 'SUB_HEADING'
  | 'TEXT'
  | 'VIDEO';

export type StartPageBlockVideo = StartPageBlock & {
  __typename?: 'StartPageBlockVideo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Video specific data */
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

/** Input Types */
export type StartPageConfigInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  /** deprecated(reason: "Use `template`.") */
  preset?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<StartPageThemeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageData = {
  __typename?: 'StartPageData';
  link?: Maybe<Scalars['String']['output']>;
};

/** Output Types */
export type StartPageGlobalStyles = {
  __typename?: 'StartPageGlobalStyles';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type StartPageGlobalStylesInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageIconLink = {
  __typename?: 'StartPageIconLink';
  icon?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageIconType =
  | 'FACEBOOK'
  | 'INSTAGRAM'
  | 'MESSENGER'
  | 'PINTEREST'
  | 'TWITTER'
  | 'WHATSAPP';

export type StartPageLinkGrid = {
  __typename?: 'StartPageLinkGrid';
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageLinksClicks = {
  __typename?: 'StartPageLinksClicks';
  block?: Maybe<StartPageBlock>;
  clicks?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type StartPageMedia = {
  __typename?: 'StartPageMedia';
  altText?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageMigrationAsAChannel = {
  __typename?: 'StartPageMigrationAsAChannel';
  errorReason?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  wasAtLimit?: Maybe<Scalars['Boolean']['output']>;
  wasBilling?: Maybe<Scalars['String']['output']>;
  wasMobile?: Maybe<Scalars['Boolean']['output']>;
  wasPublished?: Maybe<Scalars['Boolean']['output']>;
  wasTrialist?: Maybe<Scalars['Boolean']['output']>;
};

export type StartPageMutationResponse = CommonError | StartPageMutationSuccess;

/** Query / Mutation responses */
export type StartPageMutationSuccess = MutationResponse & {
  __typename?: 'StartPageMutationSuccess';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  startPage?: Maybe<StartPage>;
  startPages?: Maybe<Array<Maybe<StartPage>>>;
  success: Scalars['Boolean']['output'];
};

/** Start Page post metadata */
export type StartPagePostMetadata = CommonPostMetadata & {
  __typename?: 'StartPagePostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Optional link in post */
  link?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Start Page post metadata */
export type StartPagePostMetadataInput = {
  /** Optional link in post */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageResponse = CommonError | StartPage;

export type StartPageStats = {
  __typename?: 'StartPageStats';
  allTimeViews?: Maybe<Scalars['Int']['output']>;
  dailyViews?: Maybe<Scalars['Int']['output']>;
  linksClicks?: Maybe<Array<Maybe<StartPageLinksClicks>>>;
  weeklyViews?: Maybe<Scalars['Int']['output']>;
};

export type StartPageTemplate = {
  __typename?: 'StartPageTemplate';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type StartPageTemplatesResponse = {
  __typename?: 'StartPageTemplatesResponse';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templates?: Maybe<Array<Maybe<StartPageTemplate>>>;
};

export type StartPageTextAlign =
  | 'CENTER'
  | 'LEFT'
  | 'RIGHT';

export type StartPageTheme = {
  __typename?: 'StartPageTheme';
  blockStyles?: Maybe<Array<Maybe<StartPageBlockStyles>>>;
  globalStyles?: Maybe<StartPageGlobalStyles>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StartPageThemeInput = {
  blockStyles?: InputMaybe<Array<InputMaybe<StartPageBlockStylesInput>>>;
  globalStyles?: InputMaybe<StartPageGlobalStylesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageThemeSaved = {
  __typename?: 'StartPageThemeSaved';
  blockStyles?: Maybe<Array<Maybe<StartPageBlockStyles>>>;
  globalStyles?: Maybe<StartPageGlobalStyles>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StartPageThemesResponse = {
  __typename?: 'StartPageThemesResponse';
  themes?: Maybe<Array<Maybe<StartPageTheme>>>;
};

export type StartPages = {
  __typename?: 'StartPages';
  startPages?: Maybe<Array<Maybe<StartPage>>>;
};

export type StartPagesResponse = CommonError | StartPages;

/** The label used to reflect the current status of a service */
export type StatusLabel =
  /** The service is not yet available but will be soon */
  | 'coming_soon'
  /** The service is new to our platform */
  | 'new'
  /** The service has no status, typically it is available and has been for some time */
  | 'none';

export type StopImpersonationInput = {
  bufferTeammateAccountId: Scalars['String']['input'];
};

/** Represents a streak of consecutive actions or achievements */
export type Streak = {
  __typename?: 'Streak';
  /** The number of consecutive periods the streak goal has been met. */
  count: Scalars['Int']['output'];
  /** The longest streak. This value takes into account the current streak. */
  longestCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of weeks ahead of the current streak
   * It currently returns either 0 or 1 because every period requires a DB call
   */
  periodsAhead?: Maybe<Scalars['Int']['output']>;
  /** Previous period streak count. If the current streak is the only one, it returns 0 */
  previousCount?: Maybe<Scalars['Int']['output']>;
  /** The current streak status */
  status: StreakStatus;
  /** The enum indicating which streak content to display on the client */
  userStreakState: UserStreakState;
};

/** Represents the current status of a user's streak */
export type StreakStatus =
  /** There is a low chance the goal will be met in this period. */
  | 'AtRisk'
  /** The goal for the period was hit */
  | 'Hit'
  /** The streak has been reset (broken streak) */
  | 'Missed'
  /** There is a good chance the goal will be met in this period. */
  | 'OnTrack'
  /** Neutral value at the start of the period. This is the default value. */
  | 'Started';

/** Deprecated in favor of Billing type. */
export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  cycle?: Maybe<Scalars['String']['output']>;
  cycleEndDate?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<LegacyDiscount>;
  isActiveTrial?: Maybe<Scalars['Boolean']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  product?: Maybe<Scalars['String']['output']>;
  subscriptionCanceledDate?: Maybe<Scalars['Int']['output']>;
  subscriptionEndDate?: Maybe<Scalars['Int']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionIsCanceled?: Maybe<Scalars['Boolean']['output']>;
  subscriptionIsPaused?: Maybe<Scalars['Boolean']['output']>;
  trialEndDate?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Deprecated in favor of Billing type. */
export type Subscriptionv2 = {
  __typename?: 'Subscriptionv2';
  analyze: SubscriptionDetails;
  analyzeTrial: SubscriptionDetails;
  publish: SubscriptionDetails;
  publishTrial: SubscriptionDetails;
};

/** Represents a suggested response or action for a comment. */
export type Suggestion = {
  __typename?: 'Suggestion';
  /** The source of the suggestion (e.g., AI, predefined template). */
  source: CommentSuggestionSource;
  /** The suggested text to respond with. */
  text: Scalars['String']['output'];
};

/** Represents whether a client is currently supported by the API */
export type SupportStatus =
  | 'notSupported'
  | 'supported';

/** Swap post's request input. */
export type SwapPostsInQueueInput = {
  /** ID of the source post, i.e., the post that was dragged */
  sourceId: Scalars['PostId']['input'];
  /** ID of the target post, i.e., the post the source post was dropped on */
  targetId: Scalars['PostId']['input'];
};

/** Swap post's request response payload. */
export type SwapPostsInQueuePayload = NotFoundError | RestProxyError | SwapPostsInQueueSuccess | UnauthorizedError | UnexpectedError;

/** Swap post's request success response. */
export type SwapPostsInQueueSuccess = {
  __typename?: 'SwapPostsInQueueSuccess';
  /** Return the swapped posts - Order is not relevant. */
  posts: Array<Post>;
};

/** Input for the mutation to swap shop grid custom links */
export type SwapShopGridCustomLinksInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The source ID of the custom link to be swapped */
  sourceId: Scalars['ShopGridLinkId']['input'];
  /** The target ID of the custom link to be swapped */
  targetId: Scalars['ShopGridLinkId']['input'];
};

/** TFA information */
export type Tfa = {
  __typename?: 'TFA';
  /** The method of Two Factor Authentication */
  type: TwoFactorMethod;
};

/** Tag entity */
export type Tag = {
  __typename?: 'Tag';
  /** Hex color for tag e.g '#F523F1' */
  color: Scalars['String']['output'];
  /** ObjectId of the tag */
  id: Scalars['TagId']['output'];
  /**
   * Locked tag cannot be assigned to new items in the UI.
   * A Tag is locked after a customer downgrades and has more tags than the free plan limit allows
   */
  isLocked: Scalars['Boolean']['output'];
  /** Name of the tag e.g 'Summer sales' */
  name: Scalars['String']['output'];
};

export type TagActionInIdeasPayload = CoreWebAppCommonError | TagActionInIdeasSuccess;

export type TagActionInIdeasSuccess = CoreWebAppMutationResponse & {
  __typename?: 'TagActionInIdeasSuccess';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Success response returns the full up-to-date tag from after the action was performed. */
export type TagActionSuccess = {
  __typename?: 'TagActionSuccess';
  /** Tag on which the action was successfully performed. */
  tag: Tag;
};

export type TagInput = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type TagRemovalFromIdeaInput = {
  ideaId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type TagRemovalFromIdeasInput = {
  organizationId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** Input to pass when creating a Tag. */
export type TagToCreateInput = {
  /** Hex color for tag e.g '#F523F1' */
  color: Scalars['String']['input'];
  /** Name of the tag e.g 'Summer sales' */
  name: Scalars['String']['input'];
};

/** Input to pass when updating a Tag. */
export type TagToUpdateInput = {
  /** Hex color for tag e.g '#F523F1' */
  color: Scalars['String']['input'];
  /** Name of the tag e.g 'Summer sales' */
  name: Scalars['String']['input'];
};

/** Filter to pass when fetching tags. */
export type TagsFiltersInput = {
  /** if not defined, it returns all tags - if true, it only returns locked tags - if false, it only returns not locked tags */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input to pass when fetching tags. */
export type TagsInput = {
  /** A list of option filters */
  filter?: InputMaybe<TagsFiltersInput>;
  /** The Organization id to fetch tags for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type TaxDetails = {
  __typename?: 'TaxDetails';
  automaticTax?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<TaxLocation>;
};

export type TaxId = {
  __typename?: 'TaxId';
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  verification?: Maybe<TaxIdVerification>;
};

export type TaxIdVerification = {
  __typename?: 'TaxIdVerification';
  status?: Maybe<Scalars['String']['output']>;
  verifiedAddress?: Maybe<Scalars['String']['output']>;
  verifiedName?: Maybe<Scalars['String']['output']>;
};

export type TaxLocation = {
  __typename?: 'TaxLocation';
  country?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type TestIdeasInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};

export type TextGenerated = {
  __typename?: 'TextGenerated';
  suggestions: Array<Maybe<TextSuggestionGenerated>>;
};

/** Query / Mutation responses */
export type TextGenerationResponse = CommonError | TextGenerated;

/** Output Types */
export type TextSuggestionGenerated = {
  __typename?: 'TextSuggestionGenerated';
  content: Scalars['String']['output'];
};

/**
 * A post authored by the user which is posted to a thread.
 * This is commonly used for long-format twitter and meta threads posts to
 * allow authored content to span multiple threads.
 * Threads are represented as a list of replies, each replying to the previous one.
 */
export type ThreadedPost = {
  __typename?: 'ThreadedPost';
  /** Media assets of the threaded post */
  assets: Array<Asset>;
  /** The text body content of the threaded post */
  text: Scalars['String']['output'];
};

/**
 * A post authored by the user which is posted to a thread.
 * This is commonly used for long-format twitter and meta threads posts to
 * allow authored content to span multiple threads.
 * Threads are represented as a list of replies, each replying to the previous one.
 */
export type ThreadedPostInput = {
  /** Media assets of the threaded post */
  assets?: InputMaybe<AssetsInput>;
  /** The text body content of the threaded post */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Common properties for all posts that support threaded replies.
 * See ThreadedPost for more details.
 */
export type ThreadedPostMetadata = {
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
};

export type ThreadsData = {
  __typename?: 'ThreadsData';
  location_id?: Maybe<Scalars['String']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** Represents a location that can be tagged in Threads posts */
export type ThreadsLocation = {
  __typename?: 'ThreadsLocation';
  /** Street address of the location (optional) */
  address?: Maybe<Scalars['String']['output']>;
  /** City where the location is situated (optional) */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the location is situated (optional) */
  country?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the location */
  id: Scalars['String']['output'];
  /** Latitude coordinate of the location (optional) */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude coordinate of the location (optional) */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Display name of the location */
  name: Scalars['String']['output'];
  /** Postal code of the location (optional) */
  postalCode?: Maybe<Scalars['String']['output']>;
};

/** Threads post metadata */
export type ThreadsPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'ThreadsPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** LocationId associated with the post */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Location name associated with the post */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** Topic associated with the post */
  topic?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Threads post metadata */
export type ThreadsPostMetadataInput = {
  /** Link attachment */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** LocationId associated with the post */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** Location name associated with the post */
  locationName?: InputMaybe<Scalars['String']['input']>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
  /** Topic associated with the post */
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** Tiktok post metadata */
export type TiktokPostMetadata = CommonPostMetadata & {
  __typename?: 'TiktokPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** The time format preference for the account. */
export type TimeFormat =
  /** The time format in 12-hour format. */
  | 'twelveHour'
  /** The time format in 24-hour format. */
  | 'twentyFourHour';

export type TokenUsageInput = {
  featureAction: FeatureAction;
  usedTokens?: InputMaybe<Scalars['Int']['input']>;
};

/** Error returned when the input query string is too short */
export type TooShortQueryStringError = MutationError & {
  __typename?: 'TooShortQueryStringError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Response type for track an action in a survey or saved a completed survey */
export type TrackActionOnboardingSurveySuccess = {
  __typename?: 'TrackActionOnboardingSurveySuccess';
  actionsTaken: Array<OnboardingSurveyActionTaken>;
  /** onboarding survey saved in the DB */
  surveyId: Scalars['String']['output'];
};

export type TrackExternalServiceUsageResponse = Error | Response;

/** Error type for specific transfer-related issues. */
export type TransferError = MutationError & {
  __typename?: 'TransferError';
  /**
   * A human-readable message explaining why the transfer cannot happen.
   * E.g., the new owner is not an Admin, they have channels, or are not on the
   * Free plan
   */
  message: Scalars['String']['output'];
};

/** Input for transferOrganizationOwnership mutation */
export type TransferOrganizationOwnershipInput = {
  /** The ID of the account that will become the new owner. */
  newOwner: Scalars['AccountId']['input'];
  /** The ID of the organization for which ownership is being transferred. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors for transferOrganizationOwnership */
export type TransferOrganizationOwnershipPayload = EmptySuccess | TransferError;

export type Trial = {
  __typename?: 'Trial';
  endDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Returns whether an admin need to take an action: it happens when the trial expires, we present the admin with a modal to decide if they want to start paying for Buffer */
  isAwaitingUserAction: Scalars['Boolean']['output'];
  remainingDays: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

/** Twitter metadata */
export type TwitterMetadata = {
  __typename?: 'TwitterMetadata';
  /** Indicates the type of subscription the user has on Twitter */
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

/** Twitter post metadata */
export type TwitterPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'TwitterPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The details of the tweet being retweeted */
  retweet?: Maybe<RetweetMetadata>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Twitter post metadata */
export type TwitterPostMetadataInput = {
  /** The details of the tweet being retweeted */
  retweet?: InputMaybe<RetweetMetadataInput>;
  /** The list of threaded posts (not paginated) */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

/** Input for confirming Two Factor Authentication */
export type TwoFactorConfirmInput = {
  /** Confirmation Code */
  code: Scalars['String']['input'];
  /** The Account with the Two Factor Authentication set up */
  key: Scalars['String']['input'];
  /** Method type */
  method: TwoFactorMethod;
};

/** The payload of the response from TwoFactorConfirm */
export type TwoFactorConfirmPayload = InvalidInputError | TwoFactorConfirmResponse | UnexpectedError;

/** The response for confirming Two Factor Authentication */
export type TwoFactorConfirmResponse = {
  __typename?: 'TwoFactorConfirmResponse';
  /** Recovery code */
  recoveryCode: Scalars['String']['output'];
};

/**
 * Input for disabling Two Factor Authentication with Account ID
 * This is used for Buffer Admin to disable Two Factor Authentication for an account
 */
export type TwoFactorDisableByAccountIdInput = {
  /** The Account ID */
  accountId: Scalars['AccountId']['input'];
};

/** The payload of the response from TwoFactorDisable */
export type TwoFactorDisablePayload = EmptySuccess | UnexpectedError;

/** The type of Two Factor Authentication method */
export type TwoFactorMethod =
  | 'app'
  | 'email';

/** The input for showing the Two Factor recovery code */
export type TwoFactorRecoveryCodeInput = {
  /** The one time password code */
  code: Scalars['String']['input'];
};

/** The Payload for Two Factor Recovery Code */
export type TwoFactorRecoveryCodePayload = InvalidInputError | TwoFactorRecoveryCodeResponse | UnexpectedError;

/** The response for showing the Two Factor recovery code */
export type TwoFactorRecoveryCodeResponse = {
  __typename?: 'TwoFactorRecoveryCodeResponse';
  /** The recovery code */
  recoveryCode: Scalars['String']['output'];
};

/** The Payload for Two Factor Request One-Time Password */
export type TwoFactorRequestOneTimePasswordPayload = EmptySuccess | UnexpectedError;

/** Input for setting up Two Factor Authentication */
export type TwoFactorSetupInput = {
  /** Method type */
  method: TwoFactorMethod;
};

/** The payload of the response from TwoFactorSetup */
export type TwoFactorSetupPayload = InvalidInputError | TwoFactorSetupResponse | UnexpectedError;

/** The response for setting up Two Factor Authentication */
export type TwoFactorSetupResponse = {
  __typename?: 'TwoFactorSetupResponse';
  /** The Account with the Two Factor Authentication set up */
  key?: Maybe<Scalars['String']['output']>;
};

/** Error returned when the user is not authorized to perform the action */
export type UnauthorizedError = MutationError & {
  __typename?: 'UnauthorizedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Input type for the `undismissComment` mutation.
 * Defines the comment being undismissed.
 */
export type UndismissCommentInput = {
  /** ID of the comment being undismissed. */
  commentId: Scalars['CommentId']['input'];
};

/** Mutation Response: Success and errors */
export type UndismissCommentPayload = InvalidInputError | NotFoundError | UnauthorizedError | UndismissCommentSuccess | UnexpectedError;

/** Successful undismiss response. */
export type UndismissCommentSuccess = {
  __typename?: 'UndismissCommentSuccess';
  /** The comment that was successfully undismissed. */
  comment: CommentData;
};

/** Error returned when unexpected error occurs */
export type UnexpectedError = MutationError & {
  __typename?: 'UnexpectedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Error message returned when channel is a non-supported type */
export type UnsupportedChannelError = MutationError & {
  __typename?: 'UnsupportedChannelError';
  /** Error message returned when token is requested for unsupported channel */
  message: Scalars['String']['output'];
};

export type UnverifiedEmailAddressError = {
  __typename?: 'UnverifiedEmailAddressError';
  cause: Scalars['String']['output'];
};

export type UpcomingInvoiceCostsPreview = {
  __typename?: 'UpcomingInvoiceCostsPreview';
  chargeAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  isScheduledChange: Scalars['Boolean']['output'];
  nextBillingDate: Scalars['DateTime']['output'];
};

/** Input for the updateAccountAvatar mutation */
export type UpdateAccountAvatarInput = {
  /** new url for the account avatar */
  url: Scalars['String']['input'];
};

/** updateAccountAvatar response payload */
export type UpdateAccountAvatarPayload = InvalidInputError | NotFoundError | UnexpectedError | UpdateAccountAvatarSuccess;

/** success response for deleteAccount mutation */
export type UpdateAccountAvatarSuccess = MutationSuccess & {
  __typename?: 'UpdateAccountAvatarSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updateAccountName mutation */
export type UpdateAccountNameInput = {
  /** new name for the account */
  name: Scalars['String']['input'];
};

/** updateAccountName response payload */
export type UpdateAccountNamePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateAccountNameSuccess;

/** success response for updateName mutation */
export type UpdateAccountNameSuccess = MutationSuccess & {
  __typename?: 'UpdateAccountNameSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updatePreferences mutation */
export type UpdateAccountPreferencesInput = {
  /** default schedule option, if not provided, the default schedule option will not be updated */
  defaultScheduleOption?: InputMaybe<ScheduleOption>;
  /** start of week, if not provided, the start of week will not be updated */
  startOfWeek?: InputMaybe<StartOfWeek>;
  /** time format, if not provided, the time format will not be updated */
  timeFormat?: InputMaybe<TimeFormat>;
};

/** updatePreferences response payload */
export type UpdateAccountPreferencesPayload = InvalidInputError | UpdateAccountPreferencesSuccess;

/** success response for updatePreferences mutation */
export type UpdateAccountPreferencesSuccess = {
  __typename?: 'UpdateAccountPreferencesSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  preferences: Preferences;
};

/** Input for updateAccountTimezone mutation */
export type UpdateAccountTimezoneInput = {
  /** New timezone to set */
  timezone: Scalars['String']['input'];
};

/** updateAccountTimezone response payload */
export type UpdateAccountTimezonePayload = InvalidInputError | NotFoundError | UnexpectedError | UpdateAccountTimezoneSuccess;

/** success response for updateAccountTimezone mutation */
export type UpdateAccountTimezoneSuccess = {
  __typename?: 'UpdateAccountTimezoneSuccess';
  /** The id of the updated account */
  accountId: Scalars['AccountId']['output'];
  /** The updated timezone for the account */
  timezone: Scalars['String']['output'];
};

/** input for updateAdminComment mutation */
export type UpdateAdminCommentInput = {
  /** ID of the account that will have the comment applied */
  accountId: Scalars['AccountId']['input'];
  /** Text to be applied as a comment to the account */
  message: Scalars['String']['input'];
};

/** updateAdminComment response payload */
export type UpdateAdminCommentPayload = NotFoundError | UnauthorizedError | UnexpectedError | UpdateAdminCommentSuccess;

/** success response for updateAdminComment mutation */
export type UpdateAdminCommentSuccess = {
  __typename?: 'UpdateAdminCommentSuccess';
  /** Returns the updated admin comment */
  adminComment: Scalars['String']['output'];
};

/** Bluesky-specific metadata for custom channel update */
export type UpdateBlueskyMetadata = {
  /** Bluesky account App Password */
  appPassword?: InputMaybe<Scalars['String']['input']>;
  /** Bluesky account Handle (username) */
  handle?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updateChannelGroup mutation */
export type UpdateChannelGroupInput = {
  /** The channels to be added to the group */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The id of the channel group */
  id: Scalars['ChannelGroupId']['input'];
  /** The name of the channel group */
  name: Scalars['String']['input'];
};

/** Mutation Response: Success and errors */
export type UpdateChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Input for updating the posting goal for a Channel */
export type UpdateChannelPostingGoalInput = {
  /** The channel id to update the posting goal */
  channelId: Scalars['ChannelId']['input'];
  /** The posting goal */
  goal: Scalars['Int']['input'];
  /**
   * Indicates if the posting schedules should be overridden
   * @deprecated Use scheduleUpdateMode instead
   */
  overridePostingSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mode for updating the posting schedule: override, add, or none */
  scheduleUpdateMode?: InputMaybe<ScheduleUpdateMode>;
};

/** The payload of the response from updateChannelPostingGoal */
export type UpdateChannelPostingGoalPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateChannelPostingGoalResponse;

/** The response for updating the posting goal for a Channel */
export type UpdateChannelPostingGoalResponse = {
  __typename?: 'UpdateChannelPostingGoalResponse';
  /** The posting goal updated from the Channel */
  channel: Channel;
};

/** Input for updating custom channels, like Bluesky or FB Group */
export type UpdateCustomChannelInput = {
  /** Channel ID of updated channel */
  channelId: Scalars['ChannelId']['input'];
  /** Channel-specific metadata to use during creation */
  customChannelMetadata?: InputMaybe<UpdateCustomChannelMetadata>;
  /** Timezone to be used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Channel-specific metadata for custom channel update */
export type UpdateCustomChannelMetadata = {
  /** Bluesky-specific metadata */
  blueskyMetadata?: InputMaybe<UpdateBlueskyMetadata>;
  /** FB Group-specific metadata */
  facebookGroupMetadata?: InputMaybe<UpdateFacebookGroupMetadata>;
  /** IG Personal Profile-specific metadata */
  instagramPersonalProfileMetadata?: InputMaybe<UpdateInstagramPersonalProfileMetadata>;
};

/** Payload for updateCustomChannel mutation */
export type UpdateCustomChannelPayload = CustomChannelError | UpdateCustomChannelResponse;

/** The response for custom channel refresh */
export type UpdateCustomChannelResponse = {
  __typename?: 'UpdateCustomChannelResponse';
  /** Updated channel */
  channel: Channel;
};

/** Input to update custom links colors for a channel */
export type UpdateCustomLinksColorsInput = {
  /** The channel id to update the custom links colors */
  channelId: Scalars['ChannelId']['input'];
  /** The color for the custom links */
  color: Scalars['HexColorCode']['input'];
  /** The contrast color for the custom links */
  contrastColor: Scalars['HexColorCode']['input'];
};

/** The response for updating custom links colors for a Channel */
export type UpdateCustomLinksColorsPayload = EmptySuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Facebook Group-specific metadata for custom channel update */
export type UpdateFacebookGroupMetadata = {
  /** Avatar URL of this FB Group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this FB Group */
  name?: InputMaybe<Scalars['String']['input']>;
  /** URL to FB Group's page */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing failed post error. */
export type UpdateFailedPostErrorInput = {
  /** ID of the failed post error to update. */
  id: Scalars['ErrorMessageId']['input'];
  /** Updated link to further information. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Updated localized link text. */
  linkText?: InputMaybe<LocalizedTextInput>;
  /** Updated patterns for this error. */
  patterns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The position of the error message in the list of error messages. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The service that this error is associated with. */
  service?: InputMaybe<Service>;
  /** Updated localized text for the error message. */
  text?: InputMaybe<LocalizedTextInput>;
};

/** Union type representing either a successful update of a failed post error or an error */
export type UpdateFailedPostErrorPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateFailedPostErrorSuccess;

/** Payload for successfully updating a failed post error. */
export type UpdateFailedPostErrorSuccess = {
  __typename?: 'UpdateFailedPostErrorSuccess';
  /** The failed post error that was updated. */
  failedPostError: FailedPostError;
};

/** Input for updateFeedCollection mutation */
export type UpdateFeedCollectionInput = {
  /** Id of the feed collection to update */
  feedCollectionId: Scalars['FeedCollectionId']['input'];
  /**
   * Feeds to subscribe to in this feed, if not set, will not update
   * @deprecated(reason: "Use moveFeed mutation to manage feed associations")
   */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
  /** The name of the feed collection. If set, this will override the name of the feed. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization that the feed collection will belong to */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Input type for updating an idea group. */
export type UpdateIdeaGroupInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Union type representing possible payloads for updating an idea group. */
export type UpdateIdeaGroupPayload = IdeaGroup | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** updateIdea input type */
export type UpdateIdeaInput = {
  /** New content and metadata for the idea */
  content: IdeaContentInput;
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** New group ID (null for unassigned group) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the idea to update */
  id: Scalars['String']['input'];
};

/** updateIdea response (including errors) */
export type UpdateIdeaPayload = IdeaResponse | InvalidInputError | UnauthorizedError | UnexpectedError;

/** Instagram Personal Profile-specific metadata for custom channel update */
export type UpdateInstagramPersonalProfileMetadata = {
  /** Avatar URL for the channel */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this IG Profile */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating lastActivityAt for a channel */
export type UpdateLastActivityAtForChannelInput = {
  /** The channel id to update the lastActivityAt */
  channelId: Scalars['ChannelId']['input'];
};

/** UpdateChannelLastActivityAt possible responses */
export type UpdateLastActivityAtForChannelPayload = UnauthorizedError | UnexpectedError | UpdateLastActivityAtForChannelSuccess;

/** success response for updateLastActivityAtForChannel mutation */
export type UpdateLastActivityAtForChannelSuccess = MutationSuccess & {
  __typename?: 'UpdateLastActivityAtForChannelSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input type for updating a note on a post */
export type UpdateNoteOnPostInput = {
  /** The ID of the note */
  noteId: Scalars['NoteId']['input'];
  /** The ID of the post */
  postId: Scalars['PostId']['input'];
  /** The new text for the note */
  text: Scalars['String']['input'];
};

/** Union type representing the possible outcomes of the updateNoteOnPost mutation */
export type UpdateNoteOnPostPayload = InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateNoteOnPostSuccess;

/** Type returned on successful update of a note on a post */
export type UpdateNoteOnPostSuccess = {
  __typename?: 'UpdateNoteOnPostSuccess';
  /** The post with the updated note */
  post: Post;
};

/** Input for the updatePassword mutation */
export type UpdatePasswordInput = {
  /** New Password to update Account with */
  newPassword: Scalars['String']['input'];
  /** Current Password for Account to verify if we allow updating the password */
  password: Scalars['String']['input'];
};

/** updatePassword response payload */
export type UpdatePasswordPayload = EmptySuccess | InvalidInputError | UnauthorizedError | UnexpectedError;

export type UpdatePostDueAtInput = {
  postId: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

/** @deprecated: use the generic PostUpdatedPayload */
export type UpdatePostDueAtMutationResponse = CoreWebAppCommonError | PostNotFound | PostNotUpdated | PostUpdated;

/** Update post's tags request input. */
export type UpdatePostTagsInput = {
  /** Post id to update. */
  id: Scalars['PostId']['input'];
  /**
   * The entire list of tags to assign to the Post. This list will fully replace the existing one.
   * E.g., if a post has two tags and you call this mutation with a new tag, the Post will have only the new tag assigned and the two old tags will be removed.
   */
  tags: Array<Scalars['TagId']['input']>;
};

/** Update post's tags request response payload. */
export type UpdatePostTagsPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input type for updating a saved reply. */
export type UpdateSavedReplyInput = {
  /** Id of the saved reply to update. */
  id: Scalars['SavedReplyId']['input'];
  /** The new data for the saved reply. */
  savedReply: SavedReplyToUpdateInput;
};

/**
 * Response type for the updateSavedReply mutation.
 * It can return either success or an error.
 */
export type UpdateSavedReplyPayload = DuplicateError | InvalidInputError | NotFoundError | SavedReplyActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for the mutation to update a shop grid custom link */
export type UpdateShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The ID of the custom link to be updated */
  id: Scalars['ShopGridLinkId']['input'];
  /** Link text to be saved */
  text: Scalars['String']['input'];
  /** URL to be saved */
  url: Scalars['String']['input'];
};

/** Input for the mutation to update a shop grid post link */
export type UpdateShopGridPostLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Link to be saved */
  link?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post to be updated */
  postId: Scalars['PostId']['input'];
};

/** Mutation Payload for updating shop grid link: Success and errors */
export type UpdateShopGridPostLinkPayload = EmptySuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for the updateStartOfWeekPreference mutation */
export type UpdateStartOfWeekPreferenceInput = {
  /** preferences to update */
  startOfWeek: StartOfWeek;
};

/** updateStartOfWeekPreference response payload */
export type UpdateStartOfWeekPreferencePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateStartOfWeekPreferenceSuccess;

/** success response for updateStartOfWeekPreference mutation */
export type UpdateStartOfWeekPreferenceSuccess = MutationSuccess & {
  __typename?: 'UpdateStartOfWeekPreferenceSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type UpdateTagInIdeasInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** Input to pass when updating a Tag. */
export type UpdateTagInput = {
  /** The id of tag to update */
  id: Scalars['TagId']['input'];
  /** The new tag data to set */
  tag: TagToUpdateInput;
};

/** Update tag request response payload. */
export type UpdateTagPayload = DuplicateError | InvalidInputError | NotFoundError | RestProxyError | TagActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for the updateTimeFormatPreference mutation */
export type UpdateTimeFormatPreferenceInput = {
  /** preferences to update */
  timeFormat: TimeFormat;
};

/** updateTimeFormatPreference response payload */
export type UpdateTimeFormatPreferencePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateTimeFormatPreferenceSuccess;

/** success response for updateTimeFormatPreference mutation */
export type UpdateTimeFormatPreferenceSuccess = MutationSuccess & {
  __typename?: 'UpdateTimeFormatPreferenceSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for setting the timezone for a Channel */
export type UpdateTimezoneForChannelInput = {
  /** The channel id to update the timezone */
  channelId: Scalars['ChannelId']['input'];
  /** The timezone value (IANA timezone format) */
  timezone: Scalars['TimeZone']['input'];
};

/** The payload of the response from updateTimezoneForChannel */
export type UpdateTimezoneForChannelPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateTimezoneForChannelResponse;

/** The response for updating timezone for a Channel */
export type UpdateTimezoneForChannelResponse = {
  __typename?: 'UpdateTimezoneForChannelResponse';
  /** The timezone updated in the Channel */
  channel: Channel;
};

export type UploadDetails = {
  __typename?: 'UploadDetails';
  duration: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  transcodedLocation?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type UploadIdInput = {
  id: Scalars['String']['input'];
};

export type UploadPayload = CoreWebAppCommonError | UploadDetails;

/** The type of uploads we support. It will determine where we store the media in S3. */
export type UploadType =
  | 'accountAvatar'
  | 'channelAvatar'
  | 'postAsset';

/** Details to be used when allowing users to upvote service functionality */
export type UpvoteDetails = {
  __typename?: 'UpvoteDetails';
  /**
   * The (optional) message to be displayed when the feature upvote has been tracked. Clients should fallback to a default
   * message if this is not provided.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** The ID to be used when tracking the upvote for the feature */
  upvoteId: Scalars['Int']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  id?: Maybe<Scalars['String']['output']>;
  showMarkAsReadWarningModal?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * An enum representing the streak status used to map client content.
 * The underlying logic is opaque and simply indicates the user-facing streak status.
 */
export type UserStreakState =
  | 'ChannelConnectionStreakCelebration'
  | 'ExistingStreakAtRisk'
  | 'ExistingStreakHit'
  | 'ExistingStreakHitAndAhead'
  | 'ExistingStreakOnTrack'
  | 'ExistingStreakOnTrackAndAhead'
  | 'NewStreakHit'
  | 'NewStreakHitAndAhead'
  | 'NewStreakNoProgress'
  | 'NewStreakOnTrack'
  | 'NewStreakOnTrackAndAhead'
  | 'StreakLost';

/** User tag in the image */
export type UserTag = {
  __typename?: 'UserTag';
  /** The handle of the user */
  handle: Scalars['String']['output'];
  /** The x coordinate of the user tag */
  x: Scalars['Float']['output'];
  /** The y coordinate of the user tag */
  y: Scalars['Float']['output'];
};

/** User tag in the image */
export type UserTagInput = {
  /** The handle of the user */
  handle: Scalars['String']['input'];
  /** The x coordinate of the user tag */
  x: Scalars['Float']['input'];
  /** The y coordinate of the user tag */
  y: Scalars['Float']['input'];
};

/** Input for the verifyPassword mutation */
export type VerifyPasswordInput = {
  /** current password for the account to be verified */
  password: Scalars['String']['input'];
};

/** verifyPassword response payload */
export type VerifyPasswordPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | VerifyPasswordSuccess;

/** success response for verifypassword mutation */
export type VerifyPasswordSuccess = MutationSuccess & {
  __typename?: 'VerifyPasswordSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for verifyTfaCode mutation */
export type VerifyTfaCodeInput = {
  /** TFA code to verify. */
  tfaCode: Scalars['String']['input'];
};

/** verifyTfaCode response payload. */
export type VerifyTfaCodePayload = InvalidInputError | MutationBasicResponse | NotFoundError | UnexpectedError;

/** Video asset */
export type VideoAsset = Asset & {
  __typename?: 'VideoAsset';
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
  /** Video specific metadata */
  video: VideoMetadata;
};

/** Video asset */
export type VideoAssetInput = {
  /** Video specific metadata */
  metadata?: InputMaybe<VideoMetadataInput>;
  /** URL to the thumbnail of the video */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the file source */
  url: Scalars['String']['input'];
};

/** Video metadata */
export type VideoMetadata = {
  __typename?: 'VideoMetadata';
  /** Audio codec */
  audioCodec?: Maybe<Scalars['String']['output']>;
  /** Video container format */
  containerFormat?: Maybe<Scalars['String']['output']>;
  /** Video duration in seconds */
  durationMs: Scalars['Int']['output'];
  /** Video fileSize in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** Video framerate */
  frameRate?: Maybe<Scalars['Int']['output']>;
  /** Video height in pixels */
  height: Scalars['Int']['output'];
  /** Whether the video needs to be transcoded before it can be broadcasted */
  isTranscodingRequired: Scalars['Boolean']['output'];
  /** Rotation degree */
  rotationDegree?: Maybe<Scalars['Int']['output']>;
  /** Video bitrate in kbps */
  videoBitRate?: Maybe<Scalars['Int']['output']>;
  /** Video codec */
  videoCodec?: Maybe<Scalars['String']['output']>;
  /** Video width in pixels */
  width: Scalars['Int']['output'];
};

/** Video metadata */
export type VideoMetadataInput = {
  /** Offset of the thumbnail chosen for the video, in ms */
  thumbnailOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Video title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Error returned when video still processing error occurs */
export type VideoProcessingError = MutationError & {
  __typename?: 'VideoProcessingError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Error implementation that allows clients to resolve the MutationError on mutations that do not currently have typed errors.
 * This allows clients to automatically handle errors that may be added to a mutation in future.
 *
 * Do not directly throw this error, use a custom typed error instead
 */
export type VoidMutationError = MutationError & {
  __typename?: 'VoidMutationError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Weekly posting limit for a channel */
export type WeeklyPostingLimit = {
  __typename?: 'WeeklyPostingLimit';
  /** The weekly posting limit for the channel */
  limit: Scalars['Int']['output'];
  /** The number of posts the channel has scheduled for this week */
  scheduled: Scalars['Int']['output'];
  /** The number of posts the channel has sent this week */
  sent: Scalars['Int']['output'];
};

/** Input for the weekly posting streak query */
export type WeeklyPostingStreakInput = {
  /** The organization to get the weekly posting streak for */
  organizationId: Scalars['String']['input'];
};

export type YoutubeCategory = {
  __typename?: 'YoutubeCategory';
  categoryId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type YoutubeData = {
  __typename?: 'YoutubeData';
  title?: Maybe<Scalars['String']['output']>;
};

/** List of license types */
export type YoutubeLicense =
  | 'creativeCommon'
  | 'youtube';

/** Youtube post metadata */
export type YoutubePostMetadata = CommonPostMetadata & {
  __typename?: 'YoutubePostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Post category */
  category?: Maybe<YoutubeCategory>;
  /** Indicates whether the video allows embedding */
  embeddable: Scalars['Boolean']['output'];
  /** Video license */
  license?: Maybe<YoutubeLicense>;
  /** Indicates whether the video is suitable for kids */
  madeForKids: Scalars['Boolean']['output'];
  /** Indicates whether to notify subscribers on publish video */
  notifySubscribers: Scalars['Boolean']['output'];
  /** Privacy setting for post */
  privacy?: Maybe<YoutubePrivacy>;
  /** Title of the Youtube post */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Youtube */
  type: PostType;
};

/** Youtube post metadata */
export type YoutubePostMetadataInput = {
  /**
   * Youtube Category ID, one ID of this list:
   * ID: 1 -> Film & Animation
   * ID: 2 -> Autos & Vehicles
   * ID: 10 -> Music
   * ID: 15 -> Pets & Animals
   * ID: 17 -> Sports
   * ID: 19 -> Travel & Events
   * ID: 20 -> Gaming
   * ID: 22 -> People & Blogs
   * ID: 23 -> Comedy
   * ID: 24 -> Entertainment
   * ID: 25 -> News & Politics
   * ID: 26 -> Howto & Style
   * ID: 27 -> Education
   * ID: 28 -> Science & Technology
   * ID: 29 -> Nonprofits & Activism
   */
  categoryId: Scalars['String']['input'];
  /** Indicates whether the video allows embedding (default: true) */
  embeddable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Video license (default: youtube) */
  license?: InputMaybe<YoutubeLicense>;
  /** Indicates whether the video is suitable for kids (default: false) */
  madeForKids?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether to notify subscribers on publish video (default: true) */
  notifySubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Privacy setting for post (default: public) */
  privacy?: InputMaybe<YoutubePrivacy>;
  /** Title of the Youtube post */
  title: Scalars['String']['input'];
};

/** List of privacy types */
export type YoutubePrivacy =
  | 'private'
  | 'public'
  | 'unlisted';

export type AccountSetSettingsPayload = AccountSetSettingsError | AccountSetSettingsResponse;

export type CanConnectChannelsInput = {
  organizationId: Scalars['ID']['input'];
  service: Service;
  serviceId: Scalars['String']['input'];
};

export type TrackActionOnboardingSurveyPayload = InvalidInputError | TrackActionOnboardingSurveySuccess | UnauthorizedError | UnexpectedError;

export type VoteForFeatureMutationResponse = BasicError | MutationBasicResponse;

export type CommentsChannelNavChannelFragmentFragment = { __typename?: 'Channel', id: string, name: string, service: Service, avatar: string, serverUrl?: string | null, isLocked: boolean, isDisconnected: boolean, type: ChannelType, apiVersion?: string | null, scopes: Array<string | null>, locationData?: { __typename?: 'LocationData', location?: string | null } | null } & { ' $fragmentName'?: 'CommentsChannelNavChannelFragmentFragment' };

export type GetCommentsSidebarInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommentsSidebarInfoQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, currentOrganization?: { __typename?: 'AccountOrganization', id: string, channels: Array<(
        { __typename?: 'Channel', id: string, name: string, service: Service, avatar: string }
        & { ' $fragmentRefs'?: { 'CommentsChannelNavChannelFragmentFragment': CommentsChannelNavChannelFragmentFragment } }
      )> } | null } };

export type FilterByChannel_ChannelFragment = { __typename?: 'Channel', id: string, type: ChannelType, name: string, service: Service, avatar: string, serverUrl?: string | null, timezone: string, locationData?: { __typename?: 'LocationData', location?: string | null } | null } & { ' $fragmentName'?: 'FilterByChannel_ChannelFragment' };

export type FilterByTag_TagFragment = { __typename?: 'Tag', id: string, name: string, color: string } & { ' $fragmentName'?: 'FilterByTag_TagFragment' };

export type GetIdeaGroupsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetIdeaGroupsQuery = { __typename?: 'Query', ideaGroups: Array<{ __typename?: 'IdeaGroup', id: string, name: string, isLocked: boolean }> };

export type CreateIdeaMutationVariables = Exact<{
  input: CreateIdeaInput;
}>;


export type CreateIdeaMutation = { __typename?: 'Mutation', createIdea: { __typename: 'Idea', id: string, organizationId: string, groupId?: string | null, createdAt: number, content: { __typename?: 'IdeaContent', title?: string | null, text?: string | null, aiAssisted: boolean, media?: Array<{ __typename?: 'IdeaMedia', id: string, url: string, alt?: string | null, thumbnailUrl?: string | null, type: MediaType, size?: number | null, source?: { __typename?: 'IdeaMediaSource', name: string, id?: string | null } | null }> | null, tags: Array<{ __typename?: 'PublishingTag', id: string, name: string, color: string }> } } | { __typename: 'IdeaResponse' } | { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type UpdateIdeaMutationVariables = Exact<{
  input: UpdateIdeaInput;
}>;


export type UpdateIdeaMutation = { __typename?: 'Mutation', updateIdea: { __typename: 'IdeaResponse', idea?: { __typename?: 'Idea', id: string, organizationId: string, groupId?: string | null, position?: number | null, createdAt: number, content: { __typename?: 'IdeaContent', title?: string | null, text?: string | null, aiAssisted: boolean, date?: string | null, services: Array<Service>, media?: Array<{ __typename?: 'IdeaMedia', id: string, url: string, alt?: string | null, thumbnailUrl?: string | null, type: MediaType, size?: number | null, source?: { __typename?: 'IdeaMediaSource', name: string, id?: string | null } | null }> | null, tags: Array<{ __typename?: 'PublishingTag', id: string, name: string, color: string }> } } | null } | { __typename: 'InvalidInputError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type GetIdeaQueryVariables = Exact<{
  input: IdeaIdInput;
}>;


export type GetIdeaQuery = { __typename?: 'Query', idea?: { __typename?: 'CoreWebAppCommonError', message: string } | (
    { __typename?: 'Idea', id: string }
    & { ' $fragmentRefs'?: { 'IdeaCard_IdeaFragment': IdeaCard_IdeaFragment } }
  ) | null };

export type LegacyCreateIdeaMutationVariables = Exact<{
  input: CreateIdeaInput;
}>;


export type LegacyCreateIdeaMutation = { __typename?: 'Mutation', createIdea: { __typename: 'Idea', id: string, organizationId: string, groupId?: string | null, createdAt: number, content: { __typename?: 'IdeaContent', title?: string | null, text?: string | null, aiAssisted: boolean, media?: Array<{ __typename?: 'IdeaMedia', id: string, url: string, alt?: string | null, thumbnailUrl?: string | null, type: MediaType, size?: number | null, source?: { __typename?: 'IdeaMediaSource', name: string, id?: string | null } | null }> | null, tags: Array<{ __typename?: 'PublishingTag', id: string, name: string, color: string }> } } | { __typename: 'IdeaResponse' } | { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type LegacyUpdateIdeaMutationVariables = Exact<{
  input: UpdateIdeaInput;
}>;


export type LegacyUpdateIdeaMutation = { __typename?: 'Mutation', updateIdea: { __typename: 'IdeaResponse', idea?: { __typename?: 'Idea', id: string, organizationId: string, groupId?: string | null, position?: number | null, createdAt: number, content: { __typename?: 'IdeaContent', title?: string | null, text?: string | null, aiAssisted: boolean, media?: Array<{ __typename?: 'IdeaMedia', id: string, url: string, alt?: string | null, thumbnailUrl?: string | null, type: MediaType, size?: number | null, source?: { __typename?: 'IdeaMediaSource', name: string, id?: string | null } | null }> | null, tags: Array<{ __typename?: 'PublishingTag', id: string, name: string, color: string }> } } | null } | { __typename: 'InvalidInputError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type PostCard_PostFragment = { __typename?: 'Post', id: string, isProcessing: boolean, allowedActions: Array<PostAction>, ideaId?: string | null, status: PostStatus, notificationStatus?: NotificationStatus | null, sharedNow: boolean, via: PostVia, schedulingType?: SchedulingType | null, isCustomScheduled: boolean, isPinned: boolean, externalLink?: string | null, createdAt: string, updatedAt: string, dueAt?: string | null, sentAt?: string | null, metricsUpdatedAt?: string | null, text: string, author?: { __typename: 'Author', id: string, email: string, name?: string | null, avatar: string, isDeleted: boolean } | null, metadata?: { __typename: 'BlueskyPostMetadata', type: PostType, threadCount: number, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, thread: Array<{ __typename?: 'ThreadedPost', text: string, assets: Array<(
        { __typename: 'DocumentAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
      ) | (
        { __typename: 'ImageAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
      ) | (
        { __typename: 'VideoAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
      )> }>, linkAttachment?: { __typename: 'LinkAttachment', url: string, expandedUrl?: string | null, title: string, thumbnail?: string | null, text: string } | null } | { __typename: 'FacebookPostMetadata', type: PostType, firstComment?: string | null, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, linkAttachment?: { __typename: 'LinkAttachment', url: string, expandedUrl?: string | null, title: string, thumbnail?: string | null, text: string } | null } | { __typename: 'GoogleBusinessPostMetadata', type: PostType, title?: string | null, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )> } | { __typename: 'InstagramPostMetadata', type: PostType, firstComment?: string | null, link?: string | null, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, geolocation?: { __typename?: 'InstagramGeolocation', id?: string | null, text?: string | null } | null } | { __typename: 'LinkedInPostMetadata', type: PostType, firstComment?: string | null, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, linkAttachment?: { __typename: 'LinkAttachment', url: string, expandedUrl?: string | null, title: string, thumbnail?: string | null, text: string } | null } | { __typename: 'MastodonPostMetadata', type: PostType, threadCount: number, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, thread: Array<{ __typename?: 'ThreadedPost', text: string, assets: Array<(
        { __typename: 'DocumentAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
      ) | (
        { __typename: 'ImageAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
      ) | (
        { __typename: 'VideoAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
      )> }> } | { __typename: 'PinterestPostMetadata', type: PostType, title?: string | null, url?: string | null, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, board?: { __typename?: 'PinterestBoard', serviceId: string, name: string, url: string, description?: string | null, avatar?: string | null } | null } | { __typename: 'StartPagePostMetadata', type: PostType, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )> } | { __typename: 'ThreadsPostMetadata', type: PostType, threadCount: number, topic?: string | null, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, thread: Array<{ __typename?: 'ThreadedPost', text: string, assets: Array<(
        { __typename: 'DocumentAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
      ) | (
        { __typename: 'ImageAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
      ) | (
        { __typename: 'VideoAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
      )> }> } | { __typename: 'TiktokPostMetadata', type: PostType, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )> } | { __typename: 'TwitterPostMetadata', type: PostType, threadCount: number, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )>, thread: Array<{ __typename?: 'ThreadedPost', text: string, assets: Array<(
        { __typename: 'DocumentAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
      ) | (
        { __typename: 'ImageAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
      ) | (
        { __typename: 'VideoAsset' }
        & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
      )> }>, retweet?: { __typename?: 'RetweetMetadata', id: string, url: string, text: string, createdAt: string, user: { __typename?: 'RetweetUserMetadata', name: string, username: string, avatar: string } } | null } | { __typename: 'YoutubePostMetadata', type: PostType, annotations: Array<(
      { __typename: 'Annotation' }
      & { ' $fragmentRefs'?: { 'PostCardContent_AnnotationFragment': PostCardContent_AnnotationFragment } }
    )> } | null, channel: { __typename: 'Channel', id: string, type: ChannelType, name: string, avatar: string, service: Service, products?: Array<Product> | null, serviceId: string, serverUrl?: string | null, timezone: string, displayName?: string | null, isQueuePaused: boolean, isDisconnected: boolean, scopes: Array<string | null>, locationData?: { __typename?: 'LocationData', location?: string | null } | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string, color: string }>, notes: Array<(
    { __typename?: 'Note' }
    & { ' $fragmentRefs'?: { 'PostCardNotes_NoteFragment': PostCardNotes_NoteFragment } }
  )>, error?: { __typename?: 'PostPublishingError', message: string, supportUrl?: string | null } | null, assets: Array<(
    { __typename: 'DocumentAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
  ) | (
    { __typename: 'ImageAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
  ) | (
    { __typename: 'VideoAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
  )>, metrics?: Array<{ __typename?: 'PostMetric', type: PostMetricType, name: string, displayName: string, description: string, value: number, nullableValue?: number | null, unit: PostMetricUnit }> | null } & { ' $fragmentName'?: 'PostCard_PostFragment' };

export type PostCardNotes_NoteFragment = { __typename: 'Note', id: string, text: string, type: NoteType, createdAt: string, updatedAt?: string | null, allowedActions: Array<NoteAction>, author: { __typename: 'Author', id: string, email: string, avatar: string, isDeleted: boolean, name?: string | null } } & { ' $fragmentName'?: 'PostCardNotes_NoteFragment' };

type PostMediaAsset_Asset_DocumentAsset_Fragment = { __typename: 'DocumentAsset', mimeType: string, thumbnail: string, source: string, document: { __typename?: 'DocumentMetadata', filesize?: number | null, numPages: number } } & { ' $fragmentName'?: 'PostMediaAsset_Asset_DocumentAsset_Fragment' };

type PostMediaAsset_Asset_ImageAsset_Fragment = { __typename: 'ImageAsset', mimeType: string, thumbnail: string, source: string, image: { __typename?: 'ImageMetadata', altText: string, width: number, height: number, isAnimated: boolean } } & { ' $fragmentName'?: 'PostMediaAsset_Asset_ImageAsset_Fragment' };

type PostMediaAsset_Asset_VideoAsset_Fragment = { __typename: 'VideoAsset', mimeType: string, thumbnail: string, source: string, video: { __typename?: 'VideoMetadata', width: number, height: number } } & { ' $fragmentName'?: 'PostMediaAsset_Asset_VideoAsset_Fragment' };

export type PostMediaAsset_AssetFragment = PostMediaAsset_Asset_DocumentAsset_Fragment | PostMediaAsset_Asset_ImageAsset_Fragment | PostMediaAsset_Asset_VideoAsset_Fragment;

export type UpdatedNoteOnPostFragment = { __typename: 'Post', id: string, notes: Array<{ __typename: 'Note', id: string, text: string, type: NoteType, createdAt: string, updatedAt?: string | null, allowedActions: Array<NoteAction>, author: { __typename: 'Author', id: string, email: string, avatar: string, isDeleted: boolean } }> } & { ' $fragmentName'?: 'UpdatedNoteOnPostFragment' };

export type AddNoteToPostMutationVariables = Exact<{
  postId: Scalars['PostId']['input'];
  text: Scalars['String']['input'];
}>;


export type AddNoteToPostMutation = { __typename?: 'Mutation', addNoteToPost: { __typename: 'AddNoteToPostSuccess', post: (
      { __typename: 'Post', id: string }
      & { ' $fragmentRefs'?: { 'UpdatedNoteOnPostFragment': UpdatedNoteOnPostFragment } }
    ) } | { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type AddPostToQueueMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type AddPostToQueueMutation = { __typename?: 'Mutation', addPostToQueue: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type ApprovePostMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type ApprovePostMutation = { __typename?: 'Mutation', approvePost: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type DeleteNoteFromPostMutationVariables = Exact<{
  postId: Scalars['PostId']['input'];
  noteId: Scalars['NoteId']['input'];
}>;


export type DeleteNoteFromPostMutation = { __typename?: 'Mutation', deleteNoteFromPost: { __typename: 'DeleteNoteFromPostSuccess', post: { __typename: 'Post', id: string, notes: Array<(
        { __typename?: 'Note' }
        & { ' $fragmentRefs'?: { 'PostCardNotes_NoteFragment': PostCardNotes_NoteFragment } }
      )> } } | { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type DeletePostMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePostV2: { __typename: 'DeletePostSuccess', id: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type MovePostToDraftsMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type MovePostToDraftsMutation = { __typename?: 'Mutation', movePostToDraftsV2: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type PublishPostNowMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type PublishPostNowMutation = { __typename?: 'Mutation', publishPostNow: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null, externalLink?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'VideoProcessingError', message: string } };

export type RejectPostMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type RejectPostMutation = { __typename?: 'Mutation', rejectPost: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type RequestPostApprovalMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type RequestPostApprovalMutation = { __typename?: 'Mutation', requestPostApproval: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null, externalLink?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type RevertPostApprovalRequestMutationVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type RevertPostApprovalRequestMutation = { __typename?: 'Mutation', revertPostApprovalRequest: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type UpdateNoteOnPostMutationVariables = Exact<{
  postId: Scalars['PostId']['input'];
  noteId: Scalars['NoteId']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateNoteOnPostMutation = { __typename?: 'Mutation', updateNoteOnPost: { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateNoteOnPostSuccess', post: { __typename?: 'Post', id: string, notes: Array<(
        { __typename?: 'Note' }
        & { ' $fragmentRefs'?: { 'PostCardNotes_NoteFragment': PostCardNotes_NoteFragment } }
      )> } } };

export type PostCardContent_AnnotationFragment = { __typename?: 'Annotation', type: AnnotationType, indices: Array<number>, content: string, text: string, url: string } & { ' $fragmentName'?: 'PostCardContent_AnnotationFragment' };

export type UpdatePostTagsMutationVariables = Exact<{
  input: UpdatePostTagsInput;
}>;


export type UpdatePostTagsMutation = { __typename?: 'Mutation', updatePostTags: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string, color: string }> } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type TagFieldsFragment = { __typename?: 'Tag', id: string, name: string, color: string } & { ' $fragmentName'?: 'TagFieldsFragment' };

export type GetPostQueryVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type GetPostQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post', id: string }
    & { ' $fragmentRefs'?: { 'PostCard_PostFragment': PostCard_PostFragment } }
  ) };

export type ChannelNavChannelFragmentFragment = { __typename?: 'Channel', id: string, name: string, service: Service, type: ChannelType, avatar: string, timezone: string, serverUrl?: string | null, isLocked: boolean, isDisconnected: boolean, isQueuePaused: boolean, apiVersion?: string | null, locationData?: { __typename?: 'LocationData', location?: string | null } | null } & { ' $fragmentName'?: 'ChannelNavChannelFragmentFragment' };

export type GetSidebarInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSidebarInfoQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, currentOrganization?: { __typename?: 'AccountOrganization', id: string, channels: Array<(
        { __typename?: 'Channel', id: string, name: string, service: Service, avatar: string, type: ChannelType }
        & { ' $fragmentRefs'?: { 'ChannelNavChannelFragmentFragment': ChannelNavChannelFragmentFragment } }
      )> } | null } };

export type OrderChannelForAccountMutationVariables = Exact<{
  input: OrderChannelForAccountInput;
}>;


export type OrderChannelForAccountMutation = { __typename?: 'Mutation', orderChannelForAccount: { __typename: 'EmptySuccess' } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name?: string | null, email: string, backupEmail?: string | null, hasVerifiedEmail?: boolean | null, hasVerifiedBackupEmail?: boolean | null, avatar: string, featureFlips: Array<string>, createdAt?: string | null, dismissedBanners?: Array<string | null> | null, timezone?: string | null, tfa?: { __typename?: 'TFA', type: TwoFactorMethod } | null, preferences?: { __typename?: 'Preferences', timeFormat?: string | null, startOfWeek?: string | null, defaultScheduleOption: ScheduleOption } | null, settings?: { __typename?: 'Settings', aiSettings?: { __typename?: 'AISettings', onboarded?: boolean | null } | null } | null, currentOrganization?: { __typename?: 'AccountOrganization', id: string, isOneBufferOrganization: boolean, isBetaEnabled?: boolean | null, entitlements: Array<Entitlement | null>, createdAt?: string | null, ownerEmail: string, name: string, role: Role, members: { __typename?: 'MemberConnection', totalCount: number }, privileges: { __typename?: 'AccountPrivileges', canManageChannels: boolean, canManageBilling: boolean, canManageAllNotes: boolean, canEdit: boolean, canTransferOwnership: boolean }, channels: Array<{ __typename?: 'Channel', id: string, name: string, service: Service, organizationId: string, isLocked: boolean, accessLevel: ChannelAccessLevel, descriptor: string, avatar: string }>, commonTrackingProperties?: { __typename?: 'CommonTrackingProperties', atEventBillingState: BillingState, atEventBillingPlan: string, atEventBillingCycle: BillingInterval, atEventBillingGateway: BillingGateway, atEventIsNewBuffer: boolean, atEventChannelQty: number } | null, dismissedObjects?: Array<{ __typename?: 'DismissedObject', id: string } | null> | null, billing: { __typename: 'MPBilling', canAccessPublishing: boolean } | { __typename: 'OBBilling', id: string, canStartTrial: boolean, canAccessPublishing: boolean, subscription: { __typename?: 'OBSubscription', interval: BillingInterval, plan: { __typename?: 'OBPlan', id: ObPlanId }, trial?: { __typename?: 'Trial', isActive: boolean } | null }, changePlanOptions: Array<{ __typename?: 'OBPlanOption', planId: ObPlanId, planInterval: BillingInterval, isRecommended: boolean } | null>, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway }, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null }, pricingTiers: Array<{ __typename?: 'PricingTier', flatFee: number, unitPrice: number, upperBound: number }> }, limits: { __typename?: 'OrganizationLimits', ideas: number, channels: number, scheduledPosts: number, tags: number, savedReplies: number } } | null } };

export type GetDismissedBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDismissedBannersQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, dismissedBanners?: Array<string | null> | null } };

export type DismissBannerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DismissBannerMutation = { __typename?: 'Mutation', dismissBanner: { __typename: 'DismissBannerError', cause: string } | { __typename: 'DismissBannerResponse', success: boolean } };

export type StartTrialMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  interval?: InputMaybe<BillingInterval>;
  attribution?: InputMaybe<AttributionInput>;
}>;


export type StartTrialMutation = { __typename?: 'Mutation', billingStartTrial: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingResponse', success: boolean } };

export type GetTagsQueryVariables = Exact<{
  input: TagsInput;
}>;


export type GetTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', color: string, id: string, isLocked: boolean, name: string }> };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'DuplicateError', message: string } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'LimitReachedError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'RestProxyError', message: string } | { __typename?: 'TagActionSuccess', tag: { __typename?: 'Tag', id: string, name: string, color: string, isLocked: boolean } } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'DuplicateError', message: string } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'RestProxyError', message: string } | { __typename?: 'TagActionSuccess', tag: { __typename?: 'Tag', id: string, name: string, color: string, isLocked: boolean } } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type DeleteTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'DeleteTagActionSuccess', id: string } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'RestProxyError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type AccountSetSettingsMutationVariables = Exact<{
  settings: SettingsInput;
}>;


export type AccountSetSettingsMutation = { __typename?: 'Mutation', accountSetSettings: { __typename?: 'AccountSetSettingsError', userFriendlyMessage: string, cause: string } | { __typename?: 'AccountSetSettingsResponse', success: boolean, settings: { __typename?: 'Settings', aiSettings?: { __typename?: 'AISettings', onboarded?: boolean | null } | null } } };

export type IdeasCountByTagsQueryVariables = Exact<{
  input: OrganizationIdInput;
}>;


export type IdeasCountByTagsQuery = { __typename?: 'Query', ideasCountByTags: { __typename?: 'CoreWebAppCommonError', code: string, error: string } | { __typename?: 'IdeasCountByTags', counts: Array<{ __typename?: 'IdeasCountByTag', tagId: string, count: number }> } };

export type SearchThreadsLocationsQueryVariables = Exact<{
  input: SearchThreadsLocationsInput;
}>;


export type SearchThreadsLocationsQuery = { __typename?: 'Query', searchThreadsLocations: { __typename: 'ChannelRefreshRequired', message: string } | { __typename: 'SearchThreadsLocationsResponse', locations: Array<{ __typename?: 'ThreadsLocation', id: string, name: string, address?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null }> } | { __typename: 'TooShortQueryStringError', message: string } };

export type UpdateTimezoneForChannelMutationVariables = Exact<{
  input: UpdateTimezoneForChannelInput;
}>;


export type UpdateTimezoneForChannelMutation = { __typename?: 'Mutation', updateTimezoneForChannel: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateTimezoneForChannelResponse', channel: { __typename?: 'Channel', id: string, timezone: string } } };

export type OptimizePostingScheduleMutationVariables = Exact<{
  input: OptimizePostingScheduleInput;
}>;


export type OptimizePostingScheduleMutation = { __typename?: 'Mutation', optimizePostingSchedule: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'OptimizePostingScheduleResponse', postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, times: Array<string>, paused: boolean } | null> } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type SetPostingScheduleForChannelMutationVariables = Exact<{
  input: SetPostingScheduleForChannelInput;
}>;


export type SetPostingScheduleForChannelMutation = { __typename?: 'Mutation', setPostingScheduleForChannel: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'SetPostingScheduleForChannelResponse', postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, paused: boolean, times: Array<string> } | null> } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type GetPostingScheduleInfoQueryVariables = Exact<{
  channelId: Scalars['ChannelId']['input'];
}>;


export type GetPostingScheduleInfoQuery = { __typename?: 'Query', channel: { __typename?: 'Channel', id: string, service: Service, serviceId: string, displayName?: string | null, type: ChannelType, accessLevel: ChannelAccessLevel, postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, paused: boolean, times: Array<string> }> } };

export type UpdateChannelPostingGoalMutationVariables = Exact<{
  input: UpdateChannelPostingGoalInput;
}>;


export type UpdateChannelPostingGoalMutation = { __typename?: 'Mutation', updateChannelPostingGoal: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateChannelPostingGoalResponse', channel: { __typename?: 'Channel', id: string, postingGoal?: { __typename?: 'PostingGoal', goal: number, sentCount: number, scheduledCount: number, periodStart: string, periodEnd: string, status: PostingGoalStatus } | null } } };

export type ChecklistsQueryVariables = Exact<{
  input: OrganizationIdInput;
}>;


export type ChecklistsQuery = { __typename?: 'Query', checklists: { __typename?: 'ChecklistsResponse', checklists?: Array<{ __typename?: 'Checklist', id: number, title: string, items?: Array<{ __typename?: 'ChecklistItem', id: number, description: string, isCompleted: boolean } | null> | null } | null> | null } | { __typename?: 'CoreWebAppCommonError', code: string, error: string } };

export type GetAllChannelsInfoQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type GetAllChannelsInfoQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, currentOrganization?: { __typename?: 'AccountOrganization', id: string, channels: Array<(
        { __typename?: 'Channel', id: string, isQueuePaused: boolean }
        & { ' $fragmentRefs'?: { 'FilterByChannel_ChannelFragment': FilterByChannel_ChannelFragment } }
      )> } | null }, tags: Array<(
    { __typename?: 'Tag', id: string }
    & { ' $fragmentRefs'?: { 'FilterByTag_TagFragment': FilterByTag_TagFragment } }
  )> };

export type GetPostListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']> | Scalars['ChannelId']['input']>;
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']> | Scalars['TagId']['input']>;
  status?: InputMaybe<Array<PostStatus> | PostStatus>;
  sort?: InputMaybe<Array<PostSortInput> | PostSortInput>;
}>;


export type GetPostListQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResults', edges?: Array<{ __typename?: 'PostsEdge', node: (
        { __typename?: 'Post', id: string, dueAt?: string | null, sentAt?: string | null }
        & { ' $fragmentRefs'?: { 'PostCard_PostFragment': PostCard_PostFragment } }
      ) }> | null, pageInfo: { __typename?: 'PaginationPageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type GetPostCountsByChannelQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']> | Scalars['ChannelId']['input']>;
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']> | Scalars['TagId']['input']>;
}>;


export type GetPostCountsByChannelQuery = { __typename?: 'Query', drafts: { __typename?: 'PostCountsResponse', counts: Array<{ __typename?: 'PostsCount', channelId: string, count: number, limit?: number | null }> }, queue: { __typename?: 'PostCountsResponse', counts: Array<{ __typename?: 'PostsCount', channelId: string, count: number, limit?: number | null }> }, approvals: { __typename?: 'PostCountsResponse', counts: Array<{ __typename?: 'PostsCount', channelId: string, count: number, limit?: number | null }> }, sent: { __typename?: 'PostCountsResponse', counts: Array<{ __typename?: 'PostsCount', channelId: string, count: number, limit?: number | null }> } };

export type RealTimeUpdates_PostFragment = { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null, tags: Array<{ __typename?: 'Tag', id: string }>, channel: { __typename?: 'Channel', id: string } } & { ' $fragmentName'?: 'RealTimeUpdates_PostFragment' };

export type GetPostForRealTimeUpdateQueryVariables = Exact<{
  postId: Scalars['PostId']['input'];
}>;


export type GetPostForRealTimeUpdateQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post', id: string, dueAt?: string | null }
    & { ' $fragmentRefs'?: { 'PostCard_PostFragment': PostCard_PostFragment;'RealTimeUpdates_PostFragment': RealTimeUpdates_PostFragment } }
  ) };

export type GetPostListForRealTimeUpdateQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']> | Scalars['ChannelId']['input']>;
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']> | Scalars['TagId']['input']>;
  status?: InputMaybe<Array<PostStatus> | PostStatus>;
  sort?: InputMaybe<Array<PostSortInput> | PostSortInput>;
}>;


export type GetPostListForRealTimeUpdateQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResults', edges?: Array<{ __typename?: 'PostsEdge', node: { __typename?: 'Post', id: string, dueAt?: string | null } }> | null } };

export type Post_EvictingFragment = { __typename?: 'Post', id: string } & { ' $fragmentName'?: 'Post_EvictingFragment' };

export type Post_IsProcessingFragment = { __typename?: 'Post', isProcessing: boolean } & { ' $fragmentName'?: 'Post_IsProcessingFragment' };

export type CalendarPostCard_PostFragment = { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null, schedulingType?: SchedulingType | null, isCustomScheduled: boolean, isPinned: boolean, notificationStatus?: NotificationStatus | null, text: string, channelId: string, channelService: Service, tags: Array<{ __typename?: 'Tag', id: string, color: string, name: string }>, metadata?: { __typename?: 'BlueskyPostMetadata', type: PostType } | { __typename?: 'FacebookPostMetadata', type: PostType } | { __typename?: 'GoogleBusinessPostMetadata', type: PostType, title?: string | null } | { __typename?: 'InstagramPostMetadata', type: PostType } | { __typename?: 'LinkedInPostMetadata', type: PostType } | { __typename?: 'MastodonPostMetadata', type: PostType } | { __typename?: 'PinterestPostMetadata', type: PostType } | { __typename?: 'StartPagePostMetadata', type: PostType } | { __typename?: 'ThreadsPostMetadata', type: PostType, topic?: string | null } | { __typename?: 'TiktokPostMetadata', type: PostType } | { __typename?: 'TwitterPostMetadata', type: PostType } | { __typename?: 'YoutubePostMetadata', type: PostType } | null, assets: Array<(
    { __typename: 'DocumentAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
  ) | (
    { __typename: 'ImageAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
  ) | (
    { __typename: 'VideoAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
  )>, channel: { __typename?: 'Channel', id: string, serviceId: string, type: ChannelType, name: string } } & { ' $fragmentName'?: 'CalendarPostCard_PostFragment' };

export type GetCalendarAndPostListQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']> | Scalars['ChannelId']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  postsLimit: Scalars['Int']['input'];
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']> | Scalars['TagId']['input']>;
  status?: InputMaybe<Array<PostStatus> | PostStatus>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCalendarAndPostListQuery = { __typename?: 'Query', posts: { __typename?: 'PostsResults', edges?: Array<{ __typename?: 'PostsEdge', node: (
        { __typename?: 'Post', id: string, dueAt?: string | null }
        & { ' $fragmentRefs'?: { 'CalendarPostCard_PostFragment': CalendarPostCard_PostFragment } }
      ) }> | null, pageInfo: { __typename?: 'PaginationPageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetAllChannelsInfoForCalendarQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type GetAllChannelsInfoForCalendarQuery = { __typename?: 'Query', account: { __typename?: 'Account', currentOrganization?: { __typename?: 'AccountOrganization', channels: Array<(
        { __typename?: 'Channel', id: string, accessLevel: ChannelAccessLevel, isQueuePaused: boolean }
        & { ' $fragmentRefs'?: { 'FilterByChannel_ChannelFragment': FilterByChannel_ChannelFragment } }
      )> } | null }, tags: Array<(
    { __typename?: 'Tag' }
    & { ' $fragmentRefs'?: { 'FilterByTag_TagFragment': FilterByTag_TagFragment } }
  )> };

export type GetCalendarPostForRealTimeUpdateQueryVariables = Exact<{
  postId: Scalars['PostId']['input'];
}>;


export type GetCalendarPostForRealTimeUpdateQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post', id: string, dueAt?: string | null }
    & { ' $fragmentRefs'?: { 'CalendarPostCard_PostFragment': CalendarPostCard_PostFragment;'RealTimeUpdates_PostFragment': RealTimeUpdates_PostFragment } }
  ) };

export type GetPostForCalendarPostCardQueryVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type GetPostForCalendarPostCardQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post' }
    & { ' $fragmentRefs'?: { 'PostCard_PostFragment': PostCard_PostFragment } }
  ) };

export type CalendarView_PostFragment = { __typename?: 'PublishingPost', id: string, type: PublishingPostType, text?: string | null, status: PublishingPostStatus, serviceLink?: string | null, via?: string | null, isReminder: boolean, isCustomScheduled: boolean, isPinned: boolean, formattedTime?: string | null, isRetweet: boolean, dueAt?: number | null, title?: string | null, createdBy: string, needsApproval?: boolean | null, sourceUrl?: string | null, isBlueprint?: boolean | null, updateType?: string | null, threadCount?: number | null, error?: { __typename?: 'PublishingPostError', message: string, link?: string | null, actionType?: PublishingPostErrorAction | null } | null, channelData?: { __typename?: 'ChannelData', googlebusiness?: { __typename?: 'GoogleBusinessData', start_date?: number | null, end_date?: number | null, start_time?: string | null, end_time?: string | null, title?: string | null, code?: string | null, link?: string | null, terms?: string | null } | null, startPage?: { __typename?: 'StartPageData', link?: string | null } | null, youtube?: { __typename?: 'YoutubeData', title?: string | null } | null, instagram?: { __typename?: 'InstagramData', link?: string | null, service_geolocation_name?: string | null } | null, pinterest?: { __typename?: 'PinterestData', is_repin?: boolean | null } | null } | null, statistics?: { __typename?: 'PostStatistics', retweets?: number | null, comments?: number | null, likes?: number | null, favorites?: number | null, mentions?: number | null, clicks?: number | null, reach_twitter?: number | null, reach?: number | null, shares?: number | null, reshares?: number | null, repins?: number | null, linkClicks?: number | null, views?: number | null, reactions?: number | null, impressions?: number | null, saves?: number | null, quotes?: number | null, replies?: number | null, reposts?: number | null } | null, geoLocation?: { __typename?: 'GeoLocation', id?: string | null, text?: string | null } | null, channel: { __typename?: 'PublishingChannel', id: string, service: Service, avatar?: string | null, username: string, serverUrl?: string | null, locationData?: { __typename?: 'ChannelLocationData', location?: string | null } | null }, subprofile?: { __typename?: 'PublishingSubprofile', id: string, name: string } | null, attachments?: Array<{ __typename?: 'PublishingPostDestinationUrl', url: string } | { __typename?: 'PublishingPostFirstComment', text: string } | { __typename?: 'PublishingPostLink', url: string, title?: string | null, description?: string | null, thumbnail?: string | null } | { __typename?: 'PublishingPostRetweet', avatar?: string | null, accountName: string, username: string, text: string, url: string, sentAt: number } | null> | null, media?: Array<{ __typename?: 'PublishingPostMedia', thumbnail?: string | null, type: MediaType }> | null, campaign?: { __typename?: 'PublishingCampaign', name: string, color: { __typename?: 'HexColor', value?: string | null } } | null, tags: Array<{ __typename?: 'PublishingTag', id: string, name: string, color: string }> } & { ' $fragmentName'?: 'CalendarView_PostFragment' };

export type UpdateCalendarPostDueAtMutationVariables = Exact<{
  input: DropPostInput;
}>;


export type UpdateCalendarPostDueAtMutation = { __typename?: 'Mutation', dropPost: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, dueAt?: string | null } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type ChannelPage_ChannelFragment = (
  { __typename?: 'Channel', accessLevel: ChannelAccessLevel, id: string, createdAt: string, avatar: string, isQueuePaused: boolean, isDisconnected: boolean, isLocked: boolean, name: string, organizationId: string, hasActiveMemberDevice: boolean, serverUrl?: string | null, service: Service, timezone: string, type: ChannelType, apiVersion?: string | null, metadata?: { __typename?: 'BlueskyMetadata' } | { __typename?: 'FacebookMetadata' } | { __typename?: 'GoogleBusinessMetadata' } | { __typename?: 'InstagramMetadata' } | { __typename: 'LinkedInMetadata', shouldShowLinkedinAnalyticsRefreshBanner: boolean } | { __typename?: 'MastodonMetadata' } | { __typename?: 'PinterestMetadata' } | { __typename?: 'TwitterMetadata' } | null, locationData?: { __typename?: 'LocationData', location?: string | null } | null, postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, times: Array<string>, paused: boolean }>, postingGoal?: { __typename?: 'PostingGoal', goal: number, sentCount: number, scheduledCount: number, periodStart: string, periodEnd: string, status: PostingGoalStatus } | null, weeklyPostingLimit?: { __typename?: 'WeeklyPostingLimit', limit: number, sent: number, scheduled: number } | null }
  & { ' $fragmentRefs'?: { 'QueueList_ChannelFragment': QueueList_ChannelFragment } }
) & { ' $fragmentName'?: 'ChannelPage_ChannelFragment' };

export type GetChannelInfoQueryVariables = Exact<{
  channelId: Scalars['ChannelId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type GetChannelInfoQuery = { __typename?: 'Query', channel: (
    { __typename?: 'Channel', id: string, avatar: string, isQueuePaused: boolean, isLocked: boolean, name: string, serverUrl?: string | null, service: Service, timezone: string, type: ChannelType, apiVersion?: string | null, locationData?: { __typename?: 'LocationData', location?: string | null } | null }
    & { ' $fragmentRefs'?: { 'QueueList_ChannelFragment': QueueList_ChannelFragment;'ChannelPage_ChannelFragment': ChannelPage_ChannelFragment } }
  ), tags: Array<(
    { __typename?: 'Tag', id: string }
    & { ' $fragmentRefs'?: { 'FilterByTag_TagFragment': FilterByTag_TagFragment } }
  )> };

export type BackfillUpdatesForGridMutationVariables = Exact<{
  input: BackfillUpdatesForGridInput;
}>;


export type BackfillUpdatesForGridMutation = { __typename?: 'Mutation', backfillUpdatesForGrid: { __typename?: 'BackfillUpdatesForGridResponse', _empty: string } | { __typename?: 'InvalidInputError' } | { __typename?: 'NotFoundError' } | { __typename?: 'UnauthorizedError' } | { __typename?: 'UnexpectedError' } };

export type ShopGridCustomLinksQueryVariables = Exact<{
  input: ShopGridCustomLinksInput;
}>;


export type ShopGridCustomLinksQuery = { __typename?: 'Query', shopGridCustomLinks: { __typename?: 'ShopGridCustomLinksPayload', color?: any | null, contrastColor?: any | null, links?: Array<{ __typename?: 'CustomLink', id: any, text: string, url: any }> | null } };

export type QueueList_ChannelFragment = { __typename?: 'Channel', id: string, name: string, service: Service, accessLevel: ChannelAccessLevel, isQueuePaused: boolean, timezone: string, postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, times: Array<string>, paused: boolean }>, postingGoal?: { __typename?: 'PostingGoal', goal: number } | null } & { ' $fragmentName'?: 'QueueList_ChannelFragment' };

export type DropPostMutationVariables = Exact<{
  input: DropPostInput;
}>;


export type DropPostMutation = { __typename?: 'Mutation', dropPost: { __typename: 'NotFoundError', message: string } | { __typename: 'PostActionSuccess', post: { __typename?: 'Post', id: string, dueAt?: string | null, isCustomScheduled: boolean, isPinned: boolean } } | { __typename: 'RestProxyError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type SwapPostsInQueueMutationVariables = Exact<{
  input: SwapPostsInQueueInput;
}>;


export type SwapPostsInQueueMutation = { __typename?: 'Mutation', swapPostsInQueue: { __typename: 'NotFoundError', message: string } | { __typename: 'RestProxyError', message: string } | { __typename: 'SwapPostsInQueueSuccess', posts: Array<{ __typename?: 'Post', id: string, dueAt?: string | null, status: PostStatus, isCustomScheduled: boolean, isPinned: boolean }> } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type SourcePostFragment = { __typename?: 'Post', id: string, dueAt?: string | null, status: PostStatus, isCustomScheduled: boolean, isPinned: boolean } & { ' $fragmentName'?: 'SourcePostFragment' };

export type TargetPostFragment = { __typename?: 'Post', id: string, dueAt?: string | null, status: PostStatus, isCustomScheduled: boolean, isPinned: boolean } & { ' $fragmentName'?: 'TargetPostFragment' };

export type ChannelPageCommentsFragmentFragment = { __typename?: 'Channel', accessLevel: ChannelAccessLevel, id: string, avatar: string, isDisconnected: boolean, isLocked: boolean, name: string, serverUrl?: string | null, service: Service, timezone: string, type: ChannelType, scopes: Array<string | null>, metadata?: { __typename?: 'BlueskyMetadata' } | { __typename?: 'FacebookMetadata' } | { __typename?: 'GoogleBusinessMetadata' } | { __typename?: 'InstagramMetadata' } | { __typename: 'LinkedInMetadata', shouldShowLinkedinAnalyticsRefreshBanner: boolean } | { __typename?: 'MastodonMetadata' } | { __typename?: 'PinterestMetadata' } | { __typename?: 'TwitterMetadata' } | null, locationData?: { __typename?: 'LocationData', location?: string | null } | null } & { ' $fragmentName'?: 'ChannelPageCommentsFragmentFragment' };

export type GetChannelInfoForCommentsQueryVariables = Exact<{
  channelId: Scalars['ChannelId']['input'];
}>;


export type GetChannelInfoForCommentsQuery = { __typename?: 'Query', channel: (
    { __typename?: 'Channel', accessLevel: ChannelAccessLevel, id: string, avatar: string, isLocked: boolean, name: string, serverUrl?: string | null, service: Service, timezone: string, type: ChannelType, scopes: Array<string | null>, locationData?: { __typename?: 'LocationData', location?: string | null } | null }
    & { ' $fragmentRefs'?: { 'ChannelPageCommentsFragmentFragment': ChannelPageCommentsFragmentFragment } }
  ) };

export type CommentsPostCard_PostFragment = { __typename?: 'Post', id: string, status: PostStatus, dueAt?: string | null, schedulingType?: SchedulingType | null, isCustomScheduled: boolean, isPinned: boolean, notificationStatus?: NotificationStatus | null, text: string, channelId: string, channelService: Service, tags: Array<{ __typename?: 'Tag', id: string, color: string, name: string }>, metadata?: { __typename?: 'BlueskyPostMetadata', type: PostType } | { __typename?: 'FacebookPostMetadata', type: PostType } | { __typename?: 'GoogleBusinessPostMetadata', type: PostType, title?: string | null } | { __typename?: 'InstagramPostMetadata', type: PostType } | { __typename?: 'LinkedInPostMetadata', type: PostType } | { __typename?: 'MastodonPostMetadata', type: PostType } | { __typename?: 'PinterestPostMetadata', type: PostType } | { __typename?: 'StartPagePostMetadata', type: PostType } | { __typename?: 'ThreadsPostMetadata', type: PostType } | { __typename?: 'TiktokPostMetadata', type: PostType } | { __typename?: 'TwitterPostMetadata', type: PostType } | { __typename?: 'YoutubePostMetadata', type: PostType } | null, assets: Array<(
    { __typename: 'DocumentAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
  ) | (
    { __typename: 'ImageAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
  ) | (
    { __typename: 'VideoAsset' }
    & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
  )>, channel: { __typename?: 'Channel', id: string, serviceId: string, type: ChannelType, name: string } } & { ' $fragmentName'?: 'CommentsPostCard_PostFragment' };

export type CreateSavedReplyMutationVariables = Exact<{
  input: CreateSavedReplyInput;
}>;


export type CreateSavedReplyMutation = { __typename?: 'Mutation', createSavedReply: { __typename: 'DuplicateError', message: string } | { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename?: 'SavedReplyActionSuccess', savedReply: { __typename?: 'SavedReply', id: string, organizationId: string, title?: string | null, hotkeys?: Array<string> | null, createdAt: string, updatedAt: string, content: { __typename?: 'SavedReplyContent', text: string } } } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type DeleteSavedReplyMutationVariables = Exact<{
  input: DeleteSavedReplyInput;
}>;


export type DeleteSavedReplyMutation = { __typename?: 'Mutation', deleteSavedReply: { __typename?: 'DeleteSavedReplySuccess', id: string } | { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type SavedRepliesQueryQueryVariables = Exact<{
  input: SavedRepliesInput;
}>;


export type SavedRepliesQueryQuery = { __typename?: 'Query', savedReplies: { __typename?: 'SavedRepliesResponse', savedReplies: Array<{ __typename?: 'SavedReply', id: string, organizationId: string, title?: string | null, createdAt: string, updatedAt: string, content: { __typename?: 'SavedReplyContent', text: string } }> } };

export type UpdateSavedReplyMutationVariables = Exact<{
  input: UpdateSavedReplyInput;
}>;


export type UpdateSavedReplyMutation = { __typename?: 'Mutation', updateSavedReply: { __typename?: 'DuplicateError', message: string } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'SavedReplyActionSuccess', savedReply: { __typename?: 'SavedReply', id: string, organizationId: string, title?: string | null, hotkeys?: Array<string> | null, createdAt: string, updatedAt: string, content: { __typename?: 'SavedReplyContent', text: string } } } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type CommentSuggestionsQueryVariables = Exact<{
  input: CommentSuggestionsInput;
}>;


export type CommentSuggestionsQuery = { __typename?: 'Query', commentSuggestions: { __typename?: 'CommentSuggestionsResponse', suggestions: Array<{ __typename?: 'Suggestion', text: string, source: CommentSuggestionSource }> } };

export type CommentThreadQueryVariables = Exact<{
  input: CommentThreadInput;
}>;


export type CommentThreadQuery = { __typename?: 'Query', commentThread: { __typename?: 'CommentThreadResponse', thread: Array<{ __typename: 'CommentFromBuffer', id: string, text: string, publishedAt?: string | null, status: CommentStatus, parentId?: string | null, serviceType: Service, isOwnReply: boolean, assets: Array<{ __typename?: 'DocumentAsset', id?: string | null, mimeType: string, source: string, thumbnail: string, type: AssetType } | { __typename?: 'ImageAsset', id?: string | null, mimeType: string, source: string, thumbnail: string, type: AssetType } | { __typename?: 'VideoAsset', id?: string | null, mimeType: string, source: string, thumbnail: string, type: AssetType }>, author: { __typename?: 'CommentAuthor', username: string, name?: string | null, avatar: string }, post: { __typename?: 'Post', id: string, text: string, dueAt?: string | null, channelService: Service, assets: Array<(
          { __typename?: 'DocumentAsset' }
          & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
        ) | (
          { __typename?: 'ImageAsset' }
          & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
        ) | (
          { __typename?: 'VideoAsset' }
          & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
        )>, tags: Array<{ __typename?: 'Tag', name: string, color: string }>, metadata?: { __typename?: 'BlueskyPostMetadata', type: PostType } | { __typename?: 'FacebookPostMetadata', type: PostType } | { __typename?: 'GoogleBusinessPostMetadata', type: PostType } | { __typename?: 'InstagramPostMetadata', type: PostType } | { __typename?: 'LinkedInPostMetadata', type: PostType } | { __typename?: 'MastodonPostMetadata', type: PostType } | { __typename?: 'PinterestPostMetadata', type: PostType } | { __typename?: 'StartPagePostMetadata', type: PostType } | { __typename?: 'ThreadsPostMetadata', type: PostType } | { __typename?: 'TiktokPostMetadata', type: PostType } | { __typename?: 'TwitterPostMetadata', type: PostType } | { __typename?: 'YoutubePostMetadata', type: PostType } | null }, publishingStatus: { __typename?: 'PublishingStatus', status: CommentEngagementStatusTypes } } | { __typename: 'CommentFromThirdParty', id: string, text: string, publishedAt?: string | null, status: CommentStatus, parentId?: string | null, serviceType: Service, isOwnReply: boolean, labels: Array<CommentLabel>, assets: Array<{ __typename?: 'DocumentAsset', id?: string | null, mimeType: string, source: string, thumbnail: string, type: AssetType } | { __typename?: 'ImageAsset', id?: string | null, mimeType: string, source: string, thumbnail: string, type: AssetType } | { __typename?: 'VideoAsset', id?: string | null, mimeType: string, source: string, thumbnail: string, type: AssetType }>, author: { __typename?: 'CommentAuthor', username: string, name?: string | null, avatar: string }, post: { __typename?: 'Post', id: string, text: string, dueAt?: string | null, channelService: Service, assets: Array<(
          { __typename?: 'DocumentAsset' }
          & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
        ) | (
          { __typename?: 'ImageAsset' }
          & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
        ) | (
          { __typename?: 'VideoAsset' }
          & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
        )>, tags: Array<{ __typename?: 'Tag', name: string, color: string }>, metadata?: { __typename?: 'BlueskyPostMetadata', type: PostType } | { __typename?: 'FacebookPostMetadata', type: PostType } | { __typename?: 'GoogleBusinessPostMetadata', type: PostType } | { __typename?: 'InstagramPostMetadata', type: PostType } | { __typename?: 'LinkedInPostMetadata', type: PostType } | { __typename?: 'MastodonPostMetadata', type: PostType } | { __typename?: 'PinterestPostMetadata', type: PostType } | { __typename?: 'StartPagePostMetadata', type: PostType } | { __typename?: 'ThreadsPostMetadata', type: PostType } | { __typename?: 'TiktokPostMetadata', type: PostType } | { __typename?: 'TwitterPostMetadata', type: PostType } | { __typename?: 'YoutubePostMetadata', type: PostType } | null }, suggestions: Array<{ __typename?: 'Suggestion', text: string, source: CommentSuggestionSource }>, sentimentAnalysis?: Array<{ __typename?: 'SentimentAnalysis', type: CommentLabel }> | null }> } };

export type CommentsCountsQueryQueryVariables = Exact<{
  input: CommentsCountsInput;
}>;


export type CommentsCountsQueryQuery = { __typename?: 'Query', commentsCounts: { __typename?: 'CommentsCountsResponse', counts: Array<{ __typename?: 'CommentsCount', channelId: string, count: number, limit: number }> } };

export type CommentsInsightsQueryVariables = Exact<{
  input: CommentsInsightsInput;
}>;


export type CommentsInsightsQuery = { __typename?: 'Query', commentsInsights: { __typename?: 'CommentsInsightsResponse', insights: string } };

type CommentMediaAsset_Asset_DocumentAsset_Fragment = { __typename: 'DocumentAsset', id?: string | null, mimeType: string, thumbnail: string, source: string, type: AssetType } & { ' $fragmentName'?: 'CommentMediaAsset_Asset_DocumentAsset_Fragment' };

type CommentMediaAsset_Asset_ImageAsset_Fragment = { __typename: 'ImageAsset', id?: string | null, mimeType: string, thumbnail: string, source: string, type: AssetType, image: { __typename?: 'ImageMetadata', altText: string, width: number, height: number, isAnimated: boolean } } & { ' $fragmentName'?: 'CommentMediaAsset_Asset_ImageAsset_Fragment' };

type CommentMediaAsset_Asset_VideoAsset_Fragment = { __typename: 'VideoAsset', id?: string | null, mimeType: string, thumbnail: string, source: string, type: AssetType, video: { __typename?: 'VideoMetadata', width: number, height: number } } & { ' $fragmentName'?: 'CommentMediaAsset_Asset_VideoAsset_Fragment' };

export type CommentMediaAsset_AssetFragment = CommentMediaAsset_Asset_DocumentAsset_Fragment | CommentMediaAsset_Asset_ImageAsset_Fragment | CommentMediaAsset_Asset_VideoAsset_Fragment;

export type CommentsQueryVariables = Exact<{
  input: CommentsInput;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: { __typename?: 'CommentsResults', edges: Array<{ __typename?: 'CommentsEdge', node: { __typename: 'CommentFromBuffer', id: string, text: string, publishedAt?: string | null, status: CommentStatus, parentId?: string | null, channelId: string, serviceType: Service, isOwnReply: boolean, organizationId: string, isDeleted: boolean, lastReply?: { __typename?: 'LastReply', id: string, text: string, organizationId: string, serviceType: Service, publishedAt?: string | null, parentId?: string | null, status: CommentStatus, isOwnReply: boolean, author: { __typename?: 'CommentAuthor', username: string, name?: string | null, avatar: string }, assets: Array<(
            { __typename?: 'DocumentAsset' }
            & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_DocumentAsset_Fragment': CommentMediaAsset_Asset_DocumentAsset_Fragment } }
          ) | (
            { __typename?: 'ImageAsset' }
            & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_ImageAsset_Fragment': CommentMediaAsset_Asset_ImageAsset_Fragment } }
          ) | (
            { __typename?: 'VideoAsset' }
            & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_VideoAsset_Fragment': CommentMediaAsset_Asset_VideoAsset_Fragment } }
          )> } | null, assets: Array<(
          { __typename?: 'DocumentAsset' }
          & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_DocumentAsset_Fragment': CommentMediaAsset_Asset_DocumentAsset_Fragment } }
        ) | (
          { __typename?: 'ImageAsset' }
          & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_ImageAsset_Fragment': CommentMediaAsset_Asset_ImageAsset_Fragment } }
        ) | (
          { __typename?: 'VideoAsset' }
          & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_VideoAsset_Fragment': CommentMediaAsset_Asset_VideoAsset_Fragment } }
        )>, author: { __typename?: 'CommentAuthor', username: string, name?: string | null, avatar: string }, post: { __typename?: 'Post', id: string, text: string, dueAt?: string | null, channelService: Service, assets: Array<(
            { __typename?: 'DocumentAsset' }
            & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
          ) | (
            { __typename?: 'ImageAsset' }
            & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
          ) | (
            { __typename?: 'VideoAsset' }
            & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
          )>, tags: Array<{ __typename?: 'Tag', name: string, color: string }>, metadata?: { __typename?: 'BlueskyPostMetadata', type: PostType } | { __typename?: 'FacebookPostMetadata', type: PostType } | { __typename?: 'GoogleBusinessPostMetadata', type: PostType } | { __typename?: 'InstagramPostMetadata', type: PostType } | { __typename?: 'LinkedInPostMetadata', type: PostType } | { __typename?: 'MastodonPostMetadata', type: PostType } | { __typename?: 'PinterestPostMetadata', type: PostType } | { __typename?: 'StartPagePostMetadata', type: PostType } | { __typename?: 'ThreadsPostMetadata', type: PostType } | { __typename?: 'TiktokPostMetadata', type: PostType } | { __typename?: 'TwitterPostMetadata', type: PostType } | { __typename?: 'YoutubePostMetadata', type: PostType } | null, channel: { __typename?: 'Channel', id: string, service: Service } }, publishingStatus: { __typename?: 'PublishingStatus', status: CommentEngagementStatusTypes } } | { __typename: 'CommentFromThirdParty', id: string, text: string, publishedAt?: string | null, status: CommentStatus, parentId?: string | null, channelId: string, serviceType: Service, isOwnReply: boolean, organizationId: string, isDeleted: boolean, labels: Array<CommentLabel>, lastReply?: { __typename?: 'LastReply', id: string, text: string, organizationId: string, serviceType: Service, publishedAt?: string | null, parentId?: string | null, status: CommentStatus, isOwnReply: boolean, author: { __typename?: 'CommentAuthor', username: string, name?: string | null, avatar: string }, assets: Array<(
            { __typename?: 'DocumentAsset' }
            & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_DocumentAsset_Fragment': CommentMediaAsset_Asset_DocumentAsset_Fragment } }
          ) | (
            { __typename?: 'ImageAsset' }
            & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_ImageAsset_Fragment': CommentMediaAsset_Asset_ImageAsset_Fragment } }
          ) | (
            { __typename?: 'VideoAsset' }
            & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_VideoAsset_Fragment': CommentMediaAsset_Asset_VideoAsset_Fragment } }
          )> } | null, assets: Array<(
          { __typename?: 'DocumentAsset' }
          & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_DocumentAsset_Fragment': CommentMediaAsset_Asset_DocumentAsset_Fragment } }
        ) | (
          { __typename?: 'ImageAsset' }
          & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_ImageAsset_Fragment': CommentMediaAsset_Asset_ImageAsset_Fragment } }
        ) | (
          { __typename?: 'VideoAsset' }
          & { ' $fragmentRefs'?: { 'CommentMediaAsset_Asset_VideoAsset_Fragment': CommentMediaAsset_Asset_VideoAsset_Fragment } }
        )>, author: { __typename?: 'CommentAuthor', username: string, name?: string | null, avatar: string }, post: { __typename?: 'Post', id: string, text: string, dueAt?: string | null, channelService: Service, assets: Array<(
            { __typename?: 'DocumentAsset' }
            & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_DocumentAsset_Fragment': PostMediaAsset_Asset_DocumentAsset_Fragment } }
          ) | (
            { __typename?: 'ImageAsset' }
            & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_ImageAsset_Fragment': PostMediaAsset_Asset_ImageAsset_Fragment } }
          ) | (
            { __typename?: 'VideoAsset' }
            & { ' $fragmentRefs'?: { 'PostMediaAsset_Asset_VideoAsset_Fragment': PostMediaAsset_Asset_VideoAsset_Fragment } }
          )>, tags: Array<{ __typename?: 'Tag', name: string, color: string }>, metadata?: { __typename?: 'BlueskyPostMetadata', type: PostType } | { __typename?: 'FacebookPostMetadata', type: PostType } | { __typename?: 'GoogleBusinessPostMetadata', type: PostType } | { __typename?: 'InstagramPostMetadata', type: PostType } | { __typename?: 'LinkedInPostMetadata', type: PostType } | { __typename?: 'MastodonPostMetadata', type: PostType } | { __typename?: 'PinterestPostMetadata', type: PostType } | { __typename?: 'StartPagePostMetadata', type: PostType } | { __typename?: 'ThreadsPostMetadata', type: PostType } | { __typename?: 'TiktokPostMetadata', type: PostType } | { __typename?: 'TwitterPostMetadata', type: PostType } | { __typename?: 'YoutubePostMetadata', type: PostType } | null, channel: { __typename?: 'Channel', id: string, service: Service } }, suggestions: Array<{ __typename?: 'Suggestion', text: string, source: CommentSuggestionSource }>, sentimentAnalysis?: Array<{ __typename?: 'SentimentAnalysis', type: CommentLabel }> | null } }>, pageInfo: { __typename?: 'PaginationPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type CommentsScoreQueryQueryVariables = Exact<{
  input: CommentsScoreInput;
}>;


export type CommentsScoreQueryQuery = { __typename?: 'Query', commentsScore: { __typename?: 'CommentsScoreResponse', currentAchievementLevel: string, currentWeekScore: { __typename?: 'CommentScoreDetailed', totalValue: number, responseRate: { __typename?: 'CommentsScoreMetric', value: number, percentage: number }, responseSpeed: { __typename?: 'CommentsScoreMetric', value: number, percentage: number }, consistency: { __typename?: 'CommentsScoreMetric', value: number, percentage: number } }, previousWeekScore: { __typename?: 'CommentScoreDetailed', totalValue: number, responseRate: { __typename?: 'CommentsScoreMetric', value: number, percentage: number }, responseSpeed: { __typename?: 'CommentsScoreMetric', value: number, percentage: number }, consistency: { __typename?: 'CommentsScoreMetric', value: number, percentage: number } } } };

export type DismissAllCommentsByChannelIdMutationVariables = Exact<{
  input: DismissAllCommentsByChannelIdInput;
}>;


export type DismissAllCommentsByChannelIdMutation = { __typename?: 'Mutation', dismissAllCommentsByChannelId: { __typename: 'DismissAllCommentsSuccess', status: DismissAllStatus, affectedCommentCount: number } | { __typename: 'InvalidInputError' } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type DismissCommentMutationVariables = Exact<{
  input: DismissCommentInput;
}>;


export type DismissCommentMutation = { __typename?: 'Mutation', dismissComment: { __typename: 'DismissCommentSuccess', comment: { __typename: 'CommentFromBuffer', id: string, status: CommentStatus, text: string, updatedAt: string, parentId?: string | null, publishingStatus: { __typename?: 'PublishingStatus', status: CommentEngagementStatusTypes, errorMessage?: string | null } } | { __typename: 'CommentFromThirdParty', id: string, status: CommentStatus, text: string, updatedAt: string, parentId?: string | null, labels: Array<CommentLabel> } } | { __typename: 'InvalidInputError' } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type GetPostForCommentsPostCardQueryVariables = Exact<{
  id: Scalars['PostId']['input'];
}>;


export type GetPostForCommentsPostCardQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post' }
    & { ' $fragmentRefs'?: { 'PostCard_PostFragment': PostCard_PostFragment } }
  ) };

export type ReplyToCommentMutationVariables = Exact<{
  input: ReplyToCommentInput;
}>;


export type ReplyToCommentMutation = { __typename?: 'Mutation', replyToComment: { __typename: 'InvalidInputError' } | { __typename: 'NotFoundError', message: string } | { __typename: 'ReplyToCommentSuccess', comment: { __typename?: 'CommentFromBuffer', id: string, text: string, publishedAt?: string | null, status: CommentStatus, parentId?: string | null, author: { __typename: 'CommentAuthor', username: string, avatar: string }, assets: Array<{ __typename?: 'DocumentAsset', id?: string | null, source: string, thumbnail: string, type: AssetType, mimeType: string } | { __typename?: 'ImageAsset', id?: string | null, source: string, thumbnail: string, type: AssetType, mimeType: string } | { __typename?: 'VideoAsset', id?: string | null, source: string, thumbnail: string, type: AssetType, mimeType: string }> } | { __typename?: 'CommentFromThirdParty', id: string, text: string, publishedAt?: string | null, status: CommentStatus, parentId?: string | null, author: { __typename: 'CommentAuthor', username: string, avatar: string }, assets: Array<{ __typename?: 'DocumentAsset', id?: string | null, source: string, thumbnail: string, type: AssetType, mimeType: string } | { __typename?: 'ImageAsset', id?: string | null, source: string, thumbnail: string, type: AssetType, mimeType: string } | { __typename?: 'VideoAsset', id?: string | null, source: string, thumbnail: string, type: AssetType, mimeType: string }> } } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type UndismissCommentMutationVariables = Exact<{
  input: UndismissCommentInput;
}>;


export type UndismissCommentMutation = { __typename?: 'Mutation', undismissComment: { __typename: 'InvalidInputError' } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UndismissCommentSuccess', comment: { __typename: 'CommentFromBuffer', id: string, status: CommentStatus, text: string, updatedAt: string, parentId?: string | null, publishingStatus: { __typename?: 'PublishingStatus', status: CommentEngagementStatusTypes, errorMessage?: string | null } } | { __typename: 'CommentFromThirdParty', id: string, status: CommentStatus, text: string, updatedAt: string, parentId?: string | null, labels: Array<CommentLabel> } } | { __typename: 'UnexpectedError', message: string } };

export type CollectionListCollectionFragment = { __typename?: 'FeedCollection', id: string, name: string, feeds: Array<{ __typename?: 'Feed', id: string, name: string, lastRefreshed: string, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata', query?: string | null } | { __typename: 'RSSFeedConnectionMetadata', url: string } }> } & { ' $fragmentName'?: 'CollectionListCollectionFragment' };

export type GetCollectionListDetailsQueryVariables = Exact<{
  feedCollectionId: Scalars['FeedCollectionId']['input'];
}>;


export type GetCollectionListDetailsQuery = { __typename?: 'Query', feedCollection: (
    { __typename?: 'FeedCollection' }
    & { ' $fragmentRefs'?: { 'CollectionListCollectionFragment': CollectionListCollectionFragment } }
  ) };

export type FeedArticleCard_FeedItemFragment = { __typename?: 'FeedItem', id: string, title: string, articleUrl: string, contentTextPreview: string, createdAt: string, feed: { __typename?: 'Feed', id: string, type: ContentFeedType, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata' } | { __typename: 'RSSFeedConnectionMetadata', url: string } } } & { ' $fragmentName'?: 'FeedArticleCard_FeedItemFragment' };

export type FeedList_FeedFragment = { __typename?: 'Feed', id: string, name: string, lastRefreshed: string, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata', query?: string | null } | { __typename: 'RSSFeedConnectionMetadata', url: string } } & { ' $fragmentName'?: 'FeedList_FeedFragment' };

export type GetFeedListDetailsQueryVariables = Exact<{
  input: FeedInput;
}>;


export type GetFeedListDetailsQuery = { __typename?: 'Query', feed?: (
    { __typename?: 'Feed' }
    & { ' $fragmentRefs'?: { 'FeedList_FeedFragment': FeedList_FeedFragment } }
  ) | null };

export type SidebarCollectionItem_CollectionFragment = { __typename?: 'FeedCollection', id: string, name: string, feeds: Array<(
    { __typename?: 'Feed', id: string }
    & { ' $fragmentRefs'?: { 'SidebarFeedItem_FeedFragment': SidebarFeedItem_FeedFragment } }
  )> } & { ' $fragmentName'?: 'SidebarCollectionItem_CollectionFragment' };

export type SidebarFeedItem_FeedFragment = { __typename?: 'Feed', id: string, name: string, collection?: { __typename?: 'FeedCollection', id: string } | null, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata', query?: string | null } | { __typename: 'RSSFeedConnectionMetadata', url: string } } & { ' $fragmentName'?: 'SidebarFeedItem_FeedFragment' };

export type MoveFeedMutationVariables = Exact<{
  input: MoveFeedInput;
}>;


export type MoveFeedMutation = { __typename?: 'Mutation', moveFeed: { __typename: 'FeedMoveUpdatesResponse', updatedFeeds: Array<{ __typename?: 'Feed', id: string, name: string, collection?: { __typename?: 'FeedCollection', id: string, name: string } | null }>, updatedFeedCollections: Array<{ __typename?: 'FeedCollection', id: string, name: string, feeds: Array<{ __typename?: 'Feed', id: string, name: string }> }> } | { __typename: 'UnexpectedError' } };

export type CreateFeedMutationVariables = Exact<{
  input: CreateFeedInput;
}>;


export type CreateFeedMutation = { __typename?: 'Mutation', createFeed: { __typename: 'FeedActionSuccess', feed: { __typename: 'Feed', id: string, name: string, type: ContentFeedType, collection?: { __typename?: 'FeedCollection', id: string } | null, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata', query?: string | null } | { __typename: 'RSSFeedConnectionMetadata', url: string } } } | { __typename: 'FeedConnectionError', error: FeedConnectionErrorType, message: string, suggestions: Array<{ __typename?: 'FeedConnectionSuggestion', name: string, homepage?: string | null, type: ContentFeedType, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata', query?: string | null } | { __typename: 'RSSFeedConnectionMetadata', url: string } }> } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type CreateNewFeedCollectionMutationVariables = Exact<{
  input: CreateFeedCollectionInput;
}>;


export type CreateNewFeedCollectionMutation = { __typename?: 'Mutation', createFeedCollection: { __typename: 'FeedCollectionActionSuccess', feedCollection: { __typename?: 'FeedCollection', id: string, name: string, organizationId: string } } | { __typename: 'NotFoundError' } | { __typename: 'UnauthorizedError' } | { __typename: 'UnexpectedError' } };

export type DeleteFeedMutationVariables = Exact<{
  input: DeleteFeedInput;
}>;


export type DeleteFeedMutation = { __typename?: 'Mutation', deleteFeed: { __typename: 'DeleteFeedResponse', id: string } | { __typename: 'UnexpectedError', message: string } };

export type DeleteFeedCollectionMutationVariables = Exact<{
  input: DeleteFeedCollectionInput;
}>;


export type DeleteFeedCollectionMutation = { __typename?: 'Mutation', deleteFeedCollection: { __typename: 'FeedCollectionDeleteSuccess', feedCollectionId: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type GetFeedItemsQueryVariables = Exact<{
  feedCollectionIds?: InputMaybe<Array<Scalars['FeedCollectionId']['input']> | Scalars['FeedCollectionId']['input']>;
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']> | Scalars['FeedId']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFeedItemsQuery = { __typename?: 'Query', feedItems: { __typename?: 'FeedItemConnection', pageInfo: { __typename?: 'PaginationPageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean }, edges: Array<{ __typename?: 'FeedItemEdge', node: { __typename?: 'FeedItem', id: string, createdAt: string, title: string, contentTextPreview: string, articleUrl: string, feed: { __typename?: 'Feed', id: string, type: ContentFeedType, name: string, connectionMetadata: { __typename?: 'NewsSearchConnectionMetadata' } | { __typename: 'RSSFeedConnectionMetadata', url: string } } } }> } };

export type GetFeedsForSidebarQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type GetFeedsForSidebarQuery = { __typename?: 'Query', feeds: Array<(
    { __typename?: 'Feed', collection?: { __typename?: 'FeedCollection', id: string } | null }
    & { ' $fragmentRefs'?: { 'SidebarFeedItem_FeedFragment': SidebarFeedItem_FeedFragment } }
  )>, feedCollections: { __typename?: 'FeedCollectionConnection', edges: Array<{ __typename?: 'FeedCollectionEdge', node: (
        { __typename?: 'FeedCollection', id: string }
        & { ' $fragmentRefs'?: { 'SidebarCollectionItem_CollectionFragment': SidebarCollectionItem_CollectionFragment } }
      ) }> } };

export type RefreshFeedMutationVariables = Exact<{
  input: RefreshFeedInput;
}>;


export type RefreshFeedMutation = { __typename?: 'Mutation', refreshFeed: { __typename: 'FeedActionSuccess', feed: { __typename: 'Feed', id: string, lastRefreshed: string } } | { __typename: 'FeedConnectionError' } | { __typename: 'NotFoundError' } | { __typename: 'UnauthorizedError' } | { __typename: 'UnexpectedError' } };

export type RefreshFeedCollectionMutationVariables = Exact<{
  input: RefreshFeedCollectionInput;
}>;


export type RefreshFeedCollectionMutation = { __typename?: 'Mutation', refreshFeedCollection: { __typename: 'FeedCollectionActionSuccess' } | { __typename: 'NotFoundError' } | { __typename: 'UnauthorizedError' } | { __typename: 'UnexpectedError' } };

export type UpdateFeedCollectionMutationVariables = Exact<{
  input: UpdateFeedCollectionInput;
}>;


export type UpdateFeedCollectionMutation = { __typename?: 'Mutation', updateFeedCollection: { __typename: 'FeedCollectionActionSuccess', feedCollection: { __typename: 'FeedCollection', id: string, name: string, feeds: Array<{ __typename?: 'Feed', id: string, name: string, homepage?: string | null, connectionMetadata: { __typename: 'NewsSearchConnectionMetadata', query?: string | null } | { __typename: 'RSSFeedConnectionMetadata', url: string, lastConnected: string } }> } } | { __typename: 'NotFoundError' } | { __typename: 'UnauthorizedError' } | { __typename: 'UnexpectedError' } };

export type GetCreateInfoQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  organizationId_ID: Scalars['ID']['input'];
}>;


export type GetCreateInfoQuery = { __typename?: 'Query', tags: Array<(
    { __typename?: 'Tag', id: string }
    & { ' $fragmentRefs'?: { 'FilterByTag_TagFragment': FilterByTag_TagFragment } }
  )>, ideaGroups: Array<(
    { __typename?: 'IdeaGroup', id: string }
    & { ' $fragmentRefs'?: { 'FilterByIdeaGroup_IdeaGroupFragment': FilterByIdeaGroup_IdeaGroupFragment } }
  )> };

export type GetIdeasBoardQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetIdeasBoardQuery = { __typename?: 'Query', ideaGroups: Array<{ __typename?: 'IdeaGroup', id: string, name: string, isLocked: boolean }>, ideasV2: { __typename?: 'PaginatedIdeasV2', edges: Array<{ __typename?: 'IdeaEdge', node: (
        { __typename?: 'Idea', id: string }
        & { ' $fragmentRefs'?: { 'IdeaCard_IdeaFragment': IdeaCard_IdeaFragment } }
      ) }>, pageInfo: { __typename?: 'PaginationPageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type CreateIdeaGroupMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateIdeaGroupMutation = { __typename?: 'Mutation', createIdeaGroup: { __typename: 'IdeaGroup', id: string, name: string, isLocked: boolean } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type NewIdeaGroupFragment = { __typename: 'IdeaGroup', id: string, name: string, isLocked: boolean } & { ' $fragmentName'?: 'NewIdeaGroupFragment' };

export type DeleteIdeaGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIdeaGroupMutation = { __typename?: 'Mutation', deleteIdeaGroup: { __typename?: 'DeleteIdeaGroupResponse', updatedIdeas: Array<{ __typename?: 'Idea', id: string, groupId?: string | null, position?: number | null }> } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type PreviousIdeaFragment = { __typename?: 'Idea', id: string, groupId?: string | null, position?: number | null } & { ' $fragmentName'?: 'PreviousIdeaFragment' };

export type MoveIdeaMutationVariables = Exact<{
  input: MoveIdeaInput;
}>;


export type MoveIdeaMutation = { __typename?: 'Mutation', moveIdea: { __typename?: 'MoveIdeaResponse', updatedIdeas: Array<{ __typename?: 'Idea', id: string, groupId?: string | null, position?: number | null }> } | { __typename?: 'UnexpectedError', message: string } };

export type MoveIdeaGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveIdeaGroupMutation = { __typename?: 'Mutation', moveIdeaGroup: { __typename?: 'InvalidInputError' } | { __typename?: 'MoveIdeaGroupResponse', ideaGroups: Array<{ __typename?: 'IdeaGroup', id: string, name: string }> } | { __typename?: 'NotFoundError' } | { __typename?: 'UnauthorizedError' } | { __typename?: 'UnexpectedError', message: string } };

export type UpdateIdeaGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateIdeaGroupMutation = { __typename?: 'Mutation', updateIdeaGroup: { __typename?: 'IdeaGroup', id: string, name: string } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type FilterByIdeaGroup_IdeaGroupFragment = { __typename?: 'IdeaGroup', id: string, name: string } & { ' $fragmentName'?: 'FilterByIdeaGroup_IdeaGroupFragment' };

export type IdeaCard_IdeaFragment = { __typename?: 'Idea', id: string, organizationId: string, groupId?: string | null, position?: number | null, createdAt: number, updatedAt: number, content: { __typename?: 'IdeaContent', title?: string | null, text?: string | null, aiAssisted: boolean, date?: string | null, services: Array<Service>, media?: Array<{ __typename?: 'IdeaMedia', id: string, url: string, alt?: string | null, thumbnailUrl?: string | null, type: MediaType, size?: number | null, source?: { __typename?: 'IdeaMediaSource', name: string, id?: string | null } | null }> | null, tags: Array<{ __typename?: 'PublishingTag', id: string, name: string, color: string }> } } & { ' $fragmentName'?: 'IdeaCard_IdeaFragment' };

export type GetIdeasGalleryQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groups?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
}>;


export type GetIdeasGalleryQuery = { __typename?: 'Query', ideasV2: { __typename?: 'PaginatedIdeasV2', edges: Array<{ __typename?: 'IdeaEdge', cursor: string, node: (
        { __typename?: 'Idea', id: string }
        & { ' $fragmentRefs'?: { 'IdeaCard_IdeaFragment': IdeaCard_IdeaFragment } }
      ) }>, pageInfo: { __typename?: 'PaginationPageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type DeleteIdeaMutationMutationVariables = Exact<{
  input: IdeasDeletionInput;
}>;


export type DeleteIdeaMutationMutation = { __typename?: 'Mutation', ideasRemove: { __typename?: 'CoreWebAppCommonError', message: string } | { __typename?: 'IdeasDeletionSuccess', success: boolean, message: string, ideas: Array<{ __typename?: 'Idea', id: string }> } };

export type IdeasCountQueryVariables = Exact<{
  input: OrganizationIdInput;
}>;


export type IdeasCountQuery = { __typename?: 'Query', ideasCount: { __typename?: 'CoreWebAppCommonError', code: string, error: string } | { __typename?: 'IdeasCount', count: number } };

export type OrganizationPrivileges_AccountOrganizationFragment = { __typename?: 'AccountOrganization', canAddPaymentDetails: boolean, privileges: { __typename?: 'AccountPrivileges', canEdit: boolean, canManageBilling: boolean } } & { ' $fragmentName'?: 'OrganizationPrivileges_AccountOrganizationFragment' };

export type BillingFragment_AccountOrganizationFragment = { __typename?: 'AccountOrganization', billing: (
    { __typename?: 'MPBilling' }
    & { ' $fragmentRefs'?: { 'PaymentDetails_Billing_MpBilling_Fragment': PaymentDetails_Billing_MpBilling_Fragment;'AddressAndTax_Billing_MpBilling_Fragment': AddressAndTax_Billing_MpBilling_Fragment;'LegacyPlanContent_BillingFragment': LegacyPlanContent_BillingFragment } }
  ) | (
    { __typename?: 'OBBilling' }
    & { ' $fragmentRefs'?: { 'PaymentDetails_Billing_ObBilling_Fragment': PaymentDetails_Billing_ObBilling_Fragment;'AddressAndTax_Billing_ObBilling_Fragment': AddressAndTax_Billing_ObBilling_Fragment;'PlanContent_BillingFragment': PlanContent_BillingFragment } }
  ) } & { ' $fragmentName'?: 'BillingFragment_AccountOrganizationFragment' };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, currentOrganization?: (
      { __typename?: 'AccountOrganization', billing: { __typename: 'MPBilling' } | { __typename: 'OBBilling', paymentDetails: { __typename?: 'PaymentDetails', paymentMethod?: string | null }, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayPlatform?: BillingGatewayPlatform | null }, previousGateway?: { __typename?: 'GatewayDetails', gatewayType: BillingGateway } | null, subscription: { __typename?: 'OBSubscription', periodEnd?: string | null, isCanceledAtPeriodEnd: boolean, canceledAt?: string | null, trial?: { __typename?: 'Trial', isActive: boolean } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string, interval: BillingInterval, limits: { __typename?: 'PlanLimits', members: number }, prices: { __typename?: 'PlanPrices', basePlanPrice?: number | null, baseMonthlyPrice?: number | null } } } }, members: { __typename?: 'MemberConnection', totalCount: number }, channels: Array<{ __typename?: 'Channel', isLocked: boolean }>, limits: { __typename?: 'OrganizationLimits', channels: number }, dismissedObjects?: Array<{ __typename?: 'DismissedObject', id: string } | null> | null }
      & { ' $fragmentRefs'?: { 'BillingFragment_AccountOrganizationFragment': BillingFragment_AccountOrganizationFragment;'OrganizationDataForBilling_AccountOrganizationFragment': OrganizationDataForBilling_AccountOrganizationFragment;'OrganizationPrivileges_AccountOrganizationFragment': OrganizationPrivileges_AccountOrganizationFragment;'PaymentDetails_OrganizationFragment': PaymentDetails_OrganizationFragment } }
    ) | null } };

type AddressAndTax_Billing_MpBilling_Fragment = { __typename?: 'MPBilling', taxExempt?: string | null, gateway: { __typename?: 'GatewayDetails', gatewayId?: string | null, gatewayType: BillingGateway }, previousGateway?: { __typename?: 'GatewayDetails', gatewayType: BillingGateway } | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, state?: string | null, postalCode?: string | null } | null, taxIds?: Array<{ __typename?: 'TaxId', country?: string | null, created?: number | null, type?: string | null, value?: string | null, verification?: { __typename?: 'TaxIdVerification', status?: string | null, verifiedAddress?: string | null, verifiedName?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'AddressAndTax_Billing_MpBilling_Fragment' };

type AddressAndTax_Billing_ObBilling_Fragment = { __typename?: 'OBBilling', taxExempt?: string | null, gateway: { __typename?: 'GatewayDetails', gatewayId?: string | null, gatewayType: BillingGateway }, previousGateway?: { __typename?: 'GatewayDetails', gatewayType: BillingGateway } | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, state?: string | null, postalCode?: string | null } | null, taxIds?: Array<{ __typename?: 'TaxId', country?: string | null, created?: number | null, type?: string | null, value?: string | null, verification?: { __typename?: 'TaxIdVerification', status?: string | null, verifiedAddress?: string | null, verifiedName?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'AddressAndTax_Billing_ObBilling_Fragment' };

export type AddressAndTax_BillingFragment = AddressAndTax_Billing_MpBilling_Fragment | AddressAndTax_Billing_ObBilling_Fragment;

export type InvoicesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoicesByOrganization: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceNode', node: { __typename?: 'Invoice', id: string, amount: number, status: InvoiceStatus, downloadUrl: string, date: string, currency: string } } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor: string, endCursor: string } } };

type PaymentDetails_Billing_MpBilling_Fragment = { __typename?: 'MPBilling', gateway: { __typename?: 'GatewayDetails', gatewayId?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null } } & { ' $fragmentName'?: 'PaymentDetails_Billing_MpBilling_Fragment' };

type PaymentDetails_Billing_ObBilling_Fragment = { __typename?: 'OBBilling', subscription: { __typename?: 'OBSubscription', isPaymentPastDue?: boolean | null, plan: { __typename?: 'OBPlan', id: ObPlanId }, trial?: { __typename?: 'Trial', isActive: boolean } | null }, gateway: { __typename?: 'GatewayDetails', gatewayId?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null } } & { ' $fragmentName'?: 'PaymentDetails_Billing_ObBilling_Fragment' };

export type PaymentDetails_BillingFragment = PaymentDetails_Billing_MpBilling_Fragment | PaymentDetails_Billing_ObBilling_Fragment;

export type PaymentDetails_OrganizationFragment = { __typename?: 'AccountOrganization', dismissedObjects?: Array<{ __typename?: 'DismissedObject', id: string } | null> | null } & { ' $fragmentName'?: 'PaymentDetails_OrganizationFragment' };

export type RemoveSubscriptionScheduleMutationVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type RemoveSubscriptionScheduleMutation = { __typename?: 'Mutation', removeSubscriptionSchedule: { __typename?: 'RemoveSubscriptionScheduleError', message: string } | { __typename?: 'RemoveSubscriptionScheduleResponse', success: boolean } };

type Discount_Billing_MpBilling_Fragment = { __typename?: 'MPBilling', discount?: { __typename?: 'Discount', gatewayId?: string | null, name?: string | null, type: DiscountType, duration: DiscountDuration, value: number, durationInMonths?: number | null } | null } & { ' $fragmentName'?: 'Discount_Billing_MpBilling_Fragment' };

type Discount_Billing_ObBilling_Fragment = { __typename?: 'OBBilling', discount?: { __typename?: 'Discount', gatewayId?: string | null, name?: string | null, type: DiscountType, duration: DiscountDuration, value: number, durationInMonths?: number | null } | null } & { ' $fragmentName'?: 'Discount_Billing_ObBilling_Fragment' };

export type Discount_BillingFragment = Discount_Billing_MpBilling_Fragment | Discount_Billing_ObBilling_Fragment;

type UpcomingInvoice_Billing_MpBilling_Fragment = { __typename?: 'MPBilling', upcomingInvoiceAmount?: number | null, upcomingInvoice?: { __typename?: 'InvoiceDetails', amountWithoutTax?: number | null, amountTax?: number | null, currency?: string | null } | null } & { ' $fragmentName'?: 'UpcomingInvoice_Billing_MpBilling_Fragment' };

type UpcomingInvoice_Billing_ObBilling_Fragment = { __typename?: 'OBBilling', upcomingInvoiceAmount?: number | null, upcomingInvoice?: { __typename?: 'InvoiceDetails', amountWithoutTax?: number | null, amountTax?: number | null, currency?: string | null } | null } & { ' $fragmentName'?: 'UpcomingInvoice_Billing_ObBilling_Fragment' };

export type UpcomingInvoice_BillingFragment = UpcomingInvoice_Billing_MpBilling_Fragment | UpcomingInvoice_Billing_ObBilling_Fragment;

export type PlanContent_BillingFragment = (
  { __typename?: 'OBBilling', canStartTrial: boolean, balance: number, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null, gatewayPlatform?: BillingGatewayPlatform | null }, paymentDetails: { __typename?: 'PaymentDetails', paymentMethod?: string | null }, pricingTiers: Array<{ __typename?: 'PricingTier', flatFee: number, unitPrice: number, upperBound: number }>, subscription: { __typename?: 'OBSubscription', periodEnd?: string | null, isCanceledAtPeriodEnd: boolean, isPaymentPastDue?: boolean | null, canceledAt?: string | null, trial?: { __typename?: 'Trial', isActive: boolean, remainingDays: number, startDate: string, endDate: string } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string, interval: BillingInterval, limits: { __typename?: 'PlanLimits', channels: number, members: number }, prices: { __typename?: 'PlanPrices', baseMonthlyPrice?: number | null, basePlanPrice?: number | null, monthlyFlatFee?: number | null, monthlyChannelPrice?: number | null, channelTierUnit?: number | null } }, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdate', newPlan: string, newInterval: BillingInterval, newQuantity: number, effectiveDate: string } | null } }
  & { ' $fragmentRefs'?: { 'Discount_Billing_ObBilling_Fragment': Discount_Billing_ObBilling_Fragment;'UpcomingInvoice_Billing_ObBilling_Fragment': UpcomingInvoice_Billing_ObBilling_Fragment } }
) & { ' $fragmentName'?: 'PlanContent_BillingFragment' };

export type LegacyPlanContent_BillingFragment = (
  { __typename?: 'MPBilling', canAccessPublishing: boolean, canAccessAnalytics: boolean, billingRedirectUrl: string, balance: number, paymentDetails: { __typename?: 'PaymentDetails', paymentMethod?: string | null }, subscriptions: Array<{ __typename?: 'MPSubscription', plan: string, product: Product, interval: BillingInterval, periodEnd?: string | null, isCanceledAtPeriodEnd: boolean }> }
  & { ' $fragmentRefs'?: { 'Discount_Billing_MpBilling_Fragment': Discount_Billing_MpBilling_Fragment;'UpcomingInvoice_Billing_MpBilling_Fragment': UpcomingInvoice_Billing_MpBilling_Fragment } }
) & { ' $fragmentName'?: 'LegacyPlanContent_BillingFragment' };

export type OrganizationDataForBilling_AccountOrganizationFragment = { __typename?: 'AccountOrganization', id: string, members: { __typename?: 'MemberConnection', totalCount: number }, channels: Array<{ __typename?: 'Channel', id: string, isLocked: boolean }>, limits: { __typename?: 'OrganizationLimits', channels: number }, commonTrackingProperties?: { __typename?: 'CommonTrackingProperties', atEventBillingState: BillingState, atEventBillingPlan: string, atEventBillingCycle: BillingInterval, atEventBillingGateway: BillingGateway, atEventIsNewBuffer: boolean, atEventChannelQty: number } | null, billing: { __typename?: 'MPBilling', paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null } } | { __typename?: 'OBBilling', paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null } } } & { ' $fragmentName'?: 'OrganizationDataForBilling_AccountOrganizationFragment' };

export type GetChannelGroupsQueryVariables = Exact<{
  input: ChannelGroupsInput;
}>;


export type GetChannelGroupsQuery = { __typename?: 'Query', channelGroups: { __typename?: 'ChannelGroupsResponse', channelGroups: Array<{ __typename?: 'ChannelGroup', id: any, name: string, accountId: string, createdAt: string, organizationId: string, updatedAt: string, channelCount: number, channels?: Array<{ __typename?: 'Channel', id: string, name: string, avatar: string, type: ChannelType, service: Service }> | null }> } | { __typename?: 'UnauthorizedError' } | { __typename?: 'UnexpectedError' } };

export type CreateChannelGroupMutationVariables = Exact<{
  input: CreateChannelGroupInput;
}>;


export type CreateChannelGroupMutation = { __typename?: 'Mutation', createChannelGroup: { __typename: 'ChannelGroup', id: any, name: string, channels?: Array<{ __typename?: 'Channel', id: string, name: string }> | null } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type DeleteChannelGroupMutationVariables = Exact<{
  input: DeleteChannelGroupInput;
}>;


export type DeleteChannelGroupMutation = { __typename?: 'Mutation', deleteChannelGroup: { __typename: 'DeleteChannelGroupSuccess', id: any } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type UpdateChannelGroupMutationVariables = Exact<{
  input: UpdateChannelGroupInput;
}>;


export type UpdateChannelGroupMutation = { __typename?: 'Mutation', updateChannelGroup: { __typename: 'ChannelGroup', id: any, name: string, channels?: Array<{ __typename?: 'Channel', id: string, name: string }> | null } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type GetEmailNotificationPreferencesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailNotificationPreferencesQueryQuery = { __typename?: 'Query', emailNotificationPreferences: { __typename: 'EmailNotificationPreferenceError', message: string } | { __typename: 'EmailNotificationPreferencesResponse', preferences: Array<{ __typename?: 'EmailNotificationPreference', id: string, name: string, description: string, subscribed: boolean, cioTopicId?: string | null }> } };

export type EmailNotificationPreferencesMutationVariables = Exact<{
  input: Array<EmailNotificationPreferenceInput> | EmailNotificationPreferenceInput;
}>;


export type EmailNotificationPreferencesMutation = { __typename?: 'Mutation', emailNotificationPreferences: { __typename: 'EmailNotificationPreferenceError', message: string } | { __typename: 'EmailNotificationPreferencesResponse', preferences: Array<{ __typename?: 'EmailNotificationPreference', id: string, name: string, description: string, subscribed: boolean, cioTopicId?: string | null }> } };

export type InitiateUpdateEmailMutationVariables = Exact<{
  input: InitiateUpdateEmailInput;
}>;


export type InitiateUpdateEmailMutation = { __typename?: 'Mutation', initiateUpdateEmail: { __typename: 'EmptySuccess', _empty: string } | { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedError', message: string } };

export type RemoveAccountMutationVariables = Exact<{
  input: RemoveAccountInput;
}>;


export type RemoveAccountMutation = { __typename?: 'Mutation', removeAccount: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'RemoveAccountSuccess', _empty: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type VerifyPasswordMutationVariables = Exact<{
  input: VerifyPasswordInput;
}>;


export type VerifyPasswordMutation = { __typename?: 'Mutation', verifyPassword: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } | { __typename?: 'VerifyPasswordSuccess', _empty: string } };

export type AccountInitiateEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountInitiateEmailVerificationMutation = { __typename?: 'Mutation', accountInitiateEmailVerification: { __typename?: 'AccountInitiateEmailVerificationError', userFriendlyMessage: string } | { __typename?: 'AccountInitiateEmailVerificationResponse', success: boolean } };

export type UpdateAccountNameMutationVariables = Exact<{
  input: UpdateAccountNameInput;
}>;


export type UpdateAccountNameMutation = { __typename?: 'Mutation', updateAccountName: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError' } | { __typename: 'UnauthorizedError' } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateAccountNameSuccess', _empty: string } };

export type AccountUpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type AccountUpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'EmptySuccess', _empty: string } | { __typename?: 'InvalidInputError', message: string } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type UpdateAccountAvatarMutationVariables = Exact<{
  input: UpdateAccountAvatarInput;
}>;


export type UpdateAccountAvatarMutation = { __typename?: 'Mutation', updateAccountAvatar: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateAccountAvatarSuccess', _empty: string } };

export type TwoFactorSetupMutationVariables = Exact<{
  input: TwoFactorSetupInput;
}>;


export type TwoFactorSetupMutation = { __typename?: 'Mutation', twoFactorSetup: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'TwoFactorSetupResponse', key?: string | null } | { __typename?: 'UnexpectedError', message: string } };

export type TwoFactorConfirmMutationVariables = Exact<{
  input: TwoFactorConfirmInput;
}>;


export type TwoFactorConfirmMutation = { __typename?: 'Mutation', twoFactorConfirm: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'TwoFactorConfirmResponse', recoveryCode: string } | { __typename?: 'UnexpectedError', message: string } };

export type TwoFactorDisableMutationVariables = Exact<{ [key: string]: never; }>;


export type TwoFactorDisableMutation = { __typename?: 'Mutation', twoFactorDisable: { __typename: 'EmptySuccess' } | { __typename?: 'UnexpectedError', message: string } };

export type TwoFactorRecoveryCodeQueryVariables = Exact<{
  input: TwoFactorRecoveryCodeInput;
}>;


export type TwoFactorRecoveryCodeQuery = { __typename?: 'Query', recoveryCode: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'TwoFactorRecoveryCodeResponse', recoveryCode: string } | { __typename?: 'UnexpectedError', message: string } };

export type TwoFactorRequestOneTimePasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type TwoFactorRequestOneTimePasswordMutation = { __typename?: 'Mutation', twoFactorRequestOneTimePassword: { __typename: 'EmptySuccess' } | { __typename?: 'UnexpectedError', message: string } };

export type OrganizationReferralCodeQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type OrganizationReferralCodeQuery = { __typename?: 'Query', organizationReferralCode: { __typename?: 'OrganizationReferralCodeResponse', referralCode: string } };

export type RemoveChannelsMutationVariables = Exact<{
  channelIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RemoveChannelsMutation = { __typename?: 'Mutation', channelsRemove?: boolean | null };

export type ChannelsLockMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  channelIdsToLock?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  channelIdsToUnlock?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ChannelsLockMutation = { __typename?: 'Mutation', channelsLock?: boolean | null };

type ChannelsPricingNotice_Billing_MpBilling_Fragment = { __typename: 'MPBilling', subscriptions: Array<{ __typename?: 'MPSubscription', plan: string, product: Product }>, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null, gatewayPlatform?: BillingGatewayPlatform | null } } & { ' $fragmentName'?: 'ChannelsPricingNotice_Billing_MpBilling_Fragment' };

type ChannelsPricingNotice_Billing_ObBilling_Fragment = { __typename: 'OBBilling', subscription: { __typename?: 'OBSubscription', trial?: { __typename?: 'Trial', isActive: boolean, remainingDays: number } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string, limits: { __typename?: 'PlanLimits', channels: number } } }, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null, gatewayPlatform?: BillingGatewayPlatform | null } } & { ' $fragmentName'?: 'ChannelsPricingNotice_Billing_ObBilling_Fragment' };

export type ChannelsPricingNotice_BillingFragment = ChannelsPricingNotice_Billing_MpBilling_Fragment | ChannelsPricingNotice_Billing_ObBilling_Fragment;

export type ChannelsPricingNotice_LimitsFragment = { __typename?: 'OrganizationLimits', channels: number } & { ' $fragmentName'?: 'ChannelsPricingNotice_LimitsFragment' };

export type GetBillingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, currentOrganization?: { __typename?: 'AccountOrganization', id: string, limits: (
        { __typename?: 'OrganizationLimits' }
        & { ' $fragmentRefs'?: { 'ChannelsPricingNotice_LimitsFragment': ChannelsPricingNotice_LimitsFragment } }
      ), billing: (
        { __typename?: 'MPBilling' }
        & { ' $fragmentRefs'?: { 'ChannelsPricingNotice_Billing_MpBilling_Fragment': ChannelsPricingNotice_Billing_MpBilling_Fragment } }
      ) | (
        { __typename?: 'OBBilling' }
        & { ' $fragmentRefs'?: { 'ChannelsPricingNotice_Billing_ObBilling_Fragment': ChannelsPricingNotice_Billing_ObBilling_Fragment } }
      ) } | null } };

export type GetBetaFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBetaFeaturesQuery = { __typename?: 'Query', betaFeatures: Array<{ __typename?: 'BetaFeature', name: string, description: string, feedbackUrl?: string | null, platforms: Array<FeaturePlatform> }> };

export type ChannelSettings_ChannelFragment = { __typename?: 'Channel', accessLevel: ChannelAccessLevel, allowedActions: Array<ChannelAction>, apiVersion?: string | null, avatar: string, banners: Array<ChannelBanner>, createdAt: string, descriptor: string, displayName?: string | null, externalLink?: string | null, id: string, isDisconnected: boolean, isLocked: boolean, name: string, organizationId: string, service: Service, type: ChannelType, metadata?: { __typename?: 'BlueskyMetadata', serverUrl: string } | { __typename?: 'FacebookMetadata', locationData?: { __typename?: 'LocationData', location?: string | null } | null } | { __typename?: 'GoogleBusinessMetadata', locationData?: { __typename?: 'LocationData', location?: string | null, mapsLink?: string | null, googleAccountId?: string | null } | null } | { __typename?: 'InstagramMetadata', defaultToReminders: boolean } | { __typename?: 'LinkedInMetadata', shouldShowLinkedinAnalyticsRefreshBanner: boolean } | { __typename?: 'MastodonMetadata', serverUrl: string } | { __typename?: 'PinterestMetadata', boards: Array<{ __typename?: 'PinterestBoard', serviceId: string, name: string, url: string, description?: string | null, avatar?: string | null }> } | { __typename?: 'TwitterMetadata', subscriptionType?: string | null } | null } & { ' $fragmentName'?: 'ChannelSettings_ChannelFragment' };

export type GetChannelsQueryVariables = Exact<{
  input: ChannelsInput;
}>;


export type GetChannelsQuery = { __typename?: 'Query', channels: Array<(
    { __typename?: 'Channel', id: string }
    & { ' $fragmentRefs'?: { 'ChannelSettings_ChannelFragment': ChannelSettings_ChannelFragment } }
  )> };

export type GetConnectedAppsForAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedAppsForAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', connectedApps?: Array<{ __typename?: 'ConnectedApp', clientId: string, userId: string, name: string, description: string, website: string, createdAt: string }> | null } };

export type CreateCustomerPortalSessionMutationVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  returnURL: Scalars['String']['input'];
}>;


export type CreateCustomerPortalSessionMutation = { __typename?: 'Mutation', createCustomerPortalSession: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'CreateCustomerPortalSessionResponse', customerPortalSessionUrl: string } };

export type ValidNewOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidNewOwnersQuery = { __typename?: 'Query', account: { __typename?: 'Account', currentOrganization?: { __typename?: 'AccountOrganization', ownerEmail: string, validNewOwners: Array<{ __typename?: 'Account', id: string, name?: string | null, email: string }> } | null } };

export type RevokeAccessConnectedAppMutationVariables = Exact<{
  input: RevokeAccessConnectedAppInput;
}>;


export type RevokeAccessConnectedAppMutation = { __typename?: 'Mutation', revokeAccessConnectedApp: { __typename: 'EmptySuccess', _empty: string } | { __typename: 'UnexpectedError', message: string } };

export type TransferOrganizationOwnershipMutationVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  newOwner: Scalars['AccountId']['input'];
}>;


export type TransferOrganizationOwnershipMutation = { __typename?: 'Mutation', transferOrganizationOwnership: { __typename: 'EmptySuccess', _empty: string } | { __typename: 'TransferError', message: string } };

export type UpdateAccountPreferencesMutationVariables = Exact<{
  input: UpdateAccountPreferencesInput;
}>;


export type UpdateAccountPreferencesMutation = { __typename?: 'Mutation', updateAccountPreferences: { __typename: 'InvalidInputError', message: string } | { __typename: 'UpdateAccountPreferencesSuccess', preferences: { __typename?: 'Preferences', timeFormat?: string | null, startOfWeek?: string | null, defaultScheduleOption: ScheduleOption } } };

export type AddOrganizationToBetaProgramMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type AddOrganizationToBetaProgramMutation = { __typename?: 'Mutation', addOrganizationToBetaProgram: { __typename?: 'BasicError', userFriendlyMessage: string, cause: string } | { __typename?: 'MutationBasicResponse', success: boolean } };

export type RemoveOrganizationFromBetaProgramMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type RemoveOrganizationFromBetaProgramMutation = { __typename?: 'Mutation', removeOrganizationFromBetaProgram: { __typename?: 'BasicError', userFriendlyMessage: string, cause: string } | { __typename?: 'MutationBasicResponse', success: boolean } };

export type OrganizationSetNameMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type OrganizationSetNameMutation = { __typename?: 'Mutation', organizationSetName?: boolean | null };

export type UpdateAccountTimezoneMutationVariables = Exact<{
  input: UpdateAccountTimezoneInput;
}>;


export type UpdateAccountTimezoneMutation = { __typename?: 'Mutation', updateAccountTimezone: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateAccountTimezoneSuccess', timezone: string } };

export const CommentsChannelNavChannelFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentsChannelNavChannelFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}}]} as unknown as DocumentNode<CommentsChannelNavChannelFragmentFragment, unknown>;
export const FilterByChannel_ChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByChannel_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]} as unknown as DocumentNode<FilterByChannel_ChannelFragment, unknown>;
export const FilterByTag_TagFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByTag_Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<FilterByTag_TagFragment, unknown>;
export const PostCardContent_AnnotationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<PostCardContent_AnnotationFragment, unknown>;
export const PostMediaAsset_AssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}}]} as unknown as DocumentNode<PostMediaAsset_AssetFragment, unknown>;
export const PostCardNotes_NoteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}}]} as unknown as DocumentNode<PostCardNotes_NoteFragment, unknown>;
export const PostCard_PostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"ideaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedNow"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"metricsUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardContent_Annotation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retweet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"supportUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nullableValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}}]} as unknown as DocumentNode<PostCard_PostFragment, unknown>;
export const UpdatedNoteOnPostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdatedNoteOnPost"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}}]}}]} as unknown as DocumentNode<UpdatedNoteOnPostFragment, unknown>;
export const TagFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagFieldsFragment, unknown>;
export const ChannelNavChannelFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelNavChannelFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}}]}}]} as unknown as DocumentNode<ChannelNavChannelFragmentFragment, unknown>;
export const RealTimeUpdates_PostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RealTimeUpdates_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RealTimeUpdates_PostFragment, unknown>;
export const Post_EvictingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Post_evicting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<Post_EvictingFragment, unknown>;
export const Post_IsProcessingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Post_isProcessing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode<Post_IsProcessingFragment, unknown>;
export const CalendarPostCard_PostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarPostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelService"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}}]} as unknown as DocumentNode<CalendarPostCard_PostFragment, unknown>;
export const CalendarView_PostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarView_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublishingPost"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceLink"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"isReminder"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"formattedTime"}},{"kind":"Field","name":{"kind":"Name","value":"isRetweet"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"needsApproval"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isBlueprint"}},{"kind":"Field","name":{"kind":"Name","value":"updateType"}},{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"channelData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googlebusiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"youtube"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"service_geolocation_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinterest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_repin"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retweets"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"}},{"kind":"Field","name":{"kind":"Name","value":"mentions"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"reach_twitter"}},{"kind":"Field","name":{"kind":"Name","value":"reach"}},{"kind":"Field","name":{"kind":"Name","value":"shares"}},{"kind":"Field","name":{"kind":"Name","value":"reshares"}},{"kind":"Field","name":{"kind":"Name","value":"repins"}},{"kind":"Field","name":{"kind":"Name","value":"linkClicks"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"reactions"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}},{"kind":"Field","name":{"kind":"Name","value":"quotes"}},{"kind":"Field","name":{"kind":"Name","value":"replies"}},{"kind":"Field","name":{"kind":"Name","value":"reposts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subprofile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublishingPostLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublishingPostRetweet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublishingPostFirstComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PublishingPostDestinationUrl"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<CalendarView_PostFragment, unknown>;
export const QueueList_ChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QueueList_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}}]}}]}}]} as unknown as DocumentNode<QueueList_ChannelFragment, unknown>;
export const ChannelPage_ChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelPage_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QueueList_Channel"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedinAnalyticsRefreshBanner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveMemberDevice"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"sentCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weeklyPostingLimit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QueueList_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}}]}}]}}]} as unknown as DocumentNode<ChannelPage_ChannelFragment, unknown>;
export const SourcePostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourcePost"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}}]}}]} as unknown as DocumentNode<SourcePostFragment, unknown>;
export const TargetPostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TargetPost"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}}]}}]} as unknown as DocumentNode<TargetPostFragment, unknown>;
export const ChannelPageCommentsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelPageCommentsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedinAnalyticsRefreshBanner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}}]} as unknown as DocumentNode<ChannelPageCommentsFragmentFragment, unknown>;
export const CommentsPostCard_PostFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentsPostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelService"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}}]} as unknown as DocumentNode<CommentsPostCard_PostFragment, unknown>;
export const CommentMediaAsset_AssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<CommentMediaAsset_AssetFragment, unknown>;
export const CollectionListCollectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionListCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastRefreshed"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionListCollectionFragment, unknown>;
export const FeedArticleCard_FeedItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeedArticleCard_FeedItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"articleUrl"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextPreview"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"feed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeedArticleCard_FeedItemFragment, unknown>;
export const FeedList_FeedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeedList_Feed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastRefreshed"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]} as unknown as DocumentNode<FeedList_FeedFragment, unknown>;
export const SidebarFeedItem_FeedFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SidebarFeedItem_Feed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]} as unknown as DocumentNode<SidebarFeedItem_FeedFragment, unknown>;
export const SidebarCollectionItem_CollectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SidebarCollectionItem_Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SidebarFeedItem_Feed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SidebarFeedItem_Feed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]} as unknown as DocumentNode<SidebarCollectionItem_CollectionFragment, unknown>;
export const NewIdeaGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewIdeaGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}}]} as unknown as DocumentNode<NewIdeaGroupFragment, unknown>;
export const PreviousIdeaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"previousIdea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]} as unknown as DocumentNode<PreviousIdeaFragment, unknown>;
export const FilterByIdeaGroup_IdeaGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByIdeaGroup_IdeaGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<FilterByIdeaGroup_IdeaGroupFragment, unknown>;
export const IdeaCard_IdeaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_Idea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<IdeaCard_IdeaFragment, unknown>;
export const OrganizationPrivileges_AccountOrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationPrivileges_AccountOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAddPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"privileges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canManageBilling"}}]}}]}}]} as unknown as DocumentNode<OrganizationPrivileges_AccountOrganizationFragment, unknown>;
export const PaymentDetails_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentDetails_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentDetails_BillingFragment, unknown>;
export const AddressAndTax_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressAndTax_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousGateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"taxIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedName"}}]}}]}}]}}]} as unknown as DocumentNode<AddressAndTax_BillingFragment, unknown>;
export const Discount_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Discount_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}}]}}]} as unknown as DocumentNode<Discount_BillingFragment, unknown>;
export const UpcomingInvoice_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpcomingInvoice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoiceAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<UpcomingInvoice_BillingFragment, unknown>;
export const PlanContent_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContent_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Discount_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpcomingInvoice_Billing"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"members"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseMonthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basePlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyFlatFee"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyChannelPrice"}},{"kind":"Field","name":{"kind":"Name","value":"channelTierUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Discount_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpcomingInvoice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoiceAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<PlanContent_BillingFragment, unknown>;
export const LegacyPlanContent_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LegacyPlanContent_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Discount_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpcomingInvoice_Billing"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Discount_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpcomingInvoice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoiceAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<LegacyPlanContent_BillingFragment, unknown>;
export const BillingFragment_AccountOrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingFragment_AccountOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentDetails_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressAndTax_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContent_Billing"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentDetails_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressAndTax_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LegacyPlanContent_Billing"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Discount_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpcomingInvoice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoiceAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentDetails_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressAndTax_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousGateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"taxIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContent_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Discount_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpcomingInvoice_Billing"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"members"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseMonthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basePlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyFlatFee"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyChannelPrice"}},{"kind":"Field","name":{"kind":"Name","value":"channelTierUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LegacyPlanContent_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Discount_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpcomingInvoice_Billing"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}}]}}]}}]} as unknown as DocumentNode<BillingFragment_AccountOrganizationFragment, unknown>;
export const PaymentDetails_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentDetails_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PaymentDetails_OrganizationFragment, unknown>;
export const OrganizationDataForBilling_AccountOrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationDataForBilling_AccountOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationDataForBilling_AccountOrganizationFragment, unknown>;
export const ChannelsPricingNotice_BillingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelsPricingNotice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}}]}}]}}]}}]} as unknown as DocumentNode<ChannelsPricingNotice_BillingFragment, unknown>;
export const ChannelsPricingNotice_LimitsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelsPricingNotice_Limits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationLimits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}}]} as unknown as DocumentNode<ChannelsPricingNotice_LimitsFragment, unknown>;
export const ChannelSettings_ChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelSettings_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"banners"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptor"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultToReminders"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"mapsLink"}},{"kind":"Field","name":{"kind":"Name","value":"googleAccountId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedinAnalyticsRefreshBanner"}}]}}]}}]}}]} as unknown as DocumentNode<ChannelSettings_ChannelFragment, unknown>;
export const GetCommentsSidebarInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCommentsSidebarInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"EnumValue","value":"publish"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentsChannelNavChannelFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentsChannelNavChannelFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}}]} as unknown as DocumentNode<GetCommentsSidebarInfoQuery, GetCommentsSidebarInfoQueryVariables>;
export const GetIdeaGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIdeaGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}}]}}]} as unknown as DocumentNode<GetIdeaGroupsQuery, GetIdeaGroupsQueryVariables>;
export const CreateIdeaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIdea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIdeaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIdea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateIdeaMutation, CreateIdeaMutationVariables>;
export const UpdateIdeaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIdea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIdeaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIdea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateIdeaMutation, UpdateIdeaMutationVariables>;
export const GetIdeaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIdea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_Idea"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreWebAppCommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_Idea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetIdeaQuery, GetIdeaQueryVariables>;
export const LegacyCreateIdeaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LegacyCreateIdea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIdeaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIdea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<LegacyCreateIdeaMutation, LegacyCreateIdeaMutationVariables>;
export const LegacyUpdateIdeaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LegacyUpdateIdea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIdeaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIdea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<LegacyUpdateIdeaMutation, LegacyUpdateIdeaMutationVariables>;
export const AddNoteToPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNoteToPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNoteToPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"postId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddNoteToPostSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdatedNoteOnPost"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdatedNoteOnPost"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}}]}}]} as unknown as DocumentNode<AddNoteToPostMutation, AddNoteToPostMutationVariables>;
export const AddPostToQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPostToQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPostToQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<AddPostToQueueMutation, AddPostToQueueMutationVariables>;
export const ApprovePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApprovePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvePost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApprovePostMutation, ApprovePostMutationVariables>;
export const DeleteNoteFromPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNoteFromPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNoteFromPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"postId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteNoteFromPostSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}}]} as unknown as DocumentNode<DeleteNoteFromPostMutation, DeleteNoteFromPostMutationVariables>;
export const DeletePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePostV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeletePostSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePostMutation, DeletePostMutationVariables>;
export const MovePostToDraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MovePostToDrafts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"movePostToDraftsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MovePostToDraftsMutation, MovePostToDraftsMutationVariables>;
export const PublishPostNowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishPostNow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishPostNow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublishPostNowMutation, PublishPostNowMutationVariables>;
export const RejectPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RejectPostMutation, RejectPostMutationVariables>;
export const RequestPostApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPostApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPostApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequestPostApprovalMutation, RequestPostApprovalMutationVariables>;
export const RevertPostApprovalRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevertPostApprovalRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revertPostApprovalRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RevertPostApprovalRequestMutation, RevertPostApprovalRequestMutationVariables>;
export const UpdateNoteOnPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNoteOnPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNoteOnPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"postId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNoteOnPostSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}}]} as unknown as DocumentNode<UpdateNoteOnPostMutation, UpdateNoteOnPostMutationVariables>;
export const UpdatePostTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePostTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePostTagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePostTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePostTagsMutation, UpdatePostTagsMutationVariables>;
export const GetPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCard_Post"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"ideaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedNow"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"metricsUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardContent_Annotation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retweet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"supportUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nullableValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<GetPostQuery, GetPostQueryVariables>;
export const GetSidebarInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSidebarInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"EnumValue","value":"publish"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelNavChannelFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelNavChannelFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}}]}}]} as unknown as DocumentNode<GetSidebarInfoQuery, GetSidebarInfoQueryVariables>;
export const OrderChannelForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderChannelForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderChannelForAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderChannelForAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderChannelForAccountMutation, OrderChannelForAccountMutationVariables>;
export const GetAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"backupEmail"}},{"kind":"Field","name":{"kind":"Name","value":"hasVerifiedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"hasVerifiedBackupEmail"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedBanners"}},{"kind":"Field","name":{"kind":"Name","value":"tfa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeFormat"}},{"kind":"Field","name":{"kind":"Name","value":"startOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"defaultScheduleOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboarded"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"isBetaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"privileges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canManageChannels"}},{"kind":"Field","name":{"kind":"Name","value":"canManageBilling"}},{"kind":"Field","name":{"kind":"Name","value":"canManageAllNotes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canTransferOwnership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"descriptor"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"changePlanOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"planInterval"}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideas"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledPosts"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"savedReplies"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountQuery, GetAccountQueryVariables>;
export const GetDismissedBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDismissedBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedBanners"}}]}}]}}]} as unknown as DocumentNode<GetDismissedBannersQuery, GetDismissedBannersQueryVariables>;
export const DismissBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"banner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissBannerResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissBannerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<DismissBannerMutation, DismissBannerMutationVariables>;
export const StartTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartTrial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingStartTrial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<StartTrialMutation, StartTrialMutationVariables>;
export const GetTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTagsQuery, GetTagsQueryVariables>;
export const CreateTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TagActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TagActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTagActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTagMutation, DeleteTagMutationVariables>;
export const AccountSetSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"accountSetSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountSetSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountSetSettingsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboarded"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountSetSettingsError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}},{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<AccountSetSettingsMutation, AccountSetSettingsMutationVariables>;
export const IdeasCountByTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ideasCountByTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideasCountByTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeasCountByTags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreWebAppCommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<IdeasCountByTagsQuery, IdeasCountByTagsQueryVariables>;
export const SearchThreadsLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchThreadsLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchThreadsLocationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchThreadsLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SearchThreadsLocationsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SearchThreadsLocationsQuery, SearchThreadsLocationsQueryVariables>;
export const UpdateTimezoneForChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTimezoneForChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTimezoneForChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimezoneForChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTimezoneForChannelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTimezoneForChannelMutation, UpdateTimezoneForChannelMutationVariables>;
export const OptimizePostingScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OptimizePostingSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OptimizePostingScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optimizePostingSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptimizePostingScheduleResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OptimizePostingScheduleMutation, OptimizePostingScheduleMutationVariables>;
export const SetPostingScheduleForChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPostingScheduleForChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPostingScheduleForChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPostingScheduleForChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetPostingScheduleForChannelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetPostingScheduleForChannelMutation, SetPostingScheduleForChannelMutationVariables>;
export const GetPostingScheduleInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostingScheduleInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}}]}}]}}]} as unknown as DocumentNode<GetPostingScheduleInfoQuery, GetPostingScheduleInfoQueryVariables>;
export const UpdateChannelPostingGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChannelPostingGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelPostingGoalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChannelPostingGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelPostingGoalResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"sentCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateChannelPostingGoalMutation, UpdateChannelPostingGoalMutationVariables>;
export const ChecklistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checklists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChecklistsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreWebAppCommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<ChecklistsQuery, ChecklistsQueryVariables>;
export const GetAllChannelsInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllChannelsInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"EnumValue","value":"publish"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByChannel_Channel"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByTag_Tag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByChannel_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByTag_Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetAllChannelsInfoQuery, GetAllChannelsInfoQueryVariables>;
export const GetPostListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCard_Post"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"ideaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedNow"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"metricsUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardContent_Annotation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retweet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"supportUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nullableValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<GetPostListQuery, GetPostListQueryVariables>;
export const GetPostCountsByChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostCountsByChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagId"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"drafts"},"name":{"kind":"Name","value":"postCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"draft"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"queue"},"name":{"kind":"Name","value":"postCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"scheduled"},{"kind":"EnumValue","value":"error"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approvals"},"name":{"kind":"Name","value":"postCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"needs_approval"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sent"},"name":{"kind":"Name","value":"postCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"sent"},{"kind":"EnumValue","value":"sending"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]} as unknown as DocumentNode<GetPostCountsByChannelQuery, GetPostCountsByChannelQueryVariables>;
export const GetPostForRealTimeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostForRealTimeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCard_Post"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RealTimeUpdates_Post"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"ideaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedNow"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"metricsUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardContent_Annotation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retweet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"supportUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nullableValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RealTimeUpdates_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetPostForRealTimeUpdateQuery, GetPostForRealTimeUpdateQueryVariables>;
export const GetPostListForRealTimeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostListForRealTimeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPostListForRealTimeUpdateQuery, GetPostListForRealTimeUpdateQueryVariables>;
export const GetCalendarAndPostListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalendarAndPostList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postsLimit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postsLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dueAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"dueAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"createdAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarPostCard_Post"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarPostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelService"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCalendarAndPostListQuery, GetCalendarAndPostListQueryVariables>;
export const GetAllChannelsInfoForCalendarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllChannelsInfoForCalendar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"EnumValue","value":"publish"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByChannel_Channel"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByTag_Tag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByChannel_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByTag_Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetAllChannelsInfoForCalendarQuery, GetAllChannelsInfoForCalendarQueryVariables>;
export const GetCalendarPostForRealTimeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalendarPostForRealTimeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarPostCard_Post"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RealTimeUpdates_Post"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarPostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelService"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RealTimeUpdates_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetCalendarPostForRealTimeUpdateQuery, GetCalendarPostForRealTimeUpdateQueryVariables>;
export const GetPostForCalendarPostCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostForCalendarPostCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCard_Post"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"ideaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedNow"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"metricsUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardContent_Annotation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retweet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"supportUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nullableValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<GetPostForCalendarPostCardQuery, GetPostForCalendarPostCardQueryVariables>;
export const UpdateCalendarPostDueAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCalendarPostDueAt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DropPostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dropPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCalendarPostDueAtMutation, UpdateCalendarPostDueAtMutationVariables>;
export const GetChannelInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChannelInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QueueList_Channel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelPage_Channel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByTag_Tag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QueueList_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelPage_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QueueList_Channel"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedinAnalyticsRefreshBanner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveMemberDevice"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"sentCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weeklyPostingLimit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByTag_Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetChannelInfoQuery, GetChannelInfoQueryVariables>;
export const BackfillUpdatesForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BackfillUpdatesForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BackfillUpdatesForGridInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backfillUpdatesForGrid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}}]}}]}}]} as unknown as DocumentNode<BackfillUpdatesForGridMutation, BackfillUpdatesForGridMutationVariables>;
export const ShopGridCustomLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShopGridCustomLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopGridCustomLinksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopGridCustomLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"contrastColor"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ShopGridCustomLinksQuery, ShopGridCustomLinksQueryVariables>;
export const DropPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DropPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DropPostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dropPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DropPostMutation, DropPostMutationVariables>;
export const SwapPostsInQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SwapPostsInQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapPostsInQueueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapPostsInQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapPostsInQueueSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SwapPostsInQueueMutation, SwapPostsInQueueMutationVariables>;
export const GetChannelInfoForCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChannelInfoForComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelPageCommentsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelPageCommentsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedinAnalyticsRefreshBanner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}}]} as unknown as DocumentNode<GetChannelInfoForCommentsQuery, GetChannelInfoForCommentsQueryVariables>;
export const CreateSavedReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSavedReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSavedReplyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSavedReply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SavedReplyActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedReply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hotkeys"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSavedReplyMutation, CreateSavedReplyMutationVariables>;
export const DeleteSavedReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedReplyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedReply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedReplySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSavedReplyMutation, DeleteSavedReplyMutationVariables>;
export const SavedRepliesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavedRepliesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedRepliesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedReplies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedReplies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<SavedRepliesQueryQuery, SavedRepliesQueryQueryVariables>;
export const UpdateSavedReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSavedReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSavedReplyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSavedReply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SavedReplyActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedReply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hotkeys"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSavedReplyMutation, UpdateSavedReplyMutationVariables>;
export const CommentSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"commentSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentSuggestionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<CommentSuggestionsQuery, CommentSuggestionsQueryVariables>;
export const CommentThreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentThread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentThreadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentThread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnReply"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"channelService"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromThirdParty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentimentAnalysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromBuffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}}]} as unknown as DocumentNode<CommentThreadQuery, CommentThreadQueryVariables>;
export const CommentsCountsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentsCountsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentsCountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentsCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]} as unknown as DocumentNode<CommentsCountsQueryQuery, CommentsCountsQueryQueryVariables>;
export const CommentsInsightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentsInsights"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentsInsightsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentsInsights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insights"}}]}}]}}]} as unknown as DocumentNode<CommentsInsightsQuery, CommentsInsightsQueryVariables>;
export const CommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Comments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnReply"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"lastReply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnReply"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"channelService"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"service"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromThirdParty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentimentAnalysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromBuffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}}]} as unknown as DocumentNode<CommentsQuery, CommentsQueryVariables>;
export const CommentsScoreQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentsScoreQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentsScoreInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentsScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAchievementLevel"}},{"kind":"Field","name":{"kind":"Name","value":"currentWeekScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"responseRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseSpeed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consistency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousWeekScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"responseRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseSpeed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consistency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentsScoreQueryQuery, CommentsScoreQueryQueryVariables>;
export const DismissAllCommentsByChannelIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissAllCommentsByChannelId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DismissAllCommentsByChannelIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissAllCommentsByChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissAllCommentsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"affectedCommentCount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DismissAllCommentsByChannelIdMutation, DismissAllCommentsByChannelIdMutationVariables>;
export const DismissCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DismissCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissCommentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromThirdParty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromBuffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DismissCommentMutation, DismissCommentMutationVariables>;
export const GetPostForCommentsPostCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostForCommentsPostCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCard_Post"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardContent_Annotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Annotation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"indices"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostMediaAsset_Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"isAnimated"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filesize"}},{"kind":"Field","name":{"kind":"Name","value":"numPages"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCardNotes_Note"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Note"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PostCard_Post"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"ideaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"notificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedNow"}},{"kind":"Field","name":{"kind":"Name","value":"via"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingType"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCustomScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"metricsUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"annotations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardContent_Annotation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"geolocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retweet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstComment"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThreadsPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyPostMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expandedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isQueuePaused"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostCardNotes_Note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"supportUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PostMediaAsset_Asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"nullableValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<GetPostForCommentsPostCardQuery, GetPostForCommentsPostCardQueryVariables>;
export const ReplyToCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplyToComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReplyToCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replyToComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReplyToCommentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromBuffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromThirdParty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ReplyToCommentMutation, ReplyToCommentMutationVariables>;
export const UndismissCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UndismissComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UndismissCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"undismissComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UndismissCommentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromThirdParty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentFromBuffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UndismissCommentMutation, UndismissCommentMutationVariables>;
export const GetCollectionListDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionListDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollectionId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedCollectionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionListCollection"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionListCollection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastRefreshed"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCollectionListDetailsQuery, GetCollectionListDetailsQueryVariables>;
export const GetFeedListDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeedListDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeedList_Feed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeedList_Feed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastRefreshed"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeedListDetailsQuery, GetFeedListDetailsQueryVariables>;
export const MoveFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedMoveUpdatesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedFeeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedFeedCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MoveFeedMutation, MoveFeedMutationVariables>;
export const CreateFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedConnectionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"homepage"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFeedMutation, CreateFeedMutationVariables>;
export const CreateNewFeedCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewFeedCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeedCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollectionActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewFeedCollectionMutation, CreateNewFeedCollectionMutationVariables>;
export const DeleteFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFeedResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFeedMutation, DeleteFeedMutationVariables>;
export const DeleteFeedCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFeedCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFeedCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFeedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollectionDeleteSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedCollectionId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFeedCollectionMutation, DeleteFeedCollectionMutationVariables>;
export const GetFeedItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeedItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedCollectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollectionId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedCollectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedCollectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextPreview"}},{"kind":"Field","name":{"kind":"Name","value":"articleUrl"}},{"kind":"Field","name":{"kind":"Name","value":"feed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFeedItemsQuery, GetFeedItemsQueryVariables>;
export const GetFeedsForSidebarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeedsForSidebar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SidebarFeedItem_Feed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SidebarCollectionItem_Collection"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SidebarFeedItem_Feed"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SidebarCollectionItem_Collection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SidebarFeedItem_Feed"}}]}}]}}]} as unknown as DocumentNode<GetFeedsForSidebarQuery, GetFeedsForSidebarQueryVariables>;
export const RefreshFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefreshFeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastRefreshed"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RefreshFeedMutation, RefreshFeedMutationVariables>;
export const RefreshFeedCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshFeedCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefreshFeedCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshFeedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollectionActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<RefreshFeedCollectionMutation, RefreshFeedCollectionMutationVariables>;
export const UpdateFeedCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFeedCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFeedCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFeedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedCollectionActionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"homepage"}},{"kind":"Field","name":{"kind":"Name","value":"connectionMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RSSFeedConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnected"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsSearchConnectionMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFeedCollectionMutation, UpdateFeedCollectionMutationVariables>;
export const GetCreateInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId_ID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByTag_Tag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ideaGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId_ID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterByIdeaGroup_IdeaGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByTag_Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterByIdeaGroup_IdeaGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetCreateInfoQuery, GetCreateInfoQueryVariables>;
export const GetIdeasBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIdeasBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ideasV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_Idea"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_Idea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetIdeasBoardQuery, GetIdeasBoardQueryVariables>;
export const CreateIdeaGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIdeaGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIdeaGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateIdeaGroupMutation, CreateIdeaGroupMutationVariables>;
export const DeleteIdeaGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteIdeaGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIdeaGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteIdeaGroupResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedIdeas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteIdeaGroupMutation, DeleteIdeaGroupMutationVariables>;
export const MoveIdeaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveIdea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveIdeaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveIdea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveIdeaResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedIdeas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MoveIdeaMutation, MoveIdeaMutationVariables>;
export const MoveIdeaGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveIdeaGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeAfterId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveIdeaGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"placeAfterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeAfterId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveIdeaGroupResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MoveIdeaGroupMutation, MoveIdeaGroupMutationVariables>;
export const UpdateIdeaGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIdeaGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIdeaGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateIdeaGroupMutation, UpdateIdeaGroupMutationVariables>;
export const GetIdeasGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIdeasGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideasV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_Idea"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_Idea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"aiAssisted"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetIdeasGalleryQuery, GetIdeasGalleryQueryVariables>;
export const DeleteIdeaMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteIdeaMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdeasDeletionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideasRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeasDeletionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ideas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreWebAppCommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteIdeaMutationMutation, DeleteIdeaMutationMutationVariables>;
export const IdeasCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ideasCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideasCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeasCount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreWebAppCommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<IdeasCountQuery, IdeasCountQueryVariables>;
export const AccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousGateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baseMonthlyPrice"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingFragment_AccountOrganization"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationDataForBilling_AccountOrganization"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationPrivileges_AccountOrganization"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentDetails_Organization"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentDetails_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressAndTax_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousGateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"taxIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Discount_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpcomingInvoice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoiceAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContent_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Discount_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpcomingInvoice_Billing"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"members"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseMonthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basePlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyFlatFee"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyChannelPrice"}},{"kind":"Field","name":{"kind":"Name","value":"channelTierUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LegacyPlanContent_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Discount_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpcomingInvoice_Billing"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingFragment_AccountOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentDetails_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressAndTax_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContent_Billing"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentDetails_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressAndTax_Billing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LegacyPlanContent_Billing"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationDataForBilling_AccountOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationPrivileges_AccountOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAddPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"privileges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canManageBilling"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentDetails_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AccountQuery, AccountQueryVariables>;
export const InvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Invoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesByOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesQuery, InvoicesQueryVariables>;
export const RemoveSubscriptionScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeSubscriptionSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSubscriptionSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveSubscriptionScheduleResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveSubscriptionScheduleError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveSubscriptionScheduleMutation, RemoveSubscriptionScheduleMutationVariables>;
export const GetChannelGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChannelGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelGroupsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelGroupsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"channelCount"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"service"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChannelGroupsQuery, GetChannelGroupsQueryVariables>;
export const CreateChannelGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChannelGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChannelGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateChannelGroupMutation, CreateChannelGroupMutationVariables>;
export const DeleteChannelGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteChannelGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteChannelGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChannelGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteChannelGroupSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteChannelGroupMutation, DeleteChannelGroupMutationVariables>;
export const UpdateChannelGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateChannelGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChannelGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateChannelGroupMutation, UpdateChannelGroupMutationVariables>;
export const GetEmailNotificationPreferencesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmailNotificationPreferencesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationPreferencesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subscribed"}},{"kind":"Field","name":{"kind":"Name","value":"cioTopicId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationPreferenceError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetEmailNotificationPreferencesQueryQuery, GetEmailNotificationPreferencesQueryQueryVariables>;
export const EmailNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"emailNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationPreferenceInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailNotificationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationPreferencesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subscribed"}},{"kind":"Field","name":{"kind":"Name","value":"cioTopicId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationPreferenceError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<EmailNotificationPreferencesMutation, EmailNotificationPreferencesMutationVariables>;
export const InitiateUpdateEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateUpdateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateUpdateEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateUpdateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateUpdateEmailMutation, InitiateUpdateEmailMutationVariables>;
export const RemoveAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveAccountSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveAccountMutation, RemoveAccountMutationVariables>;
export const VerifyPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyPasswordSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<VerifyPasswordMutation, VerifyPasswordMutationVariables>;
export const AccountInitiateEmailVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountInitiateEmailVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountInitiateEmailVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountInitiateEmailVerificationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountInitiateEmailVerificationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<AccountInitiateEmailVerificationMutation, AccountInitiateEmailVerificationMutationVariables>;
export const UpdateAccountNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccountName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountNameSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountNameMutation, UpdateAccountNameMutationVariables>;
export const AccountUpdatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountUpdatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthorizedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<AccountUpdatePasswordMutation, AccountUpdatePasswordMutationVariables>;
export const UpdateAccountAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccountAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountAvatarSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountAvatarMutation, UpdateAccountAvatarMutationVariables>;
export const TwoFactorSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TwoFactorSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFactorSetupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twoFactorSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFactorSetupResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwoFactorSetupMutation, TwoFactorSetupMutationVariables>;
export const TwoFactorConfirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TwoFactorConfirm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFactorConfirmInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twoFactorConfirm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFactorConfirmResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recoveryCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwoFactorConfirmMutation, TwoFactorConfirmMutationVariables>;
export const TwoFactorDisableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TwoFactorDisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twoFactorDisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwoFactorDisableMutation, TwoFactorDisableMutationVariables>;
export const TwoFactorRecoveryCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TwoFactorRecoveryCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFactorRecoveryCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recoveryCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwoFactorRecoveryCodeResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recoveryCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwoFactorRecoveryCodeQuery, TwoFactorRecoveryCodeQueryVariables>;
export const TwoFactorRequestOneTimePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TwoFactorRequestOneTimePassword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twoFactorRequestOneTimePassword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwoFactorRequestOneTimePasswordMutation, TwoFactorRequestOneTimePasswordMutationVariables>;
export const OrganizationReferralCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationReferralCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationReferralCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralCode"}}]}}]}}]} as unknown as DocumentNode<OrganizationReferralCodeQuery, OrganizationReferralCodeQueryVariables>;
export const RemoveChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelsRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}]}}]} as unknown as DocumentNode<RemoveChannelsMutation, RemoveChannelsMutationVariables>;
export const ChannelsLockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChannelsLock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIdsToLock"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIdsToUnlock"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelsLock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelIdsToLock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIdsToLock"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelIdsToUnlock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIdsToUnlock"}}}]}]}}]} as unknown as DocumentNode<ChannelsLockMutation, ChannelsLockMutationVariables>;
export const GetBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelsPricingNotice_Limits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelsPricingNotice_Billing"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelsPricingNotice_Limits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationLimits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelsPricingNotice_Billing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}}]}}]}}]}}]} as unknown as DocumentNode<GetBillingQuery, GetBillingQueryVariables>;
export const GetBetaFeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBetaFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"betaFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"platforms"}}]}}]}}]} as unknown as DocumentNode<GetBetaFeaturesQuery, GetBetaFeaturesQueryVariables>;
export const GetChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelSettings_Channel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelSettings_Channel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"_unmask"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"banners"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"descriptor"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDisconnected"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultToReminders"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinterestMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MastodonMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlueskyMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleBusinessMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"mapsLink"}},{"kind":"Field","name":{"kind":"Name","value":"googleAccountId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacebookMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TwitterMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkedInMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedinAnalyticsRefreshBanner"}}]}}]}}]}}]} as unknown as DocumentNode<GetChannelsQuery, GetChannelsQueryVariables>;
export const GetConnectedAppsForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConnectedAppsForAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectedApps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetConnectedAppsForAccountQuery, GetConnectedAppsForAccountQueryVariables>;
export const CreateCustomerPortalSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomerPortalSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnURL"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerPortalSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"returnURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnURL"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerPortalSessionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPortalSessionUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>;
export const ValidNewOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidNewOwners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"validNewOwners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ValidNewOwnersQuery, ValidNewOwnersQueryVariables>;
export const RevokeAccessConnectedAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeAccessConnectedApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeAccessConnectedAppInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeAccessConnectedApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RevokeAccessConnectedAppMutation, RevokeAccessConnectedAppMutationVariables>;
export const TransferOrganizationOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferOrganizationOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newOwner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferOrganizationOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newOwner"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmptySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TransferError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TransferOrganizationOwnershipMutation, TransferOrganizationOwnershipMutationVariables>;
export const UpdateAccountPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccountPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountPreferencesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeFormat"}},{"kind":"Field","name":{"kind":"Name","value":"startOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"defaultScheduleOption"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountPreferencesMutation, UpdateAccountPreferencesMutationVariables>;
export const AddOrganizationToBetaProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addOrganizationToBetaProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrganizationToBetaProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BasicError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}},{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationBasicResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<AddOrganizationToBetaProgramMutation, AddOrganizationToBetaProgramMutationVariables>;
export const RemoveOrganizationFromBetaProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeOrganizationFromBetaProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrganizationFromBetaProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BasicError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}},{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationBasicResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveOrganizationFromBetaProgramMutation, RemoveOrganizationFromBetaProgramMutationVariables>;
export const OrganizationSetNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrganizationSetName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSetName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}]}}]} as unknown as DocumentNode<OrganizationSetNameMutation, OrganizationSetNameMutationVariables>;
export const UpdateAccountTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountTimezone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountTimezoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountTimezone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountTimezoneSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnexpectedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountTimezoneMutation, UpdateAccountTimezoneMutationVariables>;